import { t as __exportAll } from "../rolldown-runtime-CNktS9qV.mjs";
import axios from "axios";
import { stringify } from "qs";
//#region src/basecamp/gen/models/BaseRenovationScenarioConfig.ts
const SubsidiesKfwStandard = { "KfW 55": "KfW 55" };
const SubsidiesKfwStandard2 = { "KfW 70": "KfW 70" };
const SubsidiesKfwStandard3 = { "KfW 85": "KfW 85" };
const SubsidiesKfwStandard4 = { "No KfW": "No KfW" };
const SubsidiesBegEmOption = { "Individual measure shell + heating measure": "Individual measure shell + heating measure" };
const SubsidiesBegEmOption2 = { "Individual measure shell/systems with EH 55 standard": "Individual measure shell/systems with EH 55 standard" };
const SubsidiesBegEmOption3 = { "Individual measure shell/systems without EH standard": "Individual measure shell/systems without EH standard" };
const SubsidiesBegEmOption4 = { "Individual heating measure": "Individual heating measure" };
const SubsidiesBegEmOption5 = { OFF: "OFF" };
const SubsidiesIfbStandard = { "No IFB": "No IFB" };
const SubsidiesIfbStandard2 = { "IFB<75": "IFB<75" };
const SubsidiesIfbStandard3 = { IFB70: "IFB70" };
const SubsidiesIfbStandard4 = { IFB55: "IFB55" };
const SubsidiesIfbStandard5 = { IFB40: "IFB40" };
const SubsidiesIfbStandard6 = { "IFB<90": "IFB<90" };
const EnergyTargetEnergyClass = { "A+": "A+" };
const EnergyTargetEnergyClass2 = { A: "A" };
const EnergyTargetEnergyClass3 = { B: "B" };
const EnergyTargetEnergyClass4 = { C: "C" };
const EnergyTargetEnergyClass5 = { D: "D" };
const EnergyTargetEnergyClass6 = { E: "E" };
const EnergyTargetEnergyClass7 = { F: "F" };
const EnergyTargetEnergyClass8 = { G: "G" };
const EnergyTargetEnergyClass9 = { H: "H" };
//#endregion
//#region src/basecamp/gen/models/RenovationEnergeticMeasureType.ts
const RenovationEnergeticMeasureType = {
	SHELL: "SHELL",
	HEATING: "HEATING",
	FULL: "FULL"
};
//#endregion
//#region src/basecamp/gen/models/RenovationScenarioExpansionType.ts
const RenovationScenarioExpansionType = {
	NONE: "NONE",
	ROOF_ADDITION: "ROOF_ADDITION",
	ROOF_CONVERSION: "ROOF_CONVERSION"
};
//#endregion
//#region src/basecamp/gen/models/RenovationScenarioGroupCode.ts
const RenovationScenarioGroupCode = {
	KFW_261_NO_EXPANSION: "KFW_261_NO_EXPANSION",
	BAFA_NO_EXPANSION: "BAFA_NO_EXPANSION",
	KFW_261_ROOF_ADDITION: "KFW_261_ROOF_ADDITION",
	BAFA_ROOF_ADDITION: "BAFA_ROOF_ADDITION",
	KFW_261_ROOF_CONVERSION: "KFW_261_ROOF_CONVERSION",
	BAFA_ROOF_CONVERSION: "BAFA_ROOF_CONVERSION"
};
//#endregion
//#region src/basecamp/gen/models/RenovationScenarioSubsidyScheme.ts
const RenovationScenarioSubsidyScheme = {
	KFW_261: "KFW_261",
	BAFA: "BAFA"
};
//#endregion
//#region src/basecamp/gen/models/SepaDirectDebitSource.ts
const SepaDirectDebitSource = { Tenant: "Tenant" };
const SepaDirectDebitSource2 = { Escrow: "Escrow" };
//#endregion
//#region src/basecamp/gen/models/SepaDirectDebitStatus.ts
const SepaDirectDebitStatus = {
	Active: "Active",
	Cancelled: "Cancelled",
	Expired: "Expired"
};
//#endregion
//#region src/basecamp/gen/models/SepaDirectDebitType.ts
const SepaDirectDebitType = {
	Rent: "Rent",
	WEG: "WEG",
	AncillaryCosts: "AncillaryCosts",
	Electricity: "Electricity",
	Gas: "Gas",
	PropertyTax: "PropertyTax"
};
//#endregion
//#region src/basecamp/gen/models/SepaMandateDto.ts
const SepaMandateDtoSource = { Tenant: "Tenant" };
const SepaMandateDtoSource2 = { Escrow: "Escrow" };
const SepaMandateDtoMandateType = {
	Rent: "Rent",
	WEG: "WEG",
	AncillaryCosts: "AncillaryCosts",
	Electricity: "Electricity",
	Gas: "Gas",
	PropertyTax: "PropertyTax"
};
const SepaMandateDtoStatus = {
	Active: "Active",
	Cancelled: "Cancelled",
	Expired: "Expired"
};
//#endregion
//#region src/basecamp/gen/models/SepaMandateFullDto.ts
const SepaMandateFullDtoSource = { Tenant: "Tenant" };
const SepaMandateFullDtoSource2 = { Escrow: "Escrow" };
const SepaMandateFullDtoMandateType = {
	Rent: "Rent",
	WEG: "WEG",
	AncillaryCosts: "AncillaryCosts",
	Electricity: "Electricity",
	Gas: "Gas",
	PropertyTax: "PropertyTax"
};
const SepaMandateFullDtoStatus = {
	Active: "Active",
	Cancelled: "Cancelled",
	Expired: "Expired"
};
//#endregion
//#region src/basecamp/gen/models/authzModels/BulkUpdateRoles.ts
const RolesPermissions = {
	"agent.chat.view-any": "agent.chat.view-any",
	"agent.feedback.manage": "agent.feedback.manage",
	"spotlight.catalogue.manage": "spotlight.catalogue.manage",
	"spotlight.report.view": "spotlight.report.view",
	"estate.estate.view": "estate.estate.view",
	"estate.estate.edit": "estate.estate.edit",
	"estate.estate.create": "estate.estate.create",
	"estate.estate.delete": "estate.estate.delete",
	"estate.attributes.view": "estate.attributes.view",
	"estate.attributes.edit": "estate.attributes.edit",
	"estate.notes.view": "estate.notes.view",
	"estate.notes.create": "estate.notes.create",
	"estate.notes.edit": "estate.notes.edit",
	"estate.notes.delete": "estate.notes.delete",
	"estate.location.view": "estate.location.view",
	"estate.location.edit": "estate.location.edit",
	"estate.contacts.view": "estate.contacts.view",
	"estate.contacts.create": "estate.contacts.create",
	"estate.contacts.delete": "estate.contacts.delete",
	"estate.credentials.view": "estate.credentials.view",
	"estate.credentials.create": "estate.credentials.create",
	"estate.credentials.delete": "estate.credentials.delete",
	"estate.document.view": "estate.document.view",
	"estate.document.upload": "estate.document.upload",
	"estate.document.download": "estate.document.download",
	"estate.document.edit": "estate.document.edit",
	"estate.documents.delete": "estate.documents.delete",
	"estate.documents.create": "estate.documents.create",
	"estate.documents.send": "estate.documents.send",
	"core.data-room.create": "core.data-room.create",
	"core.data-room.edit": "core.data-room.edit",
	"core.data-room.delete": "core.data-room.delete",
	"core.data-room.view": "core.data-room.view",
	"estate.media.view": "estate.media.view",
	"estate.media.edit": "estate.media.edit",
	"estate.media.create": "estate.media.create",
	"estate.media.delete": "estate.media.delete",
	"estate.tasks.view": "estate.tasks.view",
	"estate.tasks.edit": "estate.tasks.edit",
	"estate.tasks.create": "estate.tasks.create",
	"estate.tasks.delete": "estate.tasks.delete",
	"estate.find-transaction-monitoring-estates.view": "estate.find-transaction-monitoring-estates.view",
	"estate.controlling.view": "estate.controlling.view",
	"estate.calendar.view": "estate.calendar.view",
	"estate.calendar.edit": "estate.calendar.edit",
	"estate.calendar.create": "estate.calendar.create",
	"estate.calendar.delete": "estate.calendar.delete",
	"estate.events.view": "estate.events.view",
	"estate.prediction.recalculate": "estate.prediction.recalculate",
	"mfh.contacts.list": "mfh.contacts.list",
	"mfh.contacts.create": "mfh.contacts.create",
	"mfh.impersonate.asset-partner": "mfh.impersonate.asset-partner",
	"mfh.mfh.view": "mfh.mfh.view",
	"mfh.mfh.edit": "mfh.mfh.edit",
	"mfh.mfh.delete": "mfh.mfh.delete",
	"mfh.mfh.create": "mfh.mfh.create",
	"mfh.mfh.bulk-create": "mfh.mfh.bulk-create",
	"mfh.capex-ee-config.view": "mfh.capex-ee-config.view",
	"mfh.capex-ee-config.create": "mfh.capex-ee-config.create",
	"mfh.capex-ee-config.edit": "mfh.capex-ee-config.edit",
	"mfh.capex-ee-config.delete": "mfh.capex-ee-config.delete",
	"mfh.capex-ee-scenario.view": "mfh.capex-ee-scenario.view",
	"mfh.capex-ee-scenario.edit": "mfh.capex-ee-scenario.edit",
	"mfh.capex-ee-scenario.create": "mfh.capex-ee-scenario.create",
	"mfh.capex-ee-scenario.delete": "mfh.capex-ee-scenario.delete",
	"mfh.estar-core-id.edit": "mfh.estar-core-id.edit",
	"mfh.events.view": "mfh.events.view",
	"mfh.attributes.view": "mfh.attributes.view",
	"mfh.attributes.edit": "mfh.attributes.edit",
	"mfh.renovation-attributes.edit": "mfh.renovation-attributes.edit",
	"mfh.location.view": "mfh.location.view",
	"mfh.location.edit": "mfh.location.edit",
	"mfh.tasks.view": "mfh.tasks.view",
	"mfh.tasks.edit": "mfh.tasks.edit",
	"mfh.tasks.create": "mfh.tasks.create",
	"mfh.tasks.delete": "mfh.tasks.delete",
	"mfh.project-planning.view": "mfh.project-planning.view",
	"mfh.project-planning.edit": "mfh.project-planning.edit",
	"mfh.project-planning.create": "mfh.project-planning.create",
	"mfh.project-planning.delete": "mfh.project-planning.delete",
	"mfh.calendar.view": "mfh.calendar.view",
	"mfh.calendar.edit": "mfh.calendar.edit",
	"mfh.calendar.create": "mfh.calendar.create",
	"mfh.calendar.delete": "mfh.calendar.delete",
	"mfh.document.view": "mfh.document.view",
	"mfh.document.edit": "mfh.document.edit",
	"mfh.document.upload": "mfh.document.upload",
	"mfh.document.delete": "mfh.document.delete",
	"mfh.renovation-project-config.edit": "mfh.renovation-project-config.edit",
	"mfh.renovation-project.create": "mfh.renovation-project.create",
	"mfh.renovation-project.view": "mfh.renovation-project.view",
	"mfh.renovation-project.edit": "mfh.renovation-project.edit",
	"mfh.renovation-project.delete": "mfh.renovation-project.delete",
	"mfh.renovation-project.review-process.create": "mfh.renovation-project.review-process.create",
	"mfh.renovation-project.review-process.view": "mfh.renovation-project.review-process.view",
	"mfh.renovation-project.review-process.edit": "mfh.renovation-project.review-process.edit",
	"mfh.renovation-project.review-process.process": "mfh.renovation-project.review-process.process",
	"mfh.renovation-project-planning-module.delete": "mfh.renovation-project-planning-module.delete",
	"mfh.renovation-project-position.delete": "mfh.renovation-project-position.delete",
	"mfh.renovation-event.history.view": "mfh.renovation-event.history.view",
	"mfh.renovation-project-lot.delete": "mfh.renovation-project-lot.delete",
	"mfh.elements.create": "mfh.elements.create",
	"mfh.elements.edit": "mfh.elements.edit",
	"mfh.elements.view": "mfh.elements.view",
	"mfh.elements.delete": "mfh.elements.delete",
	"mfh.media.view": "mfh.media.view",
	"mfh.media.edit": "mfh.media.edit",
	"mfh.notes.view": "mfh.notes.view",
	"mfh.notes.create": "mfh.notes.create",
	"mfh.notes.edit": "mfh.notes.edit",
	"mfh.notes.delete": "mfh.notes.delete",
	"mfh.dd.view": "mfh.dd.view",
	"mfh.dd.edit": "mfh.dd.edit",
	"mfh.infas.fetch": "mfh.infas.fetch",
	"mfh.syte.fetch": "mfh.syte.fetch",
	"mfh.syte.debug": "mfh.syte.debug",
	"mfh.investment-case.view": "mfh.investment-case.view",
	"mfh.investment-case.create": "mfh.investment-case.create",
	"mfh.investment-case.edit": "mfh.investment-case.edit",
	"mfh.investment-case.export": "mfh.investment-case.export",
	"mfh.investment-case.upload": "mfh.investment-case.upload",
	"mfh.investment-case.delete": "mfh.investment-case.delete",
	"mfh.investment-case.restore": "mfh.investment-case.restore",
	"mfh.investment-case-admin-input.edit": "mfh.investment-case-admin-input.edit",
	"mfh.asset-analyzer.view": "mfh.asset-analyzer.view",
	"mfh.asset-analyzer.edit-any": "mfh.asset-analyzer.edit-any",
	"mfh.investment-case.copy-as-json": "mfh.investment-case.copy-as-json",
	"mfh.investment-case.paste-as-json": "mfh.investment-case.paste-as-json",
	"mfh.investment-case-review-process.create": "mfh.investment-case-review-process.create",
	"mfh.investment-case-review-process.view": "mfh.investment-case-review-process.view",
	"mfh.investment-case-review-process.edit": "mfh.investment-case-review-process.edit",
	"mfh.investment-case-review-process.process": "mfh.investment-case-review-process.process",
	"mfh-portfolio.process.trigger": "mfh-portfolio.process.trigger",
	"mfh.portfolio-review-process.create": "mfh.portfolio-review-process.create",
	"mfh.portfolio-review-process.view": "mfh.portfolio-review-process.view",
	"mfh.portfolio-review-process.edit": "mfh.portfolio-review-process.edit",
	"mfh.portfolio-review-process.process": "mfh.portfolio-review-process.process",
	"mfh-portfolio.tasks.view": "mfh-portfolio.tasks.view",
	"mfh-portfolio.tasks.edit": "mfh-portfolio.tasks.edit",
	"mfh-portfolio.tasks.create": "mfh-portfolio.tasks.create",
	"mfh-portfolio.tasks.delete": "mfh-portfolio.tasks.delete",
	"mfh.prediction.view": "mfh.prediction.view",
	"mfh.prediction.create": "mfh.prediction.create",
	"mfh.prediction.edit": "mfh.prediction.edit",
	"mfh.prediction.delete": "mfh.prediction.delete",
	"mfh.rent-roll.import": "mfh.rent-roll.import",
	"mfh.rent-roll-version.view": "mfh.rent-roll-version.view",
	"mfh.rent-roll-version.create": "mfh.rent-roll-version.create",
	"mfh.rent-roll-version.edit": "mfh.rent-roll-version.edit",
	"mfh.rent-roll-version.delete": "mfh.rent-roll-version.delete",
	"mfh.placement.view": "mfh.placement.view",
	"mfh.placement.create": "mfh.placement.create",
	"mfh.placement.edit": "mfh.placement.edit",
	"core.sign-off-envelope.create": "core.sign-off-envelope.create",
	"core.sign-off-envelope.cancel": "core.sign-off-envelope.cancel",
	"core.sign-off-envelope.view": "core.sign-off-envelope.view",
	"core.sign-off-envelope.delete": "core.sign-off-envelope.delete",
	"core.sign-off-envelope.list": "core.sign-off-envelope.list",
	"core.sign-off-envelope.edit": "core.sign-off-envelope.edit",
	"core.sign-off-envelope.trigger": "core.sign-off-envelope.trigger",
	"core.sign-off-comment.create": "core.sign-off-comment.create",
	"core.sign-off-comment.view": "core.sign-off-comment.view",
	"core.sign-off-comment.edit": "core.sign-off-comment.edit",
	"core.sign-off-comment.delete": "core.sign-off-comment.delete",
	"core.sign-off-template.create": "core.sign-off-template.create",
	"core.sign-off-template.edit": "core.sign-off-template.edit",
	"renovation.tendering-process.view": "renovation.tendering-process.view",
	"renovation.tendering-process.create": "renovation.tendering-process.create",
	"renovation.tendering-process.edit": "renovation.tendering-process.edit",
	"renovation.tendering-process.delete": "renovation.tendering-process.delete",
	"renovation.addendum.create": "renovation.addendum.create",
	"renovation.addendum.view": "renovation.addendum.view",
	"renovation.addendum.edit": "renovation.addendum.edit",
	"mfh.construction-plan.view": "mfh.construction-plan.view",
	"mfh.construction-plan.edit": "mfh.construction-plan.edit",
	"mfh.construction-plan-approval-matrix.edit": "mfh.construction-plan-approval-matrix.edit",
	"mfh.construction-plan.approve": "mfh.construction-plan.approve",
	"mfh.construction-plan.create": "mfh.construction-plan.create",
	"mfh.construction-plan.delete": "mfh.construction-plan.delete",
	"mfh.construction-plan.archive": "mfh.construction-plan.archive",
	"document.annotation.create": "document.annotation.create",
	"document.annotation.update": "document.annotation.update",
	"document.annotation.update-any": "document.annotation.update-any",
	"document.annotation.delete": "document.annotation.delete",
	"document.annotation.delete-any": "document.annotation.delete-any",
	"renovation.position-cost-allocation.create": "renovation.position-cost-allocation.create",
	"renovation.position-cost-allocation.view": "renovation.position-cost-allocation.view",
	"renovation.contract.view": "renovation.contract.view",
	"renovation.contract.create": "renovation.contract.create",
	"renovation.contract.edit": "renovation.contract.edit",
	"renovation.contract.delete": "renovation.contract.delete",
	"rental.rental-contract-review-process.create": "rental.rental-contract-review-process.create",
	"rental.rental-contract.view": "rental.rental-contract.view",
	"rental.rental-contract.create": "rental.rental-contract.create",
	"rental.rental-contract.edit": "rental.rental-contract.edit",
	"rental.rental-contract.delete": "rental.rental-contract.delete",
	"estate.sourcing.view": "estate.sourcing.view",
	"estate.inspection.review-process.view": "estate.inspection.review-process.view",
	"estate.inspection.review-process.create": "estate.inspection.review-process.create",
	"estate.inspection.review-process.edit": "estate.inspection.review-process.edit",
	"estate.sourcing-inspection.view": "estate.sourcing-inspection.view",
	"estate.sourcing-inspection.create": "estate.sourcing-inspection.create",
	"estate.sourcing-inspection.edit": "estate.sourcing-inspection.edit",
	"estate.sourcing-inspection.delete": "estate.sourcing-inspection.delete",
	"estate.sourcing-document-inspection.view": "estate.sourcing-document-inspection.view",
	"estate.sourcing-document-inspection.create": "estate.sourcing-document-inspection.create",
	"estate.sourcing-document-inspection.edit": "estate.sourcing-document-inspection.edit",
	"estate.sourcing-document-inspection.delete": "estate.sourcing-document-inspection.delete",
	"estate.market-details.view": "estate.market-details.view",
	"estate.market-details.edit": "estate.market-details.edit",
	"estate.predictions.view": "estate.predictions.view",
	"estate.sourcing-investmentcase.view": "estate.sourcing-investmentcase.view",
	"estate.sourcing-investmentcase.create": "estate.sourcing-investmentcase.create",
	"estate.sourcing-investmentcase.edit": "estate.sourcing-investmentcase.edit",
	"estate.sourcing-investmentcase.delete": "estate.sourcing-investmentcase.delete",
	"estate.sourcing-calendar.view": "estate.sourcing-calendar.view",
	"estate.sourcing-calendar.create": "estate.sourcing-calendar.create",
	"estate.sourcing-calendar.edit": "estate.sourcing-calendar.edit",
	"estate.sourcing-calendar.delete": "estate.sourcing-calendar.delete",
	"estate.sourcing-process.reset": "estate.sourcing-process.reset",
	"estate.sourcing-process.view": "estate.sourcing-process.view",
	"estate.sourcing-process.edit": "estate.sourcing-process.edit",
	"estate.purchasing.view": "estate.purchasing.view",
	"estate.purchasing-notes.view": "estate.purchasing-notes.view",
	"estate.purchasing-notes.edit": "estate.purchasing-notes.edit",
	"estate.purchasing-notes.create": "estate.purchasing-notes.create",
	"estate.purchasing-notes.delete": "estate.purchasing-notes.delete",
	"estate.purchasing-calendar.view": "estate.purchasing-calendar.view",
	"estate.purchasing-calendar.edit": "estate.purchasing-calendar.edit",
	"estate.purchasing-calendar.create": "estate.purchasing-calendar.create",
	"estate.purchasing-calendar.delete": "estate.purchasing-calendar.delete",
	"estate.purchasing-financing-info.view": "estate.purchasing-financing-info.view",
	"estate.purchasing-financing-info.edit": "estate.purchasing-financing-info.edit",
	"estate.purchasing-history.view": "estate.purchasing-history.view",
	"estate.purchasing-events.view": "estate.purchasing-events.view",
	"estate.purchasing-process.view": "estate.purchasing-process.view",
	"estate.purchasing-process.edit": "estate.purchasing-process.edit",
	"estate.renovation.view": "estate.renovation.view",
	"estate.renovation-summary.view": "estate.renovation-summary.view",
	"estate.renovation-inspection.view": "estate.renovation-inspection.view",
	"estate.renovation-inspection.edit": "estate.renovation-inspection.edit",
	"estate.renovation-inspection.create": "estate.renovation-inspection.create",
	"estate.renovation-inspection.send": "estate.renovation-inspection.send",
	"estate.renovation-inspection.pdf-generate": "estate.renovation-inspection.pdf-generate",
	"estate.renovation-inspection.delete": "estate.renovation-inspection.delete",
	"estate.renovation-inspection-notes.view": "estate.renovation-inspection-notes.view",
	"estate.renovation-inspection-notes.edit": "estate.renovation-inspection-notes.edit",
	"estate.renovation-inspection-notes.create": "estate.renovation-inspection-notes.create",
	"estate.renovation-inspection-notes.delete": "estate.renovation-inspection-notes.delete",
	"estate.renovation-craft-notes.view": "estate.renovation-craft-notes.view",
	"estate.renovation-craft-notes.edit": "estate.renovation-craft-notes.edit",
	"estate.renovation-craft-notes.create": "estate.renovation-craft-notes.create",
	"estate.renovation-craft-notes.delete": "estate.renovation-craft-notes.delete",
	"estate.renovation-catalogue.view": "estate.renovation-catalogue.view",
	"estate.renovation-catalogue.edit": "estate.renovation-catalogue.edit",
	"estate.renovation-catalogue.create": "estate.renovation-catalogue.create",
	"estate.renovation-catalogue.delete": "estate.renovation-catalogue.delete",
	"estate.renovation-catalogue-pricing.view": "estate.renovation-catalogue-pricing.view",
	"estate.renovation-catalogue-pricing.create": "estate.renovation-catalogue-pricing.create",
	"estate.renovation-catalogue-pricing.edit": "estate.renovation-catalogue-pricing.edit",
	"estate.renovation-catalogue-pricing.delete": "estate.renovation-catalogue-pricing.delete",
	"estate.renovation-contractors.view": "estate.renovation-contractors.view",
	"estate.renovation-milestones.view": "estate.renovation-milestones.view",
	"estate.renovation-milestones.edit": "estate.renovation-milestones.edit",
	"estate.renovation-calendar.view": "estate.renovation-calendar.view",
	"estate.renovation-calendar.edit": "estate.renovation-calendar.edit",
	"estate.renovation-calendar.create": "estate.renovation-calendar.create",
	"estate.renovation-calendar.delete": "estate.renovation-calendar.delete",
	"estate.renovation-dates.view": "estate.renovation-dates.view",
	"estate.renovation-history.view": "estate.renovation-history.view",
	"estate.renovation-events.view": "estate.renovation-events.view",
	"estate.renovation-elements.view": "estate.renovation-elements.view",
	"estate.renovation-elements.edit": "estate.renovation-elements.edit",
	"estate.renovation-elements.create": "estate.renovation-elements.create",
	"estate.renovation-elements.delete": "estate.renovation-elements.delete",
	"estate.renovation-elements.create-from-ifc": "estate.renovation-elements.create-from-ifc",
	"estate.renovation-elements.create-from-pred": "estate.renovation-elements.create-from-pred",
	"estate.renovation-ifc.view": "estate.renovation-ifc.view",
	"estate.renovation-constructionplan.view": "estate.renovation-constructionplan.view",
	"estate.renovation-constructionplan.edit": "estate.renovation-constructionplan.edit",
	"estate.renovation-constructionplan.create": "estate.renovation-constructionplan.create",
	"estate.renovation-constructionplan.edit-budget-origin": "estate.renovation-constructionplan.edit-budget-origin",
	"estate.renovation-constructionplan.actions-all": "estate.renovation-constructionplan.actions-all",
	"estate.renovation-constructionplan.delete": "estate.renovation-constructionplan.delete",
	"estate.renovation-constructionplan.pdf-generate": "estate.renovation-constructionplan.pdf-generate",
	"estate.renovation-constructionplan.send": "estate.renovation-constructionplan.send",
	"estate.renovation-constructionplan-overshoot.edit": "estate.renovation-constructionplan-overshoot.edit",
	"estate.construction-progress.edit": "estate.construction-progress.edit",
	"estate.construction-progress.create": "estate.construction-progress.create",
	"estate.construction-progress.view": "estate.construction-progress.view",
	"estate.renovation-defects.view": "estate.renovation-defects.view",
	"estate.renovation-defects.edit": "estate.renovation-defects.edit",
	"estate.renovation-defects.create": "estate.renovation-defects.create",
	"estate.renovation-defects.delete": "estate.renovation-defects.delete",
	"estate.renovation-defect-history.view": "estate.renovation-defect-history.view",
	"estate.renovation-process.view": "estate.renovation-process.view",
	"estate.renovation-process.edit": "estate.renovation-process.edit",
	"estate.renovation-position.view": "estate.renovation-position.view",
	"estate.renovation-position.edit": "estate.renovation-position.edit",
	"estate.renovation-position.create": "estate.renovation-position.create",
	"estate.renovation-position.delete": "estate.renovation-position.delete",
	"estate.renovation-position.history": "estate.renovation-position.history",
	"estate.renting.view": "estate.renting.view",
	"estate.renting-dates.view": "estate.renting-dates.view",
	"estate.renting-calendar.view": "estate.renting-calendar.view",
	"estate.renting-calendar.edit": "estate.renting-calendar.edit",
	"estate.renting-calendar.create": "estate.renting-calendar.create",
	"estate.renting-calendar.delete": "estate.renting-calendar.delete",
	"estate.renting-history.view": "estate.renting-history.view",
	"estate.renting-listing.view": "estate.renting-listing.view",
	"estate.renting-listing.create": "estate.renting-listing.create",
	"estate.renting-listing.edit": "estate.renting-listing.edit",
	"estate.renting-listing.delete": "estate.renting-listing.delete",
	"estate.renting-listing.prepublish": "estate.renting-listing.prepublish",
	"estate.renting-listing.publish": "estate.renting-listing.publish",
	"estate.renting-listing.unpublish": "estate.renting-listing.unpublish",
	"estate.renting-listing.open-immo-download": "estate.renting-listing.open-immo-download",
	"estate.renting-lead.view": "estate.renting-lead.view",
	"estate.renting-lead.create": "estate.renting-lead.create",
	"estate.renting-lead.edit": "estate.renting-lead.edit",
	"estate.renting-lead.delete": "estate.renting-lead.delete",
	"estate.renting-events.view": "estate.renting-events.view",
	"estate.renting-process.view": "estate.renting-process.view",
	"estate.renting-process.edit": "estate.renting-process.edit",
	"estate.renting-contract.approve": "estate.renting-contract.approve",
	"estate.livings-check.view": "estate.livings-check.view",
	"estate.livings-check.edit": "estate.livings-check.edit",
	"estate.livings-check.create": "estate.livings-check.create",
	"estate.selling.view": "estate.selling.view",
	"estate.selling.edit": "estate.selling.edit",
	"estate.selling-dates.view": "estate.selling-dates.view",
	"estate.selling-documents.create": "estate.selling-documents.create",
	"estate.selling-notes.view": "estate.selling-notes.view",
	"estate.selling-notes.create": "estate.selling-notes.create",
	"estate.selling-notes.edit": "estate.selling-notes.edit",
	"estate.selling-notes.delete": "estate.selling-notes.delete",
	"estate.selling-calendar.view": "estate.selling-calendar.view",
	"estate.selling-calendar.edit": "estate.selling-calendar.edit",
	"estate.selling-calendar.create": "estate.selling-calendar.create",
	"estate.selling-calendar.delete": "estate.selling-calendar.delete",
	"estate.selling-history.view": "estate.selling-history.view",
	"estate.selling-events.view": "estate.selling-events.view",
	"estate.selling-investmentcase.view": "estate.selling-investmentcase.view",
	"estate.selling-investmentcase.create": "estate.selling-investmentcase.create",
	"estate.selling-investmentcase.edit": "estate.selling-investmentcase.edit",
	"estate.selling-investmentcase.delete": "estate.selling-investmentcase.delete",
	"estate.investmentcase.edit": "estate.investmentcase.edit",
	"estate.ict-investmentcase.view": "estate.ict-investmentcase.view",
	"estate.ict-investmentcase.create": "estate.ict-investmentcase.create",
	"estate.ict-investmentcase.execute": "estate.ict-investmentcase.execute",
	"estate.ict-investmentcase.edit": "estate.ict-investmentcase.edit",
	"estate.ict-investmentcase.delete": "estate.ict-investmentcase.delete",
	"estate.selling-process.view": "estate.selling-process.view",
	"estate.selling-process.edit": "estate.selling-process.edit",
	"estate.selling-process.paid": "estate.selling-process.paid",
	"estate.property-management.view": "estate.property-management.view",
	"estate.property-management.edit": "estate.property-management.edit",
	"estate.property-management.delete": "estate.property-management.delete",
	"estate.property-management-rent.view": "estate.property-management-rent.view",
	"estate.property-management-rent.edit": "estate.property-management-rent.edit",
	"estate.propertymanagement-active-past-rent.edit": "estate.propertymanagement-active-past-rent.edit",
	"estate.property-management-rent.create": "estate.property-management-rent.create",
	"estate.property-management-rent.delete": "estate.property-management-rent.delete",
	"estate.propertymanagement-tenancy.view": "estate.propertymanagement-tenancy.view",
	"estate.propertymanagement-tenancy.edit": "estate.propertymanagement-tenancy.edit",
	"estate.propertymanagement-active-past-tenancy.edit": "estate.propertymanagement-active-past-tenancy.edit",
	"estate.propertymanagement-tenancy.create": "estate.propertymanagement-tenancy.create",
	"estate.propertymanagement-tenancy.delete": "estate.propertymanagement-tenancy.delete",
	"estate.propertymanagement-owner.view": "estate.propertymanagement-owner.view",
	"estate.propertymanagement-owner.create": "estate.propertymanagement-owner.create",
	"estate.propertymanagement-owner.edit": "estate.propertymanagement-owner.edit",
	"estate.propertymanagement-owner-annual-statement.view": "estate.propertymanagement-owner-annual-statement.view",
	"estate.propertymanagement-owner-annual-statement.create": "estate.propertymanagement-owner-annual-statement.create",
	"estate.propertymanagement-owner-annual-statement.edit": "estate.propertymanagement-owner-annual-statement.edit",
	"estate.propertymanagement-owner-annual-statement.delete": "estate.propertymanagement-owner-annual-statement.delete",
	"estate.propertymanagement-annual-service-charges.view": "estate.propertymanagement-annual-service-charges.view",
	"estate.propertymanagement-annual-service-charges.create": "estate.propertymanagement-annual-service-charges.create",
	"estate.propertymanagement-annual-service-charges.edit": "estate.propertymanagement-annual-service-charges.edit",
	"estate.propertymanagement-annual-service-charges.delete": "estate.propertymanagement-annual-service-charges.delete",
	"estate.property-management-notes.view": "estate.property-management-notes.view",
	"estate.property-management-notes.edit": "estate.property-management-notes.edit",
	"estate.property-management-notes.create": "estate.property-management-notes.create",
	"estate.property-management-notes.delete": "estate.property-management-notes.delete",
	"estate.propertymanagement-meters.view": "estate.propertymanagement-meters.view",
	"estate.propertymanagement-meters.create": "estate.propertymanagement-meters.create",
	"estate.propertymanagement-meters.edit": "estate.propertymanagement-meters.edit",
	"estate.propertymanagement-meters.delete": "estate.propertymanagement-meters.delete",
	"estate.propertymanagement-calendar.view": "estate.propertymanagement-calendar.view",
	"estate.propertymanagement-calendar.create": "estate.propertymanagement-calendar.create",
	"estate.propertymanagement-calendar.edit": "estate.propertymanagement-calendar.edit",
	"estate.propertymanagement-calendar.delete": "estate.propertymanagement-calendar.delete",
	"estate.propertymanagement-hoa-fee.view": "estate.propertymanagement-hoa-fee.view",
	"estate.propertymanagement-hoa-fee.create": "estate.propertymanagement-hoa-fee.create",
	"estate.propertymanagement-hoa-fee.edit": "estate.propertymanagement-hoa-fee.edit",
	"estate.propertymanagement-hoa-fee.delete": "estate.propertymanagement-hoa-fee.delete",
	"estate.propertymanagement-process.view": "estate.propertymanagement-process.view",
	"estate.propertymanagement-process.edit": "estate.propertymanagement-process.edit",
	"estate.propertymanagement-meter-reading.create": "estate.propertymanagement-meter-reading.create",
	"estate.propertymanagement-meter-reading.delete": "estate.propertymanagement-meter-reading.delete",
	"estate.propertymanagement-tasks.view": "estate.propertymanagement-tasks.view",
	"estate.propertymanagement-tasks.edit": "estate.propertymanagement-tasks.edit",
	"estate.property-management-events.view": "estate.property-management-events.view",
	"estate.property-management-process.future-house-geld": "estate.property-management-process.future-house-geld",
	"estate.tenant-management-process.create": "estate.tenant-management-process.create",
	"estate.tenant-management-process.view": "estate.tenant-management-process.view",
	"estate.tenant-management-process.edit": "estate.tenant-management-process.edit",
	"estate.tenant-management-process.delete": "estate.tenant-management-process.delete",
	"estate.tenant-management-process-events.view": "estate.tenant-management-process-events.view",
	"estate.tenant-management-investor-info-special-deal.edit": "estate.tenant-management-investor-info-special-deal.edit",
	"estate.tenant-management-monthly-investor-info.edit": "estate.tenant-management-monthly-investor-info.edit",
	"estate.owner-management-process.create": "estate.owner-management-process.create",
	"estate.owner-management-process.view": "estate.owner-management-process.view",
	"estate.owner-management-process.edit": "estate.owner-management-process.edit",
	"estate.owner-management-process.delete": "estate.owner-management-process.delete",
	"estate.owner-management-process-events.view": "estate.owner-management-process-events.view",
	"estate.estate-management-process.create": "estate.estate-management-process.create",
	"estate.estate-management-process.view": "estate.estate-management-process.view",
	"estate.estate-management-process.edit": "estate.estate-management-process.edit",
	"estate.estate-management-process.delete": "estate.estate-management-process.delete",
	"estate.estate-management-process-events.view": "estate.estate-management-process-events.view",
	"estate.payment-notice-summary.create": "estate.payment-notice-summary.create",
	"estate.payment-notice-summary.edit": "estate.payment-notice-summary.edit",
	"estate.payment-notice-summary.view": "estate.payment-notice-summary.view",
	"finance.general-ledger-entries.view": "finance.general-ledger-entries.view",
	"finance.general-ledger-entries.edit": "finance.general-ledger-entries.edit",
	"finance.general-ledger-entries.create": "finance.general-ledger-entries.create",
	"finance.general-ledger-entries.delete": "finance.general-ledger-entries.delete",
	"finance.general-ledger-entries.recover": "finance.general-ledger-entries.recover",
	"finance.general-ledger-statements.view": "finance.general-ledger-statements.view",
	"finance.general-ledger-statements.create": "finance.general-ledger-statements.create",
	"finance.sepa-mandate.view": "finance.sepa-mandate.view",
	"finance.sepa-mandate.edit": "finance.sepa-mandate.edit",
	"finance.sepa-mandate.create": "finance.sepa-mandate.create",
	"finance.sepa-mandate.delete": "finance.sepa-mandate.delete",
	"finance.payment-order.export": "finance.payment-order.export",
	"finance.payment-order.view": "finance.payment-order.view",
	"finance.payment-order.update": "finance.payment-order.update",
	"finance.payment-order.create": "finance.payment-order.create",
	"finance.eligible-estates.list": "finance.eligible-estates.list",
	"finance.portfolio.list": "finance.portfolio.list",
	"finance.portfolio.view": "finance.portfolio.view",
	"finance.portfolio.create": "finance.portfolio.create",
	"finance.portfolio.edit": "finance.portfolio.edit",
	"finance.portfolio.delete": "finance.portfolio.delete",
	"finance.portfolio-summary.view": "finance.portfolio-summary.view",
	"finance.portfolio.prepared": "finance.portfolio.prepared",
	"finance.portfolio.revert": "finance.portfolio.revert",
	"finance.portfolio.offer-accepted": "finance.portfolio.offer-accepted",
	"finance.portfolio.loan-created": "finance.portfolio.loan-created",
	"finance.portfolio.actions-all": "finance.portfolio.actions-all",
	"finance.portfolio-document.create": "finance.portfolio-document.create",
	"finance.portfolio-documents.view": "finance.portfolio-documents.view",
	"finance.portfolio-document-folder.generate": "finance.portfolio-document-folder.generate",
	"finance.portfolio-financing-banks.list": "finance.portfolio-financing-banks.list",
	"finance.portfolio-eligible-estates.list": "finance.portfolio-eligible-estates.list",
	"finance.portfolio-loan-offer.view": "finance.portfolio-loan-offer.view",
	"finance.portfolio-loan-offer.create": "finance.portfolio-loan-offer.create",
	"finance.portfolio-loan-offer.edit": "finance.portfolio-loan-offer.edit",
	"finance.portfolio-loan-offer.delete": "finance.portfolio-loan-offer.delete",
	"finance.portfolio-loan-offer.accept": "finance.portfolio-loan-offer.accept",
	"finance.portfolio-notes.view": "finance.portfolio-notes.view",
	"finance.portfolio-notes.create": "finance.portfolio-notes.create",
	"finance.portfolio-notes.delete": "finance.portfolio-notes.delete",
	"finance.loan-application.create": "finance.loan-application.create",
	"finance.loan-account-balance.recalculate": "finance.loan-account-balance.recalculate",
	"finance.tendering.view": "finance.tendering.view",
	"finance.tendering.edit": "finance.tendering.edit",
	"finance.tendering.delete": "finance.tendering.delete",
	"finance.portfolio-history.view": "finance.portfolio-history.view",
	"finance.invoice-history.view": "finance.invoice-history.view",
	"finance.invoice.export": "finance.invoice.export",
	"finance.invoice.list": "finance.invoice.list",
	"finance.invoice.view": "finance.invoice.view",
	"finance.invoice.view.recurrent-payments": "finance.invoice.view.recurrent-payments",
	"finance.invoice.view-all": "finance.invoice.view-all",
	"finance.invoice.view-livings": "finance.invoice.view-livings",
	"finance.invoice.create": "finance.invoice.create",
	"finance.invoice-reminder.create": "finance.invoice-reminder.create",
	"finance.invoice.edit": "finance.invoice.edit",
	"finance.invoice.delete": "finance.invoice.delete",
	"finance.invoice.assign": "finance.invoice.assign",
	"finance.invoice.approve": "finance.invoice.approve",
	"finance.invoice.authorize": "finance.invoice.authorize",
	"finance.invoice.reject": "finance.invoice.reject",
	"finance.invoice.actions-all": "finance.invoice.actions-all",
	"finance.invoice.reset": "finance.invoice.reset",
	"finance.invoice.force-reject": "finance.invoice.force-reject",
	"finance.invoice-notes.view": "finance.invoice-notes.view",
	"finance.invoice-notes.create": "finance.invoice-notes.create",
	"finance.invoice-notes.edit": "finance.invoice-notes.edit",
	"finance.invoice-notes.delete": "finance.invoice-notes.delete",
	"finance.invoice.overwrite": "finance.invoice.overwrite",
	"finance.invoice.review-process.view": "finance.invoice.review-process.view",
	"finance.invoice.review-process.create": "finance.invoice.review-process.create",
	"finance.invoice.review-process.edit": "finance.invoice.review-process.edit",
	"finance.invoice-subscription.list": "finance.invoice-subscription.list",
	"finance.invoice-subscription.view": "finance.invoice-subscription.view",
	"finance.invoice-subscription.create": "finance.invoice-subscription.create",
	"finance.invoice-subscription.edit": "finance.invoice-subscription.edit",
	"finance.invoice-subscription.delete": "finance.invoice-subscription.delete",
	"finance.invoice-subscription-document.create": "finance.invoice-subscription-document.create",
	"finance.invoice-subscription-invoices.generate": "finance.invoice-subscription-invoices.generate",
	"finance.bank-transaction.list": "finance.bank-transaction.list",
	"finance.bank-transaction.view": "finance.bank-transaction.view",
	"finance.bank-transaction.edit": "finance.bank-transaction.edit",
	"finance.bank-transaction.delete": "finance.bank-transaction.delete",
	"finance.bank-transaction.book": "finance.bank-transaction.book",
	"finance.credit-line-portfolio.create": "finance.credit-line-portfolio.create",
	"finance.credit-line-portfolio.view": "finance.credit-line-portfolio.view",
	"finance.credit-line-portfolio.edit": "finance.credit-line-portfolio.edit",
	"finance.credit-line-portfolio.delete": "finance.credit-line-portfolio.delete",
	"finance.cash-flow-predictions.create": "finance.cash-flow-predictions.create",
	"finance.investor-cashflow.view": "finance.investor-cashflow.view",
	"finance.investor-cashflow.create": "finance.investor-cashflow.create",
	"finance.investor-cashflow.edit": "finance.investor-cashflow.edit",
	"finance.sales-package.create": "finance.sales-package.create",
	"finance.sales-package.view": "finance.sales-package.view",
	"finance.sales-package.edit": "finance.sales-package.edit",
	"finance.sales-package-estate.add": "finance.sales-package-estate.add",
	"finance.sales-package-estate.delete": "finance.sales-package-estate.delete",
	"finance.sales-package-review-process.create": "finance.sales-package-review-process.create",
	"finance.sales-package-review-process.view": "finance.sales-package-review-process.view",
	"finance.sales-package-notes.create": "finance.sales-package-notes.create",
	"finance.sales-package-notes.delete": "finance.sales-package-notes.delete",
	"finance.sales-package-notes.view": "finance.sales-package-notes.view",
	"finance.sales-package-history.view": "finance.sales-package-history.view",
	"finance.payment-notice-summary.approve": "finance.payment-notice-summary.approve",
	"finance.payment-notice-summary.set-as-ready-for-review": "finance.payment-notice-summary.set-as-ready-for-review",
	"finance.special-deal.view": "finance.special-deal.view",
	"finance.special-deal.create": "finance.special-deal.create",
	"finance.special-deal.edit": "finance.special-deal.edit",
	"finance.estate.edit.is-special-deal-locked": "finance.estate.edit.is-special-deal-locked",
	"core.document.view": "core.document.view",
	"core.accounting.view": "core.accounting.view",
	"core.contact.view": "core.contact.view",
	"core.contact.list": "core.contact.list",
	"core.contact.create": "core.contact.create",
	"core.contact.edit": "core.contact.edit",
	"core.contact.delete": "core.contact.delete",
	"core.contact.merge": "core.contact.merge",
	"core.contact-estates.view": "core.contact-estates.view",
	"core.contact-documents.view": "core.contact-documents.view",
	"core.contact-document.upload": "core.contact-document.upload",
	"core.contact-documents.edit": "core.contact-documents.edit",
	"core.contact-document.delete": "core.contact-document.delete",
	"core.contact-invoices.view": "core.contact-invoices.view",
	"core.contact-notes.create": "core.contact-notes.create",
	"core.contact-notes.view": "core.contact-notes.view",
	"core.contact-notes.delete": "core.contact-notes.delete",
	"core.contact-bank-accounts.view": "core.contact-bank-accounts.view",
	"core.contact-bank-account.create": "core.contact-bank-account.create",
	"core.contact-accounting.edit": "core.contact-accounting.edit",
	"core.company.view": "core.company.view",
	"core.company.list": "core.company.list",
	"core.company-purchasing-entity.list": "core.company-purchasing-entity.list",
	"core.company-distribution-partner.list": "core.company-distribution-partner.list",
	"core.company-bank.list": "core.company-bank.list",
	"core.company.create": "core.company.create",
	"core.company.edit": "core.company.edit",
	"core.company.delete": "core.company.delete",
	"core.company-estates.view": "core.company-estates.view",
	"core.company-contacts.view": "core.company-contacts.view",
	"core.company-contacts.create": "core.company-contacts.create",
	"core.company-contacts.edit": "core.company-contacts.edit",
	"core.company-contacts.delete": "core.company-contacts.delete",
	"core.company-contractor-capacity.view": "core.company-contractor-capacity.view",
	"core.company-contractor-capacity.edit": "core.company-contractor-capacity.edit",
	"core.company-contractor-agreed-capacity.edit": "core.company-contractor-agreed-capacity.edit",
	"core.company-documents.view": "core.company-documents.view",
	"core.company-document.upload": "core.company-document.upload",
	"core.company-document.edit": "core.company-document.edit",
	"core.company-document.delete": "core.company-document.delete",
	"core.company-invoices.view": "core.company-invoices.view",
	"core.company-notes.view": "core.company-notes.view",
	"core.company-notes.create": "core.company-notes.create",
	"core.company-notes.delete": "core.company-notes.delete",
	"core.company-bank-accounts.view": "core.company-bank-accounts.view",
	"core.company-bank-account.create": "core.company-bank-account.create",
	"core.company-accounting.edit": "core.company-accounting.edit",
	"core.process.view": "core.process.view",
	"core.process.list": "core.process.list",
	"core.process.edit": "core.process.edit",
	"core.process.create": "core.process.create",
	"core.company-employment.create": "core.company-employment.create",
	"core.company-employment.delete": "core.company-employment.delete",
	"core.task.list": "core.task.list",
	"core.task.edit": "core.task.edit",
	"core.task.create": "core.task.create",
	"core.task.delete": "core.task.delete",
	"core.task-template.list": "core.task-template.list",
	"core.task-template.edit": "core.task-template.edit",
	"core.task-template.create": "core.task-template.create",
	"core.task-template.delete": "core.task-template.delete",
	"core.file.get": "core.file.get",
	"core.calendar.view": "core.calendar.view",
	"core.calendar.subscribe-all": "core.calendar.subscribe-all",
	"core.calendar.subscribe-sourcing": "core.calendar.subscribe-sourcing",
	"core.calendar.subscribe-purchasing": "core.calendar.subscribe-purchasing",
	"core.calendar.subscribe-renovation": "core.calendar.subscribe-renovation",
	"core.calendar.subscribe-renting": "core.calendar.subscribe-renting",
	"core.calendar.subscribe-selling": "core.calendar.subscribe-selling",
	"core.calendar.subscribe-propertymanagement": "core.calendar.subscribe-propertymanagement",
	"core.basecamp-maintenance.run": "core.basecamp-maintenance.run",
	"core.basecamp-maintenance.estate-export": "core.basecamp-maintenance.estate-export",
	"core.review-process.create": "core.review-process.create",
	"core.review-process.view": "core.review-process.view",
	"core.review-process.edit": "core.review-process.edit",
	"core.review-process.delete": "core.review-process.delete",
	"core.review-process.process": "core.review-process.process",
	"portfolio.review-process.create": "portfolio.review-process.create",
	"portfolio.review-process.view": "portfolio.review-process.view",
	"portfolio.review-process.edit": "portfolio.review-process.edit",
	"portfolio.review-process.delete": "portfolio.review-process.delete",
	"portfolio.review-process.process": "portfolio.review-process.process",
	"investment-case.review-process.create": "investment-case.review-process.create",
	"investment-case.review-process.view": "investment-case.review-process.view",
	"investment-case.review-process.edit": "investment-case.review-process.edit",
	"investment-case.review-process.delete": "investment-case.review-process.delete",
	"investment-case.review-process.process": "investment-case.review-process.process",
	"construction-plan.review-process.create": "construction-plan.review-process.create",
	"construction-plan.review-process.view": "construction-plan.review-process.view",
	"construction-plan.review-process.edit": "construction-plan.review-process.edit",
	"construction-plan.review-process.delete": "construction-plan.review-process.delete",
	"construction-plan.review-process.process": "construction-plan.review-process.process",
	"authz.permission.view": "authz.permission.view",
	"authz.role-binding.view": "authz.role-binding.view",
	"authz.role-binding.edit": "authz.role-binding.edit",
	"authz.role-binding.create": "authz.role-binding.create",
	"authz.role-binding.delete": "authz.role-binding.delete",
	"authz.role-binding.impersonate": "authz.role-binding.impersonate",
	"authz.role.edit": "authz.role.edit",
	"authz.role.create": "authz.role.create",
	"authz.role.delete": "authz.role.delete",
	"authz.user.view": "authz.user.view",
	"authz.user.edit": "authz.user.edit",
	"authz.user.create": "authz.user.create",
	"authz.user.delete": "authz.user.delete",
	"external.dashboard.view": "external.dashboard.view",
	"administration.internal-user.create": "administration.internal-user.create",
	"administration.external-user.create": "administration.external-user.create",
	"administration.rules.view": "administration.rules.view",
	"administration.rules.edit": "administration.rules.edit",
	"administration.rules.delete": "administration.rules.delete",
	"administration.rules.create": "administration.rules.create",
	"administration.user-company-functions.view": "administration.user-company-functions.view",
	"administration.user-company-functions.edit": "administration.user-company-functions.edit",
	"administration.user-company-functions.delete": "administration.user-company-functions.delete",
	"administration.location.view": "administration.location.view",
	"administration.location.edit": "administration.location.edit",
	"administration.location.create": "administration.location.create",
	"administration.location-profile.edit": "administration.location-profile.edit",
	"administration.location-profile.delete": "administration.location-profile.delete",
	"administration.ledger.view": "administration.ledger.view",
	"administration.ledger-entry.create": "administration.ledger-entry.create",
	"administration.ledger.recover": "administration.ledger.recover",
	"administration.renovation-inspection-questions.create": "administration.renovation-inspection-questions.create",
	"administration.renovation-inspection-questions.edit": "administration.renovation-inspection-questions.edit",
	"administration.renovation-inspection-questions.delete": "administration.renovation-inspection-questions.delete",
	"administration.loan-account.edit": "administration.loan-account.edit",
	"administration.loan-account.delete": "administration.loan-account.delete",
	"administration.loan-account.view": "administration.loan-account.view",
	"administration.loan-account.create": "administration.loan-account.create",
	"administration.bank-account.edit": "administration.bank-account.edit",
	"administration.bank-account.delete": "administration.bank-account.delete",
	"administration.bank-account.view": "administration.bank-account.view",
	"administration.bank-account.create": "administration.bank-account.create",
	"administration.bank-account-transaction.create": "administration.bank-account-transaction.create",
	"administration.bank-account-transaction.delete": "administration.bank-account-transaction.delete",
	"administration.loan-account-drawdown.create": "administration.loan-account-drawdown.create",
	"administration.loan-account-drawdown.delete": "administration.loan-account-drawdown.delete",
	"administration.loan-account-drawdown.receive": "administration.loan-account-drawdown.receive",
	"administration.investor-statement.create": "administration.investor-statement.create"
};
//#endregion
//#region src/basecamp/gen/models/authzModels/CreateRole.ts
const RolePermissions2 = {
	"agent.chat.view-any": "agent.chat.view-any",
	"agent.feedback.manage": "agent.feedback.manage",
	"spotlight.catalogue.manage": "spotlight.catalogue.manage",
	"spotlight.report.view": "spotlight.report.view",
	"estate.estate.view": "estate.estate.view",
	"estate.estate.edit": "estate.estate.edit",
	"estate.estate.create": "estate.estate.create",
	"estate.estate.delete": "estate.estate.delete",
	"estate.attributes.view": "estate.attributes.view",
	"estate.attributes.edit": "estate.attributes.edit",
	"estate.notes.view": "estate.notes.view",
	"estate.notes.create": "estate.notes.create",
	"estate.notes.edit": "estate.notes.edit",
	"estate.notes.delete": "estate.notes.delete",
	"estate.location.view": "estate.location.view",
	"estate.location.edit": "estate.location.edit",
	"estate.contacts.view": "estate.contacts.view",
	"estate.contacts.create": "estate.contacts.create",
	"estate.contacts.delete": "estate.contacts.delete",
	"estate.credentials.view": "estate.credentials.view",
	"estate.credentials.create": "estate.credentials.create",
	"estate.credentials.delete": "estate.credentials.delete",
	"estate.document.view": "estate.document.view",
	"estate.document.upload": "estate.document.upload",
	"estate.document.download": "estate.document.download",
	"estate.document.edit": "estate.document.edit",
	"estate.documents.delete": "estate.documents.delete",
	"estate.documents.create": "estate.documents.create",
	"estate.documents.send": "estate.documents.send",
	"core.data-room.create": "core.data-room.create",
	"core.data-room.edit": "core.data-room.edit",
	"core.data-room.delete": "core.data-room.delete",
	"core.data-room.view": "core.data-room.view",
	"estate.media.view": "estate.media.view",
	"estate.media.edit": "estate.media.edit",
	"estate.media.create": "estate.media.create",
	"estate.media.delete": "estate.media.delete",
	"estate.tasks.view": "estate.tasks.view",
	"estate.tasks.edit": "estate.tasks.edit",
	"estate.tasks.create": "estate.tasks.create",
	"estate.tasks.delete": "estate.tasks.delete",
	"estate.find-transaction-monitoring-estates.view": "estate.find-transaction-monitoring-estates.view",
	"estate.controlling.view": "estate.controlling.view",
	"estate.calendar.view": "estate.calendar.view",
	"estate.calendar.edit": "estate.calendar.edit",
	"estate.calendar.create": "estate.calendar.create",
	"estate.calendar.delete": "estate.calendar.delete",
	"estate.events.view": "estate.events.view",
	"estate.prediction.recalculate": "estate.prediction.recalculate",
	"mfh.contacts.list": "mfh.contacts.list",
	"mfh.contacts.create": "mfh.contacts.create",
	"mfh.impersonate.asset-partner": "mfh.impersonate.asset-partner",
	"mfh.mfh.view": "mfh.mfh.view",
	"mfh.mfh.edit": "mfh.mfh.edit",
	"mfh.mfh.delete": "mfh.mfh.delete",
	"mfh.mfh.create": "mfh.mfh.create",
	"mfh.mfh.bulk-create": "mfh.mfh.bulk-create",
	"mfh.capex-ee-config.view": "mfh.capex-ee-config.view",
	"mfh.capex-ee-config.create": "mfh.capex-ee-config.create",
	"mfh.capex-ee-config.edit": "mfh.capex-ee-config.edit",
	"mfh.capex-ee-config.delete": "mfh.capex-ee-config.delete",
	"mfh.capex-ee-scenario.view": "mfh.capex-ee-scenario.view",
	"mfh.capex-ee-scenario.edit": "mfh.capex-ee-scenario.edit",
	"mfh.capex-ee-scenario.create": "mfh.capex-ee-scenario.create",
	"mfh.capex-ee-scenario.delete": "mfh.capex-ee-scenario.delete",
	"mfh.estar-core-id.edit": "mfh.estar-core-id.edit",
	"mfh.events.view": "mfh.events.view",
	"mfh.attributes.view": "mfh.attributes.view",
	"mfh.attributes.edit": "mfh.attributes.edit",
	"mfh.renovation-attributes.edit": "mfh.renovation-attributes.edit",
	"mfh.location.view": "mfh.location.view",
	"mfh.location.edit": "mfh.location.edit",
	"mfh.tasks.view": "mfh.tasks.view",
	"mfh.tasks.edit": "mfh.tasks.edit",
	"mfh.tasks.create": "mfh.tasks.create",
	"mfh.tasks.delete": "mfh.tasks.delete",
	"mfh.project-planning.view": "mfh.project-planning.view",
	"mfh.project-planning.edit": "mfh.project-planning.edit",
	"mfh.project-planning.create": "mfh.project-planning.create",
	"mfh.project-planning.delete": "mfh.project-planning.delete",
	"mfh.calendar.view": "mfh.calendar.view",
	"mfh.calendar.edit": "mfh.calendar.edit",
	"mfh.calendar.create": "mfh.calendar.create",
	"mfh.calendar.delete": "mfh.calendar.delete",
	"mfh.document.view": "mfh.document.view",
	"mfh.document.edit": "mfh.document.edit",
	"mfh.document.upload": "mfh.document.upload",
	"mfh.document.delete": "mfh.document.delete",
	"mfh.renovation-project-config.edit": "mfh.renovation-project-config.edit",
	"mfh.renovation-project.create": "mfh.renovation-project.create",
	"mfh.renovation-project.view": "mfh.renovation-project.view",
	"mfh.renovation-project.edit": "mfh.renovation-project.edit",
	"mfh.renovation-project.delete": "mfh.renovation-project.delete",
	"mfh.renovation-project.review-process.create": "mfh.renovation-project.review-process.create",
	"mfh.renovation-project.review-process.view": "mfh.renovation-project.review-process.view",
	"mfh.renovation-project.review-process.edit": "mfh.renovation-project.review-process.edit",
	"mfh.renovation-project.review-process.process": "mfh.renovation-project.review-process.process",
	"mfh.renovation-project-planning-module.delete": "mfh.renovation-project-planning-module.delete",
	"mfh.renovation-project-position.delete": "mfh.renovation-project-position.delete",
	"mfh.renovation-event.history.view": "mfh.renovation-event.history.view",
	"mfh.renovation-project-lot.delete": "mfh.renovation-project-lot.delete",
	"mfh.elements.create": "mfh.elements.create",
	"mfh.elements.edit": "mfh.elements.edit",
	"mfh.elements.view": "mfh.elements.view",
	"mfh.elements.delete": "mfh.elements.delete",
	"mfh.media.view": "mfh.media.view",
	"mfh.media.edit": "mfh.media.edit",
	"mfh.notes.view": "mfh.notes.view",
	"mfh.notes.create": "mfh.notes.create",
	"mfh.notes.edit": "mfh.notes.edit",
	"mfh.notes.delete": "mfh.notes.delete",
	"mfh.dd.view": "mfh.dd.view",
	"mfh.dd.edit": "mfh.dd.edit",
	"mfh.infas.fetch": "mfh.infas.fetch",
	"mfh.syte.fetch": "mfh.syte.fetch",
	"mfh.syte.debug": "mfh.syte.debug",
	"mfh.investment-case.view": "mfh.investment-case.view",
	"mfh.investment-case.create": "mfh.investment-case.create",
	"mfh.investment-case.edit": "mfh.investment-case.edit",
	"mfh.investment-case.export": "mfh.investment-case.export",
	"mfh.investment-case.upload": "mfh.investment-case.upload",
	"mfh.investment-case.delete": "mfh.investment-case.delete",
	"mfh.investment-case.restore": "mfh.investment-case.restore",
	"mfh.investment-case-admin-input.edit": "mfh.investment-case-admin-input.edit",
	"mfh.asset-analyzer.view": "mfh.asset-analyzer.view",
	"mfh.asset-analyzer.edit-any": "mfh.asset-analyzer.edit-any",
	"mfh.investment-case.copy-as-json": "mfh.investment-case.copy-as-json",
	"mfh.investment-case.paste-as-json": "mfh.investment-case.paste-as-json",
	"mfh.investment-case-review-process.create": "mfh.investment-case-review-process.create",
	"mfh.investment-case-review-process.view": "mfh.investment-case-review-process.view",
	"mfh.investment-case-review-process.edit": "mfh.investment-case-review-process.edit",
	"mfh.investment-case-review-process.process": "mfh.investment-case-review-process.process",
	"mfh-portfolio.process.trigger": "mfh-portfolio.process.trigger",
	"mfh.portfolio-review-process.create": "mfh.portfolio-review-process.create",
	"mfh.portfolio-review-process.view": "mfh.portfolio-review-process.view",
	"mfh.portfolio-review-process.edit": "mfh.portfolio-review-process.edit",
	"mfh.portfolio-review-process.process": "mfh.portfolio-review-process.process",
	"mfh-portfolio.tasks.view": "mfh-portfolio.tasks.view",
	"mfh-portfolio.tasks.edit": "mfh-portfolio.tasks.edit",
	"mfh-portfolio.tasks.create": "mfh-portfolio.tasks.create",
	"mfh-portfolio.tasks.delete": "mfh-portfolio.tasks.delete",
	"mfh.prediction.view": "mfh.prediction.view",
	"mfh.prediction.create": "mfh.prediction.create",
	"mfh.prediction.edit": "mfh.prediction.edit",
	"mfh.prediction.delete": "mfh.prediction.delete",
	"mfh.rent-roll.import": "mfh.rent-roll.import",
	"mfh.rent-roll-version.view": "mfh.rent-roll-version.view",
	"mfh.rent-roll-version.create": "mfh.rent-roll-version.create",
	"mfh.rent-roll-version.edit": "mfh.rent-roll-version.edit",
	"mfh.rent-roll-version.delete": "mfh.rent-roll-version.delete",
	"mfh.placement.view": "mfh.placement.view",
	"mfh.placement.create": "mfh.placement.create",
	"mfh.placement.edit": "mfh.placement.edit",
	"core.sign-off-envelope.create": "core.sign-off-envelope.create",
	"core.sign-off-envelope.cancel": "core.sign-off-envelope.cancel",
	"core.sign-off-envelope.view": "core.sign-off-envelope.view",
	"core.sign-off-envelope.delete": "core.sign-off-envelope.delete",
	"core.sign-off-envelope.list": "core.sign-off-envelope.list",
	"core.sign-off-envelope.edit": "core.sign-off-envelope.edit",
	"core.sign-off-envelope.trigger": "core.sign-off-envelope.trigger",
	"core.sign-off-comment.create": "core.sign-off-comment.create",
	"core.sign-off-comment.view": "core.sign-off-comment.view",
	"core.sign-off-comment.edit": "core.sign-off-comment.edit",
	"core.sign-off-comment.delete": "core.sign-off-comment.delete",
	"core.sign-off-template.create": "core.sign-off-template.create",
	"core.sign-off-template.edit": "core.sign-off-template.edit",
	"renovation.tendering-process.view": "renovation.tendering-process.view",
	"renovation.tendering-process.create": "renovation.tendering-process.create",
	"renovation.tendering-process.edit": "renovation.tendering-process.edit",
	"renovation.tendering-process.delete": "renovation.tendering-process.delete",
	"renovation.addendum.create": "renovation.addendum.create",
	"renovation.addendum.view": "renovation.addendum.view",
	"renovation.addendum.edit": "renovation.addendum.edit",
	"mfh.construction-plan.view": "mfh.construction-plan.view",
	"mfh.construction-plan.edit": "mfh.construction-plan.edit",
	"mfh.construction-plan-approval-matrix.edit": "mfh.construction-plan-approval-matrix.edit",
	"mfh.construction-plan.approve": "mfh.construction-plan.approve",
	"mfh.construction-plan.create": "mfh.construction-plan.create",
	"mfh.construction-plan.delete": "mfh.construction-plan.delete",
	"mfh.construction-plan.archive": "mfh.construction-plan.archive",
	"document.annotation.create": "document.annotation.create",
	"document.annotation.update": "document.annotation.update",
	"document.annotation.update-any": "document.annotation.update-any",
	"document.annotation.delete": "document.annotation.delete",
	"document.annotation.delete-any": "document.annotation.delete-any",
	"renovation.position-cost-allocation.create": "renovation.position-cost-allocation.create",
	"renovation.position-cost-allocation.view": "renovation.position-cost-allocation.view",
	"renovation.contract.view": "renovation.contract.view",
	"renovation.contract.create": "renovation.contract.create",
	"renovation.contract.edit": "renovation.contract.edit",
	"renovation.contract.delete": "renovation.contract.delete",
	"rental.rental-contract-review-process.create": "rental.rental-contract-review-process.create",
	"rental.rental-contract.view": "rental.rental-contract.view",
	"rental.rental-contract.create": "rental.rental-contract.create",
	"rental.rental-contract.edit": "rental.rental-contract.edit",
	"rental.rental-contract.delete": "rental.rental-contract.delete",
	"estate.sourcing.view": "estate.sourcing.view",
	"estate.inspection.review-process.view": "estate.inspection.review-process.view",
	"estate.inspection.review-process.create": "estate.inspection.review-process.create",
	"estate.inspection.review-process.edit": "estate.inspection.review-process.edit",
	"estate.sourcing-inspection.view": "estate.sourcing-inspection.view",
	"estate.sourcing-inspection.create": "estate.sourcing-inspection.create",
	"estate.sourcing-inspection.edit": "estate.sourcing-inspection.edit",
	"estate.sourcing-inspection.delete": "estate.sourcing-inspection.delete",
	"estate.sourcing-document-inspection.view": "estate.sourcing-document-inspection.view",
	"estate.sourcing-document-inspection.create": "estate.sourcing-document-inspection.create",
	"estate.sourcing-document-inspection.edit": "estate.sourcing-document-inspection.edit",
	"estate.sourcing-document-inspection.delete": "estate.sourcing-document-inspection.delete",
	"estate.market-details.view": "estate.market-details.view",
	"estate.market-details.edit": "estate.market-details.edit",
	"estate.predictions.view": "estate.predictions.view",
	"estate.sourcing-investmentcase.view": "estate.sourcing-investmentcase.view",
	"estate.sourcing-investmentcase.create": "estate.sourcing-investmentcase.create",
	"estate.sourcing-investmentcase.edit": "estate.sourcing-investmentcase.edit",
	"estate.sourcing-investmentcase.delete": "estate.sourcing-investmentcase.delete",
	"estate.sourcing-calendar.view": "estate.sourcing-calendar.view",
	"estate.sourcing-calendar.create": "estate.sourcing-calendar.create",
	"estate.sourcing-calendar.edit": "estate.sourcing-calendar.edit",
	"estate.sourcing-calendar.delete": "estate.sourcing-calendar.delete",
	"estate.sourcing-process.reset": "estate.sourcing-process.reset",
	"estate.sourcing-process.view": "estate.sourcing-process.view",
	"estate.sourcing-process.edit": "estate.sourcing-process.edit",
	"estate.purchasing.view": "estate.purchasing.view",
	"estate.purchasing-notes.view": "estate.purchasing-notes.view",
	"estate.purchasing-notes.edit": "estate.purchasing-notes.edit",
	"estate.purchasing-notes.create": "estate.purchasing-notes.create",
	"estate.purchasing-notes.delete": "estate.purchasing-notes.delete",
	"estate.purchasing-calendar.view": "estate.purchasing-calendar.view",
	"estate.purchasing-calendar.edit": "estate.purchasing-calendar.edit",
	"estate.purchasing-calendar.create": "estate.purchasing-calendar.create",
	"estate.purchasing-calendar.delete": "estate.purchasing-calendar.delete",
	"estate.purchasing-financing-info.view": "estate.purchasing-financing-info.view",
	"estate.purchasing-financing-info.edit": "estate.purchasing-financing-info.edit",
	"estate.purchasing-history.view": "estate.purchasing-history.view",
	"estate.purchasing-events.view": "estate.purchasing-events.view",
	"estate.purchasing-process.view": "estate.purchasing-process.view",
	"estate.purchasing-process.edit": "estate.purchasing-process.edit",
	"estate.renovation.view": "estate.renovation.view",
	"estate.renovation-summary.view": "estate.renovation-summary.view",
	"estate.renovation-inspection.view": "estate.renovation-inspection.view",
	"estate.renovation-inspection.edit": "estate.renovation-inspection.edit",
	"estate.renovation-inspection.create": "estate.renovation-inspection.create",
	"estate.renovation-inspection.send": "estate.renovation-inspection.send",
	"estate.renovation-inspection.pdf-generate": "estate.renovation-inspection.pdf-generate",
	"estate.renovation-inspection.delete": "estate.renovation-inspection.delete",
	"estate.renovation-inspection-notes.view": "estate.renovation-inspection-notes.view",
	"estate.renovation-inspection-notes.edit": "estate.renovation-inspection-notes.edit",
	"estate.renovation-inspection-notes.create": "estate.renovation-inspection-notes.create",
	"estate.renovation-inspection-notes.delete": "estate.renovation-inspection-notes.delete",
	"estate.renovation-craft-notes.view": "estate.renovation-craft-notes.view",
	"estate.renovation-craft-notes.edit": "estate.renovation-craft-notes.edit",
	"estate.renovation-craft-notes.create": "estate.renovation-craft-notes.create",
	"estate.renovation-craft-notes.delete": "estate.renovation-craft-notes.delete",
	"estate.renovation-catalogue.view": "estate.renovation-catalogue.view",
	"estate.renovation-catalogue.edit": "estate.renovation-catalogue.edit",
	"estate.renovation-catalogue.create": "estate.renovation-catalogue.create",
	"estate.renovation-catalogue.delete": "estate.renovation-catalogue.delete",
	"estate.renovation-catalogue-pricing.view": "estate.renovation-catalogue-pricing.view",
	"estate.renovation-catalogue-pricing.create": "estate.renovation-catalogue-pricing.create",
	"estate.renovation-catalogue-pricing.edit": "estate.renovation-catalogue-pricing.edit",
	"estate.renovation-catalogue-pricing.delete": "estate.renovation-catalogue-pricing.delete",
	"estate.renovation-contractors.view": "estate.renovation-contractors.view",
	"estate.renovation-milestones.view": "estate.renovation-milestones.view",
	"estate.renovation-milestones.edit": "estate.renovation-milestones.edit",
	"estate.renovation-calendar.view": "estate.renovation-calendar.view",
	"estate.renovation-calendar.edit": "estate.renovation-calendar.edit",
	"estate.renovation-calendar.create": "estate.renovation-calendar.create",
	"estate.renovation-calendar.delete": "estate.renovation-calendar.delete",
	"estate.renovation-dates.view": "estate.renovation-dates.view",
	"estate.renovation-history.view": "estate.renovation-history.view",
	"estate.renovation-events.view": "estate.renovation-events.view",
	"estate.renovation-elements.view": "estate.renovation-elements.view",
	"estate.renovation-elements.edit": "estate.renovation-elements.edit",
	"estate.renovation-elements.create": "estate.renovation-elements.create",
	"estate.renovation-elements.delete": "estate.renovation-elements.delete",
	"estate.renovation-elements.create-from-ifc": "estate.renovation-elements.create-from-ifc",
	"estate.renovation-elements.create-from-pred": "estate.renovation-elements.create-from-pred",
	"estate.renovation-ifc.view": "estate.renovation-ifc.view",
	"estate.renovation-constructionplan.view": "estate.renovation-constructionplan.view",
	"estate.renovation-constructionplan.edit": "estate.renovation-constructionplan.edit",
	"estate.renovation-constructionplan.create": "estate.renovation-constructionplan.create",
	"estate.renovation-constructionplan.edit-budget-origin": "estate.renovation-constructionplan.edit-budget-origin",
	"estate.renovation-constructionplan.actions-all": "estate.renovation-constructionplan.actions-all",
	"estate.renovation-constructionplan.delete": "estate.renovation-constructionplan.delete",
	"estate.renovation-constructionplan.pdf-generate": "estate.renovation-constructionplan.pdf-generate",
	"estate.renovation-constructionplan.send": "estate.renovation-constructionplan.send",
	"estate.renovation-constructionplan-overshoot.edit": "estate.renovation-constructionplan-overshoot.edit",
	"estate.construction-progress.edit": "estate.construction-progress.edit",
	"estate.construction-progress.create": "estate.construction-progress.create",
	"estate.construction-progress.view": "estate.construction-progress.view",
	"estate.renovation-defects.view": "estate.renovation-defects.view",
	"estate.renovation-defects.edit": "estate.renovation-defects.edit",
	"estate.renovation-defects.create": "estate.renovation-defects.create",
	"estate.renovation-defects.delete": "estate.renovation-defects.delete",
	"estate.renovation-defect-history.view": "estate.renovation-defect-history.view",
	"estate.renovation-process.view": "estate.renovation-process.view",
	"estate.renovation-process.edit": "estate.renovation-process.edit",
	"estate.renovation-position.view": "estate.renovation-position.view",
	"estate.renovation-position.edit": "estate.renovation-position.edit",
	"estate.renovation-position.create": "estate.renovation-position.create",
	"estate.renovation-position.delete": "estate.renovation-position.delete",
	"estate.renovation-position.history": "estate.renovation-position.history",
	"estate.renting.view": "estate.renting.view",
	"estate.renting-dates.view": "estate.renting-dates.view",
	"estate.renting-calendar.view": "estate.renting-calendar.view",
	"estate.renting-calendar.edit": "estate.renting-calendar.edit",
	"estate.renting-calendar.create": "estate.renting-calendar.create",
	"estate.renting-calendar.delete": "estate.renting-calendar.delete",
	"estate.renting-history.view": "estate.renting-history.view",
	"estate.renting-listing.view": "estate.renting-listing.view",
	"estate.renting-listing.create": "estate.renting-listing.create",
	"estate.renting-listing.edit": "estate.renting-listing.edit",
	"estate.renting-listing.delete": "estate.renting-listing.delete",
	"estate.renting-listing.prepublish": "estate.renting-listing.prepublish",
	"estate.renting-listing.publish": "estate.renting-listing.publish",
	"estate.renting-listing.unpublish": "estate.renting-listing.unpublish",
	"estate.renting-listing.open-immo-download": "estate.renting-listing.open-immo-download",
	"estate.renting-lead.view": "estate.renting-lead.view",
	"estate.renting-lead.create": "estate.renting-lead.create",
	"estate.renting-lead.edit": "estate.renting-lead.edit",
	"estate.renting-lead.delete": "estate.renting-lead.delete",
	"estate.renting-events.view": "estate.renting-events.view",
	"estate.renting-process.view": "estate.renting-process.view",
	"estate.renting-process.edit": "estate.renting-process.edit",
	"estate.renting-contract.approve": "estate.renting-contract.approve",
	"estate.livings-check.view": "estate.livings-check.view",
	"estate.livings-check.edit": "estate.livings-check.edit",
	"estate.livings-check.create": "estate.livings-check.create",
	"estate.selling.view": "estate.selling.view",
	"estate.selling.edit": "estate.selling.edit",
	"estate.selling-dates.view": "estate.selling-dates.view",
	"estate.selling-documents.create": "estate.selling-documents.create",
	"estate.selling-notes.view": "estate.selling-notes.view",
	"estate.selling-notes.create": "estate.selling-notes.create",
	"estate.selling-notes.edit": "estate.selling-notes.edit",
	"estate.selling-notes.delete": "estate.selling-notes.delete",
	"estate.selling-calendar.view": "estate.selling-calendar.view",
	"estate.selling-calendar.edit": "estate.selling-calendar.edit",
	"estate.selling-calendar.create": "estate.selling-calendar.create",
	"estate.selling-calendar.delete": "estate.selling-calendar.delete",
	"estate.selling-history.view": "estate.selling-history.view",
	"estate.selling-events.view": "estate.selling-events.view",
	"estate.selling-investmentcase.view": "estate.selling-investmentcase.view",
	"estate.selling-investmentcase.create": "estate.selling-investmentcase.create",
	"estate.selling-investmentcase.edit": "estate.selling-investmentcase.edit",
	"estate.selling-investmentcase.delete": "estate.selling-investmentcase.delete",
	"estate.investmentcase.edit": "estate.investmentcase.edit",
	"estate.ict-investmentcase.view": "estate.ict-investmentcase.view",
	"estate.ict-investmentcase.create": "estate.ict-investmentcase.create",
	"estate.ict-investmentcase.execute": "estate.ict-investmentcase.execute",
	"estate.ict-investmentcase.edit": "estate.ict-investmentcase.edit",
	"estate.ict-investmentcase.delete": "estate.ict-investmentcase.delete",
	"estate.selling-process.view": "estate.selling-process.view",
	"estate.selling-process.edit": "estate.selling-process.edit",
	"estate.selling-process.paid": "estate.selling-process.paid",
	"estate.property-management.view": "estate.property-management.view",
	"estate.property-management.edit": "estate.property-management.edit",
	"estate.property-management.delete": "estate.property-management.delete",
	"estate.property-management-rent.view": "estate.property-management-rent.view",
	"estate.property-management-rent.edit": "estate.property-management-rent.edit",
	"estate.propertymanagement-active-past-rent.edit": "estate.propertymanagement-active-past-rent.edit",
	"estate.property-management-rent.create": "estate.property-management-rent.create",
	"estate.property-management-rent.delete": "estate.property-management-rent.delete",
	"estate.propertymanagement-tenancy.view": "estate.propertymanagement-tenancy.view",
	"estate.propertymanagement-tenancy.edit": "estate.propertymanagement-tenancy.edit",
	"estate.propertymanagement-active-past-tenancy.edit": "estate.propertymanagement-active-past-tenancy.edit",
	"estate.propertymanagement-tenancy.create": "estate.propertymanagement-tenancy.create",
	"estate.propertymanagement-tenancy.delete": "estate.propertymanagement-tenancy.delete",
	"estate.propertymanagement-owner.view": "estate.propertymanagement-owner.view",
	"estate.propertymanagement-owner.create": "estate.propertymanagement-owner.create",
	"estate.propertymanagement-owner.edit": "estate.propertymanagement-owner.edit",
	"estate.propertymanagement-owner-annual-statement.view": "estate.propertymanagement-owner-annual-statement.view",
	"estate.propertymanagement-owner-annual-statement.create": "estate.propertymanagement-owner-annual-statement.create",
	"estate.propertymanagement-owner-annual-statement.edit": "estate.propertymanagement-owner-annual-statement.edit",
	"estate.propertymanagement-owner-annual-statement.delete": "estate.propertymanagement-owner-annual-statement.delete",
	"estate.propertymanagement-annual-service-charges.view": "estate.propertymanagement-annual-service-charges.view",
	"estate.propertymanagement-annual-service-charges.create": "estate.propertymanagement-annual-service-charges.create",
	"estate.propertymanagement-annual-service-charges.edit": "estate.propertymanagement-annual-service-charges.edit",
	"estate.propertymanagement-annual-service-charges.delete": "estate.propertymanagement-annual-service-charges.delete",
	"estate.property-management-notes.view": "estate.property-management-notes.view",
	"estate.property-management-notes.edit": "estate.property-management-notes.edit",
	"estate.property-management-notes.create": "estate.property-management-notes.create",
	"estate.property-management-notes.delete": "estate.property-management-notes.delete",
	"estate.propertymanagement-meters.view": "estate.propertymanagement-meters.view",
	"estate.propertymanagement-meters.create": "estate.propertymanagement-meters.create",
	"estate.propertymanagement-meters.edit": "estate.propertymanagement-meters.edit",
	"estate.propertymanagement-meters.delete": "estate.propertymanagement-meters.delete",
	"estate.propertymanagement-calendar.view": "estate.propertymanagement-calendar.view",
	"estate.propertymanagement-calendar.create": "estate.propertymanagement-calendar.create",
	"estate.propertymanagement-calendar.edit": "estate.propertymanagement-calendar.edit",
	"estate.propertymanagement-calendar.delete": "estate.propertymanagement-calendar.delete",
	"estate.propertymanagement-hoa-fee.view": "estate.propertymanagement-hoa-fee.view",
	"estate.propertymanagement-hoa-fee.create": "estate.propertymanagement-hoa-fee.create",
	"estate.propertymanagement-hoa-fee.edit": "estate.propertymanagement-hoa-fee.edit",
	"estate.propertymanagement-hoa-fee.delete": "estate.propertymanagement-hoa-fee.delete",
	"estate.propertymanagement-process.view": "estate.propertymanagement-process.view",
	"estate.propertymanagement-process.edit": "estate.propertymanagement-process.edit",
	"estate.propertymanagement-meter-reading.create": "estate.propertymanagement-meter-reading.create",
	"estate.propertymanagement-meter-reading.delete": "estate.propertymanagement-meter-reading.delete",
	"estate.propertymanagement-tasks.view": "estate.propertymanagement-tasks.view",
	"estate.propertymanagement-tasks.edit": "estate.propertymanagement-tasks.edit",
	"estate.property-management-events.view": "estate.property-management-events.view",
	"estate.property-management-process.future-house-geld": "estate.property-management-process.future-house-geld",
	"estate.tenant-management-process.create": "estate.tenant-management-process.create",
	"estate.tenant-management-process.view": "estate.tenant-management-process.view",
	"estate.tenant-management-process.edit": "estate.tenant-management-process.edit",
	"estate.tenant-management-process.delete": "estate.tenant-management-process.delete",
	"estate.tenant-management-process-events.view": "estate.tenant-management-process-events.view",
	"estate.tenant-management-investor-info-special-deal.edit": "estate.tenant-management-investor-info-special-deal.edit",
	"estate.tenant-management-monthly-investor-info.edit": "estate.tenant-management-monthly-investor-info.edit",
	"estate.owner-management-process.create": "estate.owner-management-process.create",
	"estate.owner-management-process.view": "estate.owner-management-process.view",
	"estate.owner-management-process.edit": "estate.owner-management-process.edit",
	"estate.owner-management-process.delete": "estate.owner-management-process.delete",
	"estate.owner-management-process-events.view": "estate.owner-management-process-events.view",
	"estate.estate-management-process.create": "estate.estate-management-process.create",
	"estate.estate-management-process.view": "estate.estate-management-process.view",
	"estate.estate-management-process.edit": "estate.estate-management-process.edit",
	"estate.estate-management-process.delete": "estate.estate-management-process.delete",
	"estate.estate-management-process-events.view": "estate.estate-management-process-events.view",
	"estate.payment-notice-summary.create": "estate.payment-notice-summary.create",
	"estate.payment-notice-summary.edit": "estate.payment-notice-summary.edit",
	"estate.payment-notice-summary.view": "estate.payment-notice-summary.view",
	"finance.general-ledger-entries.view": "finance.general-ledger-entries.view",
	"finance.general-ledger-entries.edit": "finance.general-ledger-entries.edit",
	"finance.general-ledger-entries.create": "finance.general-ledger-entries.create",
	"finance.general-ledger-entries.delete": "finance.general-ledger-entries.delete",
	"finance.general-ledger-entries.recover": "finance.general-ledger-entries.recover",
	"finance.general-ledger-statements.view": "finance.general-ledger-statements.view",
	"finance.general-ledger-statements.create": "finance.general-ledger-statements.create",
	"finance.sepa-mandate.view": "finance.sepa-mandate.view",
	"finance.sepa-mandate.edit": "finance.sepa-mandate.edit",
	"finance.sepa-mandate.create": "finance.sepa-mandate.create",
	"finance.sepa-mandate.delete": "finance.sepa-mandate.delete",
	"finance.payment-order.export": "finance.payment-order.export",
	"finance.payment-order.view": "finance.payment-order.view",
	"finance.payment-order.update": "finance.payment-order.update",
	"finance.payment-order.create": "finance.payment-order.create",
	"finance.eligible-estates.list": "finance.eligible-estates.list",
	"finance.portfolio.list": "finance.portfolio.list",
	"finance.portfolio.view": "finance.portfolio.view",
	"finance.portfolio.create": "finance.portfolio.create",
	"finance.portfolio.edit": "finance.portfolio.edit",
	"finance.portfolio.delete": "finance.portfolio.delete",
	"finance.portfolio-summary.view": "finance.portfolio-summary.view",
	"finance.portfolio.prepared": "finance.portfolio.prepared",
	"finance.portfolio.revert": "finance.portfolio.revert",
	"finance.portfolio.offer-accepted": "finance.portfolio.offer-accepted",
	"finance.portfolio.loan-created": "finance.portfolio.loan-created",
	"finance.portfolio.actions-all": "finance.portfolio.actions-all",
	"finance.portfolio-document.create": "finance.portfolio-document.create",
	"finance.portfolio-documents.view": "finance.portfolio-documents.view",
	"finance.portfolio-document-folder.generate": "finance.portfolio-document-folder.generate",
	"finance.portfolio-financing-banks.list": "finance.portfolio-financing-banks.list",
	"finance.portfolio-eligible-estates.list": "finance.portfolio-eligible-estates.list",
	"finance.portfolio-loan-offer.view": "finance.portfolio-loan-offer.view",
	"finance.portfolio-loan-offer.create": "finance.portfolio-loan-offer.create",
	"finance.portfolio-loan-offer.edit": "finance.portfolio-loan-offer.edit",
	"finance.portfolio-loan-offer.delete": "finance.portfolio-loan-offer.delete",
	"finance.portfolio-loan-offer.accept": "finance.portfolio-loan-offer.accept",
	"finance.portfolio-notes.view": "finance.portfolio-notes.view",
	"finance.portfolio-notes.create": "finance.portfolio-notes.create",
	"finance.portfolio-notes.delete": "finance.portfolio-notes.delete",
	"finance.loan-application.create": "finance.loan-application.create",
	"finance.loan-account-balance.recalculate": "finance.loan-account-balance.recalculate",
	"finance.tendering.view": "finance.tendering.view",
	"finance.tendering.edit": "finance.tendering.edit",
	"finance.tendering.delete": "finance.tendering.delete",
	"finance.portfolio-history.view": "finance.portfolio-history.view",
	"finance.invoice-history.view": "finance.invoice-history.view",
	"finance.invoice.export": "finance.invoice.export",
	"finance.invoice.list": "finance.invoice.list",
	"finance.invoice.view": "finance.invoice.view",
	"finance.invoice.view.recurrent-payments": "finance.invoice.view.recurrent-payments",
	"finance.invoice.view-all": "finance.invoice.view-all",
	"finance.invoice.view-livings": "finance.invoice.view-livings",
	"finance.invoice.create": "finance.invoice.create",
	"finance.invoice-reminder.create": "finance.invoice-reminder.create",
	"finance.invoice.edit": "finance.invoice.edit",
	"finance.invoice.delete": "finance.invoice.delete",
	"finance.invoice.assign": "finance.invoice.assign",
	"finance.invoice.approve": "finance.invoice.approve",
	"finance.invoice.authorize": "finance.invoice.authorize",
	"finance.invoice.reject": "finance.invoice.reject",
	"finance.invoice.actions-all": "finance.invoice.actions-all",
	"finance.invoice.reset": "finance.invoice.reset",
	"finance.invoice.force-reject": "finance.invoice.force-reject",
	"finance.invoice-notes.view": "finance.invoice-notes.view",
	"finance.invoice-notes.create": "finance.invoice-notes.create",
	"finance.invoice-notes.edit": "finance.invoice-notes.edit",
	"finance.invoice-notes.delete": "finance.invoice-notes.delete",
	"finance.invoice.overwrite": "finance.invoice.overwrite",
	"finance.invoice.review-process.view": "finance.invoice.review-process.view",
	"finance.invoice.review-process.create": "finance.invoice.review-process.create",
	"finance.invoice.review-process.edit": "finance.invoice.review-process.edit",
	"finance.invoice-subscription.list": "finance.invoice-subscription.list",
	"finance.invoice-subscription.view": "finance.invoice-subscription.view",
	"finance.invoice-subscription.create": "finance.invoice-subscription.create",
	"finance.invoice-subscription.edit": "finance.invoice-subscription.edit",
	"finance.invoice-subscription.delete": "finance.invoice-subscription.delete",
	"finance.invoice-subscription-document.create": "finance.invoice-subscription-document.create",
	"finance.invoice-subscription-invoices.generate": "finance.invoice-subscription-invoices.generate",
	"finance.bank-transaction.list": "finance.bank-transaction.list",
	"finance.bank-transaction.view": "finance.bank-transaction.view",
	"finance.bank-transaction.edit": "finance.bank-transaction.edit",
	"finance.bank-transaction.delete": "finance.bank-transaction.delete",
	"finance.bank-transaction.book": "finance.bank-transaction.book",
	"finance.credit-line-portfolio.create": "finance.credit-line-portfolio.create",
	"finance.credit-line-portfolio.view": "finance.credit-line-portfolio.view",
	"finance.credit-line-portfolio.edit": "finance.credit-line-portfolio.edit",
	"finance.credit-line-portfolio.delete": "finance.credit-line-portfolio.delete",
	"finance.cash-flow-predictions.create": "finance.cash-flow-predictions.create",
	"finance.investor-cashflow.view": "finance.investor-cashflow.view",
	"finance.investor-cashflow.create": "finance.investor-cashflow.create",
	"finance.investor-cashflow.edit": "finance.investor-cashflow.edit",
	"finance.sales-package.create": "finance.sales-package.create",
	"finance.sales-package.view": "finance.sales-package.view",
	"finance.sales-package.edit": "finance.sales-package.edit",
	"finance.sales-package-estate.add": "finance.sales-package-estate.add",
	"finance.sales-package-estate.delete": "finance.sales-package-estate.delete",
	"finance.sales-package-review-process.create": "finance.sales-package-review-process.create",
	"finance.sales-package-review-process.view": "finance.sales-package-review-process.view",
	"finance.sales-package-notes.create": "finance.sales-package-notes.create",
	"finance.sales-package-notes.delete": "finance.sales-package-notes.delete",
	"finance.sales-package-notes.view": "finance.sales-package-notes.view",
	"finance.sales-package-history.view": "finance.sales-package-history.view",
	"finance.payment-notice-summary.approve": "finance.payment-notice-summary.approve",
	"finance.payment-notice-summary.set-as-ready-for-review": "finance.payment-notice-summary.set-as-ready-for-review",
	"finance.special-deal.view": "finance.special-deal.view",
	"finance.special-deal.create": "finance.special-deal.create",
	"finance.special-deal.edit": "finance.special-deal.edit",
	"finance.estate.edit.is-special-deal-locked": "finance.estate.edit.is-special-deal-locked",
	"core.document.view": "core.document.view",
	"core.accounting.view": "core.accounting.view",
	"core.contact.view": "core.contact.view",
	"core.contact.list": "core.contact.list",
	"core.contact.create": "core.contact.create",
	"core.contact.edit": "core.contact.edit",
	"core.contact.delete": "core.contact.delete",
	"core.contact.merge": "core.contact.merge",
	"core.contact-estates.view": "core.contact-estates.view",
	"core.contact-documents.view": "core.contact-documents.view",
	"core.contact-document.upload": "core.contact-document.upload",
	"core.contact-documents.edit": "core.contact-documents.edit",
	"core.contact-document.delete": "core.contact-document.delete",
	"core.contact-invoices.view": "core.contact-invoices.view",
	"core.contact-notes.create": "core.contact-notes.create",
	"core.contact-notes.view": "core.contact-notes.view",
	"core.contact-notes.delete": "core.contact-notes.delete",
	"core.contact-bank-accounts.view": "core.contact-bank-accounts.view",
	"core.contact-bank-account.create": "core.contact-bank-account.create",
	"core.contact-accounting.edit": "core.contact-accounting.edit",
	"core.company.view": "core.company.view",
	"core.company.list": "core.company.list",
	"core.company-purchasing-entity.list": "core.company-purchasing-entity.list",
	"core.company-distribution-partner.list": "core.company-distribution-partner.list",
	"core.company-bank.list": "core.company-bank.list",
	"core.company.create": "core.company.create",
	"core.company.edit": "core.company.edit",
	"core.company.delete": "core.company.delete",
	"core.company-estates.view": "core.company-estates.view",
	"core.company-contacts.view": "core.company-contacts.view",
	"core.company-contacts.create": "core.company-contacts.create",
	"core.company-contacts.edit": "core.company-contacts.edit",
	"core.company-contacts.delete": "core.company-contacts.delete",
	"core.company-contractor-capacity.view": "core.company-contractor-capacity.view",
	"core.company-contractor-capacity.edit": "core.company-contractor-capacity.edit",
	"core.company-contractor-agreed-capacity.edit": "core.company-contractor-agreed-capacity.edit",
	"core.company-documents.view": "core.company-documents.view",
	"core.company-document.upload": "core.company-document.upload",
	"core.company-document.edit": "core.company-document.edit",
	"core.company-document.delete": "core.company-document.delete",
	"core.company-invoices.view": "core.company-invoices.view",
	"core.company-notes.view": "core.company-notes.view",
	"core.company-notes.create": "core.company-notes.create",
	"core.company-notes.delete": "core.company-notes.delete",
	"core.company-bank-accounts.view": "core.company-bank-accounts.view",
	"core.company-bank-account.create": "core.company-bank-account.create",
	"core.company-accounting.edit": "core.company-accounting.edit",
	"core.process.view": "core.process.view",
	"core.process.list": "core.process.list",
	"core.process.edit": "core.process.edit",
	"core.process.create": "core.process.create",
	"core.company-employment.create": "core.company-employment.create",
	"core.company-employment.delete": "core.company-employment.delete",
	"core.task.list": "core.task.list",
	"core.task.edit": "core.task.edit",
	"core.task.create": "core.task.create",
	"core.task.delete": "core.task.delete",
	"core.task-template.list": "core.task-template.list",
	"core.task-template.edit": "core.task-template.edit",
	"core.task-template.create": "core.task-template.create",
	"core.task-template.delete": "core.task-template.delete",
	"core.file.get": "core.file.get",
	"core.calendar.view": "core.calendar.view",
	"core.calendar.subscribe-all": "core.calendar.subscribe-all",
	"core.calendar.subscribe-sourcing": "core.calendar.subscribe-sourcing",
	"core.calendar.subscribe-purchasing": "core.calendar.subscribe-purchasing",
	"core.calendar.subscribe-renovation": "core.calendar.subscribe-renovation",
	"core.calendar.subscribe-renting": "core.calendar.subscribe-renting",
	"core.calendar.subscribe-selling": "core.calendar.subscribe-selling",
	"core.calendar.subscribe-propertymanagement": "core.calendar.subscribe-propertymanagement",
	"core.basecamp-maintenance.run": "core.basecamp-maintenance.run",
	"core.basecamp-maintenance.estate-export": "core.basecamp-maintenance.estate-export",
	"core.review-process.create": "core.review-process.create",
	"core.review-process.view": "core.review-process.view",
	"core.review-process.edit": "core.review-process.edit",
	"core.review-process.delete": "core.review-process.delete",
	"core.review-process.process": "core.review-process.process",
	"portfolio.review-process.create": "portfolio.review-process.create",
	"portfolio.review-process.view": "portfolio.review-process.view",
	"portfolio.review-process.edit": "portfolio.review-process.edit",
	"portfolio.review-process.delete": "portfolio.review-process.delete",
	"portfolio.review-process.process": "portfolio.review-process.process",
	"investment-case.review-process.create": "investment-case.review-process.create",
	"investment-case.review-process.view": "investment-case.review-process.view",
	"investment-case.review-process.edit": "investment-case.review-process.edit",
	"investment-case.review-process.delete": "investment-case.review-process.delete",
	"investment-case.review-process.process": "investment-case.review-process.process",
	"construction-plan.review-process.create": "construction-plan.review-process.create",
	"construction-plan.review-process.view": "construction-plan.review-process.view",
	"construction-plan.review-process.edit": "construction-plan.review-process.edit",
	"construction-plan.review-process.delete": "construction-plan.review-process.delete",
	"construction-plan.review-process.process": "construction-plan.review-process.process",
	"authz.permission.view": "authz.permission.view",
	"authz.role-binding.view": "authz.role-binding.view",
	"authz.role-binding.edit": "authz.role-binding.edit",
	"authz.role-binding.create": "authz.role-binding.create",
	"authz.role-binding.delete": "authz.role-binding.delete",
	"authz.role-binding.impersonate": "authz.role-binding.impersonate",
	"authz.role.edit": "authz.role.edit",
	"authz.role.create": "authz.role.create",
	"authz.role.delete": "authz.role.delete",
	"authz.user.view": "authz.user.view",
	"authz.user.edit": "authz.user.edit",
	"authz.user.create": "authz.user.create",
	"authz.user.delete": "authz.user.delete",
	"external.dashboard.view": "external.dashboard.view",
	"administration.internal-user.create": "administration.internal-user.create",
	"administration.external-user.create": "administration.external-user.create",
	"administration.rules.view": "administration.rules.view",
	"administration.rules.edit": "administration.rules.edit",
	"administration.rules.delete": "administration.rules.delete",
	"administration.rules.create": "administration.rules.create",
	"administration.user-company-functions.view": "administration.user-company-functions.view",
	"administration.user-company-functions.edit": "administration.user-company-functions.edit",
	"administration.user-company-functions.delete": "administration.user-company-functions.delete",
	"administration.location.view": "administration.location.view",
	"administration.location.edit": "administration.location.edit",
	"administration.location.create": "administration.location.create",
	"administration.location-profile.edit": "administration.location-profile.edit",
	"administration.location-profile.delete": "administration.location-profile.delete",
	"administration.ledger.view": "administration.ledger.view",
	"administration.ledger-entry.create": "administration.ledger-entry.create",
	"administration.ledger.recover": "administration.ledger.recover",
	"administration.renovation-inspection-questions.create": "administration.renovation-inspection-questions.create",
	"administration.renovation-inspection-questions.edit": "administration.renovation-inspection-questions.edit",
	"administration.renovation-inspection-questions.delete": "administration.renovation-inspection-questions.delete",
	"administration.loan-account.edit": "administration.loan-account.edit",
	"administration.loan-account.delete": "administration.loan-account.delete",
	"administration.loan-account.view": "administration.loan-account.view",
	"administration.loan-account.create": "administration.loan-account.create",
	"administration.bank-account.edit": "administration.bank-account.edit",
	"administration.bank-account.delete": "administration.bank-account.delete",
	"administration.bank-account.view": "administration.bank-account.view",
	"administration.bank-account.create": "administration.bank-account.create",
	"administration.bank-account-transaction.create": "administration.bank-account-transaction.create",
	"administration.bank-account-transaction.delete": "administration.bank-account-transaction.delete",
	"administration.loan-account-drawdown.create": "administration.loan-account-drawdown.create",
	"administration.loan-account-drawdown.delete": "administration.loan-account-drawdown.delete",
	"administration.loan-account-drawdown.receive": "administration.loan-account-drawdown.receive",
	"administration.investor-statement.create": "administration.investor-statement.create"
};
//#endregion
//#region src/basecamp/gen/models/authzModels/FindRoles.ts
const FindRolesQueryParamsPermissions = {
	"agent.chat.view-any": "agent.chat.view-any",
	"agent.feedback.manage": "agent.feedback.manage",
	"spotlight.catalogue.manage": "spotlight.catalogue.manage",
	"spotlight.report.view": "spotlight.report.view",
	"estate.estate.view": "estate.estate.view",
	"estate.estate.edit": "estate.estate.edit",
	"estate.estate.create": "estate.estate.create",
	"estate.estate.delete": "estate.estate.delete",
	"estate.attributes.view": "estate.attributes.view",
	"estate.attributes.edit": "estate.attributes.edit",
	"estate.notes.view": "estate.notes.view",
	"estate.notes.create": "estate.notes.create",
	"estate.notes.edit": "estate.notes.edit",
	"estate.notes.delete": "estate.notes.delete",
	"estate.location.view": "estate.location.view",
	"estate.location.edit": "estate.location.edit",
	"estate.contacts.view": "estate.contacts.view",
	"estate.contacts.create": "estate.contacts.create",
	"estate.contacts.delete": "estate.contacts.delete",
	"estate.credentials.view": "estate.credentials.view",
	"estate.credentials.create": "estate.credentials.create",
	"estate.credentials.delete": "estate.credentials.delete",
	"estate.document.view": "estate.document.view",
	"estate.document.upload": "estate.document.upload",
	"estate.document.download": "estate.document.download",
	"estate.document.edit": "estate.document.edit",
	"estate.documents.delete": "estate.documents.delete",
	"estate.documents.create": "estate.documents.create",
	"estate.documents.send": "estate.documents.send",
	"core.data-room.create": "core.data-room.create",
	"core.data-room.edit": "core.data-room.edit",
	"core.data-room.delete": "core.data-room.delete",
	"core.data-room.view": "core.data-room.view",
	"estate.media.view": "estate.media.view",
	"estate.media.edit": "estate.media.edit",
	"estate.media.create": "estate.media.create",
	"estate.media.delete": "estate.media.delete",
	"estate.tasks.view": "estate.tasks.view",
	"estate.tasks.edit": "estate.tasks.edit",
	"estate.tasks.create": "estate.tasks.create",
	"estate.tasks.delete": "estate.tasks.delete",
	"estate.find-transaction-monitoring-estates.view": "estate.find-transaction-monitoring-estates.view",
	"estate.controlling.view": "estate.controlling.view",
	"estate.calendar.view": "estate.calendar.view",
	"estate.calendar.edit": "estate.calendar.edit",
	"estate.calendar.create": "estate.calendar.create",
	"estate.calendar.delete": "estate.calendar.delete",
	"estate.events.view": "estate.events.view",
	"estate.prediction.recalculate": "estate.prediction.recalculate",
	"mfh.contacts.list": "mfh.contacts.list",
	"mfh.contacts.create": "mfh.contacts.create",
	"mfh.impersonate.asset-partner": "mfh.impersonate.asset-partner",
	"mfh.mfh.view": "mfh.mfh.view",
	"mfh.mfh.edit": "mfh.mfh.edit",
	"mfh.mfh.delete": "mfh.mfh.delete",
	"mfh.mfh.create": "mfh.mfh.create",
	"mfh.mfh.bulk-create": "mfh.mfh.bulk-create",
	"mfh.capex-ee-config.view": "mfh.capex-ee-config.view",
	"mfh.capex-ee-config.create": "mfh.capex-ee-config.create",
	"mfh.capex-ee-config.edit": "mfh.capex-ee-config.edit",
	"mfh.capex-ee-config.delete": "mfh.capex-ee-config.delete",
	"mfh.capex-ee-scenario.view": "mfh.capex-ee-scenario.view",
	"mfh.capex-ee-scenario.edit": "mfh.capex-ee-scenario.edit",
	"mfh.capex-ee-scenario.create": "mfh.capex-ee-scenario.create",
	"mfh.capex-ee-scenario.delete": "mfh.capex-ee-scenario.delete",
	"mfh.estar-core-id.edit": "mfh.estar-core-id.edit",
	"mfh.events.view": "mfh.events.view",
	"mfh.attributes.view": "mfh.attributes.view",
	"mfh.attributes.edit": "mfh.attributes.edit",
	"mfh.renovation-attributes.edit": "mfh.renovation-attributes.edit",
	"mfh.location.view": "mfh.location.view",
	"mfh.location.edit": "mfh.location.edit",
	"mfh.tasks.view": "mfh.tasks.view",
	"mfh.tasks.edit": "mfh.tasks.edit",
	"mfh.tasks.create": "mfh.tasks.create",
	"mfh.tasks.delete": "mfh.tasks.delete",
	"mfh.project-planning.view": "mfh.project-planning.view",
	"mfh.project-planning.edit": "mfh.project-planning.edit",
	"mfh.project-planning.create": "mfh.project-planning.create",
	"mfh.project-planning.delete": "mfh.project-planning.delete",
	"mfh.calendar.view": "mfh.calendar.view",
	"mfh.calendar.edit": "mfh.calendar.edit",
	"mfh.calendar.create": "mfh.calendar.create",
	"mfh.calendar.delete": "mfh.calendar.delete",
	"mfh.document.view": "mfh.document.view",
	"mfh.document.edit": "mfh.document.edit",
	"mfh.document.upload": "mfh.document.upload",
	"mfh.document.delete": "mfh.document.delete",
	"mfh.renovation-project-config.edit": "mfh.renovation-project-config.edit",
	"mfh.renovation-project.create": "mfh.renovation-project.create",
	"mfh.renovation-project.view": "mfh.renovation-project.view",
	"mfh.renovation-project.edit": "mfh.renovation-project.edit",
	"mfh.renovation-project.delete": "mfh.renovation-project.delete",
	"mfh.renovation-project.review-process.create": "mfh.renovation-project.review-process.create",
	"mfh.renovation-project.review-process.view": "mfh.renovation-project.review-process.view",
	"mfh.renovation-project.review-process.edit": "mfh.renovation-project.review-process.edit",
	"mfh.renovation-project.review-process.process": "mfh.renovation-project.review-process.process",
	"mfh.renovation-project-planning-module.delete": "mfh.renovation-project-planning-module.delete",
	"mfh.renovation-project-position.delete": "mfh.renovation-project-position.delete",
	"mfh.renovation-event.history.view": "mfh.renovation-event.history.view",
	"mfh.renovation-project-lot.delete": "mfh.renovation-project-lot.delete",
	"mfh.elements.create": "mfh.elements.create",
	"mfh.elements.edit": "mfh.elements.edit",
	"mfh.elements.view": "mfh.elements.view",
	"mfh.elements.delete": "mfh.elements.delete",
	"mfh.media.view": "mfh.media.view",
	"mfh.media.edit": "mfh.media.edit",
	"mfh.notes.view": "mfh.notes.view",
	"mfh.notes.create": "mfh.notes.create",
	"mfh.notes.edit": "mfh.notes.edit",
	"mfh.notes.delete": "mfh.notes.delete",
	"mfh.dd.view": "mfh.dd.view",
	"mfh.dd.edit": "mfh.dd.edit",
	"mfh.infas.fetch": "mfh.infas.fetch",
	"mfh.syte.fetch": "mfh.syte.fetch",
	"mfh.syte.debug": "mfh.syte.debug",
	"mfh.investment-case.view": "mfh.investment-case.view",
	"mfh.investment-case.create": "mfh.investment-case.create",
	"mfh.investment-case.edit": "mfh.investment-case.edit",
	"mfh.investment-case.export": "mfh.investment-case.export",
	"mfh.investment-case.upload": "mfh.investment-case.upload",
	"mfh.investment-case.delete": "mfh.investment-case.delete",
	"mfh.investment-case.restore": "mfh.investment-case.restore",
	"mfh.investment-case-admin-input.edit": "mfh.investment-case-admin-input.edit",
	"mfh.asset-analyzer.view": "mfh.asset-analyzer.view",
	"mfh.asset-analyzer.edit-any": "mfh.asset-analyzer.edit-any",
	"mfh.investment-case.copy-as-json": "mfh.investment-case.copy-as-json",
	"mfh.investment-case.paste-as-json": "mfh.investment-case.paste-as-json",
	"mfh.investment-case-review-process.create": "mfh.investment-case-review-process.create",
	"mfh.investment-case-review-process.view": "mfh.investment-case-review-process.view",
	"mfh.investment-case-review-process.edit": "mfh.investment-case-review-process.edit",
	"mfh.investment-case-review-process.process": "mfh.investment-case-review-process.process",
	"mfh-portfolio.process.trigger": "mfh-portfolio.process.trigger",
	"mfh.portfolio-review-process.create": "mfh.portfolio-review-process.create",
	"mfh.portfolio-review-process.view": "mfh.portfolio-review-process.view",
	"mfh.portfolio-review-process.edit": "mfh.portfolio-review-process.edit",
	"mfh.portfolio-review-process.process": "mfh.portfolio-review-process.process",
	"mfh-portfolio.tasks.view": "mfh-portfolio.tasks.view",
	"mfh-portfolio.tasks.edit": "mfh-portfolio.tasks.edit",
	"mfh-portfolio.tasks.create": "mfh-portfolio.tasks.create",
	"mfh-portfolio.tasks.delete": "mfh-portfolio.tasks.delete",
	"mfh.prediction.view": "mfh.prediction.view",
	"mfh.prediction.create": "mfh.prediction.create",
	"mfh.prediction.edit": "mfh.prediction.edit",
	"mfh.prediction.delete": "mfh.prediction.delete",
	"mfh.rent-roll.import": "mfh.rent-roll.import",
	"mfh.rent-roll-version.view": "mfh.rent-roll-version.view",
	"mfh.rent-roll-version.create": "mfh.rent-roll-version.create",
	"mfh.rent-roll-version.edit": "mfh.rent-roll-version.edit",
	"mfh.rent-roll-version.delete": "mfh.rent-roll-version.delete",
	"mfh.placement.view": "mfh.placement.view",
	"mfh.placement.create": "mfh.placement.create",
	"mfh.placement.edit": "mfh.placement.edit",
	"core.sign-off-envelope.create": "core.sign-off-envelope.create",
	"core.sign-off-envelope.cancel": "core.sign-off-envelope.cancel",
	"core.sign-off-envelope.view": "core.sign-off-envelope.view",
	"core.sign-off-envelope.delete": "core.sign-off-envelope.delete",
	"core.sign-off-envelope.list": "core.sign-off-envelope.list",
	"core.sign-off-envelope.edit": "core.sign-off-envelope.edit",
	"core.sign-off-envelope.trigger": "core.sign-off-envelope.trigger",
	"core.sign-off-comment.create": "core.sign-off-comment.create",
	"core.sign-off-comment.view": "core.sign-off-comment.view",
	"core.sign-off-comment.edit": "core.sign-off-comment.edit",
	"core.sign-off-comment.delete": "core.sign-off-comment.delete",
	"core.sign-off-template.create": "core.sign-off-template.create",
	"core.sign-off-template.edit": "core.sign-off-template.edit",
	"renovation.tendering-process.view": "renovation.tendering-process.view",
	"renovation.tendering-process.create": "renovation.tendering-process.create",
	"renovation.tendering-process.edit": "renovation.tendering-process.edit",
	"renovation.tendering-process.delete": "renovation.tendering-process.delete",
	"renovation.addendum.create": "renovation.addendum.create",
	"renovation.addendum.view": "renovation.addendum.view",
	"renovation.addendum.edit": "renovation.addendum.edit",
	"mfh.construction-plan.view": "mfh.construction-plan.view",
	"mfh.construction-plan.edit": "mfh.construction-plan.edit",
	"mfh.construction-plan-approval-matrix.edit": "mfh.construction-plan-approval-matrix.edit",
	"mfh.construction-plan.approve": "mfh.construction-plan.approve",
	"mfh.construction-plan.create": "mfh.construction-plan.create",
	"mfh.construction-plan.delete": "mfh.construction-plan.delete",
	"mfh.construction-plan.archive": "mfh.construction-plan.archive",
	"document.annotation.create": "document.annotation.create",
	"document.annotation.update": "document.annotation.update",
	"document.annotation.update-any": "document.annotation.update-any",
	"document.annotation.delete": "document.annotation.delete",
	"document.annotation.delete-any": "document.annotation.delete-any",
	"renovation.position-cost-allocation.create": "renovation.position-cost-allocation.create",
	"renovation.position-cost-allocation.view": "renovation.position-cost-allocation.view",
	"renovation.contract.view": "renovation.contract.view",
	"renovation.contract.create": "renovation.contract.create",
	"renovation.contract.edit": "renovation.contract.edit",
	"renovation.contract.delete": "renovation.contract.delete",
	"rental.rental-contract-review-process.create": "rental.rental-contract-review-process.create",
	"rental.rental-contract.view": "rental.rental-contract.view",
	"rental.rental-contract.create": "rental.rental-contract.create",
	"rental.rental-contract.edit": "rental.rental-contract.edit",
	"rental.rental-contract.delete": "rental.rental-contract.delete",
	"estate.sourcing.view": "estate.sourcing.view",
	"estate.inspection.review-process.view": "estate.inspection.review-process.view",
	"estate.inspection.review-process.create": "estate.inspection.review-process.create",
	"estate.inspection.review-process.edit": "estate.inspection.review-process.edit",
	"estate.sourcing-inspection.view": "estate.sourcing-inspection.view",
	"estate.sourcing-inspection.create": "estate.sourcing-inspection.create",
	"estate.sourcing-inspection.edit": "estate.sourcing-inspection.edit",
	"estate.sourcing-inspection.delete": "estate.sourcing-inspection.delete",
	"estate.sourcing-document-inspection.view": "estate.sourcing-document-inspection.view",
	"estate.sourcing-document-inspection.create": "estate.sourcing-document-inspection.create",
	"estate.sourcing-document-inspection.edit": "estate.sourcing-document-inspection.edit",
	"estate.sourcing-document-inspection.delete": "estate.sourcing-document-inspection.delete",
	"estate.market-details.view": "estate.market-details.view",
	"estate.market-details.edit": "estate.market-details.edit",
	"estate.predictions.view": "estate.predictions.view",
	"estate.sourcing-investmentcase.view": "estate.sourcing-investmentcase.view",
	"estate.sourcing-investmentcase.create": "estate.sourcing-investmentcase.create",
	"estate.sourcing-investmentcase.edit": "estate.sourcing-investmentcase.edit",
	"estate.sourcing-investmentcase.delete": "estate.sourcing-investmentcase.delete",
	"estate.sourcing-calendar.view": "estate.sourcing-calendar.view",
	"estate.sourcing-calendar.create": "estate.sourcing-calendar.create",
	"estate.sourcing-calendar.edit": "estate.sourcing-calendar.edit",
	"estate.sourcing-calendar.delete": "estate.sourcing-calendar.delete",
	"estate.sourcing-process.reset": "estate.sourcing-process.reset",
	"estate.sourcing-process.view": "estate.sourcing-process.view",
	"estate.sourcing-process.edit": "estate.sourcing-process.edit",
	"estate.purchasing.view": "estate.purchasing.view",
	"estate.purchasing-notes.view": "estate.purchasing-notes.view",
	"estate.purchasing-notes.edit": "estate.purchasing-notes.edit",
	"estate.purchasing-notes.create": "estate.purchasing-notes.create",
	"estate.purchasing-notes.delete": "estate.purchasing-notes.delete",
	"estate.purchasing-calendar.view": "estate.purchasing-calendar.view",
	"estate.purchasing-calendar.edit": "estate.purchasing-calendar.edit",
	"estate.purchasing-calendar.create": "estate.purchasing-calendar.create",
	"estate.purchasing-calendar.delete": "estate.purchasing-calendar.delete",
	"estate.purchasing-financing-info.view": "estate.purchasing-financing-info.view",
	"estate.purchasing-financing-info.edit": "estate.purchasing-financing-info.edit",
	"estate.purchasing-history.view": "estate.purchasing-history.view",
	"estate.purchasing-events.view": "estate.purchasing-events.view",
	"estate.purchasing-process.view": "estate.purchasing-process.view",
	"estate.purchasing-process.edit": "estate.purchasing-process.edit",
	"estate.renovation.view": "estate.renovation.view",
	"estate.renovation-summary.view": "estate.renovation-summary.view",
	"estate.renovation-inspection.view": "estate.renovation-inspection.view",
	"estate.renovation-inspection.edit": "estate.renovation-inspection.edit",
	"estate.renovation-inspection.create": "estate.renovation-inspection.create",
	"estate.renovation-inspection.send": "estate.renovation-inspection.send",
	"estate.renovation-inspection.pdf-generate": "estate.renovation-inspection.pdf-generate",
	"estate.renovation-inspection.delete": "estate.renovation-inspection.delete",
	"estate.renovation-inspection-notes.view": "estate.renovation-inspection-notes.view",
	"estate.renovation-inspection-notes.edit": "estate.renovation-inspection-notes.edit",
	"estate.renovation-inspection-notes.create": "estate.renovation-inspection-notes.create",
	"estate.renovation-inspection-notes.delete": "estate.renovation-inspection-notes.delete",
	"estate.renovation-craft-notes.view": "estate.renovation-craft-notes.view",
	"estate.renovation-craft-notes.edit": "estate.renovation-craft-notes.edit",
	"estate.renovation-craft-notes.create": "estate.renovation-craft-notes.create",
	"estate.renovation-craft-notes.delete": "estate.renovation-craft-notes.delete",
	"estate.renovation-catalogue.view": "estate.renovation-catalogue.view",
	"estate.renovation-catalogue.edit": "estate.renovation-catalogue.edit",
	"estate.renovation-catalogue.create": "estate.renovation-catalogue.create",
	"estate.renovation-catalogue.delete": "estate.renovation-catalogue.delete",
	"estate.renovation-catalogue-pricing.view": "estate.renovation-catalogue-pricing.view",
	"estate.renovation-catalogue-pricing.create": "estate.renovation-catalogue-pricing.create",
	"estate.renovation-catalogue-pricing.edit": "estate.renovation-catalogue-pricing.edit",
	"estate.renovation-catalogue-pricing.delete": "estate.renovation-catalogue-pricing.delete",
	"estate.renovation-contractors.view": "estate.renovation-contractors.view",
	"estate.renovation-milestones.view": "estate.renovation-milestones.view",
	"estate.renovation-milestones.edit": "estate.renovation-milestones.edit",
	"estate.renovation-calendar.view": "estate.renovation-calendar.view",
	"estate.renovation-calendar.edit": "estate.renovation-calendar.edit",
	"estate.renovation-calendar.create": "estate.renovation-calendar.create",
	"estate.renovation-calendar.delete": "estate.renovation-calendar.delete",
	"estate.renovation-dates.view": "estate.renovation-dates.view",
	"estate.renovation-history.view": "estate.renovation-history.view",
	"estate.renovation-events.view": "estate.renovation-events.view",
	"estate.renovation-elements.view": "estate.renovation-elements.view",
	"estate.renovation-elements.edit": "estate.renovation-elements.edit",
	"estate.renovation-elements.create": "estate.renovation-elements.create",
	"estate.renovation-elements.delete": "estate.renovation-elements.delete",
	"estate.renovation-elements.create-from-ifc": "estate.renovation-elements.create-from-ifc",
	"estate.renovation-elements.create-from-pred": "estate.renovation-elements.create-from-pred",
	"estate.renovation-ifc.view": "estate.renovation-ifc.view",
	"estate.renovation-constructionplan.view": "estate.renovation-constructionplan.view",
	"estate.renovation-constructionplan.edit": "estate.renovation-constructionplan.edit",
	"estate.renovation-constructionplan.create": "estate.renovation-constructionplan.create",
	"estate.renovation-constructionplan.edit-budget-origin": "estate.renovation-constructionplan.edit-budget-origin",
	"estate.renovation-constructionplan.actions-all": "estate.renovation-constructionplan.actions-all",
	"estate.renovation-constructionplan.delete": "estate.renovation-constructionplan.delete",
	"estate.renovation-constructionplan.pdf-generate": "estate.renovation-constructionplan.pdf-generate",
	"estate.renovation-constructionplan.send": "estate.renovation-constructionplan.send",
	"estate.renovation-constructionplan-overshoot.edit": "estate.renovation-constructionplan-overshoot.edit",
	"estate.construction-progress.edit": "estate.construction-progress.edit",
	"estate.construction-progress.create": "estate.construction-progress.create",
	"estate.construction-progress.view": "estate.construction-progress.view",
	"estate.renovation-defects.view": "estate.renovation-defects.view",
	"estate.renovation-defects.edit": "estate.renovation-defects.edit",
	"estate.renovation-defects.create": "estate.renovation-defects.create",
	"estate.renovation-defects.delete": "estate.renovation-defects.delete",
	"estate.renovation-defect-history.view": "estate.renovation-defect-history.view",
	"estate.renovation-process.view": "estate.renovation-process.view",
	"estate.renovation-process.edit": "estate.renovation-process.edit",
	"estate.renovation-position.view": "estate.renovation-position.view",
	"estate.renovation-position.edit": "estate.renovation-position.edit",
	"estate.renovation-position.create": "estate.renovation-position.create",
	"estate.renovation-position.delete": "estate.renovation-position.delete",
	"estate.renovation-position.history": "estate.renovation-position.history",
	"estate.renting.view": "estate.renting.view",
	"estate.renting-dates.view": "estate.renting-dates.view",
	"estate.renting-calendar.view": "estate.renting-calendar.view",
	"estate.renting-calendar.edit": "estate.renting-calendar.edit",
	"estate.renting-calendar.create": "estate.renting-calendar.create",
	"estate.renting-calendar.delete": "estate.renting-calendar.delete",
	"estate.renting-history.view": "estate.renting-history.view",
	"estate.renting-listing.view": "estate.renting-listing.view",
	"estate.renting-listing.create": "estate.renting-listing.create",
	"estate.renting-listing.edit": "estate.renting-listing.edit",
	"estate.renting-listing.delete": "estate.renting-listing.delete",
	"estate.renting-listing.prepublish": "estate.renting-listing.prepublish",
	"estate.renting-listing.publish": "estate.renting-listing.publish",
	"estate.renting-listing.unpublish": "estate.renting-listing.unpublish",
	"estate.renting-listing.open-immo-download": "estate.renting-listing.open-immo-download",
	"estate.renting-lead.view": "estate.renting-lead.view",
	"estate.renting-lead.create": "estate.renting-lead.create",
	"estate.renting-lead.edit": "estate.renting-lead.edit",
	"estate.renting-lead.delete": "estate.renting-lead.delete",
	"estate.renting-events.view": "estate.renting-events.view",
	"estate.renting-process.view": "estate.renting-process.view",
	"estate.renting-process.edit": "estate.renting-process.edit",
	"estate.renting-contract.approve": "estate.renting-contract.approve",
	"estate.livings-check.view": "estate.livings-check.view",
	"estate.livings-check.edit": "estate.livings-check.edit",
	"estate.livings-check.create": "estate.livings-check.create",
	"estate.selling.view": "estate.selling.view",
	"estate.selling.edit": "estate.selling.edit",
	"estate.selling-dates.view": "estate.selling-dates.view",
	"estate.selling-documents.create": "estate.selling-documents.create",
	"estate.selling-notes.view": "estate.selling-notes.view",
	"estate.selling-notes.create": "estate.selling-notes.create",
	"estate.selling-notes.edit": "estate.selling-notes.edit",
	"estate.selling-notes.delete": "estate.selling-notes.delete",
	"estate.selling-calendar.view": "estate.selling-calendar.view",
	"estate.selling-calendar.edit": "estate.selling-calendar.edit",
	"estate.selling-calendar.create": "estate.selling-calendar.create",
	"estate.selling-calendar.delete": "estate.selling-calendar.delete",
	"estate.selling-history.view": "estate.selling-history.view",
	"estate.selling-events.view": "estate.selling-events.view",
	"estate.selling-investmentcase.view": "estate.selling-investmentcase.view",
	"estate.selling-investmentcase.create": "estate.selling-investmentcase.create",
	"estate.selling-investmentcase.edit": "estate.selling-investmentcase.edit",
	"estate.selling-investmentcase.delete": "estate.selling-investmentcase.delete",
	"estate.investmentcase.edit": "estate.investmentcase.edit",
	"estate.ict-investmentcase.view": "estate.ict-investmentcase.view",
	"estate.ict-investmentcase.create": "estate.ict-investmentcase.create",
	"estate.ict-investmentcase.execute": "estate.ict-investmentcase.execute",
	"estate.ict-investmentcase.edit": "estate.ict-investmentcase.edit",
	"estate.ict-investmentcase.delete": "estate.ict-investmentcase.delete",
	"estate.selling-process.view": "estate.selling-process.view",
	"estate.selling-process.edit": "estate.selling-process.edit",
	"estate.selling-process.paid": "estate.selling-process.paid",
	"estate.property-management.view": "estate.property-management.view",
	"estate.property-management.edit": "estate.property-management.edit",
	"estate.property-management.delete": "estate.property-management.delete",
	"estate.property-management-rent.view": "estate.property-management-rent.view",
	"estate.property-management-rent.edit": "estate.property-management-rent.edit",
	"estate.propertymanagement-active-past-rent.edit": "estate.propertymanagement-active-past-rent.edit",
	"estate.property-management-rent.create": "estate.property-management-rent.create",
	"estate.property-management-rent.delete": "estate.property-management-rent.delete",
	"estate.propertymanagement-tenancy.view": "estate.propertymanagement-tenancy.view",
	"estate.propertymanagement-tenancy.edit": "estate.propertymanagement-tenancy.edit",
	"estate.propertymanagement-active-past-tenancy.edit": "estate.propertymanagement-active-past-tenancy.edit",
	"estate.propertymanagement-tenancy.create": "estate.propertymanagement-tenancy.create",
	"estate.propertymanagement-tenancy.delete": "estate.propertymanagement-tenancy.delete",
	"estate.propertymanagement-owner.view": "estate.propertymanagement-owner.view",
	"estate.propertymanagement-owner.create": "estate.propertymanagement-owner.create",
	"estate.propertymanagement-owner.edit": "estate.propertymanagement-owner.edit",
	"estate.propertymanagement-owner-annual-statement.view": "estate.propertymanagement-owner-annual-statement.view",
	"estate.propertymanagement-owner-annual-statement.create": "estate.propertymanagement-owner-annual-statement.create",
	"estate.propertymanagement-owner-annual-statement.edit": "estate.propertymanagement-owner-annual-statement.edit",
	"estate.propertymanagement-owner-annual-statement.delete": "estate.propertymanagement-owner-annual-statement.delete",
	"estate.propertymanagement-annual-service-charges.view": "estate.propertymanagement-annual-service-charges.view",
	"estate.propertymanagement-annual-service-charges.create": "estate.propertymanagement-annual-service-charges.create",
	"estate.propertymanagement-annual-service-charges.edit": "estate.propertymanagement-annual-service-charges.edit",
	"estate.propertymanagement-annual-service-charges.delete": "estate.propertymanagement-annual-service-charges.delete",
	"estate.property-management-notes.view": "estate.property-management-notes.view",
	"estate.property-management-notes.edit": "estate.property-management-notes.edit",
	"estate.property-management-notes.create": "estate.property-management-notes.create",
	"estate.property-management-notes.delete": "estate.property-management-notes.delete",
	"estate.propertymanagement-meters.view": "estate.propertymanagement-meters.view",
	"estate.propertymanagement-meters.create": "estate.propertymanagement-meters.create",
	"estate.propertymanagement-meters.edit": "estate.propertymanagement-meters.edit",
	"estate.propertymanagement-meters.delete": "estate.propertymanagement-meters.delete",
	"estate.propertymanagement-calendar.view": "estate.propertymanagement-calendar.view",
	"estate.propertymanagement-calendar.create": "estate.propertymanagement-calendar.create",
	"estate.propertymanagement-calendar.edit": "estate.propertymanagement-calendar.edit",
	"estate.propertymanagement-calendar.delete": "estate.propertymanagement-calendar.delete",
	"estate.propertymanagement-hoa-fee.view": "estate.propertymanagement-hoa-fee.view",
	"estate.propertymanagement-hoa-fee.create": "estate.propertymanagement-hoa-fee.create",
	"estate.propertymanagement-hoa-fee.edit": "estate.propertymanagement-hoa-fee.edit",
	"estate.propertymanagement-hoa-fee.delete": "estate.propertymanagement-hoa-fee.delete",
	"estate.propertymanagement-process.view": "estate.propertymanagement-process.view",
	"estate.propertymanagement-process.edit": "estate.propertymanagement-process.edit",
	"estate.propertymanagement-meter-reading.create": "estate.propertymanagement-meter-reading.create",
	"estate.propertymanagement-meter-reading.delete": "estate.propertymanagement-meter-reading.delete",
	"estate.propertymanagement-tasks.view": "estate.propertymanagement-tasks.view",
	"estate.propertymanagement-tasks.edit": "estate.propertymanagement-tasks.edit",
	"estate.property-management-events.view": "estate.property-management-events.view",
	"estate.property-management-process.future-house-geld": "estate.property-management-process.future-house-geld",
	"estate.tenant-management-process.create": "estate.tenant-management-process.create",
	"estate.tenant-management-process.view": "estate.tenant-management-process.view",
	"estate.tenant-management-process.edit": "estate.tenant-management-process.edit",
	"estate.tenant-management-process.delete": "estate.tenant-management-process.delete",
	"estate.tenant-management-process-events.view": "estate.tenant-management-process-events.view",
	"estate.tenant-management-investor-info-special-deal.edit": "estate.tenant-management-investor-info-special-deal.edit",
	"estate.tenant-management-monthly-investor-info.edit": "estate.tenant-management-monthly-investor-info.edit",
	"estate.owner-management-process.create": "estate.owner-management-process.create",
	"estate.owner-management-process.view": "estate.owner-management-process.view",
	"estate.owner-management-process.edit": "estate.owner-management-process.edit",
	"estate.owner-management-process.delete": "estate.owner-management-process.delete",
	"estate.owner-management-process-events.view": "estate.owner-management-process-events.view",
	"estate.estate-management-process.create": "estate.estate-management-process.create",
	"estate.estate-management-process.view": "estate.estate-management-process.view",
	"estate.estate-management-process.edit": "estate.estate-management-process.edit",
	"estate.estate-management-process.delete": "estate.estate-management-process.delete",
	"estate.estate-management-process-events.view": "estate.estate-management-process-events.view",
	"estate.payment-notice-summary.create": "estate.payment-notice-summary.create",
	"estate.payment-notice-summary.edit": "estate.payment-notice-summary.edit",
	"estate.payment-notice-summary.view": "estate.payment-notice-summary.view",
	"finance.general-ledger-entries.view": "finance.general-ledger-entries.view",
	"finance.general-ledger-entries.edit": "finance.general-ledger-entries.edit",
	"finance.general-ledger-entries.create": "finance.general-ledger-entries.create",
	"finance.general-ledger-entries.delete": "finance.general-ledger-entries.delete",
	"finance.general-ledger-entries.recover": "finance.general-ledger-entries.recover",
	"finance.general-ledger-statements.view": "finance.general-ledger-statements.view",
	"finance.general-ledger-statements.create": "finance.general-ledger-statements.create",
	"finance.sepa-mandate.view": "finance.sepa-mandate.view",
	"finance.sepa-mandate.edit": "finance.sepa-mandate.edit",
	"finance.sepa-mandate.create": "finance.sepa-mandate.create",
	"finance.sepa-mandate.delete": "finance.sepa-mandate.delete",
	"finance.payment-order.export": "finance.payment-order.export",
	"finance.payment-order.view": "finance.payment-order.view",
	"finance.payment-order.update": "finance.payment-order.update",
	"finance.payment-order.create": "finance.payment-order.create",
	"finance.eligible-estates.list": "finance.eligible-estates.list",
	"finance.portfolio.list": "finance.portfolio.list",
	"finance.portfolio.view": "finance.portfolio.view",
	"finance.portfolio.create": "finance.portfolio.create",
	"finance.portfolio.edit": "finance.portfolio.edit",
	"finance.portfolio.delete": "finance.portfolio.delete",
	"finance.portfolio-summary.view": "finance.portfolio-summary.view",
	"finance.portfolio.prepared": "finance.portfolio.prepared",
	"finance.portfolio.revert": "finance.portfolio.revert",
	"finance.portfolio.offer-accepted": "finance.portfolio.offer-accepted",
	"finance.portfolio.loan-created": "finance.portfolio.loan-created",
	"finance.portfolio.actions-all": "finance.portfolio.actions-all",
	"finance.portfolio-document.create": "finance.portfolio-document.create",
	"finance.portfolio-documents.view": "finance.portfolio-documents.view",
	"finance.portfolio-document-folder.generate": "finance.portfolio-document-folder.generate",
	"finance.portfolio-financing-banks.list": "finance.portfolio-financing-banks.list",
	"finance.portfolio-eligible-estates.list": "finance.portfolio-eligible-estates.list",
	"finance.portfolio-loan-offer.view": "finance.portfolio-loan-offer.view",
	"finance.portfolio-loan-offer.create": "finance.portfolio-loan-offer.create",
	"finance.portfolio-loan-offer.edit": "finance.portfolio-loan-offer.edit",
	"finance.portfolio-loan-offer.delete": "finance.portfolio-loan-offer.delete",
	"finance.portfolio-loan-offer.accept": "finance.portfolio-loan-offer.accept",
	"finance.portfolio-notes.view": "finance.portfolio-notes.view",
	"finance.portfolio-notes.create": "finance.portfolio-notes.create",
	"finance.portfolio-notes.delete": "finance.portfolio-notes.delete",
	"finance.loan-application.create": "finance.loan-application.create",
	"finance.loan-account-balance.recalculate": "finance.loan-account-balance.recalculate",
	"finance.tendering.view": "finance.tendering.view",
	"finance.tendering.edit": "finance.tendering.edit",
	"finance.tendering.delete": "finance.tendering.delete",
	"finance.portfolio-history.view": "finance.portfolio-history.view",
	"finance.invoice-history.view": "finance.invoice-history.view",
	"finance.invoice.export": "finance.invoice.export",
	"finance.invoice.list": "finance.invoice.list",
	"finance.invoice.view": "finance.invoice.view",
	"finance.invoice.view.recurrent-payments": "finance.invoice.view.recurrent-payments",
	"finance.invoice.view-all": "finance.invoice.view-all",
	"finance.invoice.view-livings": "finance.invoice.view-livings",
	"finance.invoice.create": "finance.invoice.create",
	"finance.invoice-reminder.create": "finance.invoice-reminder.create",
	"finance.invoice.edit": "finance.invoice.edit",
	"finance.invoice.delete": "finance.invoice.delete",
	"finance.invoice.assign": "finance.invoice.assign",
	"finance.invoice.approve": "finance.invoice.approve",
	"finance.invoice.authorize": "finance.invoice.authorize",
	"finance.invoice.reject": "finance.invoice.reject",
	"finance.invoice.actions-all": "finance.invoice.actions-all",
	"finance.invoice.reset": "finance.invoice.reset",
	"finance.invoice.force-reject": "finance.invoice.force-reject",
	"finance.invoice-notes.view": "finance.invoice-notes.view",
	"finance.invoice-notes.create": "finance.invoice-notes.create",
	"finance.invoice-notes.edit": "finance.invoice-notes.edit",
	"finance.invoice-notes.delete": "finance.invoice-notes.delete",
	"finance.invoice.overwrite": "finance.invoice.overwrite",
	"finance.invoice.review-process.view": "finance.invoice.review-process.view",
	"finance.invoice.review-process.create": "finance.invoice.review-process.create",
	"finance.invoice.review-process.edit": "finance.invoice.review-process.edit",
	"finance.invoice-subscription.list": "finance.invoice-subscription.list",
	"finance.invoice-subscription.view": "finance.invoice-subscription.view",
	"finance.invoice-subscription.create": "finance.invoice-subscription.create",
	"finance.invoice-subscription.edit": "finance.invoice-subscription.edit",
	"finance.invoice-subscription.delete": "finance.invoice-subscription.delete",
	"finance.invoice-subscription-document.create": "finance.invoice-subscription-document.create",
	"finance.invoice-subscription-invoices.generate": "finance.invoice-subscription-invoices.generate",
	"finance.bank-transaction.list": "finance.bank-transaction.list",
	"finance.bank-transaction.view": "finance.bank-transaction.view",
	"finance.bank-transaction.edit": "finance.bank-transaction.edit",
	"finance.bank-transaction.delete": "finance.bank-transaction.delete",
	"finance.bank-transaction.book": "finance.bank-transaction.book",
	"finance.credit-line-portfolio.create": "finance.credit-line-portfolio.create",
	"finance.credit-line-portfolio.view": "finance.credit-line-portfolio.view",
	"finance.credit-line-portfolio.edit": "finance.credit-line-portfolio.edit",
	"finance.credit-line-portfolio.delete": "finance.credit-line-portfolio.delete",
	"finance.cash-flow-predictions.create": "finance.cash-flow-predictions.create",
	"finance.investor-cashflow.view": "finance.investor-cashflow.view",
	"finance.investor-cashflow.create": "finance.investor-cashflow.create",
	"finance.investor-cashflow.edit": "finance.investor-cashflow.edit",
	"finance.sales-package.create": "finance.sales-package.create",
	"finance.sales-package.view": "finance.sales-package.view",
	"finance.sales-package.edit": "finance.sales-package.edit",
	"finance.sales-package-estate.add": "finance.sales-package-estate.add",
	"finance.sales-package-estate.delete": "finance.sales-package-estate.delete",
	"finance.sales-package-review-process.create": "finance.sales-package-review-process.create",
	"finance.sales-package-review-process.view": "finance.sales-package-review-process.view",
	"finance.sales-package-notes.create": "finance.sales-package-notes.create",
	"finance.sales-package-notes.delete": "finance.sales-package-notes.delete",
	"finance.sales-package-notes.view": "finance.sales-package-notes.view",
	"finance.sales-package-history.view": "finance.sales-package-history.view",
	"finance.payment-notice-summary.approve": "finance.payment-notice-summary.approve",
	"finance.payment-notice-summary.set-as-ready-for-review": "finance.payment-notice-summary.set-as-ready-for-review",
	"finance.special-deal.view": "finance.special-deal.view",
	"finance.special-deal.create": "finance.special-deal.create",
	"finance.special-deal.edit": "finance.special-deal.edit",
	"finance.estate.edit.is-special-deal-locked": "finance.estate.edit.is-special-deal-locked",
	"core.document.view": "core.document.view",
	"core.accounting.view": "core.accounting.view",
	"core.contact.view": "core.contact.view",
	"core.contact.list": "core.contact.list",
	"core.contact.create": "core.contact.create",
	"core.contact.edit": "core.contact.edit",
	"core.contact.delete": "core.contact.delete",
	"core.contact.merge": "core.contact.merge",
	"core.contact-estates.view": "core.contact-estates.view",
	"core.contact-documents.view": "core.contact-documents.view",
	"core.contact-document.upload": "core.contact-document.upload",
	"core.contact-documents.edit": "core.contact-documents.edit",
	"core.contact-document.delete": "core.contact-document.delete",
	"core.contact-invoices.view": "core.contact-invoices.view",
	"core.contact-notes.create": "core.contact-notes.create",
	"core.contact-notes.view": "core.contact-notes.view",
	"core.contact-notes.delete": "core.contact-notes.delete",
	"core.contact-bank-accounts.view": "core.contact-bank-accounts.view",
	"core.contact-bank-account.create": "core.contact-bank-account.create",
	"core.contact-accounting.edit": "core.contact-accounting.edit",
	"core.company.view": "core.company.view",
	"core.company.list": "core.company.list",
	"core.company-purchasing-entity.list": "core.company-purchasing-entity.list",
	"core.company-distribution-partner.list": "core.company-distribution-partner.list",
	"core.company-bank.list": "core.company-bank.list",
	"core.company.create": "core.company.create",
	"core.company.edit": "core.company.edit",
	"core.company.delete": "core.company.delete",
	"core.company-estates.view": "core.company-estates.view",
	"core.company-contacts.view": "core.company-contacts.view",
	"core.company-contacts.create": "core.company-contacts.create",
	"core.company-contacts.edit": "core.company-contacts.edit",
	"core.company-contacts.delete": "core.company-contacts.delete",
	"core.company-contractor-capacity.view": "core.company-contractor-capacity.view",
	"core.company-contractor-capacity.edit": "core.company-contractor-capacity.edit",
	"core.company-contractor-agreed-capacity.edit": "core.company-contractor-agreed-capacity.edit",
	"core.company-documents.view": "core.company-documents.view",
	"core.company-document.upload": "core.company-document.upload",
	"core.company-document.edit": "core.company-document.edit",
	"core.company-document.delete": "core.company-document.delete",
	"core.company-invoices.view": "core.company-invoices.view",
	"core.company-notes.view": "core.company-notes.view",
	"core.company-notes.create": "core.company-notes.create",
	"core.company-notes.delete": "core.company-notes.delete",
	"core.company-bank-accounts.view": "core.company-bank-accounts.view",
	"core.company-bank-account.create": "core.company-bank-account.create",
	"core.company-accounting.edit": "core.company-accounting.edit",
	"core.process.view": "core.process.view",
	"core.process.list": "core.process.list",
	"core.process.edit": "core.process.edit",
	"core.process.create": "core.process.create",
	"core.company-employment.create": "core.company-employment.create",
	"core.company-employment.delete": "core.company-employment.delete",
	"core.task.list": "core.task.list",
	"core.task.edit": "core.task.edit",
	"core.task.create": "core.task.create",
	"core.task.delete": "core.task.delete",
	"core.task-template.list": "core.task-template.list",
	"core.task-template.edit": "core.task-template.edit",
	"core.task-template.create": "core.task-template.create",
	"core.task-template.delete": "core.task-template.delete",
	"core.file.get": "core.file.get",
	"core.calendar.view": "core.calendar.view",
	"core.calendar.subscribe-all": "core.calendar.subscribe-all",
	"core.calendar.subscribe-sourcing": "core.calendar.subscribe-sourcing",
	"core.calendar.subscribe-purchasing": "core.calendar.subscribe-purchasing",
	"core.calendar.subscribe-renovation": "core.calendar.subscribe-renovation",
	"core.calendar.subscribe-renting": "core.calendar.subscribe-renting",
	"core.calendar.subscribe-selling": "core.calendar.subscribe-selling",
	"core.calendar.subscribe-propertymanagement": "core.calendar.subscribe-propertymanagement",
	"core.basecamp-maintenance.run": "core.basecamp-maintenance.run",
	"core.basecamp-maintenance.estate-export": "core.basecamp-maintenance.estate-export",
	"core.review-process.create": "core.review-process.create",
	"core.review-process.view": "core.review-process.view",
	"core.review-process.edit": "core.review-process.edit",
	"core.review-process.delete": "core.review-process.delete",
	"core.review-process.process": "core.review-process.process",
	"portfolio.review-process.create": "portfolio.review-process.create",
	"portfolio.review-process.view": "portfolio.review-process.view",
	"portfolio.review-process.edit": "portfolio.review-process.edit",
	"portfolio.review-process.delete": "portfolio.review-process.delete",
	"portfolio.review-process.process": "portfolio.review-process.process",
	"investment-case.review-process.create": "investment-case.review-process.create",
	"investment-case.review-process.view": "investment-case.review-process.view",
	"investment-case.review-process.edit": "investment-case.review-process.edit",
	"investment-case.review-process.delete": "investment-case.review-process.delete",
	"investment-case.review-process.process": "investment-case.review-process.process",
	"construction-plan.review-process.create": "construction-plan.review-process.create",
	"construction-plan.review-process.view": "construction-plan.review-process.view",
	"construction-plan.review-process.edit": "construction-plan.review-process.edit",
	"construction-plan.review-process.delete": "construction-plan.review-process.delete",
	"construction-plan.review-process.process": "construction-plan.review-process.process",
	"authz.permission.view": "authz.permission.view",
	"authz.role-binding.view": "authz.role-binding.view",
	"authz.role-binding.edit": "authz.role-binding.edit",
	"authz.role-binding.create": "authz.role-binding.create",
	"authz.role-binding.delete": "authz.role-binding.delete",
	"authz.role-binding.impersonate": "authz.role-binding.impersonate",
	"authz.role.edit": "authz.role.edit",
	"authz.role.create": "authz.role.create",
	"authz.role.delete": "authz.role.delete",
	"authz.user.view": "authz.user.view",
	"authz.user.edit": "authz.user.edit",
	"authz.user.create": "authz.user.create",
	"authz.user.delete": "authz.user.delete",
	"external.dashboard.view": "external.dashboard.view",
	"administration.internal-user.create": "administration.internal-user.create",
	"administration.external-user.create": "administration.external-user.create",
	"administration.rules.view": "administration.rules.view",
	"administration.rules.edit": "administration.rules.edit",
	"administration.rules.delete": "administration.rules.delete",
	"administration.rules.create": "administration.rules.create",
	"administration.user-company-functions.view": "administration.user-company-functions.view",
	"administration.user-company-functions.edit": "administration.user-company-functions.edit",
	"administration.user-company-functions.delete": "administration.user-company-functions.delete",
	"administration.location.view": "administration.location.view",
	"administration.location.edit": "administration.location.edit",
	"administration.location.create": "administration.location.create",
	"administration.location-profile.edit": "administration.location-profile.edit",
	"administration.location-profile.delete": "administration.location-profile.delete",
	"administration.ledger.view": "administration.ledger.view",
	"administration.ledger-entry.create": "administration.ledger-entry.create",
	"administration.ledger.recover": "administration.ledger.recover",
	"administration.renovation-inspection-questions.create": "administration.renovation-inspection-questions.create",
	"administration.renovation-inspection-questions.edit": "administration.renovation-inspection-questions.edit",
	"administration.renovation-inspection-questions.delete": "administration.renovation-inspection-questions.delete",
	"administration.loan-account.edit": "administration.loan-account.edit",
	"administration.loan-account.delete": "administration.loan-account.delete",
	"administration.loan-account.view": "administration.loan-account.view",
	"administration.loan-account.create": "administration.loan-account.create",
	"administration.bank-account.edit": "administration.bank-account.edit",
	"administration.bank-account.delete": "administration.bank-account.delete",
	"administration.bank-account.view": "administration.bank-account.view",
	"administration.bank-account.create": "administration.bank-account.create",
	"administration.bank-account-transaction.create": "administration.bank-account-transaction.create",
	"administration.bank-account-transaction.delete": "administration.bank-account-transaction.delete",
	"administration.loan-account-drawdown.create": "administration.loan-account-drawdown.create",
	"administration.loan-account-drawdown.delete": "administration.loan-account-drawdown.delete",
	"administration.loan-account-drawdown.receive": "administration.loan-account-drawdown.receive",
	"administration.investor-statement.create": "administration.investor-statement.create"
};
//#endregion
//#region src/basecamp/gen/models/authzModels/UpdateRole.ts
const RolePermissions = {
	"agent.chat.view-any": "agent.chat.view-any",
	"agent.feedback.manage": "agent.feedback.manage",
	"spotlight.catalogue.manage": "spotlight.catalogue.manage",
	"spotlight.report.view": "spotlight.report.view",
	"estate.estate.view": "estate.estate.view",
	"estate.estate.edit": "estate.estate.edit",
	"estate.estate.create": "estate.estate.create",
	"estate.estate.delete": "estate.estate.delete",
	"estate.attributes.view": "estate.attributes.view",
	"estate.attributes.edit": "estate.attributes.edit",
	"estate.notes.view": "estate.notes.view",
	"estate.notes.create": "estate.notes.create",
	"estate.notes.edit": "estate.notes.edit",
	"estate.notes.delete": "estate.notes.delete",
	"estate.location.view": "estate.location.view",
	"estate.location.edit": "estate.location.edit",
	"estate.contacts.view": "estate.contacts.view",
	"estate.contacts.create": "estate.contacts.create",
	"estate.contacts.delete": "estate.contacts.delete",
	"estate.credentials.view": "estate.credentials.view",
	"estate.credentials.create": "estate.credentials.create",
	"estate.credentials.delete": "estate.credentials.delete",
	"estate.document.view": "estate.document.view",
	"estate.document.upload": "estate.document.upload",
	"estate.document.download": "estate.document.download",
	"estate.document.edit": "estate.document.edit",
	"estate.documents.delete": "estate.documents.delete",
	"estate.documents.create": "estate.documents.create",
	"estate.documents.send": "estate.documents.send",
	"core.data-room.create": "core.data-room.create",
	"core.data-room.edit": "core.data-room.edit",
	"core.data-room.delete": "core.data-room.delete",
	"core.data-room.view": "core.data-room.view",
	"estate.media.view": "estate.media.view",
	"estate.media.edit": "estate.media.edit",
	"estate.media.create": "estate.media.create",
	"estate.media.delete": "estate.media.delete",
	"estate.tasks.view": "estate.tasks.view",
	"estate.tasks.edit": "estate.tasks.edit",
	"estate.tasks.create": "estate.tasks.create",
	"estate.tasks.delete": "estate.tasks.delete",
	"estate.find-transaction-monitoring-estates.view": "estate.find-transaction-monitoring-estates.view",
	"estate.controlling.view": "estate.controlling.view",
	"estate.calendar.view": "estate.calendar.view",
	"estate.calendar.edit": "estate.calendar.edit",
	"estate.calendar.create": "estate.calendar.create",
	"estate.calendar.delete": "estate.calendar.delete",
	"estate.events.view": "estate.events.view",
	"estate.prediction.recalculate": "estate.prediction.recalculate",
	"mfh.contacts.list": "mfh.contacts.list",
	"mfh.contacts.create": "mfh.contacts.create",
	"mfh.impersonate.asset-partner": "mfh.impersonate.asset-partner",
	"mfh.mfh.view": "mfh.mfh.view",
	"mfh.mfh.edit": "mfh.mfh.edit",
	"mfh.mfh.delete": "mfh.mfh.delete",
	"mfh.mfh.create": "mfh.mfh.create",
	"mfh.mfh.bulk-create": "mfh.mfh.bulk-create",
	"mfh.capex-ee-config.view": "mfh.capex-ee-config.view",
	"mfh.capex-ee-config.create": "mfh.capex-ee-config.create",
	"mfh.capex-ee-config.edit": "mfh.capex-ee-config.edit",
	"mfh.capex-ee-config.delete": "mfh.capex-ee-config.delete",
	"mfh.capex-ee-scenario.view": "mfh.capex-ee-scenario.view",
	"mfh.capex-ee-scenario.edit": "mfh.capex-ee-scenario.edit",
	"mfh.capex-ee-scenario.create": "mfh.capex-ee-scenario.create",
	"mfh.capex-ee-scenario.delete": "mfh.capex-ee-scenario.delete",
	"mfh.estar-core-id.edit": "mfh.estar-core-id.edit",
	"mfh.events.view": "mfh.events.view",
	"mfh.attributes.view": "mfh.attributes.view",
	"mfh.attributes.edit": "mfh.attributes.edit",
	"mfh.renovation-attributes.edit": "mfh.renovation-attributes.edit",
	"mfh.location.view": "mfh.location.view",
	"mfh.location.edit": "mfh.location.edit",
	"mfh.tasks.view": "mfh.tasks.view",
	"mfh.tasks.edit": "mfh.tasks.edit",
	"mfh.tasks.create": "mfh.tasks.create",
	"mfh.tasks.delete": "mfh.tasks.delete",
	"mfh.project-planning.view": "mfh.project-planning.view",
	"mfh.project-planning.edit": "mfh.project-planning.edit",
	"mfh.project-planning.create": "mfh.project-planning.create",
	"mfh.project-planning.delete": "mfh.project-planning.delete",
	"mfh.calendar.view": "mfh.calendar.view",
	"mfh.calendar.edit": "mfh.calendar.edit",
	"mfh.calendar.create": "mfh.calendar.create",
	"mfh.calendar.delete": "mfh.calendar.delete",
	"mfh.document.view": "mfh.document.view",
	"mfh.document.edit": "mfh.document.edit",
	"mfh.document.upload": "mfh.document.upload",
	"mfh.document.delete": "mfh.document.delete",
	"mfh.renovation-project-config.edit": "mfh.renovation-project-config.edit",
	"mfh.renovation-project.create": "mfh.renovation-project.create",
	"mfh.renovation-project.view": "mfh.renovation-project.view",
	"mfh.renovation-project.edit": "mfh.renovation-project.edit",
	"mfh.renovation-project.delete": "mfh.renovation-project.delete",
	"mfh.renovation-project.review-process.create": "mfh.renovation-project.review-process.create",
	"mfh.renovation-project.review-process.view": "mfh.renovation-project.review-process.view",
	"mfh.renovation-project.review-process.edit": "mfh.renovation-project.review-process.edit",
	"mfh.renovation-project.review-process.process": "mfh.renovation-project.review-process.process",
	"mfh.renovation-project-planning-module.delete": "mfh.renovation-project-planning-module.delete",
	"mfh.renovation-project-position.delete": "mfh.renovation-project-position.delete",
	"mfh.renovation-event.history.view": "mfh.renovation-event.history.view",
	"mfh.renovation-project-lot.delete": "mfh.renovation-project-lot.delete",
	"mfh.elements.create": "mfh.elements.create",
	"mfh.elements.edit": "mfh.elements.edit",
	"mfh.elements.view": "mfh.elements.view",
	"mfh.elements.delete": "mfh.elements.delete",
	"mfh.media.view": "mfh.media.view",
	"mfh.media.edit": "mfh.media.edit",
	"mfh.notes.view": "mfh.notes.view",
	"mfh.notes.create": "mfh.notes.create",
	"mfh.notes.edit": "mfh.notes.edit",
	"mfh.notes.delete": "mfh.notes.delete",
	"mfh.dd.view": "mfh.dd.view",
	"mfh.dd.edit": "mfh.dd.edit",
	"mfh.infas.fetch": "mfh.infas.fetch",
	"mfh.syte.fetch": "mfh.syte.fetch",
	"mfh.syte.debug": "mfh.syte.debug",
	"mfh.investment-case.view": "mfh.investment-case.view",
	"mfh.investment-case.create": "mfh.investment-case.create",
	"mfh.investment-case.edit": "mfh.investment-case.edit",
	"mfh.investment-case.export": "mfh.investment-case.export",
	"mfh.investment-case.upload": "mfh.investment-case.upload",
	"mfh.investment-case.delete": "mfh.investment-case.delete",
	"mfh.investment-case.restore": "mfh.investment-case.restore",
	"mfh.investment-case-admin-input.edit": "mfh.investment-case-admin-input.edit",
	"mfh.asset-analyzer.view": "mfh.asset-analyzer.view",
	"mfh.asset-analyzer.edit-any": "mfh.asset-analyzer.edit-any",
	"mfh.investment-case.copy-as-json": "mfh.investment-case.copy-as-json",
	"mfh.investment-case.paste-as-json": "mfh.investment-case.paste-as-json",
	"mfh.investment-case-review-process.create": "mfh.investment-case-review-process.create",
	"mfh.investment-case-review-process.view": "mfh.investment-case-review-process.view",
	"mfh.investment-case-review-process.edit": "mfh.investment-case-review-process.edit",
	"mfh.investment-case-review-process.process": "mfh.investment-case-review-process.process",
	"mfh-portfolio.process.trigger": "mfh-portfolio.process.trigger",
	"mfh.portfolio-review-process.create": "mfh.portfolio-review-process.create",
	"mfh.portfolio-review-process.view": "mfh.portfolio-review-process.view",
	"mfh.portfolio-review-process.edit": "mfh.portfolio-review-process.edit",
	"mfh.portfolio-review-process.process": "mfh.portfolio-review-process.process",
	"mfh-portfolio.tasks.view": "mfh-portfolio.tasks.view",
	"mfh-portfolio.tasks.edit": "mfh-portfolio.tasks.edit",
	"mfh-portfolio.tasks.create": "mfh-portfolio.tasks.create",
	"mfh-portfolio.tasks.delete": "mfh-portfolio.tasks.delete",
	"mfh.prediction.view": "mfh.prediction.view",
	"mfh.prediction.create": "mfh.prediction.create",
	"mfh.prediction.edit": "mfh.prediction.edit",
	"mfh.prediction.delete": "mfh.prediction.delete",
	"mfh.rent-roll.import": "mfh.rent-roll.import",
	"mfh.rent-roll-version.view": "mfh.rent-roll-version.view",
	"mfh.rent-roll-version.create": "mfh.rent-roll-version.create",
	"mfh.rent-roll-version.edit": "mfh.rent-roll-version.edit",
	"mfh.rent-roll-version.delete": "mfh.rent-roll-version.delete",
	"mfh.placement.view": "mfh.placement.view",
	"mfh.placement.create": "mfh.placement.create",
	"mfh.placement.edit": "mfh.placement.edit",
	"core.sign-off-envelope.create": "core.sign-off-envelope.create",
	"core.sign-off-envelope.cancel": "core.sign-off-envelope.cancel",
	"core.sign-off-envelope.view": "core.sign-off-envelope.view",
	"core.sign-off-envelope.delete": "core.sign-off-envelope.delete",
	"core.sign-off-envelope.list": "core.sign-off-envelope.list",
	"core.sign-off-envelope.edit": "core.sign-off-envelope.edit",
	"core.sign-off-envelope.trigger": "core.sign-off-envelope.trigger",
	"core.sign-off-comment.create": "core.sign-off-comment.create",
	"core.sign-off-comment.view": "core.sign-off-comment.view",
	"core.sign-off-comment.edit": "core.sign-off-comment.edit",
	"core.sign-off-comment.delete": "core.sign-off-comment.delete",
	"core.sign-off-template.create": "core.sign-off-template.create",
	"core.sign-off-template.edit": "core.sign-off-template.edit",
	"renovation.tendering-process.view": "renovation.tendering-process.view",
	"renovation.tendering-process.create": "renovation.tendering-process.create",
	"renovation.tendering-process.edit": "renovation.tendering-process.edit",
	"renovation.tendering-process.delete": "renovation.tendering-process.delete",
	"renovation.addendum.create": "renovation.addendum.create",
	"renovation.addendum.view": "renovation.addendum.view",
	"renovation.addendum.edit": "renovation.addendum.edit",
	"mfh.construction-plan.view": "mfh.construction-plan.view",
	"mfh.construction-plan.edit": "mfh.construction-plan.edit",
	"mfh.construction-plan-approval-matrix.edit": "mfh.construction-plan-approval-matrix.edit",
	"mfh.construction-plan.approve": "mfh.construction-plan.approve",
	"mfh.construction-plan.create": "mfh.construction-plan.create",
	"mfh.construction-plan.delete": "mfh.construction-plan.delete",
	"mfh.construction-plan.archive": "mfh.construction-plan.archive",
	"document.annotation.create": "document.annotation.create",
	"document.annotation.update": "document.annotation.update",
	"document.annotation.update-any": "document.annotation.update-any",
	"document.annotation.delete": "document.annotation.delete",
	"document.annotation.delete-any": "document.annotation.delete-any",
	"renovation.position-cost-allocation.create": "renovation.position-cost-allocation.create",
	"renovation.position-cost-allocation.view": "renovation.position-cost-allocation.view",
	"renovation.contract.view": "renovation.contract.view",
	"renovation.contract.create": "renovation.contract.create",
	"renovation.contract.edit": "renovation.contract.edit",
	"renovation.contract.delete": "renovation.contract.delete",
	"rental.rental-contract-review-process.create": "rental.rental-contract-review-process.create",
	"rental.rental-contract.view": "rental.rental-contract.view",
	"rental.rental-contract.create": "rental.rental-contract.create",
	"rental.rental-contract.edit": "rental.rental-contract.edit",
	"rental.rental-contract.delete": "rental.rental-contract.delete",
	"estate.sourcing.view": "estate.sourcing.view",
	"estate.inspection.review-process.view": "estate.inspection.review-process.view",
	"estate.inspection.review-process.create": "estate.inspection.review-process.create",
	"estate.inspection.review-process.edit": "estate.inspection.review-process.edit",
	"estate.sourcing-inspection.view": "estate.sourcing-inspection.view",
	"estate.sourcing-inspection.create": "estate.sourcing-inspection.create",
	"estate.sourcing-inspection.edit": "estate.sourcing-inspection.edit",
	"estate.sourcing-inspection.delete": "estate.sourcing-inspection.delete",
	"estate.sourcing-document-inspection.view": "estate.sourcing-document-inspection.view",
	"estate.sourcing-document-inspection.create": "estate.sourcing-document-inspection.create",
	"estate.sourcing-document-inspection.edit": "estate.sourcing-document-inspection.edit",
	"estate.sourcing-document-inspection.delete": "estate.sourcing-document-inspection.delete",
	"estate.market-details.view": "estate.market-details.view",
	"estate.market-details.edit": "estate.market-details.edit",
	"estate.predictions.view": "estate.predictions.view",
	"estate.sourcing-investmentcase.view": "estate.sourcing-investmentcase.view",
	"estate.sourcing-investmentcase.create": "estate.sourcing-investmentcase.create",
	"estate.sourcing-investmentcase.edit": "estate.sourcing-investmentcase.edit",
	"estate.sourcing-investmentcase.delete": "estate.sourcing-investmentcase.delete",
	"estate.sourcing-calendar.view": "estate.sourcing-calendar.view",
	"estate.sourcing-calendar.create": "estate.sourcing-calendar.create",
	"estate.sourcing-calendar.edit": "estate.sourcing-calendar.edit",
	"estate.sourcing-calendar.delete": "estate.sourcing-calendar.delete",
	"estate.sourcing-process.reset": "estate.sourcing-process.reset",
	"estate.sourcing-process.view": "estate.sourcing-process.view",
	"estate.sourcing-process.edit": "estate.sourcing-process.edit",
	"estate.purchasing.view": "estate.purchasing.view",
	"estate.purchasing-notes.view": "estate.purchasing-notes.view",
	"estate.purchasing-notes.edit": "estate.purchasing-notes.edit",
	"estate.purchasing-notes.create": "estate.purchasing-notes.create",
	"estate.purchasing-notes.delete": "estate.purchasing-notes.delete",
	"estate.purchasing-calendar.view": "estate.purchasing-calendar.view",
	"estate.purchasing-calendar.edit": "estate.purchasing-calendar.edit",
	"estate.purchasing-calendar.create": "estate.purchasing-calendar.create",
	"estate.purchasing-calendar.delete": "estate.purchasing-calendar.delete",
	"estate.purchasing-financing-info.view": "estate.purchasing-financing-info.view",
	"estate.purchasing-financing-info.edit": "estate.purchasing-financing-info.edit",
	"estate.purchasing-history.view": "estate.purchasing-history.view",
	"estate.purchasing-events.view": "estate.purchasing-events.view",
	"estate.purchasing-process.view": "estate.purchasing-process.view",
	"estate.purchasing-process.edit": "estate.purchasing-process.edit",
	"estate.renovation.view": "estate.renovation.view",
	"estate.renovation-summary.view": "estate.renovation-summary.view",
	"estate.renovation-inspection.view": "estate.renovation-inspection.view",
	"estate.renovation-inspection.edit": "estate.renovation-inspection.edit",
	"estate.renovation-inspection.create": "estate.renovation-inspection.create",
	"estate.renovation-inspection.send": "estate.renovation-inspection.send",
	"estate.renovation-inspection.pdf-generate": "estate.renovation-inspection.pdf-generate",
	"estate.renovation-inspection.delete": "estate.renovation-inspection.delete",
	"estate.renovation-inspection-notes.view": "estate.renovation-inspection-notes.view",
	"estate.renovation-inspection-notes.edit": "estate.renovation-inspection-notes.edit",
	"estate.renovation-inspection-notes.create": "estate.renovation-inspection-notes.create",
	"estate.renovation-inspection-notes.delete": "estate.renovation-inspection-notes.delete",
	"estate.renovation-craft-notes.view": "estate.renovation-craft-notes.view",
	"estate.renovation-craft-notes.edit": "estate.renovation-craft-notes.edit",
	"estate.renovation-craft-notes.create": "estate.renovation-craft-notes.create",
	"estate.renovation-craft-notes.delete": "estate.renovation-craft-notes.delete",
	"estate.renovation-catalogue.view": "estate.renovation-catalogue.view",
	"estate.renovation-catalogue.edit": "estate.renovation-catalogue.edit",
	"estate.renovation-catalogue.create": "estate.renovation-catalogue.create",
	"estate.renovation-catalogue.delete": "estate.renovation-catalogue.delete",
	"estate.renovation-catalogue-pricing.view": "estate.renovation-catalogue-pricing.view",
	"estate.renovation-catalogue-pricing.create": "estate.renovation-catalogue-pricing.create",
	"estate.renovation-catalogue-pricing.edit": "estate.renovation-catalogue-pricing.edit",
	"estate.renovation-catalogue-pricing.delete": "estate.renovation-catalogue-pricing.delete",
	"estate.renovation-contractors.view": "estate.renovation-contractors.view",
	"estate.renovation-milestones.view": "estate.renovation-milestones.view",
	"estate.renovation-milestones.edit": "estate.renovation-milestones.edit",
	"estate.renovation-calendar.view": "estate.renovation-calendar.view",
	"estate.renovation-calendar.edit": "estate.renovation-calendar.edit",
	"estate.renovation-calendar.create": "estate.renovation-calendar.create",
	"estate.renovation-calendar.delete": "estate.renovation-calendar.delete",
	"estate.renovation-dates.view": "estate.renovation-dates.view",
	"estate.renovation-history.view": "estate.renovation-history.view",
	"estate.renovation-events.view": "estate.renovation-events.view",
	"estate.renovation-elements.view": "estate.renovation-elements.view",
	"estate.renovation-elements.edit": "estate.renovation-elements.edit",
	"estate.renovation-elements.create": "estate.renovation-elements.create",
	"estate.renovation-elements.delete": "estate.renovation-elements.delete",
	"estate.renovation-elements.create-from-ifc": "estate.renovation-elements.create-from-ifc",
	"estate.renovation-elements.create-from-pred": "estate.renovation-elements.create-from-pred",
	"estate.renovation-ifc.view": "estate.renovation-ifc.view",
	"estate.renovation-constructionplan.view": "estate.renovation-constructionplan.view",
	"estate.renovation-constructionplan.edit": "estate.renovation-constructionplan.edit",
	"estate.renovation-constructionplan.create": "estate.renovation-constructionplan.create",
	"estate.renovation-constructionplan.edit-budget-origin": "estate.renovation-constructionplan.edit-budget-origin",
	"estate.renovation-constructionplan.actions-all": "estate.renovation-constructionplan.actions-all",
	"estate.renovation-constructionplan.delete": "estate.renovation-constructionplan.delete",
	"estate.renovation-constructionplan.pdf-generate": "estate.renovation-constructionplan.pdf-generate",
	"estate.renovation-constructionplan.send": "estate.renovation-constructionplan.send",
	"estate.renovation-constructionplan-overshoot.edit": "estate.renovation-constructionplan-overshoot.edit",
	"estate.construction-progress.edit": "estate.construction-progress.edit",
	"estate.construction-progress.create": "estate.construction-progress.create",
	"estate.construction-progress.view": "estate.construction-progress.view",
	"estate.renovation-defects.view": "estate.renovation-defects.view",
	"estate.renovation-defects.edit": "estate.renovation-defects.edit",
	"estate.renovation-defects.create": "estate.renovation-defects.create",
	"estate.renovation-defects.delete": "estate.renovation-defects.delete",
	"estate.renovation-defect-history.view": "estate.renovation-defect-history.view",
	"estate.renovation-process.view": "estate.renovation-process.view",
	"estate.renovation-process.edit": "estate.renovation-process.edit",
	"estate.renovation-position.view": "estate.renovation-position.view",
	"estate.renovation-position.edit": "estate.renovation-position.edit",
	"estate.renovation-position.create": "estate.renovation-position.create",
	"estate.renovation-position.delete": "estate.renovation-position.delete",
	"estate.renovation-position.history": "estate.renovation-position.history",
	"estate.renting.view": "estate.renting.view",
	"estate.renting-dates.view": "estate.renting-dates.view",
	"estate.renting-calendar.view": "estate.renting-calendar.view",
	"estate.renting-calendar.edit": "estate.renting-calendar.edit",
	"estate.renting-calendar.create": "estate.renting-calendar.create",
	"estate.renting-calendar.delete": "estate.renting-calendar.delete",
	"estate.renting-history.view": "estate.renting-history.view",
	"estate.renting-listing.view": "estate.renting-listing.view",
	"estate.renting-listing.create": "estate.renting-listing.create",
	"estate.renting-listing.edit": "estate.renting-listing.edit",
	"estate.renting-listing.delete": "estate.renting-listing.delete",
	"estate.renting-listing.prepublish": "estate.renting-listing.prepublish",
	"estate.renting-listing.publish": "estate.renting-listing.publish",
	"estate.renting-listing.unpublish": "estate.renting-listing.unpublish",
	"estate.renting-listing.open-immo-download": "estate.renting-listing.open-immo-download",
	"estate.renting-lead.view": "estate.renting-lead.view",
	"estate.renting-lead.create": "estate.renting-lead.create",
	"estate.renting-lead.edit": "estate.renting-lead.edit",
	"estate.renting-lead.delete": "estate.renting-lead.delete",
	"estate.renting-events.view": "estate.renting-events.view",
	"estate.renting-process.view": "estate.renting-process.view",
	"estate.renting-process.edit": "estate.renting-process.edit",
	"estate.renting-contract.approve": "estate.renting-contract.approve",
	"estate.livings-check.view": "estate.livings-check.view",
	"estate.livings-check.edit": "estate.livings-check.edit",
	"estate.livings-check.create": "estate.livings-check.create",
	"estate.selling.view": "estate.selling.view",
	"estate.selling.edit": "estate.selling.edit",
	"estate.selling-dates.view": "estate.selling-dates.view",
	"estate.selling-documents.create": "estate.selling-documents.create",
	"estate.selling-notes.view": "estate.selling-notes.view",
	"estate.selling-notes.create": "estate.selling-notes.create",
	"estate.selling-notes.edit": "estate.selling-notes.edit",
	"estate.selling-notes.delete": "estate.selling-notes.delete",
	"estate.selling-calendar.view": "estate.selling-calendar.view",
	"estate.selling-calendar.edit": "estate.selling-calendar.edit",
	"estate.selling-calendar.create": "estate.selling-calendar.create",
	"estate.selling-calendar.delete": "estate.selling-calendar.delete",
	"estate.selling-history.view": "estate.selling-history.view",
	"estate.selling-events.view": "estate.selling-events.view",
	"estate.selling-investmentcase.view": "estate.selling-investmentcase.view",
	"estate.selling-investmentcase.create": "estate.selling-investmentcase.create",
	"estate.selling-investmentcase.edit": "estate.selling-investmentcase.edit",
	"estate.selling-investmentcase.delete": "estate.selling-investmentcase.delete",
	"estate.investmentcase.edit": "estate.investmentcase.edit",
	"estate.ict-investmentcase.view": "estate.ict-investmentcase.view",
	"estate.ict-investmentcase.create": "estate.ict-investmentcase.create",
	"estate.ict-investmentcase.execute": "estate.ict-investmentcase.execute",
	"estate.ict-investmentcase.edit": "estate.ict-investmentcase.edit",
	"estate.ict-investmentcase.delete": "estate.ict-investmentcase.delete",
	"estate.selling-process.view": "estate.selling-process.view",
	"estate.selling-process.edit": "estate.selling-process.edit",
	"estate.selling-process.paid": "estate.selling-process.paid",
	"estate.property-management.view": "estate.property-management.view",
	"estate.property-management.edit": "estate.property-management.edit",
	"estate.property-management.delete": "estate.property-management.delete",
	"estate.property-management-rent.view": "estate.property-management-rent.view",
	"estate.property-management-rent.edit": "estate.property-management-rent.edit",
	"estate.propertymanagement-active-past-rent.edit": "estate.propertymanagement-active-past-rent.edit",
	"estate.property-management-rent.create": "estate.property-management-rent.create",
	"estate.property-management-rent.delete": "estate.property-management-rent.delete",
	"estate.propertymanagement-tenancy.view": "estate.propertymanagement-tenancy.view",
	"estate.propertymanagement-tenancy.edit": "estate.propertymanagement-tenancy.edit",
	"estate.propertymanagement-active-past-tenancy.edit": "estate.propertymanagement-active-past-tenancy.edit",
	"estate.propertymanagement-tenancy.create": "estate.propertymanagement-tenancy.create",
	"estate.propertymanagement-tenancy.delete": "estate.propertymanagement-tenancy.delete",
	"estate.propertymanagement-owner.view": "estate.propertymanagement-owner.view",
	"estate.propertymanagement-owner.create": "estate.propertymanagement-owner.create",
	"estate.propertymanagement-owner.edit": "estate.propertymanagement-owner.edit",
	"estate.propertymanagement-owner-annual-statement.view": "estate.propertymanagement-owner-annual-statement.view",
	"estate.propertymanagement-owner-annual-statement.create": "estate.propertymanagement-owner-annual-statement.create",
	"estate.propertymanagement-owner-annual-statement.edit": "estate.propertymanagement-owner-annual-statement.edit",
	"estate.propertymanagement-owner-annual-statement.delete": "estate.propertymanagement-owner-annual-statement.delete",
	"estate.propertymanagement-annual-service-charges.view": "estate.propertymanagement-annual-service-charges.view",
	"estate.propertymanagement-annual-service-charges.create": "estate.propertymanagement-annual-service-charges.create",
	"estate.propertymanagement-annual-service-charges.edit": "estate.propertymanagement-annual-service-charges.edit",
	"estate.propertymanagement-annual-service-charges.delete": "estate.propertymanagement-annual-service-charges.delete",
	"estate.property-management-notes.view": "estate.property-management-notes.view",
	"estate.property-management-notes.edit": "estate.property-management-notes.edit",
	"estate.property-management-notes.create": "estate.property-management-notes.create",
	"estate.property-management-notes.delete": "estate.property-management-notes.delete",
	"estate.propertymanagement-meters.view": "estate.propertymanagement-meters.view",
	"estate.propertymanagement-meters.create": "estate.propertymanagement-meters.create",
	"estate.propertymanagement-meters.edit": "estate.propertymanagement-meters.edit",
	"estate.propertymanagement-meters.delete": "estate.propertymanagement-meters.delete",
	"estate.propertymanagement-calendar.view": "estate.propertymanagement-calendar.view",
	"estate.propertymanagement-calendar.create": "estate.propertymanagement-calendar.create",
	"estate.propertymanagement-calendar.edit": "estate.propertymanagement-calendar.edit",
	"estate.propertymanagement-calendar.delete": "estate.propertymanagement-calendar.delete",
	"estate.propertymanagement-hoa-fee.view": "estate.propertymanagement-hoa-fee.view",
	"estate.propertymanagement-hoa-fee.create": "estate.propertymanagement-hoa-fee.create",
	"estate.propertymanagement-hoa-fee.edit": "estate.propertymanagement-hoa-fee.edit",
	"estate.propertymanagement-hoa-fee.delete": "estate.propertymanagement-hoa-fee.delete",
	"estate.propertymanagement-process.view": "estate.propertymanagement-process.view",
	"estate.propertymanagement-process.edit": "estate.propertymanagement-process.edit",
	"estate.propertymanagement-meter-reading.create": "estate.propertymanagement-meter-reading.create",
	"estate.propertymanagement-meter-reading.delete": "estate.propertymanagement-meter-reading.delete",
	"estate.propertymanagement-tasks.view": "estate.propertymanagement-tasks.view",
	"estate.propertymanagement-tasks.edit": "estate.propertymanagement-tasks.edit",
	"estate.property-management-events.view": "estate.property-management-events.view",
	"estate.property-management-process.future-house-geld": "estate.property-management-process.future-house-geld",
	"estate.tenant-management-process.create": "estate.tenant-management-process.create",
	"estate.tenant-management-process.view": "estate.tenant-management-process.view",
	"estate.tenant-management-process.edit": "estate.tenant-management-process.edit",
	"estate.tenant-management-process.delete": "estate.tenant-management-process.delete",
	"estate.tenant-management-process-events.view": "estate.tenant-management-process-events.view",
	"estate.tenant-management-investor-info-special-deal.edit": "estate.tenant-management-investor-info-special-deal.edit",
	"estate.tenant-management-monthly-investor-info.edit": "estate.tenant-management-monthly-investor-info.edit",
	"estate.owner-management-process.create": "estate.owner-management-process.create",
	"estate.owner-management-process.view": "estate.owner-management-process.view",
	"estate.owner-management-process.edit": "estate.owner-management-process.edit",
	"estate.owner-management-process.delete": "estate.owner-management-process.delete",
	"estate.owner-management-process-events.view": "estate.owner-management-process-events.view",
	"estate.estate-management-process.create": "estate.estate-management-process.create",
	"estate.estate-management-process.view": "estate.estate-management-process.view",
	"estate.estate-management-process.edit": "estate.estate-management-process.edit",
	"estate.estate-management-process.delete": "estate.estate-management-process.delete",
	"estate.estate-management-process-events.view": "estate.estate-management-process-events.view",
	"estate.payment-notice-summary.create": "estate.payment-notice-summary.create",
	"estate.payment-notice-summary.edit": "estate.payment-notice-summary.edit",
	"estate.payment-notice-summary.view": "estate.payment-notice-summary.view",
	"finance.general-ledger-entries.view": "finance.general-ledger-entries.view",
	"finance.general-ledger-entries.edit": "finance.general-ledger-entries.edit",
	"finance.general-ledger-entries.create": "finance.general-ledger-entries.create",
	"finance.general-ledger-entries.delete": "finance.general-ledger-entries.delete",
	"finance.general-ledger-entries.recover": "finance.general-ledger-entries.recover",
	"finance.general-ledger-statements.view": "finance.general-ledger-statements.view",
	"finance.general-ledger-statements.create": "finance.general-ledger-statements.create",
	"finance.sepa-mandate.view": "finance.sepa-mandate.view",
	"finance.sepa-mandate.edit": "finance.sepa-mandate.edit",
	"finance.sepa-mandate.create": "finance.sepa-mandate.create",
	"finance.sepa-mandate.delete": "finance.sepa-mandate.delete",
	"finance.payment-order.export": "finance.payment-order.export",
	"finance.payment-order.view": "finance.payment-order.view",
	"finance.payment-order.update": "finance.payment-order.update",
	"finance.payment-order.create": "finance.payment-order.create",
	"finance.eligible-estates.list": "finance.eligible-estates.list",
	"finance.portfolio.list": "finance.portfolio.list",
	"finance.portfolio.view": "finance.portfolio.view",
	"finance.portfolio.create": "finance.portfolio.create",
	"finance.portfolio.edit": "finance.portfolio.edit",
	"finance.portfolio.delete": "finance.portfolio.delete",
	"finance.portfolio-summary.view": "finance.portfolio-summary.view",
	"finance.portfolio.prepared": "finance.portfolio.prepared",
	"finance.portfolio.revert": "finance.portfolio.revert",
	"finance.portfolio.offer-accepted": "finance.portfolio.offer-accepted",
	"finance.portfolio.loan-created": "finance.portfolio.loan-created",
	"finance.portfolio.actions-all": "finance.portfolio.actions-all",
	"finance.portfolio-document.create": "finance.portfolio-document.create",
	"finance.portfolio-documents.view": "finance.portfolio-documents.view",
	"finance.portfolio-document-folder.generate": "finance.portfolio-document-folder.generate",
	"finance.portfolio-financing-banks.list": "finance.portfolio-financing-banks.list",
	"finance.portfolio-eligible-estates.list": "finance.portfolio-eligible-estates.list",
	"finance.portfolio-loan-offer.view": "finance.portfolio-loan-offer.view",
	"finance.portfolio-loan-offer.create": "finance.portfolio-loan-offer.create",
	"finance.portfolio-loan-offer.edit": "finance.portfolio-loan-offer.edit",
	"finance.portfolio-loan-offer.delete": "finance.portfolio-loan-offer.delete",
	"finance.portfolio-loan-offer.accept": "finance.portfolio-loan-offer.accept",
	"finance.portfolio-notes.view": "finance.portfolio-notes.view",
	"finance.portfolio-notes.create": "finance.portfolio-notes.create",
	"finance.portfolio-notes.delete": "finance.portfolio-notes.delete",
	"finance.loan-application.create": "finance.loan-application.create",
	"finance.loan-account-balance.recalculate": "finance.loan-account-balance.recalculate",
	"finance.tendering.view": "finance.tendering.view",
	"finance.tendering.edit": "finance.tendering.edit",
	"finance.tendering.delete": "finance.tendering.delete",
	"finance.portfolio-history.view": "finance.portfolio-history.view",
	"finance.invoice-history.view": "finance.invoice-history.view",
	"finance.invoice.export": "finance.invoice.export",
	"finance.invoice.list": "finance.invoice.list",
	"finance.invoice.view": "finance.invoice.view",
	"finance.invoice.view.recurrent-payments": "finance.invoice.view.recurrent-payments",
	"finance.invoice.view-all": "finance.invoice.view-all",
	"finance.invoice.view-livings": "finance.invoice.view-livings",
	"finance.invoice.create": "finance.invoice.create",
	"finance.invoice-reminder.create": "finance.invoice-reminder.create",
	"finance.invoice.edit": "finance.invoice.edit",
	"finance.invoice.delete": "finance.invoice.delete",
	"finance.invoice.assign": "finance.invoice.assign",
	"finance.invoice.approve": "finance.invoice.approve",
	"finance.invoice.authorize": "finance.invoice.authorize",
	"finance.invoice.reject": "finance.invoice.reject",
	"finance.invoice.actions-all": "finance.invoice.actions-all",
	"finance.invoice.reset": "finance.invoice.reset",
	"finance.invoice.force-reject": "finance.invoice.force-reject",
	"finance.invoice-notes.view": "finance.invoice-notes.view",
	"finance.invoice-notes.create": "finance.invoice-notes.create",
	"finance.invoice-notes.edit": "finance.invoice-notes.edit",
	"finance.invoice-notes.delete": "finance.invoice-notes.delete",
	"finance.invoice.overwrite": "finance.invoice.overwrite",
	"finance.invoice.review-process.view": "finance.invoice.review-process.view",
	"finance.invoice.review-process.create": "finance.invoice.review-process.create",
	"finance.invoice.review-process.edit": "finance.invoice.review-process.edit",
	"finance.invoice-subscription.list": "finance.invoice-subscription.list",
	"finance.invoice-subscription.view": "finance.invoice-subscription.view",
	"finance.invoice-subscription.create": "finance.invoice-subscription.create",
	"finance.invoice-subscription.edit": "finance.invoice-subscription.edit",
	"finance.invoice-subscription.delete": "finance.invoice-subscription.delete",
	"finance.invoice-subscription-document.create": "finance.invoice-subscription-document.create",
	"finance.invoice-subscription-invoices.generate": "finance.invoice-subscription-invoices.generate",
	"finance.bank-transaction.list": "finance.bank-transaction.list",
	"finance.bank-transaction.view": "finance.bank-transaction.view",
	"finance.bank-transaction.edit": "finance.bank-transaction.edit",
	"finance.bank-transaction.delete": "finance.bank-transaction.delete",
	"finance.bank-transaction.book": "finance.bank-transaction.book",
	"finance.credit-line-portfolio.create": "finance.credit-line-portfolio.create",
	"finance.credit-line-portfolio.view": "finance.credit-line-portfolio.view",
	"finance.credit-line-portfolio.edit": "finance.credit-line-portfolio.edit",
	"finance.credit-line-portfolio.delete": "finance.credit-line-portfolio.delete",
	"finance.cash-flow-predictions.create": "finance.cash-flow-predictions.create",
	"finance.investor-cashflow.view": "finance.investor-cashflow.view",
	"finance.investor-cashflow.create": "finance.investor-cashflow.create",
	"finance.investor-cashflow.edit": "finance.investor-cashflow.edit",
	"finance.sales-package.create": "finance.sales-package.create",
	"finance.sales-package.view": "finance.sales-package.view",
	"finance.sales-package.edit": "finance.sales-package.edit",
	"finance.sales-package-estate.add": "finance.sales-package-estate.add",
	"finance.sales-package-estate.delete": "finance.sales-package-estate.delete",
	"finance.sales-package-review-process.create": "finance.sales-package-review-process.create",
	"finance.sales-package-review-process.view": "finance.sales-package-review-process.view",
	"finance.sales-package-notes.create": "finance.sales-package-notes.create",
	"finance.sales-package-notes.delete": "finance.sales-package-notes.delete",
	"finance.sales-package-notes.view": "finance.sales-package-notes.view",
	"finance.sales-package-history.view": "finance.sales-package-history.view",
	"finance.payment-notice-summary.approve": "finance.payment-notice-summary.approve",
	"finance.payment-notice-summary.set-as-ready-for-review": "finance.payment-notice-summary.set-as-ready-for-review",
	"finance.special-deal.view": "finance.special-deal.view",
	"finance.special-deal.create": "finance.special-deal.create",
	"finance.special-deal.edit": "finance.special-deal.edit",
	"finance.estate.edit.is-special-deal-locked": "finance.estate.edit.is-special-deal-locked",
	"core.document.view": "core.document.view",
	"core.accounting.view": "core.accounting.view",
	"core.contact.view": "core.contact.view",
	"core.contact.list": "core.contact.list",
	"core.contact.create": "core.contact.create",
	"core.contact.edit": "core.contact.edit",
	"core.contact.delete": "core.contact.delete",
	"core.contact.merge": "core.contact.merge",
	"core.contact-estates.view": "core.contact-estates.view",
	"core.contact-documents.view": "core.contact-documents.view",
	"core.contact-document.upload": "core.contact-document.upload",
	"core.contact-documents.edit": "core.contact-documents.edit",
	"core.contact-document.delete": "core.contact-document.delete",
	"core.contact-invoices.view": "core.contact-invoices.view",
	"core.contact-notes.create": "core.contact-notes.create",
	"core.contact-notes.view": "core.contact-notes.view",
	"core.contact-notes.delete": "core.contact-notes.delete",
	"core.contact-bank-accounts.view": "core.contact-bank-accounts.view",
	"core.contact-bank-account.create": "core.contact-bank-account.create",
	"core.contact-accounting.edit": "core.contact-accounting.edit",
	"core.company.view": "core.company.view",
	"core.company.list": "core.company.list",
	"core.company-purchasing-entity.list": "core.company-purchasing-entity.list",
	"core.company-distribution-partner.list": "core.company-distribution-partner.list",
	"core.company-bank.list": "core.company-bank.list",
	"core.company.create": "core.company.create",
	"core.company.edit": "core.company.edit",
	"core.company.delete": "core.company.delete",
	"core.company-estates.view": "core.company-estates.view",
	"core.company-contacts.view": "core.company-contacts.view",
	"core.company-contacts.create": "core.company-contacts.create",
	"core.company-contacts.edit": "core.company-contacts.edit",
	"core.company-contacts.delete": "core.company-contacts.delete",
	"core.company-contractor-capacity.view": "core.company-contractor-capacity.view",
	"core.company-contractor-capacity.edit": "core.company-contractor-capacity.edit",
	"core.company-contractor-agreed-capacity.edit": "core.company-contractor-agreed-capacity.edit",
	"core.company-documents.view": "core.company-documents.view",
	"core.company-document.upload": "core.company-document.upload",
	"core.company-document.edit": "core.company-document.edit",
	"core.company-document.delete": "core.company-document.delete",
	"core.company-invoices.view": "core.company-invoices.view",
	"core.company-notes.view": "core.company-notes.view",
	"core.company-notes.create": "core.company-notes.create",
	"core.company-notes.delete": "core.company-notes.delete",
	"core.company-bank-accounts.view": "core.company-bank-accounts.view",
	"core.company-bank-account.create": "core.company-bank-account.create",
	"core.company-accounting.edit": "core.company-accounting.edit",
	"core.process.view": "core.process.view",
	"core.process.list": "core.process.list",
	"core.process.edit": "core.process.edit",
	"core.process.create": "core.process.create",
	"core.company-employment.create": "core.company-employment.create",
	"core.company-employment.delete": "core.company-employment.delete",
	"core.task.list": "core.task.list",
	"core.task.edit": "core.task.edit",
	"core.task.create": "core.task.create",
	"core.task.delete": "core.task.delete",
	"core.task-template.list": "core.task-template.list",
	"core.task-template.edit": "core.task-template.edit",
	"core.task-template.create": "core.task-template.create",
	"core.task-template.delete": "core.task-template.delete",
	"core.file.get": "core.file.get",
	"core.calendar.view": "core.calendar.view",
	"core.calendar.subscribe-all": "core.calendar.subscribe-all",
	"core.calendar.subscribe-sourcing": "core.calendar.subscribe-sourcing",
	"core.calendar.subscribe-purchasing": "core.calendar.subscribe-purchasing",
	"core.calendar.subscribe-renovation": "core.calendar.subscribe-renovation",
	"core.calendar.subscribe-renting": "core.calendar.subscribe-renting",
	"core.calendar.subscribe-selling": "core.calendar.subscribe-selling",
	"core.calendar.subscribe-propertymanagement": "core.calendar.subscribe-propertymanagement",
	"core.basecamp-maintenance.run": "core.basecamp-maintenance.run",
	"core.basecamp-maintenance.estate-export": "core.basecamp-maintenance.estate-export",
	"core.review-process.create": "core.review-process.create",
	"core.review-process.view": "core.review-process.view",
	"core.review-process.edit": "core.review-process.edit",
	"core.review-process.delete": "core.review-process.delete",
	"core.review-process.process": "core.review-process.process",
	"portfolio.review-process.create": "portfolio.review-process.create",
	"portfolio.review-process.view": "portfolio.review-process.view",
	"portfolio.review-process.edit": "portfolio.review-process.edit",
	"portfolio.review-process.delete": "portfolio.review-process.delete",
	"portfolio.review-process.process": "portfolio.review-process.process",
	"investment-case.review-process.create": "investment-case.review-process.create",
	"investment-case.review-process.view": "investment-case.review-process.view",
	"investment-case.review-process.edit": "investment-case.review-process.edit",
	"investment-case.review-process.delete": "investment-case.review-process.delete",
	"investment-case.review-process.process": "investment-case.review-process.process",
	"construction-plan.review-process.create": "construction-plan.review-process.create",
	"construction-plan.review-process.view": "construction-plan.review-process.view",
	"construction-plan.review-process.edit": "construction-plan.review-process.edit",
	"construction-plan.review-process.delete": "construction-plan.review-process.delete",
	"construction-plan.review-process.process": "construction-plan.review-process.process",
	"authz.permission.view": "authz.permission.view",
	"authz.role-binding.view": "authz.role-binding.view",
	"authz.role-binding.edit": "authz.role-binding.edit",
	"authz.role-binding.create": "authz.role-binding.create",
	"authz.role-binding.delete": "authz.role-binding.delete",
	"authz.role-binding.impersonate": "authz.role-binding.impersonate",
	"authz.role.edit": "authz.role.edit",
	"authz.role.create": "authz.role.create",
	"authz.role.delete": "authz.role.delete",
	"authz.user.view": "authz.user.view",
	"authz.user.edit": "authz.user.edit",
	"authz.user.create": "authz.user.create",
	"authz.user.delete": "authz.user.delete",
	"external.dashboard.view": "external.dashboard.view",
	"administration.internal-user.create": "administration.internal-user.create",
	"administration.external-user.create": "administration.external-user.create",
	"administration.rules.view": "administration.rules.view",
	"administration.rules.edit": "administration.rules.edit",
	"administration.rules.delete": "administration.rules.delete",
	"administration.rules.create": "administration.rules.create",
	"administration.user-company-functions.view": "administration.user-company-functions.view",
	"administration.user-company-functions.edit": "administration.user-company-functions.edit",
	"administration.user-company-functions.delete": "administration.user-company-functions.delete",
	"administration.location.view": "administration.location.view",
	"administration.location.edit": "administration.location.edit",
	"administration.location.create": "administration.location.create",
	"administration.location-profile.edit": "administration.location-profile.edit",
	"administration.location-profile.delete": "administration.location-profile.delete",
	"administration.ledger.view": "administration.ledger.view",
	"administration.ledger-entry.create": "administration.ledger-entry.create",
	"administration.ledger.recover": "administration.ledger.recover",
	"administration.renovation-inspection-questions.create": "administration.renovation-inspection-questions.create",
	"administration.renovation-inspection-questions.edit": "administration.renovation-inspection-questions.edit",
	"administration.renovation-inspection-questions.delete": "administration.renovation-inspection-questions.delete",
	"administration.loan-account.edit": "administration.loan-account.edit",
	"administration.loan-account.delete": "administration.loan-account.delete",
	"administration.loan-account.view": "administration.loan-account.view",
	"administration.loan-account.create": "administration.loan-account.create",
	"administration.bank-account.edit": "administration.bank-account.edit",
	"administration.bank-account.delete": "administration.bank-account.delete",
	"administration.bank-account.view": "administration.bank-account.view",
	"administration.bank-account.create": "administration.bank-account.create",
	"administration.bank-account-transaction.create": "administration.bank-account-transaction.create",
	"administration.bank-account-transaction.delete": "administration.bank-account-transaction.delete",
	"administration.loan-account-drawdown.create": "administration.loan-account-drawdown.create",
	"administration.loan-account-drawdown.delete": "administration.loan-account-drawdown.delete",
	"administration.loan-account-drawdown.receive": "administration.loan-account-drawdown.receive",
	"administration.investor-statement.create": "administration.investor-statement.create"
};
//#endregion
//#region src/basecamp/gen/models/documentModels/CreateLinkDocument.ts
const CreateLinkDocumentMutationRequestConstructionCraft = { Demolition: "Demolition" };
const CreateLinkDocumentMutationRequestConstructionCraft2 = { HSE: "HSE" };
const CreateLinkDocumentMutationRequestConstructionCraft3 = { Bricklayer: "Bricklayer" };
const CreateLinkDocumentMutationRequestConstructionCraft4 = { Drywall: "Drywall" };
const CreateLinkDocumentMutationRequestConstructionCraft5 = { Painting: "Painting" };
const CreateLinkDocumentMutationRequestConstructionCraft6 = { Tiling: "Tiling" };
const CreateLinkDocumentMutationRequestConstructionCraft7 = { Flooring: "Flooring" };
const CreateLinkDocumentMutationRequestConstructionCraft8 = { Carpenter: "Carpenter" };
const CreateLinkDocumentMutationRequestConstructionCraft9 = { Kitchen: "Kitchen" };
const CreateLinkDocumentMutationRequestConstructionCraft10 = { Finishing: "Finishing" };
const CreateLinkDocumentMutationRequestConstructionCraft11 = { Electrical: "Electrical" };
const CreateLinkDocumentMutationRequestConstructionCraft12 = { Other: "Other" };
const CreateLinkDocumentMutationRequestFileCategory = { Document: "Document" };
const CreateLinkDocumentMutationRequestFileCategory2 = { MediaFile: "MediaFile" };
const CreateLinkDocumentMutationRequestCategory = { Listing: "Listing" };
const CreateLinkDocumentMutationRequestCategory2 = { Inspection: "Inspection" };
const CreateLinkDocumentMutationRequestCategory3 = { PreRenovation: "PreRenovation" };
const CreateLinkDocumentMutationRequestCategory4 = { PostRenovation: "PostRenovation" };
const CreateLinkDocumentMutationRequestCategory5 = { Renovation: "Renovation" };
const CreateLinkDocumentMutationRequestCategory6 = { Avatar: "Avatar" };
const CreateLinkDocumentMutationRequestCategory7 = { Other: "Other" };
const CreateLinkDocumentMutationRequestCategory8 = { PropertyManagement: "PropertyManagement" };
const CreateLinkDocumentMutationRequestCategory9 = { Livings: "Livings" };
const CreateLinkDocumentMutationRequestCategory10 = { TechnicalDDInspection: "TechnicalDDInspection" };
const DuplicateCheckConfigScope = { global: "global" };
const DuplicateCheckConfigScope2 = { folder: "folder" };
const DuplicateCheckConfigMode = { hash: "hash" };
const DuplicateCheckConfigMode2 = { filename: "filename" };
const DuplicateCheckConfigMode3 = { hashAndFilename: "hashAndFilename" };
//#endregion
//#region src/basecamp/gen/models/documentModels/FindDocuments.ts
const QueryDocumentTypes = { EbicsAuthorizationLetter: "EbicsAuthorizationLetter" };
const QueryDocumentTypes2 = { PaymentOrder: "PaymentOrder" };
const QueryDocumentTypes3 = { LoanOfferTermSheet: "LoanOfferTermSheet" };
const QueryDocumentTypes4 = { LoanContract: "LoanContract" };
const QueryDocumentTypes5 = { PortfolioInvestmentPlan: "PortfolioInvestmentPlan" };
const QueryDocumentTypes6 = { PurchasingDrawdownRequest: "PurchasingDrawdownRequest" };
const QueryDocumentTypes7 = { InvoicesDrawdownRequest: "InvoicesDrawdownRequest" };
const QueryDocumentTypes8 = { RenovationAcceptanceReport: "RenovationAcceptanceReport" };
const QueryDocumentTypes9 = { ConstructionSiteReport: "ConstructionSiteReport" };
const QueryDocumentTypes10 = { GeneratedInvoiceSubscriptionInvoice: "GeneratedInvoiceSubscriptionInvoice" };
const QueryDocumentTypes11 = { InvoiceApprovalSlip: "InvoiceApprovalSlip" };
const QueryDocumentTypes12 = { InvoiceInXML: "InvoiceInXML" };
const QueryDocumentTypes13 = { InvoiceInPDF: "InvoiceInPDF" };
const QueryDocumentTypes14 = { InvoiceOutPDF: "InvoiceOutPDF" };
const QueryDocumentTypes15 = { Invoice: "Invoice" };
const QueryDocumentTypes16 = { SubscriptionContract: "SubscriptionContract" };
const QueryDocumentTypes17 = { ProtocolArchived: "ProtocolArchived" };
const QueryDocumentTypes18 = { Protocol2024: "Protocol2024" };
const QueryDocumentTypes19 = { Protocol2025: "Protocol2025" };
const QueryDocumentTypes20 = { Protocol2026: "Protocol2026" };
const QueryDocumentTypes21 = { ArchiveOfResolutions: "ArchiveOfResolutions" };
const QueryDocumentTypes22 = { InvitationETV: "InvitationETV" };
const QueryDocumentTypes23 = { AnnualStatement: "AnnualStatement" };
const QueryDocumentTypes24 = { EconomicPlan: "EconomicPlan" };
const QueryDocumentTypes25 = { HomeOwnerFeeStatement: "HomeOwnerFeeStatement" };
const QueryDocumentTypes26 = { BuildingInsurance: "BuildingInsurance" };
const QueryDocumentTypes27 = { EnergyCertificate: "EnergyCertificate" };
const QueryDocumentTypes28 = { PropertyTaxNotice: "PropertyTaxNotice" };
const QueryDocumentTypes29 = { ConstructionBurdenStatement: "ConstructionBurdenStatement" };
const QueryDocumentTypes30 = { AbstractOfTitle: "AbstractOfTitle" };
const QueryDocumentTypes31 = { DeclarationOfCondominium: "DeclarationOfCondominium" };
const QueryDocumentTypes32 = { AmendmentToDeclarationOfDivision: "AmendmentToDeclarationOfDivision" };
const QueryDocumentTypes33 = { AllowanceOfEntrySectionII: "AllowanceOfEntrySectionII" };
const QueryDocumentTypes34 = { SeparationDeclaration: "SeparationDeclaration" };
const QueryDocumentTypes35 = { PartitionPlan: "PartitionPlan" };
const QueryDocumentTypes36 = { Floorplans: "Floorplans" };
const QueryDocumentTypes37 = { ViewsAndSections: "ViewsAndSections" };
const QueryDocumentTypes38 = { LivingSpaceCalculation: "LivingSpaceCalculation" };
const QueryDocumentTypes39 = { ConstructionDescriptionBuilding: "ConstructionDescriptionBuilding" };
const QueryDocumentTypes40 = { HouseRules: "HouseRules" };
const QueryDocumentTypes41 = { LandRegisterMap: "LandRegisterMap" };
const QueryDocumentTypes42 = { ManagementAgreement: "ManagementAgreement" };
const QueryDocumentTypes43 = { SpecialAssessments: "SpecialAssessments" };
const QueryDocumentTypes44 = { Other: "Other" };
const QueryDocumentTypes45 = { EstateMedia: "EstateMedia" };
const QueryDocumentTypes46 = { BuildingPermit: "BuildingPermit" };
const QueryDocumentTypes47 = { Expose: "Expose" };
const QueryDocumentTypes48 = { ExposeExternal: "ExposeExternal" };
const QueryDocumentTypes49 = { ContractDraft: "ContractDraft" };
const QueryDocumentTypes50 = { ContractNotarized: "ContractNotarized" };
const QueryDocumentTypes51 = { LandCharge: "LandCharge" };
const QueryDocumentTypes52 = { PaymentNotice: "PaymentNotice" };
const QueryDocumentTypes53 = { RegistrationNotice: "RegistrationNotice" };
const QueryDocumentTypes54 = { NotaryCorrespondence: "NotaryCorrespondence" };
const QueryDocumentTypes55 = { AdministrationCorrespondence: "AdministrationCorrespondence" };
const QueryDocumentTypes56 = { NotaryRegistrationReservation: "NotaryRegistrationReservation" };
const QueryDocumentTypes57 = { SEPAMandateHomeOwnersFee: "SEPAMandateHomeOwnersFee" };
const QueryDocumentTypes58 = { PurchasingHandoverProtocol: "PurchasingHandoverProtocol" };
const QueryDocumentTypes59 = { ProofOfPayment: "ProofOfPayment" };
const QueryDocumentTypes60 = { SellingExpose: "SellingExpose" };
const QueryDocumentTypes61 = { PromotionExpose: "PromotionExpose" };
const QueryDocumentTypes62 = { CustomizedSellingExpose: "CustomizedSellingExpose" };
const QueryDocumentTypes63 = { SellingExposeSlip: "SellingExposeSlip" };
const QueryDocumentTypes64 = { SellingCalculations: "SellingCalculations" };
const QueryDocumentTypes65 = { SellingCalculationsSlip: "SellingCalculationsSlip" };
const QueryDocumentTypes66 = { SellingContractDraft: "SellingContractDraft" };
const QueryDocumentTypes67 = { SellingContractSummary: "SellingContractSummary" };
const QueryDocumentTypes68 = { SellingContractNotarized: "SellingContractNotarized" };
const QueryDocumentTypes69 = { SellingPaymentNotice: "SellingPaymentNotice" };
const QueryDocumentTypes70 = { SellingRenovationAcceptanceProtocol: "SellingRenovationAcceptanceProtocol" };
const QueryDocumentTypes71 = { SellingRegistrationNotice: "SellingRegistrationNotice" };
const QueryDocumentTypes72 = { SellingNotaryCorrespondence: "SellingNotaryCorrespondence" };
const QueryDocumentTypes73 = { SellingAdministrationCorrespondence: "SellingAdministrationCorrespondence" };
const QueryDocumentTypes74 = { SellingDataSheet: "SellingDataSheet" };
const QueryDocumentTypes75 = { SellingNotaryRegistrationReservation: "SellingNotaryRegistrationReservation" };
const QueryDocumentTypes76 = { SellingHandoverProtocol: "SellingHandoverProtocol" };
const QueryDocumentTypes77 = { SellingExpertReportWithCapEx: "SellingExpertReportWithCapEx" };
const QueryDocumentTypes78 = { SellingExpertReport: "SellingExpertReport" };
const QueryDocumentTypes79 = { SellingResidualValueCertificate: "SellingResidualValueCertificate" };
const QueryDocumentTypes80 = { BuildingModernizationMeasures: "BuildingModernizationMeasures" };
const QueryDocumentTypes81 = { SellingExposeLocation: "SellingExposeLocation" };
const QueryDocumentTypes82 = { SellingAbstractOfTitle: "SellingAbstractOfTitle" };
const QueryDocumentTypes83 = { NotaryCertification: "NotaryCertification" };
const QueryDocumentTypes84 = { SellingProofOfPayment: "SellingProofOfPayment" };
const QueryDocumentTypes85 = { LandRegisterParkingSpace: "LandRegisterParkingSpace" };
const QueryDocumentTypes86 = { BuildingAcceptancePowerOfAttorney: "BuildingAcceptancePowerOfAttorney" };
const QueryDocumentTypes87 = { LocationProfile: "LocationProfile" };
const QueryDocumentTypes88 = { BuildingInformationModel: "BuildingInformationModel" };
const QueryDocumentTypes89 = { FloorPlanSketch: "FloorPlanSketch" };
const QueryDocumentTypes90 = { DimensionedFloorPlan: "DimensionedFloorPlan" };
const QueryDocumentTypes91 = { DimensionedFloorPlanPlanned: "DimensionedFloorPlanPlanned" };
const QueryDocumentTypes92 = { CadFile: "CadFile" };
const QueryDocumentTypes93 = { CadFilePlanned: "CadFilePlanned" };
const QueryDocumentTypes94 = { LV: "LV" };
const QueryDocumentTypes95 = { LongLV: "LongLV" };
const QueryDocumentTypes96 = { Kitchen: "Kitchen" };
const QueryDocumentTypes97 = { KitchenContracted: "KitchenContracted" };
const QueryDocumentTypes98 = { Inspection: "Inspection" };
const QueryDocumentTypes99 = { ConstructionContract: "ConstructionContract" };
const QueryDocumentTypes100 = { ContractorOffer: "ContractorOffer" };
const QueryDocumentTypes101 = { RevisionDocumentation: "RevisionDocumentation" };
const QueryDocumentTypes102 = { ReportsCalculationsAppraisals: "ReportsCalculationsAppraisals" };
const QueryDocumentTypes103 = { ConstructionGuarantee: "ConstructionGuarantee" };
const QueryDocumentTypes104 = { BathPlan: "BathPlan" };
const QueryDocumentTypes105 = { StructuredLvSheet: "StructuredLvSheet" };
const QueryDocumentTypes106 = { RenovationCostTrackingSheet: "RenovationCostTrackingSheet" };
const QueryDocumentTypes107 = { MfhConstructionPlan: "MfhConstructionPlan" };
const QueryDocumentTypes108 = { ConstructionDescriptionRenovation: "ConstructionDescriptionRenovation" };
const QueryDocumentTypes109 = { PostRenovationDimensionedFloorPlan: "PostRenovationDimensionedFloorPlan" };
const QueryDocumentTypes110 = { SalesPartnerFloorPlan: "SalesPartnerFloorPlan" };
const QueryDocumentTypes111 = { LivingSpaceCalculations: "LivingSpaceCalculations" };
const QueryDocumentTypes112 = { BeforeAfterPictures: "BeforeAfterPictures" };
const QueryDocumentTypes113 = { PostRenovationAcceptanceProtocol: "PostRenovationAcceptanceProtocol" };
const QueryDocumentTypes114 = { RoomVolumeCalculation: "RoomVolumeCalculation" };
const QueryDocumentTypes115 = { RentContract: "RentContract" };
const QueryDocumentTypes116 = { RentIncrease: "RentIncrease" };
const QueryDocumentTypes117 = { AcceptanceProtocol: "AcceptanceProtocol" };
const QueryDocumentTypes118 = { HeatingBill: "HeatingBill" };
const QueryDocumentTypes119 = { Correspondence: "Correspondence" };
const QueryDocumentTypes120 = { SelfAssessmentSheet: "SelfAssessmentSheet" };
const QueryDocumentTypes121 = { ID: "ID" };
const QueryDocumentTypes122 = { SalaryInformation: "SalaryInformation" };
const QueryDocumentTypes123 = { SchufaReport: "SchufaReport" };
const QueryDocumentTypes124 = { Deposit: "Deposit" };
const QueryDocumentTypes125 = { HousingProviderConfirmation: "HousingProviderConfirmation" };
const QueryDocumentTypes126 = { SEVContract: "SEVContract" };
const QueryDocumentTypes127 = { SEVContractWithFee: "SEVContractWithFee" };
const QueryDocumentTypes128 = { SEVContractWithoutFee: "SEVContractWithoutFee" };
const QueryDocumentTypes129 = { SEVPoA: "SEVPoA" };
const QueryDocumentTypes130 = { DkbInvestorVerification: "DkbInvestorVerification" };
const QueryDocumentTypes131 = { SEVCoverLetter: "SEVCoverLetter" };
const QueryDocumentTypes132 = { GDPRTenant: "GDPRTenant" };
const QueryDocumentTypes133 = { GDPROwner: "GDPROwner" };
const QueryDocumentTypes134 = { PersonalIDOwner: "PersonalIDOwner" };
const QueryDocumentTypes135 = { SEPAManadateHouseGeld: "SEPAManadateHouseGeld" };
const QueryDocumentTypes136 = { SEPATenant: "SEPATenant" };
const QueryDocumentTypes137 = { WithdrawlInstructionTenant: "WithdrawlInstructionTenant" };
const QueryDocumentTypes138 = { WithdrawlInstructionOwner: "WithdrawlInstructionOwner" };
const QueryDocumentTypes139 = { TenantCorrespondence: "TenantCorrespondence" };
const QueryDocumentTypes140 = { OwnerCorrespondence: "OwnerCorrespondence" };
const QueryDocumentTypes141 = { UtilitiesCorrespondence: "UtilitiesCorrespondence" };
const QueryDocumentTypes142 = { CancellationLease: "CancellationLease" };
const QueryDocumentTypes143 = { CancellationLeaseConfirmation: "CancellationLeaseConfirmation" };
const QueryDocumentTypes144 = { CancellationSEVContract: "CancellationSEVContract" };
const QueryDocumentTypes145 = { CancellationSEVContractConfirmation: "CancellationSEVContractConfirmation" };
const QueryDocumentTypes146 = { CondoTerminationAgreement: "CondoTerminationAgreement" };
const QueryDocumentTypes147 = { LegalDisputes: "LegalDisputes" };
const QueryDocumentTypes148 = { EstateInvestorShare: "EstateInvestorShare" };
const QueryDocumentTypes149 = { EstateAggregatedInvestorShare: "EstateAggregatedInvestorShare" };
const QueryDocumentTypes150 = { WEGAnnualStatement: "WEGAnnualStatement" };
const QueryDocumentTypes151 = { InvoicesPropertyManagement: "InvoicesPropertyManagement" };
const QueryDocumentTypes152 = { EstateRentReport: "EstateRentReport" };
const QueryDocumentTypes153 = { CorrespondencePropertyManagement: "CorrespondencePropertyManagement" };
const QueryDocumentTypes154 = { SalutationWEG: "SalutationWEG" };
const QueryDocumentTypes155 = { InvestorPayout: "InvestorPayout" };
const QueryDocumentTypes156 = { InvestorYearlyPayout: "InvestorYearlyPayout" };
const QueryDocumentTypes157 = { InvestorYearlyPayoutLegacy: "InvestorYearlyPayoutLegacy" };
const QueryDocumentTypes158 = { RentArrearNotice: "RentArrearNotice" };
const QueryDocumentTypes159 = { RentGuarantee: "RentGuarantee" };
const QueryDocumentTypes160 = { DunningNotice: "DunningNotice" };
const QueryDocumentTypes161 = { EnforcementNotice: "EnforcementNotice" };
const QueryDocumentTypes162 = { BKAStatement: "BKAStatement" };
const QueryDocumentTypes163 = { BKAHeatingStatement: "BKAHeatingStatement" };
const QueryDocumentTypes164 = { BKAAllocationCalculation: "BKAAllocationCalculation" };
const QueryDocumentTypes165 = { BKAHouseholdCosts: "BKAHouseholdCosts" };
const QueryDocumentTypes166 = { BKADeposit: "BKADeposit" };
const QueryDocumentTypes167 = { SelfDeclarationTenant: "SelfDeclarationTenant" };
const QueryDocumentTypes168 = { QuestionnaireTenant: "QuestionnaireTenant" };
const QueryDocumentTypes169 = { RentalContractDraft: "RentalContractDraft" };
const QueryDocumentTypes170 = { SalaryRecordPropesctiveTenant: "SalaryRecordPropesctiveTenant" };
const QueryDocumentTypes171 = { SchufaProspectiveTenant: "SchufaProspectiveTenant" };
const QueryDocumentTypes172 = { AnnualServiceChargeCalculation: "AnnualServiceChargeCalculation" };
const QueryDocumentTypes173 = { PersonalIDProspectiveTenant: "PersonalIDProspectiveTenant" };
const QueryDocumentTypes174 = { Safe: "Safe" };
const QueryDocumentTypes175 = { Estate: "Estate" };
const QueryDocumentTypes176 = { BasementRoom: "BasementRoom" };
const QueryDocumentTypes177 = { AtticRoom: "AtticRoom" };
const QueryDocumentTypes178 = { CommonRoom: "CommonRoom" };
const QueryDocumentTypes179 = { Parking: "Parking" };
const QueryDocumentTypes180 = { FurniturePlanPdf: "FurniturePlanPdf" };
const QueryDocumentTypes181 = { FurniturePlanDwg: "FurniturePlanDwg" };
const QueryDocumentTypes182 = { RequestedOrderLists: "RequestedOrderLists" };
const QueryDocumentTypes183 = { ContractedOrderLists: "ContractedOrderLists" };
const QueryDocumentTypes184 = { PartnerBrochure: "PartnerBrochure" };
const QueryDocumentTypes185 = { InvoicesFittings: "InvoicesFittings" };
const QueryDocumentTypes186 = { InvoicesServiceProvider: "InvoicesServiceProvider" };
const QueryDocumentTypes187 = { Internet: "Internet" };
const QueryDocumentTypes188 = { LivingsAcceptanceProtocol: "LivingsAcceptanceProtocol" };
const QueryDocumentTypes189 = { PortfolioInspectionSheet: "PortfolioInspectionSheet" };
const QueryDocumentTypes190 = { CreditLineCashflowPredictions: "CreditLineCashflowPredictions" };
const QueryDocumentTypes191 = { CreditLineBudgetCosts: "CreditLineBudgetCosts" };
const QueryDocumentTypes192 = { EstateInvestorCashflow: "EstateInvestorCashflow" };
const QueryDocumentTypes193 = { SalesPackageFinalSheet: "SalesPackageFinalSheet" };
const QueryDocumentTypes194 = { SalesPackageDataSheet: "SalesPackageDataSheet" };
const QueryDocumentTypes195 = { SalesPackageNotarySheet: "SalesPackageNotarySheet" };
const QueryDocumentTypes196 = { SalesPackageChecklist: "SalesPackageChecklist" };
const QueryDocumentTypes197 = { SalesPackageSellingCompanies: "SalesPackageSellingCompanies" };
const QueryDocumentTypes198 = { PurchasingDocumentsSheet: "PurchasingDocumentsSheet" };
const QueryDocumentTypes199 = { SellingDocumentsSheet: "SellingDocumentsSheet" };
const QueryDocumentTypes200 = { SellingDataChecklist: "SellingDataChecklist" };
const QueryDocumentTypes201 = { SellingEstatesDataSheet: "SellingEstatesDataSheet" };
const QueryDocumentTypes202 = { CashflowStatementSheet: "CashflowStatementSheet" };
const QueryDocumentTypes203 = { InvestorPaymentSlip: "InvestorPaymentSlip" };
const QueryDocumentTypes204 = { InvestorPayoutStatement: "InvestorPayoutStatement" };
const QueryDocumentTypes205 = { DefectReport: "DefectReport" };
const QueryDocumentTypes206 = { SalesPackageUserUploadedPriceList: "SalesPackageUserUploadedPriceList" };
const QueryDocumentTypes207 = { SalesPackageUserUploadedDataSheet: "SalesPackageUserUploadedDataSheet" };
const QueryDocumentTypes208 = { SalesPackageUserUploadedChecklist: "SalesPackageUserUploadedChecklist" };
const QueryDocumentTypes209 = { SalesPackageUserUploadedPhotoAlbum: "SalesPackageUserUploadedPhotoAlbum" };
const QueryDocumentTypes210 = { SellingRegionBrochure: "SellingRegionBrochure" };
const QueryDocumentTypes211 = { TransferRecurrentPaymentsSEPAXmlList: "TransferRecurrentPaymentsSEPAXmlList" };
const QueryDocumentTypes212 = { CondoSellingPresentation: "CondoSellingPresentation" };
const QueryDocumentTypes213 = { SalesPartnerFlyer: "SalesPartnerFlyer" };
const QueryDocumentTypes214 = { PropertyManagementOwnerBrochure: "PropertyManagementOwnerBrochure" };
const QueryDocumentTypes215 = { ModelPurchaseContract: "ModelPurchaseContract" };
const QueryDocumentTypes216 = { ModelRentalContract: "ModelRentalContract" };
const QueryDocumentTypes217 = { ModelPropertyManagementContractWithFee: "ModelPropertyManagementContractWithFee" };
const QueryDocumentTypes218 = { ModelPropertyManagementLawOfAttorney: "ModelPropertyManagementLawOfAttorney" };
const QueryDocumentTypes219 = { ModelPropertyManagementGDPR: "ModelPropertyManagementGDPR" };
const QueryDocumentTypes220 = { CurrentLandRegisterExtract: "CurrentLandRegisterExtract" };
const QueryDocumentTypes221 = { EncumbranceBasisInDeptII: "EncumbranceBasisInDeptII" };
const QueryDocumentTypes222 = { CurrentParcelMap: "CurrentParcelMap" };
const QueryDocumentTypes223 = { CurrentPlanningRights: "CurrentPlanningRights" };
const QueryDocumentTypes224 = { InformationUrbanRenewalArea: "InformationUrbanRenewalArea" };
const QueryDocumentTypes225 = { InformationUrbanConservationArea: "InformationUrbanConservationArea" };
const QueryDocumentTypes226 = { InformationMonumentProtection: "InformationMonumentProtection" };
const QueryDocumentTypes227 = { SocialPreservationOrdinance: "SocialPreservationOrdinance" };
const QueryDocumentTypes228 = { InformationBuildingChargeRegister: "InformationBuildingChargeRegister" };
const QueryDocumentTypes229 = { ExtractContaminatedSitesRegister: "ExtractContaminatedSitesRegister" };
const QueryDocumentTypes230 = { ExtractDevelopmentAndExpansionContributions: "ExtractDevelopmentAndExpansionContributions" };
const QueryDocumentTypes231 = { UrbanDevelopmentContracts: "UrbanDevelopmentContracts" };
const QueryDocumentTypes232 = { SoilReportOrContaminatedSites: "SoilReportOrContaminatedSites" };
const QueryDocumentTypes233 = { GroundLease: "GroundLease" };
const QueryDocumentTypes234 = { VerificationOfExplosiveOrdnance: "VerificationOfExplosiveOrdnance" };
const QueryDocumentTypes235 = { OngoingLegalDisputesRegardingProperty: "OngoingLegalDisputesRegardingProperty" };
const QueryDocumentTypes236 = { BuildingEnergyCertificate: "BuildingEnergyCertificate" };
const QueryDocumentTypes237 = { SectionDrawingsBuildingElevations: "SectionDrawingsBuildingElevations" };
const QueryDocumentTypes238 = { FloorPlansIncludingAreaCalculation: "FloorPlansIncludingAreaCalculation" };
const QueryDocumentTypes239 = { BuildingApplicationOrBuildingPermit: "BuildingApplicationOrBuildingPermit" };
const QueryDocumentTypes240 = { WarrantyGuarantees: "WarrantyGuarantees" };
const QueryDocumentTypes241 = { OverviewOfPastOngoingAndPlannedModernization: "OverviewOfPastOngoingAndPlannedModernization" };
const QueryDocumentTypes242 = { InsuranceClaimsLast5Years: "InsuranceClaimsLast5Years" };
const QueryDocumentTypes243 = { ModernizationsOfIndividualApartments: "ModernizationsOfIndividualApartments" };
const QueryDocumentTypes244 = { DeclarationOfDivisionIfDivided: "DeclarationOfDivisionIfDivided" };
const QueryDocumentTypes245 = { OngoingLegalDisputesRegardingObject: "OngoingLegalDisputesRegardingObject" };
const QueryDocumentTypes246 = { TenantList: "TenantList" };
const QueryDocumentTypes247 = { RentIncreaseLetters: "RentIncreaseLetters" };
const QueryDocumentTypes248 = { RentalAgreements: "RentalAgreements" };
const QueryDocumentTypes249 = { ListOfExistingRentalDeposits: "ListOfExistingRentalDeposits" };
const QueryDocumentTypes250 = { OperatingCostStatement: "OperatingCostStatement" };
const QueryDocumentTypes251 = { TenantHandoverProtocols: "TenantHandoverProtocols" };
const QueryDocumentTypes252 = { ListOfCurrentDefectComplaintsReductionsArrears: "ListOfCurrentDefectComplaintsReductionsArrears" };
const QueryDocumentTypes253 = { OngoingLegalDisputesWithTenants: "OngoingLegalDisputesWithTenants" };
const QueryDocumentTypes254 = { ManagementContracts: "ManagementContracts" };
const QueryDocumentTypes255 = { MaintenanceProtocols: "MaintenanceProtocols" };
const QueryDocumentTypes256 = { ListOfAgeOfInstallations: "ListOfAgeOfInstallations" };
const QueryDocumentTypes257 = { InsurancesMainlyCurrentBuildingInsurance: "InsurancesMainlyCurrentBuildingInsurance" };
const QueryDocumentTypes258 = { PropertyTaxAssessmentAndUnitValueNotice: "PropertyTaxAssessmentAndUnitValueNotice" };
const QueryDocumentTypes259 = { ListOfCraftsmen: "ListOfCraftsmen" };
const QueryDocumentTypes260 = { PurchaseContractDraft: "PurchaseContractDraft" };
const QueryDocumentTypes261 = { AttachmentsToPurchaseContract: "AttachmentsToPurchaseContract" };
const QueryDocumentTypes262 = { PowersOfAttorney: "PowersOfAttorney" };
const QueryDocumentTypes263 = { MfhExpose: "MfhExpose" };
const QueryDocumentTypes264 = { SuperStructures: "SuperStructures" };
const QueryDocumentTypes265 = { LandValueMap: "LandValueMap" };
const QueryDocumentTypes266 = { CommercialOwnerRegisterExtract: "CommercialOwnerRegisterExtract" };
const QueryDocumentTypes267 = { NeighbourhoodAgreements: "NeighbourhoodAgreements" };
const QueryDocumentTypes268 = { LandUsePlan: "LandUsePlan" };
const QueryDocumentTypes269 = { OtherPermits: "OtherPermits" };
const QueryDocumentTypes270 = { OfficialCertificates: "OfficialCertificates" };
const QueryDocumentTypes271 = { BuildingInventoryPlans: "BuildingInventoryPlans" };
const QueryDocumentTypes272 = { BuildingSections: "BuildingSections" };
const QueryDocumentTypes273 = { BuildingStatics: "BuildingStatics" };
const QueryDocumentTypes274 = { BuildingHeating: "BuildingHeating" };
const QueryDocumentTypes275 = { BuildingVentilation: "BuildingVentilation" };
const QueryDocumentTypes276 = { BuildingAirConditioning: "BuildingAirConditioning" };
const QueryDocumentTypes277 = { BuildingSanitary: "BuildingSanitary" };
const QueryDocumentTypes278 = { BuildingElectrical: "BuildingElectrical" };
const QueryDocumentTypes279 = { FireProtection: "FireProtection" };
const QueryDocumentTypes280 = { SpecialistPlannerContracts: "SpecialistPlannerContracts" };
const QueryDocumentTypes281 = { SpecialRealEstateAdditionalInformation: "SpecialRealEstateAdditionalInformation" };
const QueryDocumentTypes282 = { BuildingAdditonalInformation: "BuildingAdditonalInformation" };
const QueryDocumentTypes283 = { Terminations: "Terminations" };
const QueryDocumentTypes284 = { TaxAssessmentNotices: "TaxAssessmentNotices" };
const QueryDocumentTypes285 = { TaxOtherMunicipalCharges: "TaxOtherMunicipalCharges" };
const QueryDocumentTypes286 = { TaxCorrectionBalancesAndPeriods: "TaxCorrectionBalancesAndPeriods" };
const QueryDocumentTypes287 = { TaxValueAddTenants: "TaxValueAddTenants" };
const QueryDocumentTypes288 = { TaxValueAddSellers: "TaxValueAddSellers" };
const QueryDocumentTypes289 = { TaxOptionRatesAndAreaKeys: "TaxOptionRatesAndAreaKeys" };
const QueryDocumentTypes290 = { CompanyOverview: "CompanyOverview" };
const QueryDocumentTypes291 = { CommercialRegisterExtract: "CommercialRegisterExtract" };
const QueryDocumentTypes292 = { TransferOfShares: "TransferOfShares" };
const QueryDocumentTypes293 = { RegisterExcerpts: "RegisterExcerpts" };
const QueryDocumentTypes294 = { ShareRegister: "ShareRegister" };
const QueryDocumentTypes295 = { ListOfShareholders: "ListOfShareholders" };
const QueryDocumentTypes296 = { ArticlesOfAssociation: "ArticlesOfAssociation" };
const QueryDocumentTypes297 = { ArticlesOfAssociationResolutionAmmendments: "ArticlesOfAssociationResolutionAmmendments" };
const QueryDocumentTypes298 = { ArticlesOfAssociationResolutions: "ArticlesOfAssociationResolutions" };
const QueryDocumentTypes299 = { DistributionOfProfitsResolutions: "DistributionOfProfitsResolutions" };
const QueryDocumentTypes300 = { CapitalEndowmentResolutions: "CapitalEndowmentResolutions" };
const QueryDocumentTypes301 = { OtherResolutions: "OtherResolutions" };
const QueryDocumentTypes302 = { ManagingDirectorResolutions: "ManagingDirectorResolutions" };
const QueryDocumentTypes303 = { Minutes: "Minutes" };
const QueryDocumentTypes304 = { AgreementsWithManagement: "AgreementsWithManagement" };
const QueryDocumentTypes305 = { CompanyAccountant: "CompanyAccountant" };
const QueryDocumentTypes306 = { CompanyAuditor: "CompanyAuditor" };
const QueryDocumentTypes307 = { CompanyTaxConsultant: "CompanyTaxConsultant" };
const QueryDocumentTypes308 = { CompanyOtherContracts: "CompanyOtherContracts" };
const QueryDocumentTypes309 = { LoanAgreement: "LoanAgreement" };
const QueryDocumentTypes310 = { LandChargeDeed: "LandChargeDeed" };
const QueryDocumentTypes311 = { DeclarationOfSecurityPurpose: "DeclarationOfSecurityPurpose" };
const QueryDocumentTypes312 = { DeclarationOfAssignment: "DeclarationOfAssignment" };
const QueryDocumentTypes313 = { Pledges: "Pledges" };
const QueryDocumentTypes314 = { PurchasingTerminationDocuments: "PurchasingTerminationDocuments" };
const QueryDocumentTypes315 = { FinancialAnnualStatements: "FinancialAnnualStatements" };
const QueryDocumentTypes316 = { FinancialTaxes: "FinancialTaxes" };
const QueryDocumentTypes317 = { FinancialManagementReporting: "FinancialManagementReporting" };
const QueryDocumentTypes318 = { FinancialLiabilities: "FinancialLiabilities" };
const QueryDocumentTypes319 = { FinancialCurrentBalances: "FinancialCurrentBalances" };
const QueryDocumentTypes320 = { FinancialOtherInformation: "FinancialOtherInformation" };
const QueryDocumentTypes321 = { FoundationReport: "FoundationReport" };
const QueryDocumentTypes322 = { ImportantCorrespondence: "ImportantCorrespondence" };
const QueryDocumentTypes323 = { AdditionalCostsInvoice: "AdditionalCostsInvoice" };
const QueryDocumentTypes324 = { MFHSummary: "MFHSummary" };
const QueryDocumentTypes325 = { MFHInvestmentCaseExportableSheet: "MFHInvestmentCaseExportableSheet" };
const QueryDocumentTypes326 = { AssetPipelineSheet: "AssetPipelineSheet" };
const QueryDocumentTypes327 = { ExternalInvoiceExport: "ExternalInvoiceExport" };
const QueryDocumentTypes328 = { AssetTenderingProcess: "AssetTenderingProcess" };
const QueryDocumentTypes329 = { DueDiligenceOnSiteInspection: "DueDiligenceOnSiteInspection" };
const QueryDocumentTypes330 = { TechnicalDD: "TechnicalDD" };
const QueryDocumentTypes331 = { LegalDD: "LegalDD" };
const QueryDocumentTypes332 = { CommercialDD: "CommercialDD" };
const QueryDocumentTypes333 = { EnergyConsultation: "EnergyConsultation" };
const QueryDocumentTypes334 = { Vicinity: "Vicinity" };
const QueryDocumentTypes335 = { ZoningPlan: "ZoningPlan" };
const QueryDocumentTypes336 = { DevelopmentPlanOrdinance: "DevelopmentPlanOrdinance" };
const QueryDocumentTypes337 = { OtherPlanningLaw: "OtherPlanningLaw" };
const QueryDocumentTypes338 = { ExtractLandChargeRegister: "ExtractLandChargeRegister" };
const QueryDocumentTypes339 = { ExtractTreeInventoryRegister: "ExtractTreeInventoryRegister" };
const QueryDocumentTypes340 = { FloodRiskMap: "FloodRiskMap" };
const QueryDocumentTypes341 = { GroundwaterPlans: "GroundwaterPlans" };
const QueryDocumentTypes342 = { ProtectedAreaMap: "ProtectedAreaMap" };
const QueryDocumentTypes343 = { LiabilityInsuranceForBuildingAndProperty: "LiabilityInsuranceForBuildingAndProperty" };
const QueryDocumentTypes344 = { LiabilityInsuranceForWaterPollutionDamage: "LiabilityInsuranceForWaterPollutionDamage" };
const QueryDocumentTypes345 = { MaintenanceContracts: "MaintenanceContracts" };
const QueryDocumentTypes346 = { PreliminaryBuildingPermit: "PreliminaryBuildingPermit" };
const QueryDocumentTypes347 = { SoilPollutantReportsAndSoilDecontaminationReceipts: "SoilPollutantReportsAndSoilDecontaminationReceipts" };
const QueryDocumentTypes348 = { ConstructionAcceptanceCertificate: "ConstructionAcceptanceCertificate" };
const QueryDocumentTypes349 = { ReportTechnicalDueDiligence: "ReportTechnicalDueDiligence" };
const QueryDocumentTypes350 = { PurchasingOffer: "PurchasingOffer" };
const QueryDocumentTypes351 = { CourtageAgreement: "CourtageAgreement" };
const QueryDocumentTypes352 = { ExclusivityAgreement: "ExclusivityAgreement" };
const QueryDocumentTypes353 = { BillingOrInvoices: "BillingOrInvoices" };
const QueryDocumentTypes354 = { InvestmentProposal: "InvestmentProposal" };
const QueryDocumentTypes355 = { KYCDraft: "KYCDraft" };
const QueryDocumentTypes356 = { IDSeller: "IDSeller" };
const QueryDocumentTypes357 = { AddendumContractDraft: "AddendumContractDraft" };
const QueryDocumentTypes358 = { AddendumContract: "AddendumContract" };
const QueryDocumentTypes359 = { Auftragsempfehlung: "Auftragsempfehlung" };
const QueryDocumentTypes360 = { Entscheidungsvorlage: "Entscheidungsvorlage" };
const QueryDocumentTypes361 = { Werkvertrag: "Werkvertrag" };
const QueryDocumentTypes362 = { Planervertrag: "Planervertrag" };
const QueryDocumentCategories = { General: "General" };
const QueryDocumentCategories2 = { Sourcing: "Sourcing" };
const QueryDocumentCategories3 = { Purchasing: "Purchasing" };
const QueryDocumentCategories4 = { Renovation: "Renovation" };
const QueryDocumentCategories5 = { Marketing: "Marketing" };
const QueryDocumentCategories6 = { PortfolioManagement: "PortfolioManagement" };
const QueryDocumentCategories7 = { PropertyManagement: "PropertyManagement" };
const QueryDocumentCategories8 = { Accounting: "Accounting" };
const QueryDocumentCategories9 = { PostRenovation: "PostRenovation" };
const QueryDocumentCategories10 = { Renting: "Renting" };
const QueryDocumentCategories11 = { Selling: "Selling" };
const QueryDocumentCategories12 = { Orientation: "Orientation" };
const QueryDocumentCategories13 = { Livings: "Livings" };
const QueryDocumentCategories14 = { SalesPackage: "SalesPackage" };
const QueryDocumentCategories15 = { SellingRegion: "SellingRegion" };
const QueryDocumentCategories16 = { Land: "Land" };
const QueryDocumentCategories17 = { Building: "Building" };
const QueryDocumentCategories18 = { RentalContract: "RentalContract" };
const QueryDocumentCategories19 = { ObjectManagement: "ObjectManagement" };
const QueryDocumentCategories20 = { PurchasingContract: "PurchasingContract" };
const QueryDocumentCategories21 = { DueDiligence: "DueDiligence" };
const QueryDocumentCategories22 = { MfhOther: "MfhOther" };
const QueryDocumentCategories23 = { Taxes: "Taxes" };
const QueryDocumentCategories24 = { GeneralCompany: "GeneralCompany" };
const QueryDocumentCategories25 = { ShareholderAndStatutes: "ShareholderAndStatutes" };
const QueryDocumentCategories26 = { CompanyContracts: "CompanyContracts" };
const QueryDocumentCategories27 = { Financing: "Financing" };
const QueryDocumentCategories28 = { KYC: "KYC" };
const QueryServiceChargeStatementIds = {};
//#endregion
//#region src/basecamp/gen/models/documentModels/GeneratePdfFromHtml.ts
const ConvertOptionsPageOrientation = { portrait: "portrait" };
const ConvertOptionsPageOrientation2 = { landscape: "landscape" };
//#endregion
//#region src/basecamp/gen/models/documentModels/GetStaticMapImage.ts
const GetStaticMapImageQueryParamsScale = { "1": 1 };
const GetStaticMapImageQueryParamsScale2 = { "2": 2 };
//#endregion
//#region src/basecamp/gen/models/documentModels/UpdateDocument.ts
const UpdateDocumentMutationRequestDocumentType = { EbicsAuthorizationLetter: "EbicsAuthorizationLetter" };
const UpdateDocumentMutationRequestDocumentType2 = { PaymentOrder: "PaymentOrder" };
const UpdateDocumentMutationRequestDocumentType3 = { LoanOfferTermSheet: "LoanOfferTermSheet" };
const UpdateDocumentMutationRequestDocumentType4 = { LoanContract: "LoanContract" };
const UpdateDocumentMutationRequestDocumentType5 = { PortfolioInvestmentPlan: "PortfolioInvestmentPlan" };
const UpdateDocumentMutationRequestDocumentType6 = { PurchasingDrawdownRequest: "PurchasingDrawdownRequest" };
const UpdateDocumentMutationRequestDocumentType7 = { InvoicesDrawdownRequest: "InvoicesDrawdownRequest" };
const UpdateDocumentMutationRequestDocumentType8 = { RenovationAcceptanceReport: "RenovationAcceptanceReport" };
const UpdateDocumentMutationRequestDocumentType9 = { ConstructionSiteReport: "ConstructionSiteReport" };
const UpdateDocumentMutationRequestDocumentType10 = { GeneratedInvoiceSubscriptionInvoice: "GeneratedInvoiceSubscriptionInvoice" };
const UpdateDocumentMutationRequestDocumentType11 = { InvoiceApprovalSlip: "InvoiceApprovalSlip" };
const UpdateDocumentMutationRequestDocumentType12 = { InvoiceInXML: "InvoiceInXML" };
const UpdateDocumentMutationRequestDocumentType13 = { InvoiceInPDF: "InvoiceInPDF" };
const UpdateDocumentMutationRequestDocumentType14 = { InvoiceOutPDF: "InvoiceOutPDF" };
const UpdateDocumentMutationRequestDocumentType15 = { Invoice: "Invoice" };
const UpdateDocumentMutationRequestDocumentType16 = { SubscriptionContract: "SubscriptionContract" };
const UpdateDocumentMutationRequestDocumentType17 = { ProtocolArchived: "ProtocolArchived" };
const UpdateDocumentMutationRequestDocumentType18 = { Protocol2024: "Protocol2024" };
const UpdateDocumentMutationRequestDocumentType19 = { Protocol2025: "Protocol2025" };
const UpdateDocumentMutationRequestDocumentType20 = { Protocol2026: "Protocol2026" };
const UpdateDocumentMutationRequestDocumentType21 = { ArchiveOfResolutions: "ArchiveOfResolutions" };
const UpdateDocumentMutationRequestDocumentType22 = { InvitationETV: "InvitationETV" };
const UpdateDocumentMutationRequestDocumentType23 = { AnnualStatement: "AnnualStatement" };
const UpdateDocumentMutationRequestDocumentType24 = { EconomicPlan: "EconomicPlan" };
const UpdateDocumentMutationRequestDocumentType25 = { HomeOwnerFeeStatement: "HomeOwnerFeeStatement" };
const UpdateDocumentMutationRequestDocumentType26 = { BuildingInsurance: "BuildingInsurance" };
const UpdateDocumentMutationRequestDocumentType27 = { EnergyCertificate: "EnergyCertificate" };
const UpdateDocumentMutationRequestDocumentType28 = { PropertyTaxNotice: "PropertyTaxNotice" };
const UpdateDocumentMutationRequestDocumentType29 = { ConstructionBurdenStatement: "ConstructionBurdenStatement" };
const UpdateDocumentMutationRequestDocumentType30 = { AbstractOfTitle: "AbstractOfTitle" };
const UpdateDocumentMutationRequestDocumentType31 = { DeclarationOfCondominium: "DeclarationOfCondominium" };
const UpdateDocumentMutationRequestDocumentType32 = { AmendmentToDeclarationOfDivision: "AmendmentToDeclarationOfDivision" };
const UpdateDocumentMutationRequestDocumentType33 = { AllowanceOfEntrySectionII: "AllowanceOfEntrySectionII" };
const UpdateDocumentMutationRequestDocumentType34 = { SeparationDeclaration: "SeparationDeclaration" };
const UpdateDocumentMutationRequestDocumentType35 = { PartitionPlan: "PartitionPlan" };
const UpdateDocumentMutationRequestDocumentType36 = { Floorplans: "Floorplans" };
const UpdateDocumentMutationRequestDocumentType37 = { ViewsAndSections: "ViewsAndSections" };
const UpdateDocumentMutationRequestDocumentType38 = { LivingSpaceCalculation: "LivingSpaceCalculation" };
const UpdateDocumentMutationRequestDocumentType39 = { ConstructionDescriptionBuilding: "ConstructionDescriptionBuilding" };
const UpdateDocumentMutationRequestDocumentType40 = { HouseRules: "HouseRules" };
const UpdateDocumentMutationRequestDocumentType41 = { LandRegisterMap: "LandRegisterMap" };
const UpdateDocumentMutationRequestDocumentType42 = { ManagementAgreement: "ManagementAgreement" };
const UpdateDocumentMutationRequestDocumentType43 = { SpecialAssessments: "SpecialAssessments" };
const UpdateDocumentMutationRequestDocumentType44 = { Other: "Other" };
const UpdateDocumentMutationRequestDocumentType45 = { EstateMedia: "EstateMedia" };
const UpdateDocumentMutationRequestDocumentType46 = { BuildingPermit: "BuildingPermit" };
const UpdateDocumentMutationRequestDocumentType47 = { Expose: "Expose" };
const UpdateDocumentMutationRequestDocumentType48 = { ExposeExternal: "ExposeExternal" };
const UpdateDocumentMutationRequestDocumentType49 = { ContractDraft: "ContractDraft" };
const UpdateDocumentMutationRequestDocumentType50 = { ContractNotarized: "ContractNotarized" };
const UpdateDocumentMutationRequestDocumentType51 = { LandCharge: "LandCharge" };
const UpdateDocumentMutationRequestDocumentType52 = { PaymentNotice: "PaymentNotice" };
const UpdateDocumentMutationRequestDocumentType53 = { RegistrationNotice: "RegistrationNotice" };
const UpdateDocumentMutationRequestDocumentType54 = { NotaryCorrespondence: "NotaryCorrespondence" };
const UpdateDocumentMutationRequestDocumentType55 = { AdministrationCorrespondence: "AdministrationCorrespondence" };
const UpdateDocumentMutationRequestDocumentType56 = { NotaryRegistrationReservation: "NotaryRegistrationReservation" };
const UpdateDocumentMutationRequestDocumentType57 = { SEPAMandateHomeOwnersFee: "SEPAMandateHomeOwnersFee" };
const UpdateDocumentMutationRequestDocumentType58 = { PurchasingHandoverProtocol: "PurchasingHandoverProtocol" };
const UpdateDocumentMutationRequestDocumentType59 = { ProofOfPayment: "ProofOfPayment" };
const UpdateDocumentMutationRequestDocumentType60 = { SellingExpose: "SellingExpose" };
const UpdateDocumentMutationRequestDocumentType61 = { PromotionExpose: "PromotionExpose" };
const UpdateDocumentMutationRequestDocumentType62 = { CustomizedSellingExpose: "CustomizedSellingExpose" };
const UpdateDocumentMutationRequestDocumentType63 = { SellingExposeSlip: "SellingExposeSlip" };
const UpdateDocumentMutationRequestDocumentType64 = { SellingCalculations: "SellingCalculations" };
const UpdateDocumentMutationRequestDocumentType65 = { SellingCalculationsSlip: "SellingCalculationsSlip" };
const UpdateDocumentMutationRequestDocumentType66 = { SellingContractDraft: "SellingContractDraft" };
const UpdateDocumentMutationRequestDocumentType67 = { SellingContractSummary: "SellingContractSummary" };
const UpdateDocumentMutationRequestDocumentType68 = { SellingContractNotarized: "SellingContractNotarized" };
const UpdateDocumentMutationRequestDocumentType69 = { SellingPaymentNotice: "SellingPaymentNotice" };
const UpdateDocumentMutationRequestDocumentType70 = { SellingRenovationAcceptanceProtocol: "SellingRenovationAcceptanceProtocol" };
const UpdateDocumentMutationRequestDocumentType71 = { SellingRegistrationNotice: "SellingRegistrationNotice" };
const UpdateDocumentMutationRequestDocumentType72 = { SellingNotaryCorrespondence: "SellingNotaryCorrespondence" };
const UpdateDocumentMutationRequestDocumentType73 = { SellingAdministrationCorrespondence: "SellingAdministrationCorrespondence" };
const UpdateDocumentMutationRequestDocumentType74 = { SellingDataSheet: "SellingDataSheet" };
const UpdateDocumentMutationRequestDocumentType75 = { SellingNotaryRegistrationReservation: "SellingNotaryRegistrationReservation" };
const UpdateDocumentMutationRequestDocumentType76 = { SellingHandoverProtocol: "SellingHandoverProtocol" };
const UpdateDocumentMutationRequestDocumentType77 = { SellingExpertReportWithCapEx: "SellingExpertReportWithCapEx" };
const UpdateDocumentMutationRequestDocumentType78 = { SellingExpertReport: "SellingExpertReport" };
const UpdateDocumentMutationRequestDocumentType79 = { SellingResidualValueCertificate: "SellingResidualValueCertificate" };
const UpdateDocumentMutationRequestDocumentType80 = { BuildingModernizationMeasures: "BuildingModernizationMeasures" };
const UpdateDocumentMutationRequestDocumentType81 = { SellingExposeLocation: "SellingExposeLocation" };
const UpdateDocumentMutationRequestDocumentType82 = { SellingAbstractOfTitle: "SellingAbstractOfTitle" };
const UpdateDocumentMutationRequestDocumentType83 = { NotaryCertification: "NotaryCertification" };
const UpdateDocumentMutationRequestDocumentType84 = { SellingProofOfPayment: "SellingProofOfPayment" };
const UpdateDocumentMutationRequestDocumentType85 = { LandRegisterParkingSpace: "LandRegisterParkingSpace" };
const UpdateDocumentMutationRequestDocumentType86 = { BuildingAcceptancePowerOfAttorney: "BuildingAcceptancePowerOfAttorney" };
const UpdateDocumentMutationRequestDocumentType87 = { LocationProfile: "LocationProfile" };
const UpdateDocumentMutationRequestDocumentType88 = { BuildingInformationModel: "BuildingInformationModel" };
const UpdateDocumentMutationRequestDocumentType89 = { FloorPlanSketch: "FloorPlanSketch" };
const UpdateDocumentMutationRequestDocumentType90 = { DimensionedFloorPlan: "DimensionedFloorPlan" };
const UpdateDocumentMutationRequestDocumentType91 = { DimensionedFloorPlanPlanned: "DimensionedFloorPlanPlanned" };
const UpdateDocumentMutationRequestDocumentType92 = { CadFile: "CadFile" };
const UpdateDocumentMutationRequestDocumentType93 = { CadFilePlanned: "CadFilePlanned" };
const UpdateDocumentMutationRequestDocumentType94 = { LV: "LV" };
const UpdateDocumentMutationRequestDocumentType95 = { LongLV: "LongLV" };
const UpdateDocumentMutationRequestDocumentType96 = { Kitchen: "Kitchen" };
const UpdateDocumentMutationRequestDocumentType97 = { KitchenContracted: "KitchenContracted" };
const UpdateDocumentMutationRequestDocumentType98 = { Inspection: "Inspection" };
const UpdateDocumentMutationRequestDocumentType99 = { ConstructionContract: "ConstructionContract" };
const UpdateDocumentMutationRequestDocumentType100 = { ContractorOffer: "ContractorOffer" };
const UpdateDocumentMutationRequestDocumentType101 = { RevisionDocumentation: "RevisionDocumentation" };
const UpdateDocumentMutationRequestDocumentType102 = { ReportsCalculationsAppraisals: "ReportsCalculationsAppraisals" };
const UpdateDocumentMutationRequestDocumentType103 = { ConstructionGuarantee: "ConstructionGuarantee" };
const UpdateDocumentMutationRequestDocumentType104 = { BathPlan: "BathPlan" };
const UpdateDocumentMutationRequestDocumentType105 = { StructuredLvSheet: "StructuredLvSheet" };
const UpdateDocumentMutationRequestDocumentType106 = { RenovationCostTrackingSheet: "RenovationCostTrackingSheet" };
const UpdateDocumentMutationRequestDocumentType107 = { MfhConstructionPlan: "MfhConstructionPlan" };
const UpdateDocumentMutationRequestDocumentType108 = { ConstructionDescriptionRenovation: "ConstructionDescriptionRenovation" };
const UpdateDocumentMutationRequestDocumentType109 = { PostRenovationDimensionedFloorPlan: "PostRenovationDimensionedFloorPlan" };
const UpdateDocumentMutationRequestDocumentType110 = { SalesPartnerFloorPlan: "SalesPartnerFloorPlan" };
const UpdateDocumentMutationRequestDocumentType111 = { LivingSpaceCalculations: "LivingSpaceCalculations" };
const UpdateDocumentMutationRequestDocumentType112 = { BeforeAfterPictures: "BeforeAfterPictures" };
const UpdateDocumentMutationRequestDocumentType113 = { PostRenovationAcceptanceProtocol: "PostRenovationAcceptanceProtocol" };
const UpdateDocumentMutationRequestDocumentType114 = { RoomVolumeCalculation: "RoomVolumeCalculation" };
const UpdateDocumentMutationRequestDocumentType115 = { RentContract: "RentContract" };
const UpdateDocumentMutationRequestDocumentType116 = { RentIncrease: "RentIncrease" };
const UpdateDocumentMutationRequestDocumentType117 = { AcceptanceProtocol: "AcceptanceProtocol" };
const UpdateDocumentMutationRequestDocumentType118 = { HeatingBill: "HeatingBill" };
const UpdateDocumentMutationRequestDocumentType119 = { Correspondence: "Correspondence" };
const UpdateDocumentMutationRequestDocumentType120 = { SelfAssessmentSheet: "SelfAssessmentSheet" };
const UpdateDocumentMutationRequestDocumentType121 = { ID: "ID" };
const UpdateDocumentMutationRequestDocumentType122 = { SalaryInformation: "SalaryInformation" };
const UpdateDocumentMutationRequestDocumentType123 = { SchufaReport: "SchufaReport" };
const UpdateDocumentMutationRequestDocumentType124 = { Deposit: "Deposit" };
const UpdateDocumentMutationRequestDocumentType125 = { HousingProviderConfirmation: "HousingProviderConfirmation" };
const UpdateDocumentMutationRequestDocumentType126 = { SEVContract: "SEVContract" };
const UpdateDocumentMutationRequestDocumentType127 = { SEVContractWithFee: "SEVContractWithFee" };
const UpdateDocumentMutationRequestDocumentType128 = { SEVContractWithoutFee: "SEVContractWithoutFee" };
const UpdateDocumentMutationRequestDocumentType129 = { SEVPoA: "SEVPoA" };
const UpdateDocumentMutationRequestDocumentType130 = { DkbInvestorVerification: "DkbInvestorVerification" };
const UpdateDocumentMutationRequestDocumentType131 = { SEVCoverLetter: "SEVCoverLetter" };
const UpdateDocumentMutationRequestDocumentType132 = { GDPRTenant: "GDPRTenant" };
const UpdateDocumentMutationRequestDocumentType133 = { GDPROwner: "GDPROwner" };
const UpdateDocumentMutationRequestDocumentType134 = { PersonalIDOwner: "PersonalIDOwner" };
const UpdateDocumentMutationRequestDocumentType135 = { SEPAManadateHouseGeld: "SEPAManadateHouseGeld" };
const UpdateDocumentMutationRequestDocumentType136 = { SEPATenant: "SEPATenant" };
const UpdateDocumentMutationRequestDocumentType137 = { WithdrawlInstructionTenant: "WithdrawlInstructionTenant" };
const UpdateDocumentMutationRequestDocumentType138 = { WithdrawlInstructionOwner: "WithdrawlInstructionOwner" };
const UpdateDocumentMutationRequestDocumentType139 = { TenantCorrespondence: "TenantCorrespondence" };
const UpdateDocumentMutationRequestDocumentType140 = { OwnerCorrespondence: "OwnerCorrespondence" };
const UpdateDocumentMutationRequestDocumentType141 = { UtilitiesCorrespondence: "UtilitiesCorrespondence" };
const UpdateDocumentMutationRequestDocumentType142 = { CancellationLease: "CancellationLease" };
const UpdateDocumentMutationRequestDocumentType143 = { CancellationLeaseConfirmation: "CancellationLeaseConfirmation" };
const UpdateDocumentMutationRequestDocumentType144 = { CancellationSEVContract: "CancellationSEVContract" };
const UpdateDocumentMutationRequestDocumentType145 = { CancellationSEVContractConfirmation: "CancellationSEVContractConfirmation" };
const UpdateDocumentMutationRequestDocumentType146 = { CondoTerminationAgreement: "CondoTerminationAgreement" };
const UpdateDocumentMutationRequestDocumentType147 = { LegalDisputes: "LegalDisputes" };
const UpdateDocumentMutationRequestDocumentType148 = { EstateInvestorShare: "EstateInvestorShare" };
const UpdateDocumentMutationRequestDocumentType149 = { EstateAggregatedInvestorShare: "EstateAggregatedInvestorShare" };
const UpdateDocumentMutationRequestDocumentType150 = { WEGAnnualStatement: "WEGAnnualStatement" };
const UpdateDocumentMutationRequestDocumentType151 = { InvoicesPropertyManagement: "InvoicesPropertyManagement" };
const UpdateDocumentMutationRequestDocumentType152 = { EstateRentReport: "EstateRentReport" };
const UpdateDocumentMutationRequestDocumentType153 = { CorrespondencePropertyManagement: "CorrespondencePropertyManagement" };
const UpdateDocumentMutationRequestDocumentType154 = { SalutationWEG: "SalutationWEG" };
const UpdateDocumentMutationRequestDocumentType155 = { InvestorPayout: "InvestorPayout" };
const UpdateDocumentMutationRequestDocumentType156 = { InvestorYearlyPayout: "InvestorYearlyPayout" };
const UpdateDocumentMutationRequestDocumentType157 = { InvestorYearlyPayoutLegacy: "InvestorYearlyPayoutLegacy" };
const UpdateDocumentMutationRequestDocumentType158 = { RentArrearNotice: "RentArrearNotice" };
const UpdateDocumentMutationRequestDocumentType159 = { RentGuarantee: "RentGuarantee" };
const UpdateDocumentMutationRequestDocumentType160 = { DunningNotice: "DunningNotice" };
const UpdateDocumentMutationRequestDocumentType161 = { EnforcementNotice: "EnforcementNotice" };
const UpdateDocumentMutationRequestDocumentType162 = { BKAStatement: "BKAStatement" };
const UpdateDocumentMutationRequestDocumentType163 = { BKAHeatingStatement: "BKAHeatingStatement" };
const UpdateDocumentMutationRequestDocumentType164 = { BKAAllocationCalculation: "BKAAllocationCalculation" };
const UpdateDocumentMutationRequestDocumentType165 = { BKAHouseholdCosts: "BKAHouseholdCosts" };
const UpdateDocumentMutationRequestDocumentType166 = { BKADeposit: "BKADeposit" };
const UpdateDocumentMutationRequestDocumentType167 = { SelfDeclarationTenant: "SelfDeclarationTenant" };
const UpdateDocumentMutationRequestDocumentType168 = { QuestionnaireTenant: "QuestionnaireTenant" };
const UpdateDocumentMutationRequestDocumentType169 = { RentalContractDraft: "RentalContractDraft" };
const UpdateDocumentMutationRequestDocumentType170 = { SalaryRecordPropesctiveTenant: "SalaryRecordPropesctiveTenant" };
const UpdateDocumentMutationRequestDocumentType171 = { SchufaProspectiveTenant: "SchufaProspectiveTenant" };
const UpdateDocumentMutationRequestDocumentType172 = { AnnualServiceChargeCalculation: "AnnualServiceChargeCalculation" };
const UpdateDocumentMutationRequestDocumentType173 = { PersonalIDProspectiveTenant: "PersonalIDProspectiveTenant" };
const UpdateDocumentMutationRequestDocumentType174 = { Safe: "Safe" };
const UpdateDocumentMutationRequestDocumentType175 = { Estate: "Estate" };
const UpdateDocumentMutationRequestDocumentType176 = { BasementRoom: "BasementRoom" };
const UpdateDocumentMutationRequestDocumentType177 = { AtticRoom: "AtticRoom" };
const UpdateDocumentMutationRequestDocumentType178 = { CommonRoom: "CommonRoom" };
const UpdateDocumentMutationRequestDocumentType179 = { Parking: "Parking" };
const UpdateDocumentMutationRequestDocumentType180 = { FurniturePlanPdf: "FurniturePlanPdf" };
const UpdateDocumentMutationRequestDocumentType181 = { FurniturePlanDwg: "FurniturePlanDwg" };
const UpdateDocumentMutationRequestDocumentType182 = { RequestedOrderLists: "RequestedOrderLists" };
const UpdateDocumentMutationRequestDocumentType183 = { ContractedOrderLists: "ContractedOrderLists" };
const UpdateDocumentMutationRequestDocumentType184 = { PartnerBrochure: "PartnerBrochure" };
const UpdateDocumentMutationRequestDocumentType185 = { InvoicesFittings: "InvoicesFittings" };
const UpdateDocumentMutationRequestDocumentType186 = { InvoicesServiceProvider: "InvoicesServiceProvider" };
const UpdateDocumentMutationRequestDocumentType187 = { Internet: "Internet" };
const UpdateDocumentMutationRequestDocumentType188 = { LivingsAcceptanceProtocol: "LivingsAcceptanceProtocol" };
const UpdateDocumentMutationRequestDocumentType189 = { PortfolioInspectionSheet: "PortfolioInspectionSheet" };
const UpdateDocumentMutationRequestDocumentType190 = { CreditLineCashflowPredictions: "CreditLineCashflowPredictions" };
const UpdateDocumentMutationRequestDocumentType191 = { CreditLineBudgetCosts: "CreditLineBudgetCosts" };
const UpdateDocumentMutationRequestDocumentType192 = { EstateInvestorCashflow: "EstateInvestorCashflow" };
const UpdateDocumentMutationRequestDocumentType193 = { SalesPackageFinalSheet: "SalesPackageFinalSheet" };
const UpdateDocumentMutationRequestDocumentType194 = { SalesPackageDataSheet: "SalesPackageDataSheet" };
const UpdateDocumentMutationRequestDocumentType195 = { SalesPackageNotarySheet: "SalesPackageNotarySheet" };
const UpdateDocumentMutationRequestDocumentType196 = { SalesPackageChecklist: "SalesPackageChecklist" };
const UpdateDocumentMutationRequestDocumentType197 = { SalesPackageSellingCompanies: "SalesPackageSellingCompanies" };
const UpdateDocumentMutationRequestDocumentType198 = { PurchasingDocumentsSheet: "PurchasingDocumentsSheet" };
const UpdateDocumentMutationRequestDocumentType199 = { SellingDocumentsSheet: "SellingDocumentsSheet" };
const UpdateDocumentMutationRequestDocumentType200 = { SellingDataChecklist: "SellingDataChecklist" };
const UpdateDocumentMutationRequestDocumentType201 = { SellingEstatesDataSheet: "SellingEstatesDataSheet" };
const UpdateDocumentMutationRequestDocumentType202 = { CashflowStatementSheet: "CashflowStatementSheet" };
const UpdateDocumentMutationRequestDocumentType203 = { InvestorPaymentSlip: "InvestorPaymentSlip" };
const UpdateDocumentMutationRequestDocumentType204 = { InvestorPayoutStatement: "InvestorPayoutStatement" };
const UpdateDocumentMutationRequestDocumentType205 = { DefectReport: "DefectReport" };
const UpdateDocumentMutationRequestDocumentType206 = { SalesPackageUserUploadedPriceList: "SalesPackageUserUploadedPriceList" };
const UpdateDocumentMutationRequestDocumentType207 = { SalesPackageUserUploadedDataSheet: "SalesPackageUserUploadedDataSheet" };
const UpdateDocumentMutationRequestDocumentType208 = { SalesPackageUserUploadedChecklist: "SalesPackageUserUploadedChecklist" };
const UpdateDocumentMutationRequestDocumentType209 = { SalesPackageUserUploadedPhotoAlbum: "SalesPackageUserUploadedPhotoAlbum" };
const UpdateDocumentMutationRequestDocumentType210 = { SellingRegionBrochure: "SellingRegionBrochure" };
const UpdateDocumentMutationRequestDocumentType211 = { TransferRecurrentPaymentsSEPAXmlList: "TransferRecurrentPaymentsSEPAXmlList" };
const UpdateDocumentMutationRequestDocumentType212 = { CondoSellingPresentation: "CondoSellingPresentation" };
const UpdateDocumentMutationRequestDocumentType213 = { SalesPartnerFlyer: "SalesPartnerFlyer" };
const UpdateDocumentMutationRequestDocumentType214 = { PropertyManagementOwnerBrochure: "PropertyManagementOwnerBrochure" };
const UpdateDocumentMutationRequestDocumentType215 = { ModelPurchaseContract: "ModelPurchaseContract" };
const UpdateDocumentMutationRequestDocumentType216 = { ModelRentalContract: "ModelRentalContract" };
const UpdateDocumentMutationRequestDocumentType217 = { ModelPropertyManagementContractWithFee: "ModelPropertyManagementContractWithFee" };
const UpdateDocumentMutationRequestDocumentType218 = { ModelPropertyManagementLawOfAttorney: "ModelPropertyManagementLawOfAttorney" };
const UpdateDocumentMutationRequestDocumentType219 = { ModelPropertyManagementGDPR: "ModelPropertyManagementGDPR" };
const UpdateDocumentMutationRequestDocumentType220 = { CurrentLandRegisterExtract: "CurrentLandRegisterExtract" };
const UpdateDocumentMutationRequestDocumentType221 = { EncumbranceBasisInDeptII: "EncumbranceBasisInDeptII" };
const UpdateDocumentMutationRequestDocumentType222 = { CurrentParcelMap: "CurrentParcelMap" };
const UpdateDocumentMutationRequestDocumentType223 = { CurrentPlanningRights: "CurrentPlanningRights" };
const UpdateDocumentMutationRequestDocumentType224 = { InformationUrbanRenewalArea: "InformationUrbanRenewalArea" };
const UpdateDocumentMutationRequestDocumentType225 = { InformationUrbanConservationArea: "InformationUrbanConservationArea" };
const UpdateDocumentMutationRequestDocumentType226 = { InformationMonumentProtection: "InformationMonumentProtection" };
const UpdateDocumentMutationRequestDocumentType227 = { SocialPreservationOrdinance: "SocialPreservationOrdinance" };
const UpdateDocumentMutationRequestDocumentType228 = { InformationBuildingChargeRegister: "InformationBuildingChargeRegister" };
const UpdateDocumentMutationRequestDocumentType229 = { ExtractContaminatedSitesRegister: "ExtractContaminatedSitesRegister" };
const UpdateDocumentMutationRequestDocumentType230 = { ExtractDevelopmentAndExpansionContributions: "ExtractDevelopmentAndExpansionContributions" };
const UpdateDocumentMutationRequestDocumentType231 = { UrbanDevelopmentContracts: "UrbanDevelopmentContracts" };
const UpdateDocumentMutationRequestDocumentType232 = { SoilReportOrContaminatedSites: "SoilReportOrContaminatedSites" };
const UpdateDocumentMutationRequestDocumentType233 = { GroundLease: "GroundLease" };
const UpdateDocumentMutationRequestDocumentType234 = { VerificationOfExplosiveOrdnance: "VerificationOfExplosiveOrdnance" };
const UpdateDocumentMutationRequestDocumentType235 = { OngoingLegalDisputesRegardingProperty: "OngoingLegalDisputesRegardingProperty" };
const UpdateDocumentMutationRequestDocumentType236 = { BuildingEnergyCertificate: "BuildingEnergyCertificate" };
const UpdateDocumentMutationRequestDocumentType237 = { SectionDrawingsBuildingElevations: "SectionDrawingsBuildingElevations" };
const UpdateDocumentMutationRequestDocumentType238 = { FloorPlansIncludingAreaCalculation: "FloorPlansIncludingAreaCalculation" };
const UpdateDocumentMutationRequestDocumentType239 = { BuildingApplicationOrBuildingPermit: "BuildingApplicationOrBuildingPermit" };
const UpdateDocumentMutationRequestDocumentType240 = { WarrantyGuarantees: "WarrantyGuarantees" };
const UpdateDocumentMutationRequestDocumentType241 = { OverviewOfPastOngoingAndPlannedModernization: "OverviewOfPastOngoingAndPlannedModernization" };
const UpdateDocumentMutationRequestDocumentType242 = { InsuranceClaimsLast5Years: "InsuranceClaimsLast5Years" };
const UpdateDocumentMutationRequestDocumentType243 = { ModernizationsOfIndividualApartments: "ModernizationsOfIndividualApartments" };
const UpdateDocumentMutationRequestDocumentType244 = { DeclarationOfDivisionIfDivided: "DeclarationOfDivisionIfDivided" };
const UpdateDocumentMutationRequestDocumentType245 = { OngoingLegalDisputesRegardingObject: "OngoingLegalDisputesRegardingObject" };
const UpdateDocumentMutationRequestDocumentType246 = { TenantList: "TenantList" };
const UpdateDocumentMutationRequestDocumentType247 = { RentIncreaseLetters: "RentIncreaseLetters" };
const UpdateDocumentMutationRequestDocumentType248 = { RentalAgreements: "RentalAgreements" };
const UpdateDocumentMutationRequestDocumentType249 = { ListOfExistingRentalDeposits: "ListOfExistingRentalDeposits" };
const UpdateDocumentMutationRequestDocumentType250 = { OperatingCostStatement: "OperatingCostStatement" };
const UpdateDocumentMutationRequestDocumentType251 = { TenantHandoverProtocols: "TenantHandoverProtocols" };
const UpdateDocumentMutationRequestDocumentType252 = { ListOfCurrentDefectComplaintsReductionsArrears: "ListOfCurrentDefectComplaintsReductionsArrears" };
const UpdateDocumentMutationRequestDocumentType253 = { OngoingLegalDisputesWithTenants: "OngoingLegalDisputesWithTenants" };
const UpdateDocumentMutationRequestDocumentType254 = { ManagementContracts: "ManagementContracts" };
const UpdateDocumentMutationRequestDocumentType255 = { MaintenanceProtocols: "MaintenanceProtocols" };
const UpdateDocumentMutationRequestDocumentType256 = { ListOfAgeOfInstallations: "ListOfAgeOfInstallations" };
const UpdateDocumentMutationRequestDocumentType257 = { InsurancesMainlyCurrentBuildingInsurance: "InsurancesMainlyCurrentBuildingInsurance" };
const UpdateDocumentMutationRequestDocumentType258 = { PropertyTaxAssessmentAndUnitValueNotice: "PropertyTaxAssessmentAndUnitValueNotice" };
const UpdateDocumentMutationRequestDocumentType259 = { ListOfCraftsmen: "ListOfCraftsmen" };
const UpdateDocumentMutationRequestDocumentType260 = { PurchaseContractDraft: "PurchaseContractDraft" };
const UpdateDocumentMutationRequestDocumentType261 = { AttachmentsToPurchaseContract: "AttachmentsToPurchaseContract" };
const UpdateDocumentMutationRequestDocumentType262 = { PowersOfAttorney: "PowersOfAttorney" };
const UpdateDocumentMutationRequestDocumentType263 = { MfhExpose: "MfhExpose" };
const UpdateDocumentMutationRequestDocumentType264 = { SuperStructures: "SuperStructures" };
const UpdateDocumentMutationRequestDocumentType265 = { LandValueMap: "LandValueMap" };
const UpdateDocumentMutationRequestDocumentType266 = { CommercialOwnerRegisterExtract: "CommercialOwnerRegisterExtract" };
const UpdateDocumentMutationRequestDocumentType267 = { NeighbourhoodAgreements: "NeighbourhoodAgreements" };
const UpdateDocumentMutationRequestDocumentType268 = { LandUsePlan: "LandUsePlan" };
const UpdateDocumentMutationRequestDocumentType269 = { OtherPermits: "OtherPermits" };
const UpdateDocumentMutationRequestDocumentType270 = { OfficialCertificates: "OfficialCertificates" };
const UpdateDocumentMutationRequestDocumentType271 = { BuildingInventoryPlans: "BuildingInventoryPlans" };
const UpdateDocumentMutationRequestDocumentType272 = { BuildingSections: "BuildingSections" };
const UpdateDocumentMutationRequestDocumentType273 = { BuildingStatics: "BuildingStatics" };
const UpdateDocumentMutationRequestDocumentType274 = { BuildingHeating: "BuildingHeating" };
const UpdateDocumentMutationRequestDocumentType275 = { BuildingVentilation: "BuildingVentilation" };
const UpdateDocumentMutationRequestDocumentType276 = { BuildingAirConditioning: "BuildingAirConditioning" };
const UpdateDocumentMutationRequestDocumentType277 = { BuildingSanitary: "BuildingSanitary" };
const UpdateDocumentMutationRequestDocumentType278 = { BuildingElectrical: "BuildingElectrical" };
const UpdateDocumentMutationRequestDocumentType279 = { FireProtection: "FireProtection" };
const UpdateDocumentMutationRequestDocumentType280 = { SpecialistPlannerContracts: "SpecialistPlannerContracts" };
const UpdateDocumentMutationRequestDocumentType281 = { SpecialRealEstateAdditionalInformation: "SpecialRealEstateAdditionalInformation" };
const UpdateDocumentMutationRequestDocumentType282 = { BuildingAdditonalInformation: "BuildingAdditonalInformation" };
const UpdateDocumentMutationRequestDocumentType283 = { Terminations: "Terminations" };
const UpdateDocumentMutationRequestDocumentType284 = { TaxAssessmentNotices: "TaxAssessmentNotices" };
const UpdateDocumentMutationRequestDocumentType285 = { TaxOtherMunicipalCharges: "TaxOtherMunicipalCharges" };
const UpdateDocumentMutationRequestDocumentType286 = { TaxCorrectionBalancesAndPeriods: "TaxCorrectionBalancesAndPeriods" };
const UpdateDocumentMutationRequestDocumentType287 = { TaxValueAddTenants: "TaxValueAddTenants" };
const UpdateDocumentMutationRequestDocumentType288 = { TaxValueAddSellers: "TaxValueAddSellers" };
const UpdateDocumentMutationRequestDocumentType289 = { TaxOptionRatesAndAreaKeys: "TaxOptionRatesAndAreaKeys" };
const UpdateDocumentMutationRequestDocumentType290 = { CompanyOverview: "CompanyOverview" };
const UpdateDocumentMutationRequestDocumentType291 = { CommercialRegisterExtract: "CommercialRegisterExtract" };
const UpdateDocumentMutationRequestDocumentType292 = { TransferOfShares: "TransferOfShares" };
const UpdateDocumentMutationRequestDocumentType293 = { RegisterExcerpts: "RegisterExcerpts" };
const UpdateDocumentMutationRequestDocumentType294 = { ShareRegister: "ShareRegister" };
const UpdateDocumentMutationRequestDocumentType295 = { ListOfShareholders: "ListOfShareholders" };
const UpdateDocumentMutationRequestDocumentType296 = { ArticlesOfAssociation: "ArticlesOfAssociation" };
const UpdateDocumentMutationRequestDocumentType297 = { ArticlesOfAssociationResolutionAmmendments: "ArticlesOfAssociationResolutionAmmendments" };
const UpdateDocumentMutationRequestDocumentType298 = { ArticlesOfAssociationResolutions: "ArticlesOfAssociationResolutions" };
const UpdateDocumentMutationRequestDocumentType299 = { DistributionOfProfitsResolutions: "DistributionOfProfitsResolutions" };
const UpdateDocumentMutationRequestDocumentType300 = { CapitalEndowmentResolutions: "CapitalEndowmentResolutions" };
const UpdateDocumentMutationRequestDocumentType301 = { OtherResolutions: "OtherResolutions" };
const UpdateDocumentMutationRequestDocumentType302 = { ManagingDirectorResolutions: "ManagingDirectorResolutions" };
const UpdateDocumentMutationRequestDocumentType303 = { Minutes: "Minutes" };
const UpdateDocumentMutationRequestDocumentType304 = { AgreementsWithManagement: "AgreementsWithManagement" };
const UpdateDocumentMutationRequestDocumentType305 = { CompanyAccountant: "CompanyAccountant" };
const UpdateDocumentMutationRequestDocumentType306 = { CompanyAuditor: "CompanyAuditor" };
const UpdateDocumentMutationRequestDocumentType307 = { CompanyTaxConsultant: "CompanyTaxConsultant" };
const UpdateDocumentMutationRequestDocumentType308 = { CompanyOtherContracts: "CompanyOtherContracts" };
const UpdateDocumentMutationRequestDocumentType309 = { LoanAgreement: "LoanAgreement" };
const UpdateDocumentMutationRequestDocumentType310 = { LandChargeDeed: "LandChargeDeed" };
const UpdateDocumentMutationRequestDocumentType311 = { DeclarationOfSecurityPurpose: "DeclarationOfSecurityPurpose" };
const UpdateDocumentMutationRequestDocumentType312 = { DeclarationOfAssignment: "DeclarationOfAssignment" };
const UpdateDocumentMutationRequestDocumentType313 = { Pledges: "Pledges" };
const UpdateDocumentMutationRequestDocumentType314 = { PurchasingTerminationDocuments: "PurchasingTerminationDocuments" };
const UpdateDocumentMutationRequestDocumentType315 = { FinancialAnnualStatements: "FinancialAnnualStatements" };
const UpdateDocumentMutationRequestDocumentType316 = { FinancialTaxes: "FinancialTaxes" };
const UpdateDocumentMutationRequestDocumentType317 = { FinancialManagementReporting: "FinancialManagementReporting" };
const UpdateDocumentMutationRequestDocumentType318 = { FinancialLiabilities: "FinancialLiabilities" };
const UpdateDocumentMutationRequestDocumentType319 = { FinancialCurrentBalances: "FinancialCurrentBalances" };
const UpdateDocumentMutationRequestDocumentType320 = { FinancialOtherInformation: "FinancialOtherInformation" };
const UpdateDocumentMutationRequestDocumentType321 = { FoundationReport: "FoundationReport" };
const UpdateDocumentMutationRequestDocumentType322 = { ImportantCorrespondence: "ImportantCorrespondence" };
const UpdateDocumentMutationRequestDocumentType323 = { AdditionalCostsInvoice: "AdditionalCostsInvoice" };
const UpdateDocumentMutationRequestDocumentType324 = { MFHSummary: "MFHSummary" };
const UpdateDocumentMutationRequestDocumentType325 = { MFHInvestmentCaseExportableSheet: "MFHInvestmentCaseExportableSheet" };
const UpdateDocumentMutationRequestDocumentType326 = { AssetPipelineSheet: "AssetPipelineSheet" };
const UpdateDocumentMutationRequestDocumentType327 = { ExternalInvoiceExport: "ExternalInvoiceExport" };
const UpdateDocumentMutationRequestDocumentType328 = { AssetTenderingProcess: "AssetTenderingProcess" };
const UpdateDocumentMutationRequestDocumentType329 = { DueDiligenceOnSiteInspection: "DueDiligenceOnSiteInspection" };
const UpdateDocumentMutationRequestDocumentType330 = { TechnicalDD: "TechnicalDD" };
const UpdateDocumentMutationRequestDocumentType331 = { LegalDD: "LegalDD" };
const UpdateDocumentMutationRequestDocumentType332 = { CommercialDD: "CommercialDD" };
const UpdateDocumentMutationRequestDocumentType333 = { EnergyConsultation: "EnergyConsultation" };
const UpdateDocumentMutationRequestDocumentType334 = { Vicinity: "Vicinity" };
const UpdateDocumentMutationRequestDocumentType335 = { ZoningPlan: "ZoningPlan" };
const UpdateDocumentMutationRequestDocumentType336 = { DevelopmentPlanOrdinance: "DevelopmentPlanOrdinance" };
const UpdateDocumentMutationRequestDocumentType337 = { OtherPlanningLaw: "OtherPlanningLaw" };
const UpdateDocumentMutationRequestDocumentType338 = { ExtractLandChargeRegister: "ExtractLandChargeRegister" };
const UpdateDocumentMutationRequestDocumentType339 = { ExtractTreeInventoryRegister: "ExtractTreeInventoryRegister" };
const UpdateDocumentMutationRequestDocumentType340 = { FloodRiskMap: "FloodRiskMap" };
const UpdateDocumentMutationRequestDocumentType341 = { GroundwaterPlans: "GroundwaterPlans" };
const UpdateDocumentMutationRequestDocumentType342 = { ProtectedAreaMap: "ProtectedAreaMap" };
const UpdateDocumentMutationRequestDocumentType343 = { LiabilityInsuranceForBuildingAndProperty: "LiabilityInsuranceForBuildingAndProperty" };
const UpdateDocumentMutationRequestDocumentType344 = { LiabilityInsuranceForWaterPollutionDamage: "LiabilityInsuranceForWaterPollutionDamage" };
const UpdateDocumentMutationRequestDocumentType345 = { MaintenanceContracts: "MaintenanceContracts" };
const UpdateDocumentMutationRequestDocumentType346 = { PreliminaryBuildingPermit: "PreliminaryBuildingPermit" };
const UpdateDocumentMutationRequestDocumentType347 = { SoilPollutantReportsAndSoilDecontaminationReceipts: "SoilPollutantReportsAndSoilDecontaminationReceipts" };
const UpdateDocumentMutationRequestDocumentType348 = { ConstructionAcceptanceCertificate: "ConstructionAcceptanceCertificate" };
const UpdateDocumentMutationRequestDocumentType349 = { ReportTechnicalDueDiligence: "ReportTechnicalDueDiligence" };
const UpdateDocumentMutationRequestDocumentType350 = { PurchasingOffer: "PurchasingOffer" };
const UpdateDocumentMutationRequestDocumentType351 = { CourtageAgreement: "CourtageAgreement" };
const UpdateDocumentMutationRequestDocumentType352 = { ExclusivityAgreement: "ExclusivityAgreement" };
const UpdateDocumentMutationRequestDocumentType353 = { BillingOrInvoices: "BillingOrInvoices" };
const UpdateDocumentMutationRequestDocumentType354 = { InvestmentProposal: "InvestmentProposal" };
const UpdateDocumentMutationRequestDocumentType355 = { KYCDraft: "KYCDraft" };
const UpdateDocumentMutationRequestDocumentType356 = { IDSeller: "IDSeller" };
const UpdateDocumentMutationRequestDocumentType357 = { AddendumContractDraft: "AddendumContractDraft" };
const UpdateDocumentMutationRequestDocumentType358 = { AddendumContract: "AddendumContract" };
const UpdateDocumentMutationRequestDocumentType359 = { Auftragsempfehlung: "Auftragsempfehlung" };
const UpdateDocumentMutationRequestDocumentType360 = { Entscheidungsvorlage: "Entscheidungsvorlage" };
const UpdateDocumentMutationRequestDocumentType361 = { Werkvertrag: "Werkvertrag" };
const UpdateDocumentMutationRequestDocumentType362 = { Planervertrag: "Planervertrag" };
const UpdateDocumentMutationRequestDocumentCategory = { General: "General" };
const UpdateDocumentMutationRequestDocumentCategory2 = { Sourcing: "Sourcing" };
const UpdateDocumentMutationRequestDocumentCategory3 = { Purchasing: "Purchasing" };
const UpdateDocumentMutationRequestDocumentCategory4 = { Renovation: "Renovation" };
const UpdateDocumentMutationRequestDocumentCategory5 = { Marketing: "Marketing" };
const UpdateDocumentMutationRequestDocumentCategory6 = { PortfolioManagement: "PortfolioManagement" };
const UpdateDocumentMutationRequestDocumentCategory7 = { PropertyManagement: "PropertyManagement" };
const UpdateDocumentMutationRequestDocumentCategory8 = { Accounting: "Accounting" };
const UpdateDocumentMutationRequestDocumentCategory9 = { PostRenovation: "PostRenovation" };
const UpdateDocumentMutationRequestDocumentCategory10 = { Renting: "Renting" };
const UpdateDocumentMutationRequestDocumentCategory11 = { Selling: "Selling" };
const UpdateDocumentMutationRequestDocumentCategory12 = { Orientation: "Orientation" };
const UpdateDocumentMutationRequestDocumentCategory13 = { Livings: "Livings" };
const UpdateDocumentMutationRequestDocumentCategory14 = { SalesPackage: "SalesPackage" };
const UpdateDocumentMutationRequestDocumentCategory15 = { SellingRegion: "SellingRegion" };
const UpdateDocumentMutationRequestDocumentCategory16 = { Land: "Land" };
const UpdateDocumentMutationRequestDocumentCategory17 = { Building: "Building" };
const UpdateDocumentMutationRequestDocumentCategory18 = { RentalContract: "RentalContract" };
const UpdateDocumentMutationRequestDocumentCategory19 = { ObjectManagement: "ObjectManagement" };
const UpdateDocumentMutationRequestDocumentCategory20 = { PurchasingContract: "PurchasingContract" };
const UpdateDocumentMutationRequestDocumentCategory21 = { DueDiligence: "DueDiligence" };
const UpdateDocumentMutationRequestDocumentCategory22 = { MfhOther: "MfhOther" };
const UpdateDocumentMutationRequestDocumentCategory23 = { Taxes: "Taxes" };
const UpdateDocumentMutationRequestDocumentCategory24 = { GeneralCompany: "GeneralCompany" };
const UpdateDocumentMutationRequestDocumentCategory25 = { ShareholderAndStatutes: "ShareholderAndStatutes" };
const UpdateDocumentMutationRequestDocumentCategory26 = { CompanyContracts: "CompanyContracts" };
const UpdateDocumentMutationRequestDocumentCategory27 = { Financing: "Financing" };
const UpdateDocumentMutationRequestDocumentCategory28 = { KYC: "KYC" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CalculateAutomaticMfhInvestmentCase.ts
const CalculateAutomaticMfhInvestmentCase200Status = { calculated: "calculated" };
const CalculateAutomaticMfhInvestmentCase200Status2 = { needs_input: "needs_input" };
const InvestmentCaseStatus33 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType33 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const OutputsGroup = { returns: "returns" };
const OutputsGroup2 = { exit: "exit" };
const OutputsGroup3 = { rent: "rent" };
const OutputsGroup4 = { modernizationRent: "modernizationRent" };
const OutputsGroup5 = { capexFees: "capexFees" };
const OutputsGroup6 = { financing: "financing" };
const OutputsGroup7 = { subsidies: "subsidies" };
const OutputsFormat = { currency: "currency" };
const OutputsFormat2 = { number: "number" };
const OutputsFormat3 = { percent: "percent" };
const OutputsFormat4 = { multiple: "multiple" };
const ChartsChartType = { pie: "pie" };
const ChartsChartType2 = { bar: "bar" };
const ChartsChartType3 = { line: "line" };
const ChartsChartType4 = { waterfall: "waterfall" };
const SlicesFormat = { currency: "currency" };
const SlicesFormat2 = { number: "number" };
const SlicesFormat3 = { percent: "percent" };
const SlicesFormat4 = { multiple: "multiple" };
const SlicesRole = { add: "add" };
const SlicesRole2 = { subtract: "subtract" };
const SlicesRole3 = { subtotal: "subtotal" };
const SeriesFormat = { currency: "currency" };
const SeriesFormat2 = { number: "number" };
const SeriesFormat3 = { percent: "percent" };
const SeriesFormat4 = { multiple: "multiple" };
const MissingInputsSource = { formConfig: "formConfig" };
const MissingInputsSource2 = { calcengine: "calcengine" };
const MissingInputsSource3 = { rentRoll: "rentRoll" };
const FieldTupleErrorsTupleKind = { scalar: "scalar" };
const FieldTupleErrorsTupleKind2 = { vector: "vector" };
const FieldTupleErrorsTupleKind3 = { matrix: "matrix" };
const FieldTupleErrorsTupleKind4 = { error: "error" };
const FieldTupleErrorsSourceKind = { input: "input" };
const FieldTupleErrorsSourceKind2 = { direct: "direct" };
const FieldTupleErrorsSourceKind3 = { unknown: "unknown" };
const CalculateAutomaticMfhInvestmentCaseMutationResponseStatus = { calculated: "calculated" };
const CalculateAutomaticMfhInvestmentCaseMutationResponseStatus2 = { needs_input: "needs_input" };
const InvestmentCaseStatus34 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType34 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const OutputsGroup8 = { returns: "returns" };
const OutputsGroup9 = { exit: "exit" };
const OutputsGroup10 = { rent: "rent" };
const OutputsGroup11 = { modernizationRent: "modernizationRent" };
const OutputsGroup12 = { capexFees: "capexFees" };
const OutputsGroup13 = { financing: "financing" };
const OutputsGroup14 = { subsidies: "subsidies" };
const OutputsFormat5 = { currency: "currency" };
const OutputsFormat6 = { number: "number" };
const OutputsFormat7 = { percent: "percent" };
const OutputsFormat8 = { multiple: "multiple" };
const ChartsChartType5 = { pie: "pie" };
const ChartsChartType6 = { bar: "bar" };
const ChartsChartType7 = { line: "line" };
const ChartsChartType8 = { waterfall: "waterfall" };
const SlicesFormat5 = { currency: "currency" };
const SlicesFormat6 = { number: "number" };
const SlicesFormat7 = { percent: "percent" };
const SlicesFormat8 = { multiple: "multiple" };
const SlicesRole4 = { add: "add" };
const SlicesRole5 = { subtract: "subtract" };
const SlicesRole6 = { subtotal: "subtotal" };
const SeriesFormat5 = { currency: "currency" };
const SeriesFormat6 = { number: "number" };
const SeriesFormat7 = { percent: "percent" };
const SeriesFormat8 = { multiple: "multiple" };
const MissingInputsSource4 = { formConfig: "formConfig" };
const MissingInputsSource5 = { calcengine: "calcengine" };
const MissingInputsSource6 = { rentRoll: "rentRoll" };
const FieldTupleErrorsTupleKind5 = { scalar: "scalar" };
const FieldTupleErrorsTupleKind6 = { vector: "vector" };
const FieldTupleErrorsTupleKind7 = { matrix: "matrix" };
const FieldTupleErrorsTupleKind8 = { error: "error" };
const FieldTupleErrorsSourceKind4 = { input: "input" };
const FieldTupleErrorsSourceKind5 = { direct: "direct" };
const FieldTupleErrorsSourceKind6 = { unknown: "unknown" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ChangeAndRecreateMfhInvestmentCase.ts
const InvestmentCaseStatus11 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType11 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus12 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType12 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ChangeAndRecreateSheetlessMfhInvestmentCase.ts
const InvestmentCaseStatus13 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType13 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus14 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType14 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CheckBaseMfhInvestmentCase.ts
const ProblemsSource = { validation: "validation" };
const ProblemsSource2 = { calculation: "calculation" };
const ProblemsSource3 = { validation: "validation" };
const ProblemsSource4 = { calculation: "calculation" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CommitMfhInvestmentCaseOverrides.ts
const CellsKind7 = { edit: "edit" };
const CellsKind8 = { delete: "delete" };
const CellsKind9 = { clear: "clear" };
const TopStyle29 = { none: "none" };
const TopStyle30 = { thin: "thin" };
const TopStyle31 = { hair: "hair" };
const TopStyle32 = { dotted: "dotted" };
const TopStyle33 = { dashed: "dashed" };
const TopStyle34 = { dash_dot: "dash_dot" };
const TopStyle35 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle36 = { double: "double" };
const TopStyle37 = { medium: "medium" };
const TopStyle38 = { medium_dashed: "medium_dashed" };
const TopStyle39 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle41 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle42 = { thick: "thick" };
const RightStyle29 = { none: "none" };
const RightStyle30 = { thin: "thin" };
const RightStyle31 = { hair: "hair" };
const RightStyle32 = { dotted: "dotted" };
const RightStyle33 = { dashed: "dashed" };
const RightStyle34 = { dash_dot: "dash_dot" };
const RightStyle35 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle36 = { double: "double" };
const RightStyle37 = { medium: "medium" };
const RightStyle38 = { medium_dashed: "medium_dashed" };
const RightStyle39 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle41 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle42 = { thick: "thick" };
const BottomStyle29 = { none: "none" };
const BottomStyle30 = { thin: "thin" };
const BottomStyle31 = { hair: "hair" };
const BottomStyle32 = { dotted: "dotted" };
const BottomStyle33 = { dashed: "dashed" };
const BottomStyle34 = { dash_dot: "dash_dot" };
const BottomStyle35 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle36 = { double: "double" };
const BottomStyle37 = { medium: "medium" };
const BottomStyle38 = { medium_dashed: "medium_dashed" };
const BottomStyle39 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle41 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle42 = { thick: "thick" };
const LeftStyle29 = { none: "none" };
const LeftStyle30 = { thin: "thin" };
const LeftStyle31 = { hair: "hair" };
const LeftStyle32 = { dotted: "dotted" };
const LeftStyle33 = { dashed: "dashed" };
const LeftStyle34 = { dash_dot: "dash_dot" };
const LeftStyle35 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle36 = { double: "double" };
const LeftStyle37 = { medium: "medium" };
const LeftStyle38 = { medium_dashed: "medium_dashed" };
const LeftStyle39 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle41 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle42 = { thick: "thick" };
const TopLeftBottomRightStyle29 = { none: "none" };
const TopLeftBottomRightStyle30 = { thin: "thin" };
const TopLeftBottomRightStyle31 = { hair: "hair" };
const TopLeftBottomRightStyle32 = { dotted: "dotted" };
const TopLeftBottomRightStyle33 = { dashed: "dashed" };
const TopLeftBottomRightStyle34 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle35 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle36 = { double: "double" };
const TopLeftBottomRightStyle37 = { medium: "medium" };
const TopLeftBottomRightStyle38 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle39 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle41 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle42 = { thick: "thick" };
const TopLeftBottomCenterStyle29 = { none: "none" };
const TopLeftBottomCenterStyle30 = { thin: "thin" };
const TopLeftBottomCenterStyle31 = { hair: "hair" };
const TopLeftBottomCenterStyle32 = { dotted: "dotted" };
const TopLeftBottomCenterStyle33 = { dashed: "dashed" };
const TopLeftBottomCenterStyle34 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle35 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle36 = { double: "double" };
const TopLeftBottomCenterStyle37 = { medium: "medium" };
const TopLeftBottomCenterStyle38 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle39 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle41 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle42 = { thick: "thick" };
const TopLeftMiddleRightStyle29 = { none: "none" };
const TopLeftMiddleRightStyle30 = { thin: "thin" };
const TopLeftMiddleRightStyle31 = { hair: "hair" };
const TopLeftMiddleRightStyle32 = { dotted: "dotted" };
const TopLeftMiddleRightStyle33 = { dashed: "dashed" };
const TopLeftMiddleRightStyle34 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle35 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle36 = { double: "double" };
const TopLeftMiddleRightStyle37 = { medium: "medium" };
const TopLeftMiddleRightStyle38 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle39 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle41 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle42 = { thick: "thick" };
const BottomLeftTopRightStyle29 = { none: "none" };
const BottomLeftTopRightStyle30 = { thin: "thin" };
const BottomLeftTopRightStyle31 = { hair: "hair" };
const BottomLeftTopRightStyle32 = { dotted: "dotted" };
const BottomLeftTopRightStyle33 = { dashed: "dashed" };
const BottomLeftTopRightStyle34 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle35 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle36 = { double: "double" };
const BottomLeftTopRightStyle37 = { medium: "medium" };
const BottomLeftTopRightStyle38 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle39 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle41 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle42 = { thick: "thick" };
const MiddleLeftTopRightStyle29 = { none: "none" };
const MiddleLeftTopRightStyle30 = { thin: "thin" };
const MiddleLeftTopRightStyle31 = { hair: "hair" };
const MiddleLeftTopRightStyle32 = { dotted: "dotted" };
const MiddleLeftTopRightStyle33 = { dashed: "dashed" };
const MiddleLeftTopRightStyle34 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle35 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle36 = { double: "double" };
const MiddleLeftTopRightStyle37 = { medium: "medium" };
const MiddleLeftTopRightStyle38 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle39 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle41 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle42 = { thick: "thick" };
const BottomCenterTopRightStyle29 = { none: "none" };
const BottomCenterTopRightStyle30 = { thin: "thin" };
const BottomCenterTopRightStyle31 = { hair: "hair" };
const BottomCenterTopRightStyle32 = { dotted: "dotted" };
const BottomCenterTopRightStyle33 = { dashed: "dashed" };
const BottomCenterTopRightStyle34 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle35 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle36 = { double: "double" };
const BottomCenterTopRightStyle37 = { medium: "medium" };
const BottomCenterTopRightStyle38 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle39 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle40 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle41 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle42 = { thick: "thick" };
const StyleHorizontalAlign15 = { unspecified: "unspecified" };
const StyleHorizontalAlign16 = { left: "left" };
const StyleHorizontalAlign17 = { center: "center" };
const StyleHorizontalAlign18 = { right: "right" };
const StyleHorizontalAlign19 = { justified: "justified" };
const StyleHorizontalAlign20 = { both: "both" };
const StyleHorizontalAlign21 = { distributed: "distributed" };
const StyleVerticalAlign9 = { unspecified: "unspecified" };
const StyleVerticalAlign10 = { top: "top" };
const StyleVerticalAlign11 = { middle: "middle" };
const StyleVerticalAlign12 = { bottom: "bottom" };
const StyleWrapStrategy9 = { unspecified: "unspecified" };
const StyleWrapStrategy10 = { overflow: "overflow" };
const StyleWrapStrategy11 = { clip: "clip" };
const StyleWrapStrategy12 = { wrap: "wrap" };
const CommitMfhInvestmentCaseOverrides200ReadCopySyncStatus = {
	SYNCING: "SYNCING",
	SYNCED: "SYNCED",
	FAILED: "FAILED"
};
const CellEntriesKind = { edit: "edit" };
const CellEntriesKind2 = { delete: "delete" };
const CellEntriesKind3 = { clear: "clear" };
const CellEntriesSourceLanguage = { en: "en" };
const CellEntriesSourceLanguage2 = { de: "de" };
const TopStyle43 = { none: "none" };
const TopStyle44 = { thin: "thin" };
const TopStyle45 = { hair: "hair" };
const TopStyle46 = { dotted: "dotted" };
const TopStyle47 = { dashed: "dashed" };
const TopStyle48 = { dash_dot: "dash_dot" };
const TopStyle49 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle50 = { double: "double" };
const TopStyle51 = { medium: "medium" };
const TopStyle52 = { medium_dashed: "medium_dashed" };
const TopStyle53 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle55 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle56 = { thick: "thick" };
const RightStyle43 = { none: "none" };
const RightStyle44 = { thin: "thin" };
const RightStyle45 = { hair: "hair" };
const RightStyle46 = { dotted: "dotted" };
const RightStyle47 = { dashed: "dashed" };
const RightStyle48 = { dash_dot: "dash_dot" };
const RightStyle49 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle50 = { double: "double" };
const RightStyle51 = { medium: "medium" };
const RightStyle52 = { medium_dashed: "medium_dashed" };
const RightStyle53 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle55 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle56 = { thick: "thick" };
const BottomStyle43 = { none: "none" };
const BottomStyle44 = { thin: "thin" };
const BottomStyle45 = { hair: "hair" };
const BottomStyle46 = { dotted: "dotted" };
const BottomStyle47 = { dashed: "dashed" };
const BottomStyle48 = { dash_dot: "dash_dot" };
const BottomStyle49 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle50 = { double: "double" };
const BottomStyle51 = { medium: "medium" };
const BottomStyle52 = { medium_dashed: "medium_dashed" };
const BottomStyle53 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle55 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle56 = { thick: "thick" };
const LeftStyle43 = { none: "none" };
const LeftStyle44 = { thin: "thin" };
const LeftStyle45 = { hair: "hair" };
const LeftStyle46 = { dotted: "dotted" };
const LeftStyle47 = { dashed: "dashed" };
const LeftStyle48 = { dash_dot: "dash_dot" };
const LeftStyle49 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle50 = { double: "double" };
const LeftStyle51 = { medium: "medium" };
const LeftStyle52 = { medium_dashed: "medium_dashed" };
const LeftStyle53 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle55 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle56 = { thick: "thick" };
const TopLeftBottomRightStyle43 = { none: "none" };
const TopLeftBottomRightStyle44 = { thin: "thin" };
const TopLeftBottomRightStyle45 = { hair: "hair" };
const TopLeftBottomRightStyle46 = { dotted: "dotted" };
const TopLeftBottomRightStyle47 = { dashed: "dashed" };
const TopLeftBottomRightStyle48 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle49 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle50 = { double: "double" };
const TopLeftBottomRightStyle51 = { medium: "medium" };
const TopLeftBottomRightStyle52 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle53 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle55 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle56 = { thick: "thick" };
const TopLeftBottomCenterStyle43 = { none: "none" };
const TopLeftBottomCenterStyle44 = { thin: "thin" };
const TopLeftBottomCenterStyle45 = { hair: "hair" };
const TopLeftBottomCenterStyle46 = { dotted: "dotted" };
const TopLeftBottomCenterStyle47 = { dashed: "dashed" };
const TopLeftBottomCenterStyle48 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle49 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle50 = { double: "double" };
const TopLeftBottomCenterStyle51 = { medium: "medium" };
const TopLeftBottomCenterStyle52 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle53 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle55 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle56 = { thick: "thick" };
const TopLeftMiddleRightStyle43 = { none: "none" };
const TopLeftMiddleRightStyle44 = { thin: "thin" };
const TopLeftMiddleRightStyle45 = { hair: "hair" };
const TopLeftMiddleRightStyle46 = { dotted: "dotted" };
const TopLeftMiddleRightStyle47 = { dashed: "dashed" };
const TopLeftMiddleRightStyle48 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle49 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle50 = { double: "double" };
const TopLeftMiddleRightStyle51 = { medium: "medium" };
const TopLeftMiddleRightStyle52 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle53 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle55 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle56 = { thick: "thick" };
const BottomLeftTopRightStyle43 = { none: "none" };
const BottomLeftTopRightStyle44 = { thin: "thin" };
const BottomLeftTopRightStyle45 = { hair: "hair" };
const BottomLeftTopRightStyle46 = { dotted: "dotted" };
const BottomLeftTopRightStyle47 = { dashed: "dashed" };
const BottomLeftTopRightStyle48 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle49 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle50 = { double: "double" };
const BottomLeftTopRightStyle51 = { medium: "medium" };
const BottomLeftTopRightStyle52 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle53 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle55 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle56 = { thick: "thick" };
const MiddleLeftTopRightStyle43 = { none: "none" };
const MiddleLeftTopRightStyle44 = { thin: "thin" };
const MiddleLeftTopRightStyle45 = { hair: "hair" };
const MiddleLeftTopRightStyle46 = { dotted: "dotted" };
const MiddleLeftTopRightStyle47 = { dashed: "dashed" };
const MiddleLeftTopRightStyle48 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle49 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle50 = { double: "double" };
const MiddleLeftTopRightStyle51 = { medium: "medium" };
const MiddleLeftTopRightStyle52 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle53 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle55 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle56 = { thick: "thick" };
const BottomCenterTopRightStyle43 = { none: "none" };
const BottomCenterTopRightStyle44 = { thin: "thin" };
const BottomCenterTopRightStyle45 = { hair: "hair" };
const BottomCenterTopRightStyle46 = { dotted: "dotted" };
const BottomCenterTopRightStyle47 = { dashed: "dashed" };
const BottomCenterTopRightStyle48 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle49 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle50 = { double: "double" };
const BottomCenterTopRightStyle51 = { medium: "medium" };
const BottomCenterTopRightStyle52 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle53 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle54 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle55 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle56 = { thick: "thick" };
const StyleHorizontalAlign22 = { unspecified: "unspecified" };
const StyleHorizontalAlign23 = { left: "left" };
const StyleHorizontalAlign24 = { center: "center" };
const StyleHorizontalAlign25 = { right: "right" };
const StyleHorizontalAlign26 = { justified: "justified" };
const StyleHorizontalAlign27 = { both: "both" };
const StyleHorizontalAlign28 = { distributed: "distributed" };
const StyleVerticalAlign13 = { unspecified: "unspecified" };
const StyleVerticalAlign14 = { top: "top" };
const StyleVerticalAlign15 = { middle: "middle" };
const StyleVerticalAlign16 = { bottom: "bottom" };
const StyleWrapStrategy13 = { unspecified: "unspecified" };
const StyleWrapStrategy14 = { overflow: "overflow" };
const StyleWrapStrategy15 = { clip: "clip" };
const StyleWrapStrategy16 = { wrap: "wrap" };
const CellsKind10 = { edit: "edit" };
const CellsKind11 = { delete: "delete" };
const CellsKind12 = { clear: "clear" };
const TopStyle57 = { none: "none" };
const TopStyle58 = { thin: "thin" };
const TopStyle59 = { hair: "hair" };
const TopStyle60 = { dotted: "dotted" };
const TopStyle61 = { dashed: "dashed" };
const TopStyle62 = { dash_dot: "dash_dot" };
const TopStyle63 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle64 = { double: "double" };
const TopStyle65 = { medium: "medium" };
const TopStyle66 = { medium_dashed: "medium_dashed" };
const TopStyle67 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle69 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle70 = { thick: "thick" };
const RightStyle57 = { none: "none" };
const RightStyle58 = { thin: "thin" };
const RightStyle59 = { hair: "hair" };
const RightStyle60 = { dotted: "dotted" };
const RightStyle61 = { dashed: "dashed" };
const RightStyle62 = { dash_dot: "dash_dot" };
const RightStyle63 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle64 = { double: "double" };
const RightStyle65 = { medium: "medium" };
const RightStyle66 = { medium_dashed: "medium_dashed" };
const RightStyle67 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle69 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle70 = { thick: "thick" };
const BottomStyle57 = { none: "none" };
const BottomStyle58 = { thin: "thin" };
const BottomStyle59 = { hair: "hair" };
const BottomStyle60 = { dotted: "dotted" };
const BottomStyle61 = { dashed: "dashed" };
const BottomStyle62 = { dash_dot: "dash_dot" };
const BottomStyle63 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle64 = { double: "double" };
const BottomStyle65 = { medium: "medium" };
const BottomStyle66 = { medium_dashed: "medium_dashed" };
const BottomStyle67 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle69 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle70 = { thick: "thick" };
const LeftStyle57 = { none: "none" };
const LeftStyle58 = { thin: "thin" };
const LeftStyle59 = { hair: "hair" };
const LeftStyle60 = { dotted: "dotted" };
const LeftStyle61 = { dashed: "dashed" };
const LeftStyle62 = { dash_dot: "dash_dot" };
const LeftStyle63 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle64 = { double: "double" };
const LeftStyle65 = { medium: "medium" };
const LeftStyle66 = { medium_dashed: "medium_dashed" };
const LeftStyle67 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle69 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle70 = { thick: "thick" };
const TopLeftBottomRightStyle57 = { none: "none" };
const TopLeftBottomRightStyle58 = { thin: "thin" };
const TopLeftBottomRightStyle59 = { hair: "hair" };
const TopLeftBottomRightStyle60 = { dotted: "dotted" };
const TopLeftBottomRightStyle61 = { dashed: "dashed" };
const TopLeftBottomRightStyle62 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle63 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle64 = { double: "double" };
const TopLeftBottomRightStyle65 = { medium: "medium" };
const TopLeftBottomRightStyle66 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle67 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle69 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle70 = { thick: "thick" };
const TopLeftBottomCenterStyle57 = { none: "none" };
const TopLeftBottomCenterStyle58 = { thin: "thin" };
const TopLeftBottomCenterStyle59 = { hair: "hair" };
const TopLeftBottomCenterStyle60 = { dotted: "dotted" };
const TopLeftBottomCenterStyle61 = { dashed: "dashed" };
const TopLeftBottomCenterStyle62 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle63 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle64 = { double: "double" };
const TopLeftBottomCenterStyle65 = { medium: "medium" };
const TopLeftBottomCenterStyle66 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle67 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle69 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle70 = { thick: "thick" };
const TopLeftMiddleRightStyle57 = { none: "none" };
const TopLeftMiddleRightStyle58 = { thin: "thin" };
const TopLeftMiddleRightStyle59 = { hair: "hair" };
const TopLeftMiddleRightStyle60 = { dotted: "dotted" };
const TopLeftMiddleRightStyle61 = { dashed: "dashed" };
const TopLeftMiddleRightStyle62 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle63 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle64 = { double: "double" };
const TopLeftMiddleRightStyle65 = { medium: "medium" };
const TopLeftMiddleRightStyle66 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle67 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle69 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle70 = { thick: "thick" };
const BottomLeftTopRightStyle57 = { none: "none" };
const BottomLeftTopRightStyle58 = { thin: "thin" };
const BottomLeftTopRightStyle59 = { hair: "hair" };
const BottomLeftTopRightStyle60 = { dotted: "dotted" };
const BottomLeftTopRightStyle61 = { dashed: "dashed" };
const BottomLeftTopRightStyle62 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle63 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle64 = { double: "double" };
const BottomLeftTopRightStyle65 = { medium: "medium" };
const BottomLeftTopRightStyle66 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle67 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle69 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle70 = { thick: "thick" };
const MiddleLeftTopRightStyle57 = { none: "none" };
const MiddleLeftTopRightStyle58 = { thin: "thin" };
const MiddleLeftTopRightStyle59 = { hair: "hair" };
const MiddleLeftTopRightStyle60 = { dotted: "dotted" };
const MiddleLeftTopRightStyle61 = { dashed: "dashed" };
const MiddleLeftTopRightStyle62 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle63 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle64 = { double: "double" };
const MiddleLeftTopRightStyle65 = { medium: "medium" };
const MiddleLeftTopRightStyle66 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle67 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle69 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle70 = { thick: "thick" };
const BottomCenterTopRightStyle57 = { none: "none" };
const BottomCenterTopRightStyle58 = { thin: "thin" };
const BottomCenterTopRightStyle59 = { hair: "hair" };
const BottomCenterTopRightStyle60 = { dotted: "dotted" };
const BottomCenterTopRightStyle61 = { dashed: "dashed" };
const BottomCenterTopRightStyle62 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle63 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle64 = { double: "double" };
const BottomCenterTopRightStyle65 = { medium: "medium" };
const BottomCenterTopRightStyle66 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle67 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle68 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle69 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle70 = { thick: "thick" };
const StyleHorizontalAlign29 = { unspecified: "unspecified" };
const StyleHorizontalAlign30 = { left: "left" };
const StyleHorizontalAlign31 = { center: "center" };
const StyleHorizontalAlign32 = { right: "right" };
const StyleHorizontalAlign33 = { justified: "justified" };
const StyleHorizontalAlign34 = { both: "both" };
const StyleHorizontalAlign35 = { distributed: "distributed" };
const StyleVerticalAlign17 = { unspecified: "unspecified" };
const StyleVerticalAlign18 = { top: "top" };
const StyleVerticalAlign19 = { middle: "middle" };
const StyleVerticalAlign20 = { bottom: "bottom" };
const StyleWrapStrategy17 = { unspecified: "unspecified" };
const StyleWrapStrategy18 = { overflow: "overflow" };
const StyleWrapStrategy19 = { clip: "clip" };
const StyleWrapStrategy20 = { wrap: "wrap" };
const CommitMfhInvestmentCaseOverridesMutationResponseReadCopySyncStatus = {
	SYNCING: "SYNCING",
	SYNCED: "SYNCED",
	FAILED: "FAILED"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CopyAndChangeAssetPartnerMfhInvestmentCase.ts
const CopyAndChangeAssetPartnerMfhInvestmentCase200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction33 = { update_mfh: "update_mfh" };
const DecisionAction34 = { create_mfh: "create_mfh" };
const DecisionAction35 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction36 = { create_mfh_estate: "create_mfh_estate" };
const CopyAndChangeAssetPartnerMfhInvestmentCaseMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction37 = { update_mfh: "update_mfh" };
const DecisionAction38 = { create_mfh: "create_mfh" };
const DecisionAction39 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction40 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CopyAndChangeAssetPartnerSheetlessMfhInvestmentCase.ts
const InvestmentCaseStatus17 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType17 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus18 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType18 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CopyMfhInvestmentCase.ts
const CopyMfhInvestmentCase200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction25 = { update_mfh: "update_mfh" };
const DecisionAction26 = { create_mfh: "create_mfh" };
const DecisionAction27 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction28 = { create_mfh_estate: "create_mfh_estate" };
const CopyMfhInvestmentCaseMutationRequestExitApproach = {
	"MFH Sale": "MFH Sale",
	"Single Apartment Sale - 3rd Party & Already Divided": "Single Apartment Sale - 3rd Party & Already Divided",
	"Single Apartment Sale - CONDO Books & Already Divided": "Single Apartment Sale - CONDO Books & Already Divided",
	"Single Apartment Sale - 3rd Party & Not Yet Divided": "Single Apartment Sale - 3rd Party & Not Yet Divided",
	"Single Apartment Sale - CONDO Books & Not Yet Divided": "Single Apartment Sale - CONDO Books & Not Yet Divided"
};
const CopyMfhInvestmentCaseMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction29 = { update_mfh: "update_mfh" };
const DecisionAction30 = { create_mfh: "create_mfh" };
const DecisionAction31 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction32 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CopyMfhInvestmentCaseToAssetManagement.ts
const CopyMfhInvestmentCaseToAssetManagement200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction41 = { update_mfh: "update_mfh" };
const DecisionAction42 = { create_mfh: "create_mfh" };
const DecisionAction43 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction44 = { create_mfh_estate: "create_mfh_estate" };
const CopyMfhInvestmentCaseToAssetManagementMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction45 = { update_mfh: "update_mfh" };
const DecisionAction46 = { create_mfh: "create_mfh" };
const DecisionAction47 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction48 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CopySheetlessMfhInvestmentCase.ts
const InvestmentCaseStatus15 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType15 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus16 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType16 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CreateAutomaticMfhInvestmentCase.ts
const InvestmentCaseStatus29 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType29 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const MarketRentFallbackProvider5 = { sprengnetter: "sprengnetter" };
const MarketRentFallbackProvider6 = { geomap: "geomap" };
const MarketRentFallbackStatus7 = { used: "used" };
const MarketRentFallbackStatus8 = { failed: "failed" };
const MarketRentFallbackStatus9 = { skipped: "skipped" };
const AddressNation7 = { DE: "DE" };
const MarketRentFallbacksProvider9 = { sprengnetter: "sprengnetter" };
const MarketRentFallbacksProvider10 = { geomap: "geomap" };
const MarketRentFallbacksStatus13 = { used: "used" };
const MarketRentFallbacksStatus14 = { failed: "failed" };
const MarketRentFallbacksStatus15 = { skipped: "skipped" };
const AddressNation8 = { DE: "DE" };
const MarketRentSelectionSource7 = { "sprengnetter-current": "sprengnetter-current" };
const MarketRentSelectionSource8 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const MarketRentSelectionSource9 = { "geomap-current": "geomap-current" };
const MarketRentSelectionProvider5 = { sprengnetter: "sprengnetter" };
const MarketRentSelectionProvider6 = { geomap: "geomap" };
const CreateAutomaticMfhInvestmentCaseMutationRequestMarketRentSource = { "sprengnetter-current": "sprengnetter-current" };
const CreateAutomaticMfhInvestmentCaseMutationRequestMarketRentSource2 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const CreateAutomaticMfhInvestmentCaseMutationRequestMarketRentSource3 = { "geomap-current": "geomap-current" };
const InvestmentCaseStatus30 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType30 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const MarketRentFallbackProvider7 = { sprengnetter: "sprengnetter" };
const MarketRentFallbackProvider8 = { geomap: "geomap" };
const MarketRentFallbackStatus10 = { used: "used" };
const MarketRentFallbackStatus11 = { failed: "failed" };
const MarketRentFallbackStatus12 = { skipped: "skipped" };
const AddressNation9 = { DE: "DE" };
const MarketRentFallbacksProvider11 = { sprengnetter: "sprengnetter" };
const MarketRentFallbacksProvider12 = { geomap: "geomap" };
const MarketRentFallbacksStatus16 = { used: "used" };
const MarketRentFallbacksStatus17 = { failed: "failed" };
const MarketRentFallbacksStatus18 = { skipped: "skipped" };
const AddressNation10 = { DE: "DE" };
const MarketRentSelectionSource10 = { "sprengnetter-current": "sprengnetter-current" };
const MarketRentSelectionSource11 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const MarketRentSelectionSource12 = { "geomap-current": "geomap-current" };
const MarketRentSelectionProvider7 = { sprengnetter: "sprengnetter" };
const MarketRentSelectionProvider8 = { geomap: "geomap" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CreateAutomaticMfhInvestmentCases.ts
const InvestmentCasesStatus = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCasesInvestmentCaseType = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const BaseInvestmentCaseStatus = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const BaseInvestmentCaseInvestmentCaseType = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCasesStatus2 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCasesInvestmentCaseType2 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const MarketRentFallbackProvider = { sprengnetter: "sprengnetter" };
const MarketRentFallbackProvider2 = { geomap: "geomap" };
const MarketRentFallbackStatus = { used: "used" };
const MarketRentFallbackStatus2 = { failed: "failed" };
const MarketRentFallbackStatus3 = { skipped: "skipped" };
const AddressNation3 = { DE: "DE" };
const MarketRentFallbacksProvider5 = { sprengnetter: "sprengnetter" };
const MarketRentFallbacksProvider6 = { geomap: "geomap" };
const MarketRentFallbacksStatus7 = { used: "used" };
const MarketRentFallbacksStatus8 = { failed: "failed" };
const MarketRentFallbacksStatus9 = { skipped: "skipped" };
const AddressNation4 = { DE: "DE" };
const MarketRentSelectionSource = { "sprengnetter-current": "sprengnetter-current" };
const MarketRentSelectionSource2 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const MarketRentSelectionSource3 = { "geomap-current": "geomap-current" };
const MarketRentSelectionProvider = { sprengnetter: "sprengnetter" };
const MarketRentSelectionProvider2 = { geomap: "geomap" };
const CreateAutomaticMfhInvestmentCasesMutationRequestMarketRentSource = { "sprengnetter-current": "sprengnetter-current" };
const CreateAutomaticMfhInvestmentCasesMutationRequestMarketRentSource2 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const CreateAutomaticMfhInvestmentCasesMutationRequestMarketRentSource3 = { "geomap-current": "geomap-current" };
const InvestmentCasesStatus3 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCasesInvestmentCaseType3 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const BaseInvestmentCaseStatus2 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const BaseInvestmentCaseInvestmentCaseType2 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCasesStatus4 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCasesInvestmentCaseType4 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const MarketRentFallbackProvider3 = { sprengnetter: "sprengnetter" };
const MarketRentFallbackProvider4 = { geomap: "geomap" };
const MarketRentFallbackStatus4 = { used: "used" };
const MarketRentFallbackStatus5 = { failed: "failed" };
const MarketRentFallbackStatus6 = { skipped: "skipped" };
const AddressNation5 = { DE: "DE" };
const MarketRentFallbacksProvider7 = { sprengnetter: "sprengnetter" };
const MarketRentFallbacksProvider8 = { geomap: "geomap" };
const MarketRentFallbacksStatus10 = { used: "used" };
const MarketRentFallbacksStatus11 = { failed: "failed" };
const MarketRentFallbacksStatus12 = { skipped: "skipped" };
const AddressNation6 = { DE: "DE" };
const MarketRentSelectionSource4 = { "sprengnetter-current": "sprengnetter-current" };
const MarketRentSelectionSource5 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const MarketRentSelectionSource6 = { "geomap-current": "geomap-current" };
const MarketRentSelectionProvider3 = { sprengnetter: "sprengnetter" };
const MarketRentSelectionProvider4 = { geomap: "geomap" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CreateBaseMfhInvestmentCase.ts
const CreateBaseMfhInvestmentCaseMutationRequestExitApproach = {
	"MFH Sale": "MFH Sale",
	"Single Apartment Sale - 3rd Party & Already Divided": "Single Apartment Sale - 3rd Party & Already Divided",
	"Single Apartment Sale - CONDO Books & Already Divided": "Single Apartment Sale - CONDO Books & Already Divided",
	"Single Apartment Sale - 3rd Party & Not Yet Divided": "Single Apartment Sale - 3rd Party & Not Yet Divided",
	"Single Apartment Sale - CONDO Books & Not Yet Divided": "Single Apartment Sale - CONDO Books & Not Yet Divided"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CreateEmptyMfhInvestmentCase.ts
const InvestmentCaseStatus = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const CreateEmptyMfhInvestmentCaseMutationRequestExitApproach = {
	"MFH Sale": "MFH Sale",
	"Single Apartment Sale - 3rd Party & Already Divided": "Single Apartment Sale - 3rd Party & Already Divided",
	"Single Apartment Sale - CONDO Books & Already Divided": "Single Apartment Sale - CONDO Books & Already Divided",
	"Single Apartment Sale - 3rd Party & Not Yet Divided": "Single Apartment Sale - 3rd Party & Not Yet Divided",
	"Single Apartment Sale - CONDO Books & Not Yet Divided": "Single Apartment Sale - CONDO Books & Not Yet Divided"
};
const InvestmentCaseStatus2 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType2 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/CreateSheetlessMfhInvestmentCase.ts
const InvestmentCaseStatus7 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType7 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus8 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType8 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/DeleteMfhInvestmentCases.ts
const DeleteMfhInvestmentCases200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction = { update_mfh: "update_mfh" };
const DecisionAction2 = { create_mfh: "create_mfh" };
const DecisionAction3 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction4 = { create_mfh_estate: "create_mfh_estate" };
const DeleteMfhInvestmentCasesMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction5 = { update_mfh: "update_mfh" };
const DecisionAction6 = { create_mfh: "create_mfh" };
const DecisionAction7 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction8 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/DownloadMfhInvestmentCaseSheet.ts
const DownloadMfhInvestmentCaseSheet200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction9 = { update_mfh: "update_mfh" };
const DecisionAction10 = { create_mfh: "create_mfh" };
const DecisionAction11 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction12 = { create_mfh_estate: "create_mfh_estate" };
const DownloadMfhInvestmentCaseSheetQueryResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction13 = { update_mfh: "update_mfh" };
const DecisionAction14 = { create_mfh: "create_mfh" };
const DecisionAction15 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction16 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/EvaluateAutomaticMfhMarketRentSources.ts
const MarketRentFallbacksProvider = { sprengnetter: "sprengnetter" };
const MarketRentFallbacksProvider2 = { geomap: "geomap" };
const MarketRentFallbacksStatus = { used: "used" };
const MarketRentFallbacksStatus2 = { failed: "failed" };
const MarketRentFallbacksStatus3 = { skipped: "skipped" };
const AddressNation = { DE: "DE" };
const MarketRentOptionsSource = { "sprengnetter-current": "sprengnetter-current" };
const MarketRentOptionsSource2 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const MarketRentOptionsSource3 = { "geomap-current": "geomap-current" };
const MarketRentOptionsProvider = { sprengnetter: "sprengnetter" };
const MarketRentOptionsProvider2 = { geomap: "geomap" };
const MarketRentFallbacksProvider3 = { sprengnetter: "sprengnetter" };
const MarketRentFallbacksProvider4 = { geomap: "geomap" };
const MarketRentFallbacksStatus4 = { used: "used" };
const MarketRentFallbacksStatus5 = { failed: "failed" };
const MarketRentFallbacksStatus6 = { skipped: "skipped" };
const AddressNation2 = { DE: "DE" };
const MarketRentOptionsSource4 = { "sprengnetter-current": "sprengnetter-current" };
const MarketRentOptionsSource5 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const MarketRentOptionsSource6 = { "geomap-current": "geomap-current" };
const MarketRentOptionsProvider3 = { sprengnetter: "sprengnetter" };
const MarketRentOptionsProvider4 = { geomap: "geomap" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/EvaluateMfhInvestmentCasePartnerBuyBox.ts
const IrrPercentageStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const MocMultiplierStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const CocPercentageStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const PurchasePriceStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const PurchasePriceDiscountStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const InvestmentVolumeStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const LtvStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const CommercialShareStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const PreferredLocationsValue = {
	A: "A",
	B: "B",
	C: "C"
};
const PreferredLocationsThreshold = {
	A: "A",
	B: "B",
	C: "C"
};
const PreferredLocationsStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const EvaluationsBuyBoxStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const FailingCriteriaDirection = { min: "min" };
const FailingCriteriaDirection2 = { max: "max" };
const FailingCriteriaDirection3 = { includes: "includes" };
const IrrPercentageStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const MocMultiplierStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const CocPercentageStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const PurchasePriceStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const PurchasePriceDiscountStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const InvestmentVolumeStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const LtvStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const CommercialShareStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const PreferredLocationsValue2 = {
	A: "A",
	B: "B",
	C: "C"
};
const PreferredLocationsThreshold2 = {
	A: "A",
	B: "B",
	C: "C"
};
const PreferredLocationsStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const EvaluationsBuyBoxStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const FailingCriteriaDirection4 = { min: "min" };
const FailingCriteriaDirection5 = { max: "max" };
const FailingCriteriaDirection6 = { includes: "includes" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/FindMfhInvestmentCasesByMfh.ts
const FindMfhInvestmentCasesByMfhQueryParamsInvestmentCaseType = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const FindMfhInvestmentCasesByMfhQueryParamsStatus = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GenerateRentMarketData.ts
const GenerateRentMarketDataQueryParamsMfhConditions = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const GenerateRentMarketDataQueryParamsListedSince = {
	"7": 7,
	"30": 30,
	"90": 90,
	"180": 180,
	"365": 365
};
const GenerateRentMarketData200MfhConditions = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersMfhConditions3 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersListedSince13 = { "-1": -1 };
const FiltersListedSince14 = { "7": 7 };
const FiltersListedSince15 = { "30": 30 };
const FiltersListedSince16 = { "90": 90 };
const FiltersListedSince17 = { "180": 180 };
const FiltersListedSince18 = { "365": 365 };
const ListingsCondition3 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ByConditionCondition3 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const GenerateRentMarketData200RoutingStatus = {
	complete: "complete",
	partial: "partial",
	unavailable: "unavailable",
	skipped: "skipped"
};
const GenerateRentMarketDataQueryResponseMfhConditions = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersMfhConditions4 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersListedSince19 = { "-1": -1 };
const FiltersListedSince20 = { "7": 7 };
const FiltersListedSince21 = { "30": 30 };
const FiltersListedSince22 = { "90": 90 };
const FiltersListedSince23 = { "180": 180 };
const FiltersListedSince24 = { "365": 365 };
const ListingsCondition4 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ByConditionCondition4 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const GenerateRentMarketDataQueryResponseRoutingStatus = {
	complete: "complete",
	partial: "partial",
	unavailable: "unavailable",
	skipped: "skipped"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GetAutomaticMfhInvestmentCase.ts
const InvestmentCaseStatus35 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType35 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const OutputsGroup15 = { returns: "returns" };
const OutputsGroup16 = { exit: "exit" };
const OutputsGroup17 = { rent: "rent" };
const OutputsGroup18 = { modernizationRent: "modernizationRent" };
const OutputsGroup19 = { capexFees: "capexFees" };
const OutputsGroup20 = { financing: "financing" };
const OutputsGroup21 = { subsidies: "subsidies" };
const OutputsFormat9 = { currency: "currency" };
const OutputsFormat10 = { number: "number" };
const OutputsFormat11 = { percent: "percent" };
const OutputsFormat12 = { multiple: "multiple" };
const ChartsChartType9 = { pie: "pie" };
const ChartsChartType10 = { bar: "bar" };
const ChartsChartType11 = { line: "line" };
const ChartsChartType12 = { waterfall: "waterfall" };
const SlicesFormat9 = { currency: "currency" };
const SlicesFormat10 = { number: "number" };
const SlicesFormat11 = { percent: "percent" };
const SlicesFormat12 = { multiple: "multiple" };
const SlicesRole7 = { add: "add" };
const SlicesRole8 = { subtract: "subtract" };
const SlicesRole9 = { subtotal: "subtotal" };
const SeriesFormat9 = { currency: "currency" };
const SeriesFormat10 = { number: "number" };
const SeriesFormat11 = { percent: "percent" };
const SeriesFormat12 = { multiple: "multiple" };
const FieldTupleErrorsTupleKind9 = { scalar: "scalar" };
const FieldTupleErrorsTupleKind10 = { vector: "vector" };
const FieldTupleErrorsTupleKind11 = { matrix: "matrix" };
const FieldTupleErrorsTupleKind12 = { error: "error" };
const FieldTupleErrorsSourceKind7 = { input: "input" };
const FieldTupleErrorsSourceKind8 = { direct: "direct" };
const FieldTupleErrorsSourceKind9 = { unknown: "unknown" };
const InvestmentCaseStatus36 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType36 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const OutputsGroup22 = { returns: "returns" };
const OutputsGroup23 = { exit: "exit" };
const OutputsGroup24 = { rent: "rent" };
const OutputsGroup25 = { modernizationRent: "modernizationRent" };
const OutputsGroup26 = { capexFees: "capexFees" };
const OutputsGroup27 = { financing: "financing" };
const OutputsGroup28 = { subsidies: "subsidies" };
const OutputsFormat13 = { currency: "currency" };
const OutputsFormat14 = { number: "number" };
const OutputsFormat15 = { percent: "percent" };
const OutputsFormat16 = { multiple: "multiple" };
const ChartsChartType13 = { pie: "pie" };
const ChartsChartType14 = { bar: "bar" };
const ChartsChartType15 = { line: "line" };
const ChartsChartType16 = { waterfall: "waterfall" };
const SlicesFormat13 = { currency: "currency" };
const SlicesFormat14 = { number: "number" };
const SlicesFormat15 = { percent: "percent" };
const SlicesFormat16 = { multiple: "multiple" };
const SlicesRole10 = { add: "add" };
const SlicesRole11 = { subtract: "subtract" };
const SlicesRole12 = { subtotal: "subtotal" };
const SeriesFormat13 = { currency: "currency" };
const SeriesFormat14 = { number: "number" };
const SeriesFormat15 = { percent: "percent" };
const SeriesFormat16 = { multiple: "multiple" };
const FieldTupleErrorsTupleKind13 = { scalar: "scalar" };
const FieldTupleErrorsTupleKind14 = { vector: "vector" };
const FieldTupleErrorsTupleKind15 = { matrix: "matrix" };
const FieldTupleErrorsTupleKind16 = { error: "error" };
const FieldTupleErrorsSourceKind10 = { input: "input" };
const FieldTupleErrorsSourceKind11 = { direct: "direct" };
const FieldTupleErrorsSourceKind12 = { unknown: "unknown" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GetMfhInvestmentCase.ts
const InvestmentCaseStatus3 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType3 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus4 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType4 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GetMfhInvestmentCaseMissingInputs.ts
const MissingInputsSource7 = { formConfig: "formConfig" };
const MissingInputsSource8 = { calcengine: "calcengine" };
const MissingInputsSource9 = { rentRoll: "rentRoll" };
const MissingInputsSource10 = { formConfig: "formConfig" };
const MissingInputsSource11 = { calcengine: "calcengine" };
const MissingInputsSource12 = { rentRoll: "rentRoll" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GetMfhInvestmentCaseVersionResultPreview.ts
const TargetOutputStatus = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const TargetOutputInvestmentCaseType = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const TargetOutputStatus2 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const TargetOutputInvestmentCaseType2 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GetMfhInvestmentCaseVersionSheetPreview.ts
const CellsKind13 = { edit: "edit" };
const CellsKind14 = { delete: "delete" };
const CellsKind15 = { clear: "clear" };
const TopStyle71 = { none: "none" };
const TopStyle72 = { thin: "thin" };
const TopStyle73 = { hair: "hair" };
const TopStyle74 = { dotted: "dotted" };
const TopStyle75 = { dashed: "dashed" };
const TopStyle76 = { dash_dot: "dash_dot" };
const TopStyle77 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle78 = { double: "double" };
const TopStyle79 = { medium: "medium" };
const TopStyle80 = { medium_dashed: "medium_dashed" };
const TopStyle81 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle83 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle84 = { thick: "thick" };
const RightStyle71 = { none: "none" };
const RightStyle72 = { thin: "thin" };
const RightStyle73 = { hair: "hair" };
const RightStyle74 = { dotted: "dotted" };
const RightStyle75 = { dashed: "dashed" };
const RightStyle76 = { dash_dot: "dash_dot" };
const RightStyle77 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle78 = { double: "double" };
const RightStyle79 = { medium: "medium" };
const RightStyle80 = { medium_dashed: "medium_dashed" };
const RightStyle81 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle83 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle84 = { thick: "thick" };
const BottomStyle71 = { none: "none" };
const BottomStyle72 = { thin: "thin" };
const BottomStyle73 = { hair: "hair" };
const BottomStyle74 = { dotted: "dotted" };
const BottomStyle75 = { dashed: "dashed" };
const BottomStyle76 = { dash_dot: "dash_dot" };
const BottomStyle77 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle78 = { double: "double" };
const BottomStyle79 = { medium: "medium" };
const BottomStyle80 = { medium_dashed: "medium_dashed" };
const BottomStyle81 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle83 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle84 = { thick: "thick" };
const LeftStyle71 = { none: "none" };
const LeftStyle72 = { thin: "thin" };
const LeftStyle73 = { hair: "hair" };
const LeftStyle74 = { dotted: "dotted" };
const LeftStyle75 = { dashed: "dashed" };
const LeftStyle76 = { dash_dot: "dash_dot" };
const LeftStyle77 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle78 = { double: "double" };
const LeftStyle79 = { medium: "medium" };
const LeftStyle80 = { medium_dashed: "medium_dashed" };
const LeftStyle81 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle83 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle84 = { thick: "thick" };
const TopLeftBottomRightStyle71 = { none: "none" };
const TopLeftBottomRightStyle72 = { thin: "thin" };
const TopLeftBottomRightStyle73 = { hair: "hair" };
const TopLeftBottomRightStyle74 = { dotted: "dotted" };
const TopLeftBottomRightStyle75 = { dashed: "dashed" };
const TopLeftBottomRightStyle76 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle77 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle78 = { double: "double" };
const TopLeftBottomRightStyle79 = { medium: "medium" };
const TopLeftBottomRightStyle80 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle81 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle83 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle84 = { thick: "thick" };
const TopLeftBottomCenterStyle71 = { none: "none" };
const TopLeftBottomCenterStyle72 = { thin: "thin" };
const TopLeftBottomCenterStyle73 = { hair: "hair" };
const TopLeftBottomCenterStyle74 = { dotted: "dotted" };
const TopLeftBottomCenterStyle75 = { dashed: "dashed" };
const TopLeftBottomCenterStyle76 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle77 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle78 = { double: "double" };
const TopLeftBottomCenterStyle79 = { medium: "medium" };
const TopLeftBottomCenterStyle80 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle81 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle83 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle84 = { thick: "thick" };
const TopLeftMiddleRightStyle71 = { none: "none" };
const TopLeftMiddleRightStyle72 = { thin: "thin" };
const TopLeftMiddleRightStyle73 = { hair: "hair" };
const TopLeftMiddleRightStyle74 = { dotted: "dotted" };
const TopLeftMiddleRightStyle75 = { dashed: "dashed" };
const TopLeftMiddleRightStyle76 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle77 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle78 = { double: "double" };
const TopLeftMiddleRightStyle79 = { medium: "medium" };
const TopLeftMiddleRightStyle80 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle81 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle83 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle84 = { thick: "thick" };
const BottomLeftTopRightStyle71 = { none: "none" };
const BottomLeftTopRightStyle72 = { thin: "thin" };
const BottomLeftTopRightStyle73 = { hair: "hair" };
const BottomLeftTopRightStyle74 = { dotted: "dotted" };
const BottomLeftTopRightStyle75 = { dashed: "dashed" };
const BottomLeftTopRightStyle76 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle77 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle78 = { double: "double" };
const BottomLeftTopRightStyle79 = { medium: "medium" };
const BottomLeftTopRightStyle80 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle81 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle83 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle84 = { thick: "thick" };
const MiddleLeftTopRightStyle71 = { none: "none" };
const MiddleLeftTopRightStyle72 = { thin: "thin" };
const MiddleLeftTopRightStyle73 = { hair: "hair" };
const MiddleLeftTopRightStyle74 = { dotted: "dotted" };
const MiddleLeftTopRightStyle75 = { dashed: "dashed" };
const MiddleLeftTopRightStyle76 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle77 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle78 = { double: "double" };
const MiddleLeftTopRightStyle79 = { medium: "medium" };
const MiddleLeftTopRightStyle80 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle81 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle83 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle84 = { thick: "thick" };
const BottomCenterTopRightStyle71 = { none: "none" };
const BottomCenterTopRightStyle72 = { thin: "thin" };
const BottomCenterTopRightStyle73 = { hair: "hair" };
const BottomCenterTopRightStyle74 = { dotted: "dotted" };
const BottomCenterTopRightStyle75 = { dashed: "dashed" };
const BottomCenterTopRightStyle76 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle77 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle78 = { double: "double" };
const BottomCenterTopRightStyle79 = { medium: "medium" };
const BottomCenterTopRightStyle80 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle81 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle82 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle83 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle84 = { thick: "thick" };
const StyleHorizontalAlign36 = { unspecified: "unspecified" };
const StyleHorizontalAlign37 = { left: "left" };
const StyleHorizontalAlign38 = { center: "center" };
const StyleHorizontalAlign39 = { right: "right" };
const StyleHorizontalAlign40 = { justified: "justified" };
const StyleHorizontalAlign41 = { both: "both" };
const StyleHorizontalAlign42 = { distributed: "distributed" };
const StyleVerticalAlign21 = { unspecified: "unspecified" };
const StyleVerticalAlign22 = { top: "top" };
const StyleVerticalAlign23 = { middle: "middle" };
const StyleVerticalAlign24 = { bottom: "bottom" };
const StyleWrapStrategy21 = { unspecified: "unspecified" };
const StyleWrapStrategy22 = { overflow: "overflow" };
const StyleWrapStrategy23 = { clip: "clip" };
const StyleWrapStrategy24 = { wrap: "wrap" };
const CellsKind16 = { edit: "edit" };
const CellsKind17 = { delete: "delete" };
const CellsKind18 = { clear: "clear" };
const TopStyle85 = { none: "none" };
const TopStyle86 = { thin: "thin" };
const TopStyle87 = { hair: "hair" };
const TopStyle88 = { dotted: "dotted" };
const TopStyle89 = { dashed: "dashed" };
const TopStyle90 = { dash_dot: "dash_dot" };
const TopStyle91 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle92 = { double: "double" };
const TopStyle93 = { medium: "medium" };
const TopStyle94 = { medium_dashed: "medium_dashed" };
const TopStyle95 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle97 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle98 = { thick: "thick" };
const RightStyle85 = { none: "none" };
const RightStyle86 = { thin: "thin" };
const RightStyle87 = { hair: "hair" };
const RightStyle88 = { dotted: "dotted" };
const RightStyle89 = { dashed: "dashed" };
const RightStyle90 = { dash_dot: "dash_dot" };
const RightStyle91 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle92 = { double: "double" };
const RightStyle93 = { medium: "medium" };
const RightStyle94 = { medium_dashed: "medium_dashed" };
const RightStyle95 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle97 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle98 = { thick: "thick" };
const BottomStyle85 = { none: "none" };
const BottomStyle86 = { thin: "thin" };
const BottomStyle87 = { hair: "hair" };
const BottomStyle88 = { dotted: "dotted" };
const BottomStyle89 = { dashed: "dashed" };
const BottomStyle90 = { dash_dot: "dash_dot" };
const BottomStyle91 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle92 = { double: "double" };
const BottomStyle93 = { medium: "medium" };
const BottomStyle94 = { medium_dashed: "medium_dashed" };
const BottomStyle95 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle97 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle98 = { thick: "thick" };
const LeftStyle85 = { none: "none" };
const LeftStyle86 = { thin: "thin" };
const LeftStyle87 = { hair: "hair" };
const LeftStyle88 = { dotted: "dotted" };
const LeftStyle89 = { dashed: "dashed" };
const LeftStyle90 = { dash_dot: "dash_dot" };
const LeftStyle91 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle92 = { double: "double" };
const LeftStyle93 = { medium: "medium" };
const LeftStyle94 = { medium_dashed: "medium_dashed" };
const LeftStyle95 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle97 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle98 = { thick: "thick" };
const TopLeftBottomRightStyle85 = { none: "none" };
const TopLeftBottomRightStyle86 = { thin: "thin" };
const TopLeftBottomRightStyle87 = { hair: "hair" };
const TopLeftBottomRightStyle88 = { dotted: "dotted" };
const TopLeftBottomRightStyle89 = { dashed: "dashed" };
const TopLeftBottomRightStyle90 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle91 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle92 = { double: "double" };
const TopLeftBottomRightStyle93 = { medium: "medium" };
const TopLeftBottomRightStyle94 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle95 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle97 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle98 = { thick: "thick" };
const TopLeftBottomCenterStyle85 = { none: "none" };
const TopLeftBottomCenterStyle86 = { thin: "thin" };
const TopLeftBottomCenterStyle87 = { hair: "hair" };
const TopLeftBottomCenterStyle88 = { dotted: "dotted" };
const TopLeftBottomCenterStyle89 = { dashed: "dashed" };
const TopLeftBottomCenterStyle90 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle91 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle92 = { double: "double" };
const TopLeftBottomCenterStyle93 = { medium: "medium" };
const TopLeftBottomCenterStyle94 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle95 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle97 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle98 = { thick: "thick" };
const TopLeftMiddleRightStyle85 = { none: "none" };
const TopLeftMiddleRightStyle86 = { thin: "thin" };
const TopLeftMiddleRightStyle87 = { hair: "hair" };
const TopLeftMiddleRightStyle88 = { dotted: "dotted" };
const TopLeftMiddleRightStyle89 = { dashed: "dashed" };
const TopLeftMiddleRightStyle90 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle91 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle92 = { double: "double" };
const TopLeftMiddleRightStyle93 = { medium: "medium" };
const TopLeftMiddleRightStyle94 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle95 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle97 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle98 = { thick: "thick" };
const BottomLeftTopRightStyle85 = { none: "none" };
const BottomLeftTopRightStyle86 = { thin: "thin" };
const BottomLeftTopRightStyle87 = { hair: "hair" };
const BottomLeftTopRightStyle88 = { dotted: "dotted" };
const BottomLeftTopRightStyle89 = { dashed: "dashed" };
const BottomLeftTopRightStyle90 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle91 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle92 = { double: "double" };
const BottomLeftTopRightStyle93 = { medium: "medium" };
const BottomLeftTopRightStyle94 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle95 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle97 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle98 = { thick: "thick" };
const MiddleLeftTopRightStyle85 = { none: "none" };
const MiddleLeftTopRightStyle86 = { thin: "thin" };
const MiddleLeftTopRightStyle87 = { hair: "hair" };
const MiddleLeftTopRightStyle88 = { dotted: "dotted" };
const MiddleLeftTopRightStyle89 = { dashed: "dashed" };
const MiddleLeftTopRightStyle90 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle91 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle92 = { double: "double" };
const MiddleLeftTopRightStyle93 = { medium: "medium" };
const MiddleLeftTopRightStyle94 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle95 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle97 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle98 = { thick: "thick" };
const BottomCenterTopRightStyle85 = { none: "none" };
const BottomCenterTopRightStyle86 = { thin: "thin" };
const BottomCenterTopRightStyle87 = { hair: "hair" };
const BottomCenterTopRightStyle88 = { dotted: "dotted" };
const BottomCenterTopRightStyle89 = { dashed: "dashed" };
const BottomCenterTopRightStyle90 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle91 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle92 = { double: "double" };
const BottomCenterTopRightStyle93 = { medium: "medium" };
const BottomCenterTopRightStyle94 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle95 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle96 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle97 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle98 = { thick: "thick" };
const StyleHorizontalAlign43 = { unspecified: "unspecified" };
const StyleHorizontalAlign44 = { left: "left" };
const StyleHorizontalAlign45 = { center: "center" };
const StyleHorizontalAlign46 = { right: "right" };
const StyleHorizontalAlign47 = { justified: "justified" };
const StyleHorizontalAlign48 = { both: "both" };
const StyleHorizontalAlign49 = { distributed: "distributed" };
const StyleVerticalAlign25 = { unspecified: "unspecified" };
const StyleVerticalAlign26 = { top: "top" };
const StyleVerticalAlign27 = { middle: "middle" };
const StyleVerticalAlign28 = { bottom: "bottom" };
const StyleWrapStrategy25 = { unspecified: "unspecified" };
const StyleWrapStrategy26 = { overflow: "overflow" };
const StyleWrapStrategy27 = { clip: "clip" };
const StyleWrapStrategy28 = { wrap: "wrap" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/GetMfhRentIndexLookup.ts
const GetMfhRentIndexLookup200Status = {
	resolved: "resolved",
	unavailable: "unavailable",
	unsupported: "unsupported"
};
const GetMfhRentIndexLookup200PriceModel = {
	"official-range": "official-range",
	"additive-optimistic-maximum": "additive-optimistic-maximum"
};
const LocationMethod = { address: "address" };
const LocationMethod2 = { coordinates: "coordinates" };
const LocationMethod3 = { manual: "manual" };
const MissingInputsCode = {
	ADDRESS: "ADDRESS",
	AMBIGUOUS_LOCATION: "AMBIGUOUS_LOCATION",
	AREA_QUALITY: "AREA_QUALITY",
	CONSTRUCTION_YEAR: "CONSTRUCTION_YEAR",
	COORDINATES: "COORDINATES",
	EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
	OFFICIAL_CELL: "OFFICIAL_CELL"
};
const GetMfhRentIndexLookupQueryResponseStatus = {
	resolved: "resolved",
	unavailable: "unavailable",
	unsupported: "unsupported"
};
const GetMfhRentIndexLookupQueryResponsePriceModel = {
	"official-range": "official-range",
	"additive-optimistic-maximum": "additive-optimistic-maximum"
};
const LocationMethod4 = { address: "address" };
const LocationMethod5 = { coordinates: "coordinates" };
const LocationMethod6 = { manual: "manual" };
const MissingInputsCode2 = {
	ADDRESS: "ADDRESS",
	AMBIGUOUS_LOCATION: "AMBIGUOUS_LOCATION",
	AREA_QUALITY: "AREA_QUALITY",
	CONSTRUCTION_YEAR: "CONSTRUCTION_YEAR",
	COORDINATES: "COORDINATES",
	EXTERNAL_SERVICE: "EXTERNAL_SERVICE",
	OFFICIAL_CELL: "OFFICIAL_CELL"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ImportMfhInvestmentCaseFromJson.ts
const InvestmentCaseStatus9 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType9 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus10 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType10 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ListAppliedMfhInvestmentCaseOverrides.ts
const OverridesKind = { edit: "edit" };
const OverridesKind2 = { delete: "delete" };
const OverridesKind3 = { edit: "edit" };
const OverridesKind4 = { delete: "delete" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ListMfhInvestmentCaseOverrideGroups.ts
const CellsKind = { edit: "edit" };
const CellsKind2 = { delete: "delete" };
const CellsKind3 = { clear: "clear" };
const TopStyle = { none: "none" };
const TopStyle2 = { thin: "thin" };
const TopStyle3 = { hair: "hair" };
const TopStyle4 = { dotted: "dotted" };
const TopStyle5 = { dashed: "dashed" };
const TopStyle6 = { dash_dot: "dash_dot" };
const TopStyle7 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle8 = { double: "double" };
const TopStyle9 = { medium: "medium" };
const TopStyle10 = { medium_dashed: "medium_dashed" };
const TopStyle11 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle13 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle14 = { thick: "thick" };
const RightStyle = { none: "none" };
const RightStyle2 = { thin: "thin" };
const RightStyle3 = { hair: "hair" };
const RightStyle4 = { dotted: "dotted" };
const RightStyle5 = { dashed: "dashed" };
const RightStyle6 = { dash_dot: "dash_dot" };
const RightStyle7 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle8 = { double: "double" };
const RightStyle9 = { medium: "medium" };
const RightStyle10 = { medium_dashed: "medium_dashed" };
const RightStyle11 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle13 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle14 = { thick: "thick" };
const BottomStyle = { none: "none" };
const BottomStyle2 = { thin: "thin" };
const BottomStyle3 = { hair: "hair" };
const BottomStyle4 = { dotted: "dotted" };
const BottomStyle5 = { dashed: "dashed" };
const BottomStyle6 = { dash_dot: "dash_dot" };
const BottomStyle7 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle8 = { double: "double" };
const BottomStyle9 = { medium: "medium" };
const BottomStyle10 = { medium_dashed: "medium_dashed" };
const BottomStyle11 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle13 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle14 = { thick: "thick" };
const LeftStyle = { none: "none" };
const LeftStyle2 = { thin: "thin" };
const LeftStyle3 = { hair: "hair" };
const LeftStyle4 = { dotted: "dotted" };
const LeftStyle5 = { dashed: "dashed" };
const LeftStyle6 = { dash_dot: "dash_dot" };
const LeftStyle7 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle8 = { double: "double" };
const LeftStyle9 = { medium: "medium" };
const LeftStyle10 = { medium_dashed: "medium_dashed" };
const LeftStyle11 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle13 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle14 = { thick: "thick" };
const TopLeftBottomRightStyle = { none: "none" };
const TopLeftBottomRightStyle2 = { thin: "thin" };
const TopLeftBottomRightStyle3 = { hair: "hair" };
const TopLeftBottomRightStyle4 = { dotted: "dotted" };
const TopLeftBottomRightStyle5 = { dashed: "dashed" };
const TopLeftBottomRightStyle6 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle7 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle8 = { double: "double" };
const TopLeftBottomRightStyle9 = { medium: "medium" };
const TopLeftBottomRightStyle10 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle11 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle13 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle14 = { thick: "thick" };
const TopLeftBottomCenterStyle = { none: "none" };
const TopLeftBottomCenterStyle2 = { thin: "thin" };
const TopLeftBottomCenterStyle3 = { hair: "hair" };
const TopLeftBottomCenterStyle4 = { dotted: "dotted" };
const TopLeftBottomCenterStyle5 = { dashed: "dashed" };
const TopLeftBottomCenterStyle6 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle7 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle8 = { double: "double" };
const TopLeftBottomCenterStyle9 = { medium: "medium" };
const TopLeftBottomCenterStyle10 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle11 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle13 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle14 = { thick: "thick" };
const TopLeftMiddleRightStyle = { none: "none" };
const TopLeftMiddleRightStyle2 = { thin: "thin" };
const TopLeftMiddleRightStyle3 = { hair: "hair" };
const TopLeftMiddleRightStyle4 = { dotted: "dotted" };
const TopLeftMiddleRightStyle5 = { dashed: "dashed" };
const TopLeftMiddleRightStyle6 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle7 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle8 = { double: "double" };
const TopLeftMiddleRightStyle9 = { medium: "medium" };
const TopLeftMiddleRightStyle10 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle11 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle13 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle14 = { thick: "thick" };
const BottomLeftTopRightStyle = { none: "none" };
const BottomLeftTopRightStyle2 = { thin: "thin" };
const BottomLeftTopRightStyle3 = { hair: "hair" };
const BottomLeftTopRightStyle4 = { dotted: "dotted" };
const BottomLeftTopRightStyle5 = { dashed: "dashed" };
const BottomLeftTopRightStyle6 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle7 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle8 = { double: "double" };
const BottomLeftTopRightStyle9 = { medium: "medium" };
const BottomLeftTopRightStyle10 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle11 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle13 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle14 = { thick: "thick" };
const MiddleLeftTopRightStyle = { none: "none" };
const MiddleLeftTopRightStyle2 = { thin: "thin" };
const MiddleLeftTopRightStyle3 = { hair: "hair" };
const MiddleLeftTopRightStyle4 = { dotted: "dotted" };
const MiddleLeftTopRightStyle5 = { dashed: "dashed" };
const MiddleLeftTopRightStyle6 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle7 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle8 = { double: "double" };
const MiddleLeftTopRightStyle9 = { medium: "medium" };
const MiddleLeftTopRightStyle10 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle11 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle13 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle14 = { thick: "thick" };
const BottomCenterTopRightStyle = { none: "none" };
const BottomCenterTopRightStyle2 = { thin: "thin" };
const BottomCenterTopRightStyle3 = { hair: "hair" };
const BottomCenterTopRightStyle4 = { dotted: "dotted" };
const BottomCenterTopRightStyle5 = { dashed: "dashed" };
const BottomCenterTopRightStyle6 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle7 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle8 = { double: "double" };
const BottomCenterTopRightStyle9 = { medium: "medium" };
const BottomCenterTopRightStyle10 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle11 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle12 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle13 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle14 = { thick: "thick" };
const StyleHorizontalAlign = { unspecified: "unspecified" };
const StyleHorizontalAlign2 = { left: "left" };
const StyleHorizontalAlign3 = { center: "center" };
const StyleHorizontalAlign4 = { right: "right" };
const StyleHorizontalAlign5 = { justified: "justified" };
const StyleHorizontalAlign6 = { both: "both" };
const StyleHorizontalAlign7 = { distributed: "distributed" };
const StyleVerticalAlign = { unspecified: "unspecified" };
const StyleVerticalAlign2 = { top: "top" };
const StyleVerticalAlign3 = { middle: "middle" };
const StyleVerticalAlign4 = { bottom: "bottom" };
const StyleWrapStrategy = { unspecified: "unspecified" };
const StyleWrapStrategy2 = { overflow: "overflow" };
const StyleWrapStrategy3 = { clip: "clip" };
const StyleWrapStrategy4 = { wrap: "wrap" };
const CellsKind4 = { edit: "edit" };
const CellsKind5 = { delete: "delete" };
const CellsKind6 = { clear: "clear" };
const TopStyle15 = { none: "none" };
const TopStyle16 = { thin: "thin" };
const TopStyle17 = { hair: "hair" };
const TopStyle18 = { dotted: "dotted" };
const TopStyle19 = { dashed: "dashed" };
const TopStyle20 = { dash_dot: "dash_dot" };
const TopStyle21 = { dash_dot_dot: "dash_dot_dot" };
const TopStyle22 = { double: "double" };
const TopStyle23 = { medium: "medium" };
const TopStyle24 = { medium_dashed: "medium_dashed" };
const TopStyle25 = { medium_dash_dot: "medium_dash_dot" };
const TopStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopStyle27 = { slant_dash_dot: "slant_dash_dot" };
const TopStyle28 = { thick: "thick" };
const RightStyle15 = { none: "none" };
const RightStyle16 = { thin: "thin" };
const RightStyle17 = { hair: "hair" };
const RightStyle18 = { dotted: "dotted" };
const RightStyle19 = { dashed: "dashed" };
const RightStyle20 = { dash_dot: "dash_dot" };
const RightStyle21 = { dash_dot_dot: "dash_dot_dot" };
const RightStyle22 = { double: "double" };
const RightStyle23 = { medium: "medium" };
const RightStyle24 = { medium_dashed: "medium_dashed" };
const RightStyle25 = { medium_dash_dot: "medium_dash_dot" };
const RightStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const RightStyle27 = { slant_dash_dot: "slant_dash_dot" };
const RightStyle28 = { thick: "thick" };
const BottomStyle15 = { none: "none" };
const BottomStyle16 = { thin: "thin" };
const BottomStyle17 = { hair: "hair" };
const BottomStyle18 = { dotted: "dotted" };
const BottomStyle19 = { dashed: "dashed" };
const BottomStyle20 = { dash_dot: "dash_dot" };
const BottomStyle21 = { dash_dot_dot: "dash_dot_dot" };
const BottomStyle22 = { double: "double" };
const BottomStyle23 = { medium: "medium" };
const BottomStyle24 = { medium_dashed: "medium_dashed" };
const BottomStyle25 = { medium_dash_dot: "medium_dash_dot" };
const BottomStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomStyle27 = { slant_dash_dot: "slant_dash_dot" };
const BottomStyle28 = { thick: "thick" };
const LeftStyle15 = { none: "none" };
const LeftStyle16 = { thin: "thin" };
const LeftStyle17 = { hair: "hair" };
const LeftStyle18 = { dotted: "dotted" };
const LeftStyle19 = { dashed: "dashed" };
const LeftStyle20 = { dash_dot: "dash_dot" };
const LeftStyle21 = { dash_dot_dot: "dash_dot_dot" };
const LeftStyle22 = { double: "double" };
const LeftStyle23 = { medium: "medium" };
const LeftStyle24 = { medium_dashed: "medium_dashed" };
const LeftStyle25 = { medium_dash_dot: "medium_dash_dot" };
const LeftStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const LeftStyle27 = { slant_dash_dot: "slant_dash_dot" };
const LeftStyle28 = { thick: "thick" };
const TopLeftBottomRightStyle15 = { none: "none" };
const TopLeftBottomRightStyle16 = { thin: "thin" };
const TopLeftBottomRightStyle17 = { hair: "hair" };
const TopLeftBottomRightStyle18 = { dotted: "dotted" };
const TopLeftBottomRightStyle19 = { dashed: "dashed" };
const TopLeftBottomRightStyle20 = { dash_dot: "dash_dot" };
const TopLeftBottomRightStyle21 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomRightStyle22 = { double: "double" };
const TopLeftBottomRightStyle23 = { medium: "medium" };
const TopLeftBottomRightStyle24 = { medium_dashed: "medium_dashed" };
const TopLeftBottomRightStyle25 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomRightStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomRightStyle27 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomRightStyle28 = { thick: "thick" };
const TopLeftBottomCenterStyle15 = { none: "none" };
const TopLeftBottomCenterStyle16 = { thin: "thin" };
const TopLeftBottomCenterStyle17 = { hair: "hair" };
const TopLeftBottomCenterStyle18 = { dotted: "dotted" };
const TopLeftBottomCenterStyle19 = { dashed: "dashed" };
const TopLeftBottomCenterStyle20 = { dash_dot: "dash_dot" };
const TopLeftBottomCenterStyle21 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftBottomCenterStyle22 = { double: "double" };
const TopLeftBottomCenterStyle23 = { medium: "medium" };
const TopLeftBottomCenterStyle24 = { medium_dashed: "medium_dashed" };
const TopLeftBottomCenterStyle25 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftBottomCenterStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftBottomCenterStyle27 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftBottomCenterStyle28 = { thick: "thick" };
const TopLeftMiddleRightStyle15 = { none: "none" };
const TopLeftMiddleRightStyle16 = { thin: "thin" };
const TopLeftMiddleRightStyle17 = { hair: "hair" };
const TopLeftMiddleRightStyle18 = { dotted: "dotted" };
const TopLeftMiddleRightStyle19 = { dashed: "dashed" };
const TopLeftMiddleRightStyle20 = { dash_dot: "dash_dot" };
const TopLeftMiddleRightStyle21 = { dash_dot_dot: "dash_dot_dot" };
const TopLeftMiddleRightStyle22 = { double: "double" };
const TopLeftMiddleRightStyle23 = { medium: "medium" };
const TopLeftMiddleRightStyle24 = { medium_dashed: "medium_dashed" };
const TopLeftMiddleRightStyle25 = { medium_dash_dot: "medium_dash_dot" };
const TopLeftMiddleRightStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const TopLeftMiddleRightStyle27 = { slant_dash_dot: "slant_dash_dot" };
const TopLeftMiddleRightStyle28 = { thick: "thick" };
const BottomLeftTopRightStyle15 = { none: "none" };
const BottomLeftTopRightStyle16 = { thin: "thin" };
const BottomLeftTopRightStyle17 = { hair: "hair" };
const BottomLeftTopRightStyle18 = { dotted: "dotted" };
const BottomLeftTopRightStyle19 = { dashed: "dashed" };
const BottomLeftTopRightStyle20 = { dash_dot: "dash_dot" };
const BottomLeftTopRightStyle21 = { dash_dot_dot: "dash_dot_dot" };
const BottomLeftTopRightStyle22 = { double: "double" };
const BottomLeftTopRightStyle23 = { medium: "medium" };
const BottomLeftTopRightStyle24 = { medium_dashed: "medium_dashed" };
const BottomLeftTopRightStyle25 = { medium_dash_dot: "medium_dash_dot" };
const BottomLeftTopRightStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomLeftTopRightStyle27 = { slant_dash_dot: "slant_dash_dot" };
const BottomLeftTopRightStyle28 = { thick: "thick" };
const MiddleLeftTopRightStyle15 = { none: "none" };
const MiddleLeftTopRightStyle16 = { thin: "thin" };
const MiddleLeftTopRightStyle17 = { hair: "hair" };
const MiddleLeftTopRightStyle18 = { dotted: "dotted" };
const MiddleLeftTopRightStyle19 = { dashed: "dashed" };
const MiddleLeftTopRightStyle20 = { dash_dot: "dash_dot" };
const MiddleLeftTopRightStyle21 = { dash_dot_dot: "dash_dot_dot" };
const MiddleLeftTopRightStyle22 = { double: "double" };
const MiddleLeftTopRightStyle23 = { medium: "medium" };
const MiddleLeftTopRightStyle24 = { medium_dashed: "medium_dashed" };
const MiddleLeftTopRightStyle25 = { medium_dash_dot: "medium_dash_dot" };
const MiddleLeftTopRightStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const MiddleLeftTopRightStyle27 = { slant_dash_dot: "slant_dash_dot" };
const MiddleLeftTopRightStyle28 = { thick: "thick" };
const BottomCenterTopRightStyle15 = { none: "none" };
const BottomCenterTopRightStyle16 = { thin: "thin" };
const BottomCenterTopRightStyle17 = { hair: "hair" };
const BottomCenterTopRightStyle18 = { dotted: "dotted" };
const BottomCenterTopRightStyle19 = { dashed: "dashed" };
const BottomCenterTopRightStyle20 = { dash_dot: "dash_dot" };
const BottomCenterTopRightStyle21 = { dash_dot_dot: "dash_dot_dot" };
const BottomCenterTopRightStyle22 = { double: "double" };
const BottomCenterTopRightStyle23 = { medium: "medium" };
const BottomCenterTopRightStyle24 = { medium_dashed: "medium_dashed" };
const BottomCenterTopRightStyle25 = { medium_dash_dot: "medium_dash_dot" };
const BottomCenterTopRightStyle26 = { medium_dash_dot_dot: "medium_dash_dot_dot" };
const BottomCenterTopRightStyle27 = { slant_dash_dot: "slant_dash_dot" };
const BottomCenterTopRightStyle28 = { thick: "thick" };
const StyleHorizontalAlign8 = { unspecified: "unspecified" };
const StyleHorizontalAlign9 = { left: "left" };
const StyleHorizontalAlign10 = { center: "center" };
const StyleHorizontalAlign11 = { right: "right" };
const StyleHorizontalAlign12 = { justified: "justified" };
const StyleHorizontalAlign13 = { both: "both" };
const StyleHorizontalAlign14 = { distributed: "distributed" };
const StyleVerticalAlign5 = { unspecified: "unspecified" };
const StyleVerticalAlign6 = { top: "top" };
const StyleVerticalAlign7 = { middle: "middle" };
const StyleVerticalAlign8 = { bottom: "bottom" };
const StyleWrapStrategy5 = { unspecified: "unspecified" };
const StyleWrapStrategy6 = { overflow: "overflow" };
const StyleWrapStrategy7 = { clip: "clip" };
const StyleWrapStrategy8 = { wrap: "wrap" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ListMfhInvestmentCaseVersions.ts
const VersionsTriggerType = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const VersionsVersionStatus = {
	inputs_added: "inputs_added",
	calculated: "calculated"
};
const VersionsTriggerType2 = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const VersionsVersionStatus2 = {
	inputs_added: "inputs_added",
	calculated: "calculated"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/PrepareMfhInvestmentCase.ts
const PrepareMfhInvestmentCase200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction17 = { update_mfh: "update_mfh" };
const DecisionAction18 = { create_mfh: "create_mfh" };
const DecisionAction19 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction20 = { create_mfh_estate: "create_mfh_estate" };
const PrepareMfhInvestmentCaseMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction21 = { update_mfh: "update_mfh" };
const DecisionAction22 = { create_mfh: "create_mfh" };
const DecisionAction23 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction24 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/RecalculateMfhInvestmentCase.ts
const InvestmentCaseStatus21 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType21 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const RecalculateMfhInvestmentCaseMutationRequestVersionTriggerType = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const InvestmentCaseStatus22 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType22 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/RecalculateSheetlessMfhInvestmentCase.ts
const InvestmentCaseStatus23 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType23 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const RecalculateSheetlessMfhInvestmentCaseMutationRequestVersionTriggerType = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const RecalculateSheetlessMfhInvestmentCaseMutationRequestInputOrigin = {
	ASSET: "ASSET",
	GLOBAL_DEFAULT: "GLOBAL_DEFAULT",
	PARTNER_PROFILE: "PARTNER_PROFILE",
	RENOVATION_STRATEGY_SCENARIO: "RENOVATION_STRATEGY_SCENARIO",
	CALCULATED_RENOVATION_SCENARIO: "CALCULATED_RENOVATION_SCENARIO",
	PREDICTED: "PREDICTED",
	ANALYZER_DEFAULT: "ANALYZER_DEFAULT",
	PREOPTIMIZATION: "PREOPTIMIZATION",
	OPTIMIZATION: "OPTIMIZATION",
	SENSITIVITY: "SENSITIVITY",
	MANUAL_EDIT: "MANUAL_EDIT"
};
const InvestmentCaseStatus24 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType24 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/RevertMfhInvestmentCaseVersion.ts
const InvestmentCaseStatus19 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType19 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const VersionTriggerType = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const VersionVersionStatus = {
	inputs_added: "inputs_added",
	calculated: "calculated"
};
const InvestmentCaseStatus20 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType20 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const VersionTriggerType2 = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const VersionVersionStatus2 = {
	inputs_added: "inputs_added",
	calculated: "calculated"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/RunMfhInvestmentCaseSensitivity.ts
const RunMfhInvestmentCaseSensitivity200Version = { "v5.0.0": "v5.0.0" };
const RunMfhInvestmentCaseSensitivity200Version2 = { "v5.1.1": "v5.1.1" };
const RunMfhInvestmentCaseSensitivity200Version3 = { "v5.1.2": "v5.1.2" };
const RunMfhInvestmentCaseSensitivity200Version4 = { "v5.1.3": "v5.1.3" };
const RunMfhInvestmentCaseSensitivity200Version5 = { "v5.3.1": "v5.3.1" };
const RunMfhInvestmentCaseSensitivity200Version6 = { "v5.3.2": "v5.3.2" };
const RunMfhInvestmentCaseSensitivity200Version7 = { "v5.4.0": "v5.4.0" };
const RunMfhInvestmentCaseSensitivity200Version8 = { "v5.4.1": "v5.4.1" };
const RunMfhInvestmentCaseSensitivity200Version9 = { "v5.5.0": "v5.5.0" };
const RunMfhInvestmentCaseSensitivity200Version10 = { "v5.6.0": "v5.6.0" };
const RunMfhInvestmentCaseSensitivity200Version11 = { "v5.6.1": "v5.6.1" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion = { "v5.0.0": "v5.0.0" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion2 = { "v5.1.1": "v5.1.1" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion3 = { "v5.1.2": "v5.1.2" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion4 = { "v5.1.3": "v5.1.3" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion5 = { "v5.3.1": "v5.3.1" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion6 = { "v5.3.2": "v5.3.2" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion7 = { "v5.4.0": "v5.4.0" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion8 = { "v5.4.1": "v5.4.1" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion9 = { "v5.5.0": "v5.5.0" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion10 = { "v5.6.0": "v5.6.0" };
const RunMfhInvestmentCaseSensitivityMutationResponseVersion11 = { "v5.6.1": "v5.6.1" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ScreenMfhInvestmentCasePartnerRenovationCell.ts
const ScreenMfhInvestmentCasePartnerRenovationCell200BuyBoxStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const FailingCriteriaDirection7 = { min: "min" };
const FailingCriteriaDirection8 = { max: "max" };
const FailingCriteriaDirection9 = { includes: "includes" };
const PreoptimizationLogKind = { default: "default" };
const PreoptimizationLogKind2 = { conditional: "conditional" };
const PreoptimizationLogOutcome = { applied: "applied" };
const PreoptimizationLogOutcome2 = { unchanged: "unchanged" };
const PreoptimizationLogOutcome3 = { skipped: "skipped" };
const ScreenMfhInvestmentCasePartnerRenovationCellMutationResponseBuyBoxStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const FailingCriteriaDirection10 = { min: "min" };
const FailingCriteriaDirection11 = { max: "max" };
const FailingCriteriaDirection12 = { includes: "includes" };
const PreoptimizationLogKind3 = { default: "default" };
const PreoptimizationLogKind4 = { conditional: "conditional" };
const PreoptimizationLogOutcome4 = { applied: "applied" };
const PreoptimizationLogOutcome5 = { unchanged: "unchanged" };
const PreoptimizationLogOutcome6 = { skipped: "skipped" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/ScreenMfhInvestmentCasePartnerRenovationMatrix.ts
const CellsBuyBoxStatus = {
	Pass: "Pass",
	Fail: "Fail"
};
const FailingCriteriaDirection13 = { min: "min" };
const FailingCriteriaDirection14 = { max: "max" };
const FailingCriteriaDirection15 = { includes: "includes" };
const PreoptimizationLogKind5 = { default: "default" };
const PreoptimizationLogKind6 = { conditional: "conditional" };
const PreoptimizationLogOutcome7 = { applied: "applied" };
const PreoptimizationLogOutcome8 = { unchanged: "unchanged" };
const PreoptimizationLogOutcome9 = { skipped: "skipped" };
const ScreenMfhInvestmentCasePartnerRenovationMatrixMutationRequestMarketRentSource = { "sprengnetter-current": "sprengnetter-current" };
const ScreenMfhInvestmentCasePartnerRenovationMatrixMutationRequestMarketRentSource2 = { "sprengnetter-historical-average": "sprengnetter-historical-average" };
const ScreenMfhInvestmentCasePartnerRenovationMatrixMutationRequestMarketRentSource3 = { "geomap-current": "geomap-current" };
const CellsBuyBoxStatus2 = {
	Pass: "Pass",
	Fail: "Fail"
};
const FailingCriteriaDirection16 = { min: "min" };
const FailingCriteriaDirection17 = { max: "max" };
const FailingCriteriaDirection18 = { includes: "includes" };
const PreoptimizationLogKind7 = { default: "default" };
const PreoptimizationLogKind8 = { conditional: "conditional" };
const PreoptimizationLogOutcome10 = { applied: "applied" };
const PreoptimizationLogOutcome11 = { unchanged: "unchanged" };
const PreoptimizationLogOutcome12 = { skipped: "skipped" };
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/SetAutomaticMfhInvestmentCaseInputs.ts
const InvestmentCaseStatus31 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType31 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus32 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType32 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/SyncMfhInvestmentCase.ts
const InvestmentCaseStatus25 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType25 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus26 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType26 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/SyncSheetlessMfhInvestmentCase.ts
const InvestmentCaseStatus27 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType27 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus28 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType28 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/TriggerMfhInvestmentCaseReadCopySync.ts
const TriggerMfhInvestmentCaseReadCopySync200ReadCopySyncStatus = {
	SYNCING: "SYNCING",
	SYNCED: "SYNCED",
	FAILED: "FAILED"
};
const TriggerMfhInvestmentCaseReadCopySyncMutationResponseReadCopySyncStatus = {
	SYNCING: "SYNCING",
	SYNCED: "SYNCED",
	FAILED: "FAILED"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/UpdateMfhInvestmentCase.ts
const InvestmentCaseStatus5 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType5 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
const InvestmentCaseStatus6 = {
	Creating: "Creating",
	Created: "Created",
	Error: "Error",
	Review: "Review",
	Approved: "Approved",
	Reverted: "Reverted",
	Rejected: "Rejected"
};
const InvestmentCaseInvestmentCaseType6 = {
	Acquisition: "Acquisition",
	AssetManagement: "AssetManagement"
};
//#endregion
//#region src/basecamp/gen/models/mfhInvestmentCaseModels/UpdateMfhInvestmentCaseVersionTitle.ts
const VersionTriggerType3 = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const VersionVersionStatus3 = {
	inputs_added: "inputs_added",
	calculated: "calculated"
};
const VersionTriggerType4 = {
	initial: "initial",
	manual_save: "manual_save",
	manual_recalculate: "manual_recalculate",
	manual_sync: "manual_sync",
	automatic_create: "automatic_create",
	automatic_input_save: "automatic_input_save",
	copy: "copy",
	copy_partner_default: "copy_partner_default",
	copy_partner_preserve_values: "copy_partner_preserve_values",
	change_and_recreate: "change_and_recreate",
	output_sync: "output_sync",
	revert: "revert",
	overrides_committed: "overrides_committed",
	overrides_reverted: "overrides_reverted"
};
const VersionVersionStatus4 = {
	inputs_added: "inputs_added",
	calculated: "calculated"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/CreateAutomaticPortfolioWithAsset.ts
const AttributesMandateType3 = {
	Investment: "Investment",
	Management: "Management"
};
const AttributesBuildingEnergyRating3 = {
	NO_INFORMATION: "NO_INFORMATION",
	ENERGY_REQUIRED: "ENERGY_REQUIRED",
	ENERGY_CONSUMPTION: "ENERGY_CONSUMPTION"
};
const AttributesPrimaryHeatingType = {
	Coal: "Coal",
	PelletHeating: "PelletHeating",
	NaturalGasHeavy: "NaturalGasHeavy",
	SteamDistrictHeating: "SteamDistrictHeating",
	BioEnergy: "BioEnergy",
	DistrictHeating: "DistrictHeating",
	Electricity: "Electricity",
	CombinedHeatAndPowerFossilFuels: "CombinedHeatAndPowerFossilFuels",
	HydroEnergy: "HydroEnergy",
	Gas: "Gas",
	CombinedHeatAndPowerRenewableEnergy: "CombinedHeatAndPowerRenewableEnergy",
	NaturalGasLight: "NaturalGasLight",
	WindEnergy: "WindEnergy",
	CombinedHeatAndPowerRegenerativeEnergy: "CombinedHeatAndPowerRegenerativeEnergy",
	LiquidGas: "LiquidGas",
	EnvironmentalThermalEnergy: "EnvironmentalThermalEnergy",
	HeatSupply: "HeatSupply",
	Geothermal: "Geothermal",
	LocalHeating: "LocalHeating",
	Wood: "Wood",
	CombinedHeatAndPowerBioEnergy: "CombinedHeatAndPowerBioEnergy",
	SolarHeating: "SolarHeating",
	Oil: "Oil",
	WoodChips: "WoodChips",
	NoInformation: "NoInformation"
};
const AutomaticRentRollImportStatus = { ready: "ready" };
const RowsRentingState = {
	RentedUnlimited: "RentedUnlimited",
	RentedLimited: "RentedLimited",
	NotRented: "NotRented",
	NotRentable: "NotRentable"
};
const RowsApartmentType = {
	Apartment: "Apartment",
	HalfBasement: "HalfBasement",
	NoInformation: "NoInformation",
	GroundFloor: "GroundFloor",
	Maisonette: "Maisonette",
	Penthouse: "Penthouse",
	TerracedFlat: "TerracedFlat",
	RoofStorey: "RoofStorey",
	RaisedGroundFloor: "RaisedGroundFloor",
	Loft: "Loft",
	Farm: "Farm",
	TwoFamilyHouse: "TwoFamilyHouse",
	ApartmentBuilding: "ApartmentBuilding",
	OtherHouse: "OtherHouse",
	TerracedHouse: "TerracedHouse",
	Commercial: "Commercial",
	Residential: "Residential",
	Office: "Office",
	Gastronomy: "Gastronomy",
	Parking: "Parking",
	Other: "Other",
	CommercialOther: "CommercialOther",
	Shop: "Shop",
	Cellar: "Cellar",
	UndergroundParking: "UndergroundParking",
	OutdoorParking: "OutdoorParking",
	Garage: "Garage"
};
const RowsRentIncreaseType = {
	NO_INCREASE: "NO_INCREASE",
	MANUAL: "MANUAL",
	IRI: "IRI",
	FRI: "FRI"
};
const AutomaticRentRollImportStatus2 = { failed: "failed" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/CreateIcTeaser.ts
const CreateIcTeaser200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction49 = { update_mfh: "update_mfh" };
const DecisionAction50 = { create_mfh: "create_mfh" };
const DecisionAction51 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction52 = { create_mfh_estate: "create_mfh_estate" };
const CreateIcTeaserMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction53 = { update_mfh: "update_mfh" };
const DecisionAction54 = { create_mfh: "create_mfh" };
const DecisionAction55 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction56 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/CreateMfh.ts
const MfhChannelName = {
	OTHER_ONLINE_PORTAL: "OTHER_ONLINE_PORTAL",
	BROKER_OPEN_MANDATE: "BROKER_OPEN_MANDATE",
	BROKER_EXCLUSIVE_ACCESS: "BROKER_EXCLUSIVE_ACCESS",
	DIRECT_OWNER_APPROACH: "DIRECT_OWNER_APPROACH",
	NETWORK_REFERRAL: "NETWORK_REFERRAL",
	M_AND_A_PROCESS: "M_AND_A_PROCESS",
	INSOLVENCY_PROCESS: "INSOLVENCY_PROCESS",
	OTHER: "OTHER"
};
const AttributesBuildingEnergyRating = {
	NO_INFORMATION: "NO_INFORMATION",
	ENERGY_REQUIRED: "ENERGY_REQUIRED",
	ENERGY_CONSUMPTION: "ENERGY_CONSUMPTION"
};
const AttributesAdjoiningBuilding = {
	OneSide: "OneSide",
	TwoSide: "TwoSide",
	Absent: "Absent"
};
const AttributesWaterHeating = {
	Boiler: "Boiler",
	ViaHeating: "ViaHeating"
};
const AttributesRoofShape = {
	Hipped: "Hipped",
	Saddle: "Saddle",
	Pitched: "Pitched",
	Flat: "Flat",
	Mansard: "Mansard"
};
const AttributesRoofOrientation = {
	N: "N",
	NE: "NE",
	E: "E",
	SE: "SE",
	S: "S",
	SW: "SW",
	W: "W",
	NW: "NW"
};
const AttributesRoofUse = {
	FacadeWorthPreserving: "FacadeWorthPreserving",
	SingleSkinMasonry: "SingleSkinMasonry",
	DoubleSkinMasonry: "DoubleSkinMasonry"
};
const AttributesWindowGlazing = {
	One: "One",
	Two: "Two",
	Three: "Three",
	BoxWindows: "BoxWindows"
};
const AttributesCellarHeating = {
	Heated: "Heated",
	PartiallyHeated: "PartiallyHeated",
	NotHeated: "NotHeated"
};
const AttributesExitType = {
	MFH: "MFH",
	SingleUnit: "SingleUnit",
	MFHSingleUnit: "MFHSingleUnit"
};
const AttributesSplitStatus = {
	ToBeSplit: "ToBeSplit",
	AlreadySplit: "AlreadySplit",
	PleaseFillOut: "PleaseFillOut",
	NoInputNeeded: "NoInputNeeded"
};
const AttributesRiwisLocation = {
	Simple: "Simple",
	SimpleToAverage: "SimpleToAverage",
	Average: "Average",
	AverageToGood: "AverageToGood",
	Good: "Good",
	GoodToVeryGood: "GoodToVeryGood",
	VeryGood: "VeryGood",
	NoInputNeeded: "NoInputNeeded",
	PleaseFillOut: "PleaseFillOut"
};
const AttributesRestrictions = {
	UrbanisticQuirk: "UrbanisticQuirk",
	CompositionOfTheResidentPopulation: "CompositionOfTheResidentPopulation",
	RedevelopmentArea: "RedevelopmentArea",
	HeritageBuilding: "HeritageBuilding",
	GroundLease: "GroundLease",
	RentControlOrRentSubsidy: "RentControlOrRentSubsidy",
	ZoningPlan: "ZoningPlan",
	Other: "Other",
	None: "None"
};
const AttributesMandateType = {
	Investment: "Investment",
	Management: "Management"
};
const LinkableContactsRelationName = {
	Seller: "Seller",
	Realtor: "Realtor",
	Notary: "Notary",
	Bank: "Bank",
	DistrictCourt: "DistrictCourt",
	ConstructionAuthority: "ConstructionAuthority",
	ExecutionNotary: "ExecutionNotary",
	DocumentingNotary: "DocumentingNotary",
	MeasurementProvider: "MeasurementProvider",
	GeneralContractor: "GeneralContractor",
	KitchenSupplier: "KitchenSupplier",
	DistributionPartner: "DistributionPartner",
	SellingNotary: "SellingNotary",
	Buyer: "Buyer",
	SellingExecutionNotary: "SellingExecutionNotary",
	SellingDocumentingNotary: "SellingDocumentingNotary",
	ServiceProvider: "ServiceProvider",
	FacilityManagement: "FacilityManagement",
	GasProvider: "GasProvider",
	ElectricityProvider: "ElectricityProvider",
	WaterProvider: "WaterProvider",
	GeneralPropertyManagement: "GeneralPropertyManagement",
	Tenant: "Tenant",
	SalesRepresentative: "SalesRepresentative",
	FinancingAdvisor: "FinancingAdvisor",
	Craftsman: "Craftsman",
	Neighbor: "Neighbor",
	EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant",
	TechnicalDDExpert: "TechnicalDDExpert",
	LegalDDExpert: "LegalDDExpert",
	RentingPartner: "RentingPartner",
	TaxDDConsultant: "TaxDDConsultant",
	AssetPartner: "AssetPartner",
	CandidateAssetPartner: "CandidateAssetPartner",
	TechnicalProjectLead: "TechnicalProjectLead",
	PurchasingEntity: "PurchasingEntity",
	General: "General",
	ContractorGeneral: "ContractorGeneral",
	ContractorCleaning: "ContractorCleaning",
	ContractorElectricity: "ContractorElectricity",
	IndividualPropertyManager: "IndividualPropertyManager",
	MaterialSupplier: "MaterialSupplier",
	TaxOffice: "TaxOffice",
	AssetManagement: "AssetManagement",
	HrCompany: "HrCompany",
	OfficeSupplier: "OfficeSupplier",
	TravelProvider: "TravelProvider",
	RentalCarCompany: "RentalCarCompany",
	MarketingCompany: "MarketingCompany",
	HardwareProvider: "HardwareProvider",
	SoftwareCompany: "SoftwareCompany",
	RentingLead: "RentingLead",
	AuditingFirm: "AuditingFirm",
	Planning: "Planning",
	PlanningAndConstructions: "PlanningAndConstructions",
	Proptech: "Proptech"
};
const LinkableCompaniesRelationName = {
	Seller: "Seller",
	Realtor: "Realtor",
	Notary: "Notary",
	Bank: "Bank",
	DistrictCourt: "DistrictCourt",
	ConstructionAuthority: "ConstructionAuthority",
	ExecutionNotary: "ExecutionNotary",
	DocumentingNotary: "DocumentingNotary",
	MeasurementProvider: "MeasurementProvider",
	GeneralContractor: "GeneralContractor",
	KitchenSupplier: "KitchenSupplier",
	DistributionPartner: "DistributionPartner",
	SellingNotary: "SellingNotary",
	Buyer: "Buyer",
	SellingExecutionNotary: "SellingExecutionNotary",
	SellingDocumentingNotary: "SellingDocumentingNotary",
	ServiceProvider: "ServiceProvider",
	FacilityManagement: "FacilityManagement",
	GasProvider: "GasProvider",
	ElectricityProvider: "ElectricityProvider",
	WaterProvider: "WaterProvider",
	GeneralPropertyManagement: "GeneralPropertyManagement",
	Tenant: "Tenant",
	SalesRepresentative: "SalesRepresentative",
	FinancingAdvisor: "FinancingAdvisor",
	Craftsman: "Craftsman",
	Neighbor: "Neighbor",
	EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant",
	TechnicalDDExpert: "TechnicalDDExpert",
	LegalDDExpert: "LegalDDExpert",
	RentingPartner: "RentingPartner",
	TaxDDConsultant: "TaxDDConsultant",
	AssetPartner: "AssetPartner",
	CandidateAssetPartner: "CandidateAssetPartner",
	TechnicalProjectLead: "TechnicalProjectLead",
	PurchasingEntity: "PurchasingEntity",
	General: "General",
	ContractorGeneral: "ContractorGeneral",
	ContractorCleaning: "ContractorCleaning",
	ContractorElectricity: "ContractorElectricity",
	IndividualPropertyManager: "IndividualPropertyManager",
	MaterialSupplier: "MaterialSupplier",
	TaxOffice: "TaxOffice",
	AssetManagement: "AssetManagement",
	HrCompany: "HrCompany",
	OfficeSupplier: "OfficeSupplier",
	TravelProvider: "TravelProvider",
	RentalCarCompany: "RentalCarCompany",
	MarketingCompany: "MarketingCompany",
	HardwareProvider: "HardwareProvider",
	SoftwareCompany: "SoftwareCompany",
	RentingLead: "RentingLead",
	AuditingFirm: "AuditingFirm",
	Planning: "Planning",
	PlanningAndConstructions: "PlanningAndConstructions",
	Proptech: "Proptech"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/CreateMfhEstate.ts
const AttributesApartmentType = {
	Apartment: "Apartment",
	HalfBasement: "HalfBasement",
	NoInformation: "NoInformation",
	GroundFloor: "GroundFloor",
	Maisonette: "Maisonette",
	Penthouse: "Penthouse",
	TerracedFlat: "TerracedFlat",
	RoofStorey: "RoofStorey",
	RaisedGroundFloor: "RaisedGroundFloor",
	Loft: "Loft",
	Farm: "Farm",
	TwoFamilyHouse: "TwoFamilyHouse",
	ApartmentBuilding: "ApartmentBuilding",
	OtherHouse: "OtherHouse",
	TerracedHouse: "TerracedHouse",
	Commercial: "Commercial",
	Residential: "Residential",
	Office: "Office",
	Gastronomy: "Gastronomy",
	Parking: "Parking",
	Other: "Other",
	CommercialOther: "CommercialOther",
	Shop: "Shop",
	Cellar: "Cellar",
	UndergroundParking: "UndergroundParking",
	OutdoorParking: "OutdoorParking",
	Garage: "Garage"
};
const AttributesBuildingLocationType = {
	SF: "SF",
	SF_R: "SF_R",
	SF_L: "SF_L",
	HG: "HG",
	VH: "VH",
	HH: "HH",
	QG: "QG"
};
const CreateMfhEstateMutationRequestRentableUnitState = {
	Vacant: "Vacant",
	Occupied: "Occupied",
	OwnerOccupied: "OwnerOccupied",
	PartiallyOccupied: "PartiallyOccupied",
	BlockedByPm: "BlockedByPm",
	BlockedByRenovation: "BlockedByRenovation"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/CreateRentRollVersion.ts
const CreateRentRollVersion200Outcome = { validated: "validated" };
const CreateRentRollVersion200Outcome2 = { written: "written" };
const SourceType = { existing: "existing" };
const SourceType2 = { d2g: "d2g" };
const SourceType3 = { "import-sheet": "import-sheet" };
const SourceType4 = { inline: "inline" };
const RentRollsRentingState = { RentedUnlimited: "RentedUnlimited" };
const RentRollsRentingState2 = { RentedLimited: "RentedLimited" };
const RentRollsRentingState3 = { NotRented: "NotRented" };
const RentRollsRentingState4 = { NotRentable: "NotRentable" };
const RentRollsApartmentType = { Apartment: "Apartment" };
const RentRollsApartmentType2 = { HalfBasement: "HalfBasement" };
const RentRollsApartmentType3 = { NoInformation: "NoInformation" };
const RentRollsApartmentType4 = { GroundFloor: "GroundFloor" };
const RentRollsApartmentType5 = { Maisonette: "Maisonette" };
const RentRollsApartmentType6 = { Penthouse: "Penthouse" };
const RentRollsApartmentType7 = { TerracedFlat: "TerracedFlat" };
const RentRollsApartmentType8 = { RoofStorey: "RoofStorey" };
const RentRollsApartmentType9 = { RaisedGroundFloor: "RaisedGroundFloor" };
const RentRollsApartmentType10 = { Loft: "Loft" };
const RentRollsApartmentType11 = { Farm: "Farm" };
const RentRollsApartmentType12 = { TwoFamilyHouse: "TwoFamilyHouse" };
const RentRollsApartmentType13 = { ApartmentBuilding: "ApartmentBuilding" };
const RentRollsApartmentType14 = { OtherHouse: "OtherHouse" };
const RentRollsApartmentType15 = { TerracedHouse: "TerracedHouse" };
const RentRollsApartmentType16 = { Commercial: "Commercial" };
const RentRollsApartmentType17 = { Residential: "Residential" };
const RentRollsApartmentType18 = { Office: "Office" };
const RentRollsApartmentType19 = { Gastronomy: "Gastronomy" };
const RentRollsApartmentType20 = { Parking: "Parking" };
const RentRollsApartmentType21 = { Other: "Other" };
const RentRollsApartmentType22 = { CommercialOther: "CommercialOther" };
const RentRollsApartmentType23 = { Shop: "Shop" };
const RentRollsApartmentType24 = { Cellar: "Cellar" };
const RentRollsApartmentType25 = { UndergroundParking: "UndergroundParking" };
const RentRollsApartmentType26 = { OutdoorParking: "OutdoorParking" };
const RentRollsApartmentType27 = { Garage: "Garage" };
const RentRollsRentIncreaseType = { NO_INCREASE: "NO_INCREASE" };
const RentRollsRentIncreaseType2 = { MANUAL: "MANUAL" };
const RentRollsRentIncreaseType3 = { IRI: "IRI" };
const RentRollsRentIncreaseType4 = { FRI: "FRI" };
const RentRollsApartmentCondition = { Refurbished: "Refurbished" };
const RentRollsApartmentCondition2 = { Old: "Old" };
const RentRollsApartmentCondition3 = { Rentable: "Rentable" };
const RentRollsCondoSalesCondition = { EEOnly: "EEOnly" };
const RentRollsCondoSalesCondition2 = { EEOnlyPlusTI: "EEOnlyPlusTI" };
const RentRollsCondoSalesCondition3 = { EEOnlyPlusTIGuarantee: "EEOnlyPlusTIGuarantee" };
const CreateRentRollVersionMutationResponseOutcome = { validated: "validated" };
const CreateRentRollVersionMutationResponseOutcome2 = { written: "written" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/CreateRentRolls.ts
const RentRollsRentingState5 = { RentedUnlimited: "RentedUnlimited" };
const RentRollsRentingState6 = { RentedLimited: "RentedLimited" };
const RentRollsRentingState7 = { NotRented: "NotRented" };
const RentRollsRentingState8 = { NotRentable: "NotRentable" };
const RentRollsApartmentType28 = { Apartment: "Apartment" };
const RentRollsApartmentType29 = { HalfBasement: "HalfBasement" };
const RentRollsApartmentType30 = { NoInformation: "NoInformation" };
const RentRollsApartmentType31 = { GroundFloor: "GroundFloor" };
const RentRollsApartmentType32 = { Maisonette: "Maisonette" };
const RentRollsApartmentType33 = { Penthouse: "Penthouse" };
const RentRollsApartmentType34 = { TerracedFlat: "TerracedFlat" };
const RentRollsApartmentType35 = { RoofStorey: "RoofStorey" };
const RentRollsApartmentType36 = { RaisedGroundFloor: "RaisedGroundFloor" };
const RentRollsApartmentType37 = { Loft: "Loft" };
const RentRollsApartmentType38 = { Farm: "Farm" };
const RentRollsApartmentType39 = { TwoFamilyHouse: "TwoFamilyHouse" };
const RentRollsApartmentType40 = { ApartmentBuilding: "ApartmentBuilding" };
const RentRollsApartmentType41 = { OtherHouse: "OtherHouse" };
const RentRollsApartmentType42 = { TerracedHouse: "TerracedHouse" };
const RentRollsApartmentType43 = { Commercial: "Commercial" };
const RentRollsApartmentType44 = { Residential: "Residential" };
const RentRollsApartmentType45 = { Office: "Office" };
const RentRollsApartmentType46 = { Gastronomy: "Gastronomy" };
const RentRollsApartmentType47 = { Parking: "Parking" };
const RentRollsApartmentType48 = { Other: "Other" };
const RentRollsApartmentType49 = { CommercialOther: "CommercialOther" };
const RentRollsApartmentType50 = { Shop: "Shop" };
const RentRollsApartmentType51 = { Cellar: "Cellar" };
const RentRollsApartmentType52 = { UndergroundParking: "UndergroundParking" };
const RentRollsApartmentType53 = { OutdoorParking: "OutdoorParking" };
const RentRollsApartmentType54 = { Garage: "Garage" };
const RentRollsRentIncreaseType5 = { NO_INCREASE: "NO_INCREASE" };
const RentRollsRentIncreaseType6 = { MANUAL: "MANUAL" };
const RentRollsRentIncreaseType7 = { IRI: "IRI" };
const RentRollsRentIncreaseType8 = { FRI: "FRI" };
const RentRollsApartmentCondition4 = { Refurbished: "Refurbished" };
const RentRollsApartmentCondition5 = { Old: "Old" };
const RentRollsApartmentCondition6 = { Rentable: "Rentable" };
const RentRollsCondoSalesCondition4 = { EEOnly: "EEOnly" };
const RentRollsCondoSalesCondition5 = { EEOnlyPlusTI: "EEOnlyPlusTI" };
const RentRollsCondoSalesCondition6 = { EEOnlyPlusTIGuarantee: "EEOnlyPlusTIGuarantee" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/FindRentRollVersions.ts
const FindRentRollVersionsQueryParamsStatus = { New: "New" };
const FindRentRollVersionsQueryParamsStatus2 = { Draft: "Draft" };
const FindRentRollVersionsQueryParamsStatus3 = { Approved: "Approved" };
const FindRentRollVersionsQueryParamsOrder = { ASC: "ASC" };
const FindRentRollVersionsQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetAssetsInPipelineConfig.ts
const GetAssetsInPipelineConfigQueryParamsSourcingState = {
	New: "New",
	Validation: "Validation",
	NotInScope: "NotInScope",
	Duplicate: "Duplicate",
	Unpublished: "Unpublished",
	Screening: "Screening",
	Evaluation: "Evaluation",
	Placement: "Placement",
	DueDiligence: "DueDiligence",
	Closing: "Closing",
	Closed: "Closed",
	Rejected: "Rejected"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetAssetsInPipelineList.ts
const GetAssetsInPipelineListQueryParamsOrder = { ASC: "ASC" };
const GetAssetsInPipelineListQueryParamsOrder2 = { DESC: "DESC" };
const GetAssetsInPipelineListQueryParamsInvestmentRiskProfile = {
	CorePlus: "CorePlus",
	ValueAdd: "ValueAdd"
};
const GetAssetsInPipelineListQueryParamsInvestmentStrategy = {
	DevelopToGreen: "DevelopToGreen",
	HoldAndStabilize: "HoldAndStabilize",
	Exit: "Exit"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetEligibleAssetsList.ts
const GetEligibleAssetsListQueryParamsEstateType = {
	Apartment: "Apartment",
	House: "House",
	Office: "Office"
};
const GetEligibleAssetsListQueryParamsMandateType = {
	Investment: "Investment",
	Management: "Management"
};
const GetEligibleAssetsListQueryParamsMandateType2 = {
	Investment: "Investment",
	Management: "Management"
};
const GetEligibleAssetsListQueryParamsInvestmentRiskProfile = {
	CorePlus: "CorePlus",
	ValueAdd: "ValueAdd"
};
const GetEligibleAssetsListQueryParamsInvestmentStrategy = {
	DevelopToGreen: "DevelopToGreen",
	HoldAndStabilize: "HoldAndStabilize",
	Exit: "Exit"
};
const GetEligibleAssetsListQueryParamsOrder = { ASC: "ASC" };
const GetEligibleAssetsListQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetIcTeaser.ts
const SlidesBodyKind = { picture: "picture" };
const SlidesBodyKind2 = { text: "text" };
const SlidesBodyKind3 = { picture: "picture" };
const SlidesBodyKind4 = { text: "text" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetMfhElementImportSheetUrl.ts
const GetMfhElementImportSheetUrlQueryParamsType = {
	Window: "Window",
	ExteriorWall: "ExteriorWall",
	Door: "Door",
	StairwellInnerWallArea: "StairwellInnerWallArea",
	NetRoomArea: "NetRoomArea",
	GrossRoomArea: "GrossRoomArea"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetMfhElements.ts
const GetMfhElementsQueryParamsType = {
	Window: "Window",
	ExteriorWall: "ExteriorWall",
	Door: "Door",
	StairwellInnerWallArea: "StairwellInnerWallArea",
	NetRoomArea: "NetRoomArea",
	GrossRoomArea: "GrossRoomArea"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetMfhList.ts
const GetMfhListQueryParamsEstateType = {
	Apartment: "Apartment",
	House: "House",
	Office: "Office"
};
const GetMfhListQueryParamsMandateType = {
	Investment: "Investment",
	Management: "Management"
};
const GetMfhListQueryParamsMandateType2 = {
	Investment: "Investment",
	Management: "Management"
};
const GetMfhListQueryParamsInvestmentRiskProfile = {
	CorePlus: "CorePlus",
	ValueAdd: "ValueAdd"
};
const GetMfhListQueryParamsInvestmentStrategy = {
	DevelopToGreen: "DevelopToGreen",
	HoldAndStabilize: "HoldAndStabilize",
	Exit: "Exit"
};
const GetMfhListQueryParamsOrder = { ASC: "ASC" };
const GetMfhListQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetMfhSourcingList.ts
const GetMfhSourcingListQueryParamsEstateType = {
	Apartment: "Apartment",
	House: "House",
	Office: "Office"
};
const GetMfhSourcingListQueryParamsMandateType = {
	Investment: "Investment",
	Management: "Management"
};
const GetMfhSourcingListQueryParamsMandateType2 = {
	Investment: "Investment",
	Management: "Management"
};
const GetMfhSourcingListQueryParamsInvestmentRiskProfile = {
	CorePlus: "CorePlus",
	ValueAdd: "ValueAdd"
};
const GetMfhSourcingListQueryParamsInvestmentStrategy = {
	DevelopToGreen: "DevelopToGreen",
	HoldAndStabilize: "HoldAndStabilize",
	Exit: "Exit"
};
const GetMfhSourcingListQueryParamsOrder = { ASC: "ASC" };
const GetMfhSourcingListQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/GetMfhWithExpand.ts
const ParametersMfhConditions = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ParametersListedSince = { "-1": -1 };
const ParametersListedSince2 = { "7": 7 };
const ParametersListedSince3 = { "30": 30 };
const ParametersListedSince4 = { "90": 90 };
const ParametersListedSince5 = { "180": 180 };
const ParametersListedSince6 = { "365": 365 };
const ResultMfhConditions = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersMfhConditions = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersListedSince = { "-1": -1 };
const FiltersListedSince2 = { "7": 7 };
const FiltersListedSince3 = { "30": 30 };
const FiltersListedSince4 = { "90": 90 };
const FiltersListedSince5 = { "180": 180 };
const FiltersListedSince6 = { "365": 365 };
const ListingsCondition = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ByConditionCondition = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ResultRoutingStatus = {
	complete: "complete",
	partial: "partial",
	unavailable: "unavailable",
	skipped: "skipped"
};
const ParametersMfhConditions2 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ParametersListedSince7 = { "-1": -1 };
const ParametersListedSince8 = { "7": 7 };
const ParametersListedSince9 = { "30": 30 };
const ParametersListedSince10 = { "90": 90 };
const ParametersListedSince11 = { "180": 180 };
const ParametersListedSince12 = { "365": 365 };
const ResultMfhConditions2 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersMfhConditions2 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const FiltersListedSince7 = { "-1": -1 };
const FiltersListedSince8 = { "7": 7 };
const FiltersListedSince9 = { "30": 30 };
const FiltersListedSince10 = { "90": 90 };
const FiltersListedSince11 = { "180": 180 };
const FiltersListedSince12 = { "365": 365 };
const ListingsCondition2 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ByConditionCondition2 = {
	refurbished: "refurbished",
	first_occupancy: "first_occupancy"
};
const ResultRoutingStatus2 = {
	complete: "complete",
	partial: "partial",
	unavailable: "unavailable",
	skipped: "skipped"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/ImportAutomaticRentRoll.ts
const AutomaticRentRollImportStatus3 = { ready: "ready" };
const RowsRentingState2 = {
	RentedUnlimited: "RentedUnlimited",
	RentedLimited: "RentedLimited",
	NotRented: "NotRented",
	NotRentable: "NotRentable"
};
const RowsApartmentType2 = {
	Apartment: "Apartment",
	HalfBasement: "HalfBasement",
	NoInformation: "NoInformation",
	GroundFloor: "GroundFloor",
	Maisonette: "Maisonette",
	Penthouse: "Penthouse",
	TerracedFlat: "TerracedFlat",
	RoofStorey: "RoofStorey",
	RaisedGroundFloor: "RaisedGroundFloor",
	Loft: "Loft",
	Farm: "Farm",
	TwoFamilyHouse: "TwoFamilyHouse",
	ApartmentBuilding: "ApartmentBuilding",
	OtherHouse: "OtherHouse",
	TerracedHouse: "TerracedHouse",
	Commercial: "Commercial",
	Residential: "Residential",
	Office: "Office",
	Gastronomy: "Gastronomy",
	Parking: "Parking",
	Other: "Other",
	CommercialOther: "CommercialOther",
	Shop: "Shop",
	Cellar: "Cellar",
	UndergroundParking: "UndergroundParking",
	OutdoorParking: "OutdoorParking",
	Garage: "Garage"
};
const RowsRentIncreaseType2 = {
	NO_INCREASE: "NO_INCREASE",
	MANUAL: "MANUAL",
	IRI: "IRI",
	FRI: "FRI"
};
const AutomaticRentRollImportStatus4 = { failed: "failed" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/ParseMfhElementsFromSheet.ts
const ParseMfhElementsFromSheetMutationRequestType = {
	Window: "Window",
	ExteriorWall: "ExteriorWall",
	Door: "Door",
	StairwellInnerWallArea: "StairwellInnerWallArea",
	NetRoomArea: "NetRoomArea",
	GrossRoomArea: "GrossRoomArea"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/ProcessRentRollVersionEvent.ts
const ProcessRentRollVersionEventMutationRequestEvent = { ReadyForInvestment: "ReadyForInvestment" };
const ProcessRentRollVersionEventMutationRequestEvent2 = { RentRollAdded: "RentRollAdded" };
const ProcessRentRollVersionEventMutationRequestEvent3 = { Revert: "Revert" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/RegenerateIcTeaser.ts
const RegenerateIcTeaser200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction57 = { update_mfh: "update_mfh" };
const DecisionAction58 = { create_mfh: "create_mfh" };
const DecisionAction59 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction60 = { create_mfh_estate: "create_mfh_estate" };
const RegenerateIcTeaserMutationResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction61 = { update_mfh: "update_mfh" };
const DecisionAction62 = { create_mfh: "create_mfh" };
const DecisionAction63 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction64 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/RegenerateIcTeaserFields.ts
const SlidesBodyKind11 = { picture: "picture" };
const SlidesBodyKind12 = { text: "text" };
const RegenerateIcTeaserFieldsMutationRequestKeys = {
	executiveSummaryHeader: "executiveSummaryHeader",
	executiveSummarySubheader: "executiveSummarySubheader",
	microLocationSummaryHeader: "microLocationSummaryHeader",
	microLocationSummary: "microLocationSummary",
	rentPotentialSummaryHeader: "rentPotentialSummaryHeader",
	rentPotentialSummary: "rentPotentialSummary",
	energeticModernizationSummaryHeader: "energeticModernizationSummaryHeader",
	energeticModernizationSummary: "energeticModernizationSummary",
	assetOverviewHeader: "assetOverviewHeader",
	assetImpressionsHeader: "assetImpressionsHeader",
	assetImpressionsSubheader: "assetImpressionsSubheader",
	macroMicroLocationHeader: "macroMicroLocationHeader",
	locationRentComparativesHeader: "locationRentComparativesHeader",
	transformationHeader: "transformationHeader",
	apartmentModernizationSummary: "apartmentModernizationSummary",
	generalModernizationSummary: "generalModernizationSummary",
	energeticModernizationPlanSummary: "energeticModernizationPlanSummary",
	roofExpansionSummary: "roofExpansionSummary",
	rentalDevelopmentHeader: "rentalDevelopmentHeader",
	rentalDevelopmentCommentary: "rentalDevelopmentCommentary",
	projectDeliveryHeader: "projectDeliveryHeader",
	sourcesUsesFinancingHeader: "sourcesUsesFinancingHeader",
	subsidiesHeader: "subsidiesHeader",
	cashFlowHeader: "cashFlowHeader",
	jCurveCommentary: "jCurveCommentary",
	noiBridgeCommentary: "noiBridgeCommentary",
	unleveredDcfHeader: "unleveredDcfHeader",
	leveredDcfHeader: "leveredDcfHeader",
	returnsHeader: "returnsHeader",
	returnsSubheader: "returnsSubheader"
};
const SlidesBodyKind13 = { picture: "picture" };
const SlidesBodyKind14 = { text: "text" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/ReplaceRentRollVersionData.ts
const ReplaceRentRollVersionData200Outcome = { validated: "validated" };
const ReplaceRentRollVersionData200Outcome2 = { written: "written" };
const SourceType5 = { existing: "existing" };
const SourceType6 = { d2g: "d2g" };
const SourceType7 = { "import-sheet": "import-sheet" };
const SourceType8 = { inline: "inline" };
const RentRollsRentingState9 = { RentedUnlimited: "RentedUnlimited" };
const RentRollsRentingState10 = { RentedLimited: "RentedLimited" };
const RentRollsRentingState11 = { NotRented: "NotRented" };
const RentRollsRentingState12 = { NotRentable: "NotRentable" };
const RentRollsApartmentType55 = { Apartment: "Apartment" };
const RentRollsApartmentType56 = { HalfBasement: "HalfBasement" };
const RentRollsApartmentType57 = { NoInformation: "NoInformation" };
const RentRollsApartmentType58 = { GroundFloor: "GroundFloor" };
const RentRollsApartmentType59 = { Maisonette: "Maisonette" };
const RentRollsApartmentType60 = { Penthouse: "Penthouse" };
const RentRollsApartmentType61 = { TerracedFlat: "TerracedFlat" };
const RentRollsApartmentType62 = { RoofStorey: "RoofStorey" };
const RentRollsApartmentType63 = { RaisedGroundFloor: "RaisedGroundFloor" };
const RentRollsApartmentType64 = { Loft: "Loft" };
const RentRollsApartmentType65 = { Farm: "Farm" };
const RentRollsApartmentType66 = { TwoFamilyHouse: "TwoFamilyHouse" };
const RentRollsApartmentType67 = { ApartmentBuilding: "ApartmentBuilding" };
const RentRollsApartmentType68 = { OtherHouse: "OtherHouse" };
const RentRollsApartmentType69 = { TerracedHouse: "TerracedHouse" };
const RentRollsApartmentType70 = { Commercial: "Commercial" };
const RentRollsApartmentType71 = { Residential: "Residential" };
const RentRollsApartmentType72 = { Office: "Office" };
const RentRollsApartmentType73 = { Gastronomy: "Gastronomy" };
const RentRollsApartmentType74 = { Parking: "Parking" };
const RentRollsApartmentType75 = { Other: "Other" };
const RentRollsApartmentType76 = { CommercialOther: "CommercialOther" };
const RentRollsApartmentType77 = { Shop: "Shop" };
const RentRollsApartmentType78 = { Cellar: "Cellar" };
const RentRollsApartmentType79 = { UndergroundParking: "UndergroundParking" };
const RentRollsApartmentType80 = { OutdoorParking: "OutdoorParking" };
const RentRollsApartmentType81 = { Garage: "Garage" };
const RentRollsRentIncreaseType9 = { NO_INCREASE: "NO_INCREASE" };
const RentRollsRentIncreaseType10 = { MANUAL: "MANUAL" };
const RentRollsRentIncreaseType11 = { IRI: "IRI" };
const RentRollsRentIncreaseType12 = { FRI: "FRI" };
const RentRollsApartmentCondition7 = { Refurbished: "Refurbished" };
const RentRollsApartmentCondition8 = { Old: "Old" };
const RentRollsApartmentCondition9 = { Rentable: "Rentable" };
const RentRollsCondoSalesCondition7 = { EEOnly: "EEOnly" };
const RentRollsCondoSalesCondition8 = { EEOnlyPlusTI: "EEOnlyPlusTI" };
const RentRollsCondoSalesCondition9 = { EEOnlyPlusTIGuarantee: "EEOnlyPlusTIGuarantee" };
const ReplaceRentRollVersionDataMutationResponseOutcome = { validated: "validated" };
const ReplaceRentRollVersionDataMutationResponseOutcome2 = { written: "written" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/UpdateIcTeaser.ts
const SlidesBodyKind5 = { picture: "picture" };
const SlidesBodyKind6 = { text: "text" };
const SlidesBodyKind7 = { picture: "picture" };
const SlidesBodyKind8 = { text: "text" };
const SlidesBodyKind9 = { picture: "picture" };
const SlidesBodyKind10 = { text: "text" };
//#endregion
//#region src/basecamp/gen/models/mfhModels/UpdateMfh.ts
const UpdateMfhMutationRequestChannelName = {
	OTHER_ONLINE_PORTAL: "OTHER_ONLINE_PORTAL",
	BROKER_OPEN_MANDATE: "BROKER_OPEN_MANDATE",
	BROKER_EXCLUSIVE_ACCESS: "BROKER_EXCLUSIVE_ACCESS",
	DIRECT_OWNER_APPROACH: "DIRECT_OWNER_APPROACH",
	NETWORK_REFERRAL: "NETWORK_REFERRAL",
	M_AND_A_PROCESS: "M_AND_A_PROCESS",
	INSOLVENCY_PROCESS: "INSOLVENCY_PROCESS",
	OTHER: "OTHER"
};
const AttributesBuildingEnergyRating2 = {
	NO_INFORMATION: "NO_INFORMATION",
	ENERGY_REQUIRED: "ENERGY_REQUIRED",
	ENERGY_CONSUMPTION: "ENERGY_CONSUMPTION"
};
const AttributesAdjoiningBuilding2 = {
	OneSide: "OneSide",
	TwoSide: "TwoSide",
	Absent: "Absent"
};
const AttributesWaterHeating2 = {
	Boiler: "Boiler",
	ViaHeating: "ViaHeating"
};
const AttributesRoofShape2 = {
	Hipped: "Hipped",
	Saddle: "Saddle",
	Pitched: "Pitched",
	Flat: "Flat",
	Mansard: "Mansard"
};
const AttributesRoofOrientation2 = {
	N: "N",
	NE: "NE",
	E: "E",
	SE: "SE",
	S: "S",
	SW: "SW",
	W: "W",
	NW: "NW"
};
const AttributesRoofUse2 = {
	FacadeWorthPreserving: "FacadeWorthPreserving",
	SingleSkinMasonry: "SingleSkinMasonry",
	DoubleSkinMasonry: "DoubleSkinMasonry"
};
const AttributesWindowGlazing2 = {
	One: "One",
	Two: "Two",
	Three: "Three",
	BoxWindows: "BoxWindows"
};
const AttributesCellarHeating2 = {
	Heated: "Heated",
	PartiallyHeated: "PartiallyHeated",
	NotHeated: "NotHeated"
};
const AttributesExitType2 = {
	MFH: "MFH",
	SingleUnit: "SingleUnit",
	MFHSingleUnit: "MFHSingleUnit"
};
const AttributesSplitStatus2 = {
	ToBeSplit: "ToBeSplit",
	AlreadySplit: "AlreadySplit",
	PleaseFillOut: "PleaseFillOut",
	NoInputNeeded: "NoInputNeeded"
};
const AttributesRiwisLocation2 = {
	Simple: "Simple",
	SimpleToAverage: "SimpleToAverage",
	Average: "Average",
	AverageToGood: "AverageToGood",
	Good: "Good",
	GoodToVeryGood: "GoodToVeryGood",
	VeryGood: "VeryGood",
	NoInputNeeded: "NoInputNeeded",
	PleaseFillOut: "PleaseFillOut"
};
const AttributesRestrictions2 = {
	UrbanisticQuirk: "UrbanisticQuirk",
	CompositionOfTheResidentPopulation: "CompositionOfTheResidentPopulation",
	RedevelopmentArea: "RedevelopmentArea",
	HeritageBuilding: "HeritageBuilding",
	GroundLease: "GroundLease",
	RentControlOrRentSubsidy: "RentControlOrRentSubsidy",
	ZoningPlan: "ZoningPlan",
	Other: "Other",
	None: "None"
};
const AttributesMandateType2 = {
	Investment: "Investment",
	Management: "Management"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/UpdateMfhPlacementIcResponse.ts
const UpdateMfhPlacementIcResponseMutationRequestAssetPartnerPlacementResponseStatus = {
	NotApproached: "NotApproached",
	InitialOutreachCompleted: "InitialOutreachCompleted",
	TeaserSent: "TeaserSent",
	NdaSigned: "NdaSigned",
	InvestmentMemoSent: "InvestmentMemoSent",
	Loi: "Loi",
	Commitment: "Commitment",
	DeclinedByPartner: "DeclinedByPartner",
	ExcludedByReneo: "ExcludedByReneo"
};
//#endregion
//#region src/basecamp/gen/models/mfhModels/UpdateRentRoll.ts
const DataRentingState = { RentedUnlimited: "RentedUnlimited" };
const DataRentingState2 = { RentedLimited: "RentedLimited" };
const DataRentingState3 = { NotRented: "NotRented" };
const DataRentingState4 = { NotRentable: "NotRentable" };
const DataApartmentType = { Apartment: "Apartment" };
const DataApartmentType2 = { HalfBasement: "HalfBasement" };
const DataApartmentType3 = { NoInformation: "NoInformation" };
const DataApartmentType4 = { GroundFloor: "GroundFloor" };
const DataApartmentType5 = { Maisonette: "Maisonette" };
const DataApartmentType6 = { Penthouse: "Penthouse" };
const DataApartmentType7 = { TerracedFlat: "TerracedFlat" };
const DataApartmentType8 = { RoofStorey: "RoofStorey" };
const DataApartmentType9 = { RaisedGroundFloor: "RaisedGroundFloor" };
const DataApartmentType10 = { Loft: "Loft" };
const DataApartmentType11 = { Farm: "Farm" };
const DataApartmentType12 = { TwoFamilyHouse: "TwoFamilyHouse" };
const DataApartmentType13 = { ApartmentBuilding: "ApartmentBuilding" };
const DataApartmentType14 = { OtherHouse: "OtherHouse" };
const DataApartmentType15 = { TerracedHouse: "TerracedHouse" };
const DataApartmentType16 = { Commercial: "Commercial" };
const DataApartmentType17 = { Residential: "Residential" };
const DataApartmentType18 = { Office: "Office" };
const DataApartmentType19 = { Gastronomy: "Gastronomy" };
const DataApartmentType20 = { Parking: "Parking" };
const DataApartmentType21 = { Other: "Other" };
const DataApartmentType22 = { CommercialOther: "CommercialOther" };
const DataApartmentType23 = { Shop: "Shop" };
const DataApartmentType24 = { Cellar: "Cellar" };
const DataApartmentType25 = { UndergroundParking: "UndergroundParking" };
const DataApartmentType26 = { OutdoorParking: "OutdoorParking" };
const DataApartmentType27 = { Garage: "Garage" };
const DataRentIncreaseType = { NO_INCREASE: "NO_INCREASE" };
const DataRentIncreaseType2 = { MANUAL: "MANUAL" };
const DataRentIncreaseType3 = { IRI: "IRI" };
const DataRentIncreaseType4 = { FRI: "FRI" };
const DataApartmentCondition = { Refurbished: "Refurbished" };
const DataApartmentCondition2 = { Old: "Old" };
const DataApartmentCondition3 = { Rentable: "Rentable" };
const DataCondoSalesCondition = { EEOnly: "EEOnly" };
const DataCondoSalesCondition2 = { EEOnlyPlusTI: "EEOnlyPlusTI" };
const DataCondoSalesCondition3 = { EEOnlyPlusTIGuarantee: "EEOnlyPlusTIGuarantee" };
//#endregion
//#region src/basecamp/gen/models/renovationScenariosModels/CreateRenovationScenario.ts
const CreateRenovationScenarioMutationRequestSubsidyScheme = { KFW_261: "KFW_261" };
const CreateRenovationScenarioMutationRequestSubsidyScheme2 = { BAFA: "BAFA" };
const CreateRenovationScenarioMutationRequestExpansionType = { NONE: "NONE" };
const CreateRenovationScenarioMutationRequestExpansionType2 = { ROOF_ADDITION: "ROOF_ADDITION" };
const CreateRenovationScenarioMutationRequestExpansionType3 = { ROOF_CONVERSION: "ROOF_CONVERSION" };
const CreateRenovationScenarioMutationRequestEnergeticMeasureType = { SHELL: "SHELL" };
const CreateRenovationScenarioMutationRequestEnergeticMeasureType2 = { HEATING: "HEATING" };
const CreateRenovationScenarioMutationRequestEnergeticMeasureType3 = { FULL: "FULL" };
const SubsidiesKfwStandard5 = { "KfW 55": "KfW 55" };
const SubsidiesKfwStandard6 = { "KfW 70": "KfW 70" };
const SubsidiesKfwStandard7 = { "KfW 85": "KfW 85" };
const SubsidiesKfwStandard8 = { "No KfW": "No KfW" };
const SubsidiesBegEmOption6 = { "Individual measure shell + heating measure": "Individual measure shell + heating measure" };
const SubsidiesBegEmOption7 = { "Individual measure shell/systems with EH 55 standard": "Individual measure shell/systems with EH 55 standard" };
const SubsidiesBegEmOption8 = { "Individual measure shell/systems without EH standard": "Individual measure shell/systems without EH standard" };
const SubsidiesBegEmOption9 = { "Individual heating measure": "Individual heating measure" };
const SubsidiesBegEmOption10 = { OFF: "OFF" };
const SubsidiesIfbStandard7 = { "No IFB": "No IFB" };
const SubsidiesIfbStandard8 = { "IFB<75": "IFB<75" };
const SubsidiesIfbStandard9 = { IFB70: "IFB70" };
const SubsidiesIfbStandard10 = { IFB55: "IFB55" };
const SubsidiesIfbStandard11 = { IFB40: "IFB40" };
const SubsidiesIfbStandard12 = { "IFB<90": "IFB<90" };
const EnergyTargetEnergyClass10 = { "A+": "A+" };
const EnergyTargetEnergyClass11 = { A: "A" };
const EnergyTargetEnergyClass12 = { B: "B" };
const EnergyTargetEnergyClass13 = { C: "C" };
const EnergyTargetEnergyClass14 = { D: "D" };
const EnergyTargetEnergyClass15 = { E: "E" };
const EnergyTargetEnergyClass16 = { F: "F" };
const EnergyTargetEnergyClass17 = { G: "G" };
const EnergyTargetEnergyClass18 = { H: "H" };
//#endregion
//#region src/basecamp/gen/models/renovationScenariosModels/FindRenovationScenarios.ts
const FindRenovationScenariosQueryParamsGroup = {
	KFW_261_NO_EXPANSION: "KFW_261_NO_EXPANSION",
	BAFA_NO_EXPANSION: "BAFA_NO_EXPANSION",
	KFW_261_ROOF_ADDITION: "KFW_261_ROOF_ADDITION",
	BAFA_ROOF_ADDITION: "BAFA_ROOF_ADDITION",
	KFW_261_ROOF_CONVERSION: "KFW_261_ROOF_CONVERSION",
	BAFA_ROOF_CONVERSION: "BAFA_ROOF_CONVERSION"
};
//#endregion
//#region src/basecamp/gen/models/renovationScenariosModels/SaveRenovationScenarioParameters.ts
const SubsidiesKfwStandard9 = { "KfW 55": "KfW 55" };
const SubsidiesKfwStandard10 = { "KfW 70": "KfW 70" };
const SubsidiesKfwStandard11 = { "KfW 85": "KfW 85" };
const SubsidiesKfwStandard12 = { "No KfW": "No KfW" };
const SubsidiesBegEmOption11 = { "Individual measure shell + heating measure": "Individual measure shell + heating measure" };
const SubsidiesBegEmOption12 = { "Individual measure shell/systems with EH 55 standard": "Individual measure shell/systems with EH 55 standard" };
const SubsidiesBegEmOption13 = { "Individual measure shell/systems without EH standard": "Individual measure shell/systems without EH standard" };
const SubsidiesBegEmOption14 = { "Individual heating measure": "Individual heating measure" };
const SubsidiesBegEmOption15 = { OFF: "OFF" };
const SubsidiesIfbStandard13 = { "No IFB": "No IFB" };
const SubsidiesIfbStandard14 = { "IFB<75": "IFB<75" };
const SubsidiesIfbStandard15 = { IFB70: "IFB70" };
const SubsidiesIfbStandard16 = { IFB55: "IFB55" };
const SubsidiesIfbStandard17 = { IFB40: "IFB40" };
const SubsidiesIfbStandard18 = { "IFB<90": "IFB<90" };
const EnergyTargetEnergyClass19 = { "A+": "A+" };
const EnergyTargetEnergyClass20 = { A: "A" };
const EnergyTargetEnergyClass21 = { B: "B" };
const EnergyTargetEnergyClass22 = { C: "C" };
const EnergyTargetEnergyClass23 = { D: "D" };
const EnergyTargetEnergyClass24 = { E: "E" };
const EnergyTargetEnergyClass25 = { F: "F" };
const EnergyTargetEnergyClass26 = { G: "G" };
const EnergyTargetEnergyClass27 = { H: "H" };
//#endregion
//#region src/basecamp/gen/models/sepaMandatesModels/GetSepaMandates.ts
const QuerySource = {
	Tenant: "Tenant",
	Escrow: "Escrow"
};
const QueryStatus = {
	Active: "Active",
	Cancelled: "Cancelled",
	Expired: "Expired"
};
//#endregion
//#region src/basecamp/gen/models/userTaskModels/FindUserTasks.ts
const FindUserTasksQueryParamsStatus = { Created: "Created" };
const FindUserTasksQueryParamsStatus2 = { Completed: "Completed" };
const FindUserTasksQueryParamsStatus3 = { Aborted: "Aborted" };
const FindUserTasksQueryParamsType = { classify_document: "classify_document" };
const FindUserTasksQueryParamsType2 = { analyze_portfolio: "analyze_portfolio" };
const FindUserTasksQueryParamsOrder = { ASC: "ASC" };
const FindUserTasksQueryParamsOrder2 = { DESC: "DESC" };
const FindUserTasksQueryParamsSource = { email: "email" };
const FindUserTasksQueryParamsSource2 = { upload: "upload" };
const FindUserTasksQueryParamsSource3 = { existing: "existing" };
//#endregion
//#region src/basecamp/gen/models/userTaskModels/UpdatePortfolioAnalyzerResult.ts
const UpdatePortfolioAnalyzerResultMutationRequestStatus = { failed: "failed" };
//#endregion
//#region src/basecamp/client.ts
const axiosInstance = axios.create({ paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: "repeat" }) } });
function initHTTPClient(baseURL, onRequest, onRejectedResponse) {
	axiosInstance.defaults.baseURL = baseURL;
	if (onRequest) axiosInstance.interceptors.request.use(onRequest);
	if (onRejectedResponse) axiosInstance.interceptors.response.use((response) => response, onRejectedResponse);
	return axiosInstance;
}
const axiosClient = async (config) => {
	return axiosInstance.request({ ...config }).catch((e) => {
		throw e;
	});
};
//#endregion
//#region src/basecamp/gen/clients/axios.ts
var axios_exports = /* @__PURE__ */ __exportAll({
	bindRolesToUser: () => bindRolesToUser,
	buildSensitivityTakeoverInputs: () => buildSensitivityTakeoverInputs,
	bulkCreateMfhFromCsv: () => bulkCreateMfhFromCsv,
	bulkUpdateRoles: () => bulkUpdateRoles,
	calculateAutomaticMfhInvestmentCase: () => calculateAutomaticMfhInvestmentCase,
	calculateBaseMfhInvestmentCaseChildren: () => calculateBaseMfhInvestmentCaseChildren,
	cancelMfhInvestmentCaseAutoSensitivity: () => cancelMfhInvestmentCaseAutoSensitivity,
	changeAndRecreateMfhInvestmentCase: () => changeAndRecreateMfhInvestmentCase,
	changeAndRecreateSheetlessMfhInvestmentCase: () => changeAndRecreateSheetlessMfhInvestmentCase,
	checkBaseMfhInvestmentCase: () => checkBaseMfhInvestmentCase,
	classifyDocuments: () => classifyDocuments,
	classifyDocumentsEmail: () => classifyDocumentsEmail,
	commitMfhInvestmentCaseOverrides: () => commitMfhInvestmentCaseOverrides,
	completeAnalyzePortfolioUserTask: () => completeAnalyzePortfolioUserTask,
	confirmDocumentClassification: () => confirmDocumentClassification,
	consumePortalHandoff: () => consumePortalHandoff,
	convertImagesToPdf: () => convertImagesToPdf,
	copyAndChangeAssetPartnerMfhInvestmentCase: () => copyAndChangeAssetPartnerMfhInvestmentCase,
	copyAndChangeAssetPartnerSheetlessMfhInvestmentCase: () => copyAndChangeAssetPartnerSheetlessMfhInvestmentCase,
	copyDocumentsOrFolders: () => copyDocumentsOrFolders,
	copyMfhInvestmentCase: () => copyMfhInvestmentCase,
	copyMfhInvestmentCaseToAssetManagement: () => copyMfhInvestmentCaseToAssetManagement,
	copySheetlessMfhInvestmentCase: () => copySheetlessMfhInvestmentCase,
	createAssetPartnerIcProfile: () => createAssetPartnerIcProfile,
	createAutomaticMfhInvestmentCase: () => createAutomaticMfhInvestmentCase,
	createAutomaticMfhInvestmentCases: () => createAutomaticMfhInvestmentCases,
	createAutomaticPortfolioWithAsset: () => createAutomaticPortfolioWithAsset,
	createBaseMfhInvestmentCase: () => createBaseMfhInvestmentCase,
	createDocumentAnnotation: () => createDocumentAnnotation,
	createDocumentGptParseRequests: () => createDocumentGptParseRequests,
	createDocumentRelation: () => createDocumentRelation,
	createEmptyMfhInvestmentCase: () => createEmptyMfhInvestmentCase,
	createIcTeaser: () => createIcTeaser,
	createLinkDocument: () => createLinkDocument,
	createMfh: () => createMfh,
	createMfhAttributeParseRequest: () => createMfhAttributeParseRequest,
	createMfhEstate: () => createMfhEstate,
	createMfhProjectPlanSnapshot: () => createMfhProjectPlanSnapshot,
	createRenovationScenario: () => createRenovationScenario,
	createRentRollVersion: () => createRentRollVersion,
	createRentRolls: () => createRentRolls,
	createRole: () => createRole,
	createSessionCookie: () => createSessionCookie,
	createSheetlessMfhInvestmentCase: () => createSheetlessMfhInvestmentCase,
	deleteAssetPartnerIcProfile: () => deleteAssetPartnerIcProfile,
	deleteDataRoom: () => deleteDataRoom,
	deleteDocumentAnnotation: () => deleteDocumentAnnotation,
	deleteDocumentByUuid: () => deleteDocumentByUuid,
	deleteDocumentFolder: () => deleteDocumentFolder,
	deleteFile: () => deleteFile,
	deleteIcTeaser: () => deleteIcTeaser,
	deleteMfhElements: () => deleteMfhElements,
	deleteMfhInvestmentCase: () => deleteMfhInvestmentCase,
	deleteMfhInvestmentCases: () => deleteMfhInvestmentCases,
	deleteMfhProjectPlanSnapshot: () => deleteMfhProjectPlanSnapshot,
	deleteRentRollVersion: () => deleteRentRollVersion,
	deleteRentRolls: () => deleteRentRolls,
	deleteRole: () => deleteRole,
	deleteSepaMandate: () => deleteSepaMandate,
	deleteUserTask: () => deleteUserTask,
	downloadMfhInvestmentCaseSheet: () => downloadMfhInvestmentCaseSheet,
	evaluateAutomaticMfhMarketRentSources: () => evaluateAutomaticMfhMarketRentSources,
	evaluateMfhInvestmentCasePartnerBuyBox: () => evaluateMfhInvestmentCasePartnerBuyBox,
	exportMfhInvestmentCaseAsJson: () => exportMfhInvestmentCaseAsJson,
	fanOutBaseMfhInvestmentCase: () => fanOutBaseMfhInvestmentCase,
	fetchBaseMfhInvestmentCases: () => fetchBaseMfhInvestmentCases,
	fetchMfhAttributesFromInfas: () => fetchMfhAttributesFromInfas,
	findAssetPartnerIcProfileVersions: () => findAssetPartnerIcProfileVersions,
	findAssetPartnerIcProfiles: () => findAssetPartnerIcProfiles,
	findDocuments: () => findDocuments,
	findDocumentsFolders: () => findDocumentsFolders,
	findMfhInvestmentCasesByMfh: () => findMfhInvestmentCasesByMfh,
	findMfhsByNormalizedAddress: () => findMfhsByNormalizedAddress,
	findPermissions: () => findPermissions,
	findRenovationScenarioConfigs: () => findRenovationScenarioConfigs,
	findRenovationScenarios: () => findRenovationScenarios,
	findRentRollVersions: () => findRentRollVersions,
	findRoleBindings: () => findRoleBindings,
	findRoleBindingsByUser: () => findRoleBindingsByUser,
	findRoles: () => findRoles,
	findUserTasks: () => findUserTasks,
	generateDocumentFromPayload: () => generateDocumentFromPayload,
	generateDocumentSync: () => generateDocumentSync,
	generateFolderStructure: () => generateFolderStructure,
	generateMfhInvestmentCaseAggregate: () => generateMfhInvestmentCaseAggregate,
	generatePdfFromHtml: () => generatePdfFromHtml,
	generateRentMarketData: () => generateRentMarketData,
	getApprovedMfhInvestmentCase: () => getApprovedMfhInvestmentCase,
	getAssetPartnerIcProfileVersion: () => getAssetPartnerIcProfileVersion,
	getAssetPartnerProfileVersionIcInputs: () => getAssetPartnerProfileVersionIcInputs,
	getAssetRentRoll: () => getAssetRentRoll,
	getAssetsInPipelineConfig: () => getAssetsInPipelineConfig,
	getAssetsInPipelineList: () => getAssetsInPipelineList,
	getAutomaticMfhInvestmentCase: () => getAutomaticMfhInvestmentCase,
	getCalcengineInputs: () => getCalcengineInputs,
	getCalculatedInvestmentCaseValues: () => getCalculatedInvestmentCaseValues,
	getD2GVersions: () => getD2GVersions,
	getDataRooms: () => getDataRooms,
	getDocument: () => getDocument,
	getDocumentTemplate: () => getDocumentTemplate,
	getEligibleAssetsList: () => getEligibleAssetsList,
	getEstarCoreMfhIds: () => getEstarCoreMfhIds,
	getGoogleSheetMetaData: () => getGoogleSheetMetaData,
	getIcTeaser: () => getIcTeaser,
	getIcTeaserLiveSourceData: () => getIcTeaserLiveSourceData,
	getMfhCandidatePortfolioRelations: () => getMfhCandidatePortfolioRelations,
	getMfhContacts: () => getMfhContacts,
	getMfhElementImportSheetUrl: () => getMfhElementImportSheetUrl,
	getMfhElements: () => getMfhElements,
	getMfhEstarCoreEstates: () => getMfhEstarCoreEstates,
	getMfhEstates: () => getMfhEstates,
	getMfhExternalUnits: () => getMfhExternalUnits,
	getMfhHierarchy: () => getMfhHierarchy,
	getMfhInvestmentCase: () => getMfhInvestmentCase,
	getMfhInvestmentCaseAggregate: () => getMfhInvestmentCaseAggregate,
	getMfhInvestmentCaseCell: () => getMfhInvestmentCaseCell,
	getMfhInvestmentCaseMissingInputs: () => getMfhInvestmentCaseMissingInputs,
	getMfhInvestmentCaseVersionInputPreview: () => getMfhInvestmentCaseVersionInputPreview,
	getMfhInvestmentCaseVersionResultPreview: () => getMfhInvestmentCaseVersionResultPreview,
	getMfhInvestmentCaseVersionSheetPreview: () => getMfhInvestmentCaseVersionSheetPreview,
	getMfhLatestPlacement: () => getMfhLatestPlacement,
	getMfhList: () => getMfhList,
	getMfhPlacementBuyBox: () => getMfhPlacementBuyBox,
	getMfhPlacements: () => getMfhPlacements,
	getMfhProjectPlanSnapshots: () => getMfhProjectPlanSnapshots,
	getMfhRentIndexLookup: () => getMfhRentIndexLookup,
	getMfhSourcingList: () => getMfhSourcingList,
	getMfhStats: () => getMfhStats,
	getMfhTaskHierarchy: () => getMfhTaskHierarchy,
	getMfhTaskMilestoneReport: () => getMfhTaskMilestoneReport,
	getMfhTasks: () => getMfhTasks,
	getMfhWithExpand: () => getMfhWithExpand,
	getOneDataRoom: () => getOneDataRoom,
	getOneMfhForSummary: () => getOneMfhForSummary,
	getPipelineMfhPortfolios: () => getPipelineMfhPortfolios,
	getQuestionAnswerOfDocumentTemplateParams: () => getQuestionAnswerOfDocumentTemplateParams,
	getRenovationScenario: () => getRenovationScenario,
	getRenovationScenarioConfig: () => getRenovationScenarioConfig,
	getRentRollVersion: () => getRentRollVersion,
	getSepaMandates: () => getSepaMandates,
	getStaticMapImage: () => getStaticMapImage,
	getSyncedMfhInputs: () => getSyncedMfhInputs,
	getUserTask: () => getUserTask,
	grantMfhPartnerImpersonation: () => grantMfhPartnerImpersonation,
	importAutomaticRentRoll: () => importAutomaticRentRoll,
	importMfhInvestmentCaseFromJson: () => importMfhInvestmentCaseFromJson,
	listAppliedMfhInvestmentCaseOverrides: () => listAppliedMfhInvestmentCaseOverrides,
	listMfhInvestmentCaseOverrideGroups: () => listMfhInvestmentCaseOverrideGroups,
	listMfhInvestmentCaseVersions: () => listMfhInvestmentCaseVersions,
	moveDocumentsOfFolders: () => moveDocumentsOfFolders,
	moveEstatesToBuildingLocation: () => moveEstatesToBuildingLocation,
	operations: () => operations,
	parseMfhElementsFromSheet: () => parseMfhElementsFromSheet,
	prepareMfhInvestmentCase: () => prepareMfhInvestmentCase,
	processRentRollVersionEvent: () => processRentRollVersionEvent,
	propagateBaseMfhInvestmentCaseInputs: () => propagateBaseMfhInvestmentCaseInputs,
	readMfhInvestmentCaseOutputs: () => readMfhInvestmentCaseOutputs,
	recalculateMfhInvestmentCase: () => recalculateMfhInvestmentCase,
	recalculateSheetlessMfhInvestmentCase: () => recalculateSheetlessMfhInvestmentCase,
	regenerateIcTeaser: () => regenerateIcTeaser,
	regenerateIcTeaserFields: () => regenerateIcTeaserFields,
	rejectUserTask: () => rejectUserTask,
	replaceRentRollVersionData: () => replaceRentRollVersionData,
	restoreAssetLedger: () => restoreAssetLedger,
	restoreMfhInvestmentCase: () => restoreMfhInvestmentCase,
	revertMfhInvestmentCaseVersion: () => revertMfhInvestmentCaseVersion,
	runMfhInvestmentCaseSensitivity: () => runMfhInvestmentCaseSensitivity,
	saveBaseMfhInvestmentCaseInputs: () => saveBaseMfhInvestmentCaseInputs,
	saveDataRoom: () => saveDataRoom,
	saveDocumentFolder: () => saveDocumentFolder,
	saveMfhElements: () => saveMfhElements,
	saveRenovationScenarioParameters: () => saveRenovationScenarioParameters,
	saveSepaMandates: () => saveSepaMandates,
	screenMfhInvestmentCasePartnerRenovationCell: () => screenMfhInvestmentCasePartnerRenovationCell,
	screenMfhInvestmentCasePartnerRenovationMatrix: () => screenMfhInvestmentCasePartnerRenovationMatrix,
	sendDocumentsByEmail: () => sendDocumentsByEmail,
	setAutomaticMfhInvestmentCaseInputs: () => setAutomaticMfhInvestmentCaseInputs,
	setMfhInvestmentCaseAsPrimary: () => setMfhInvestmentCaseAsPrimary,
	startMfhInvestmentCaseAutoSensitivity: () => startMfhInvestmentCaseAutoSensitivity,
	subscribeMfhInvestmentCaseAutoSensitivityEvents: () => subscribeMfhInvestmentCaseAutoSensitivityEvents,
	syncMfhInvestmentCase: () => syncMfhInvestmentCase,
	syncSheetlessMfhInvestmentCase: () => syncSheetlessMfhInvestmentCase,
	triggerMfhInvestmentCaseReadCopySync: () => triggerMfhInvestmentCaseReadCopySync,
	updateAssetPartnerIcProfile: () => updateAssetPartnerIcProfile,
	updateDocument: () => updateDocument,
	updateDocumentAnnotation: () => updateDocumentAnnotation,
	updateDocumentClassificationResult: () => updateDocumentClassificationResult,
	updateDocumentRelation: () => updateDocumentRelation,
	updateIcTeaser: () => updateIcTeaser,
	updateMfh: () => updateMfh,
	updateMfhElement: () => updateMfhElement,
	updateMfhInvestmentCase: () => updateMfhInvestmentCase,
	updateMfhInvestmentCaseAssetPartnerProfileVersion: () => updateMfhInvestmentCaseAssetPartnerProfileVersion,
	updateMfhInvestmentCaseVersionTitle: () => updateMfhInvestmentCaseVersionTitle,
	updateMfhPlacement: () => updateMfhPlacement,
	updateMfhPlacementIcResponse: () => updateMfhPlacementIcResponse,
	updateMultipleDocuments: () => updateMultipleDocuments,
	updatePortfolioAnalyzerProgress: () => updatePortfolioAnalyzerProgress,
	updatePortfolioAnalyzerResult: () => updatePortfolioAnalyzerResult,
	updateRenovationScenarioMetadata: () => updateRenovationScenarioMetadata,
	updateRentRoll: () => updateRentRoll,
	updateRentRollVersion: () => updateRentRollVersion,
	updateRole: () => updateRole,
	uploadMfhInvestmentCaseReviewedSheet: () => uploadMfhInvestmentCaseReviewedSheet,
	withdrawAutomaticMfhInvestmentCases: () => withdrawAutomaticMfhInvestmentCases
});
/**
* @description Returns role bindings for a user
* @link /authz/users/:userId/role-bindings
*/
async function findRoleBindingsByUser({ userId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/authz/users/${userId}/role-bindings`,
		...options
	})).data;
}
/**
* @description Binds roles to a user
* @link /authz/users/:userId/role-bindings
*/
async function bindRolesToUser({ userId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/authz/users/${userId}/role-bindings`,
		data,
		...options
	})).data;
}
/**
* @description Returns role bindings
* @link /authz/role-bindings
*/
async function findRoleBindings(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/authz/role-bindings`,
		...options
	})).data;
}
/**
* @description Creates a session cookie for username and password login
* @link /authz/session-cookie
*/
async function createSessionCookie(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/authz/session-cookie`,
		data,
		...options
	})).data;
}
/**
* @description Updates a role
* @link /authz/roles/:roleId
*/
async function updateRole({ roleId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/authz/roles/${roleId}`,
		data,
		...options
	})).data;
}
/**
* @description Deletes a role
* @link /authz/roles/:roleId
*/
async function deleteRole({ roleId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/authz/roles/${roleId}`,
		...options
	})).data;
}
/**
* @description Updates roles in bulk
* @link /authz/roles/bulk
*/
async function bulkUpdateRoles(data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/authz/roles/bulk`,
		data,
		...options
	})).data;
}
/**
* @description Creates a role
* @link /authz/roles
*/
async function createRole(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/authz/roles`,
		data,
		...options
	})).data;
}
/**
* @description Returns roles matching the query
* @link /authz/roles
*/
async function findRoles(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/authz/roles`,
		params,
		...options
	})).data;
}
/**
* @description Returns available permissions
* @link /authz/permissions
*/
async function findPermissions(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/authz/permissions`,
		...options
	})).data;
}
/**
* @link /document
*/
async function updateDocument(data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/document`,
		data,
		...options
	})).data;
}
/**
* @link /document
*/
async function findDocuments(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/document`,
		params,
		...options
	})).data;
}
/**
* @link /document
*/
async function deleteDocumentByUuid(params, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/document`,
		params,
		...options
	})).data;
}
/**
* @link /document-relation
*/
async function createDocumentRelation(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/document-relation`,
		data,
		...options
	})).data;
}
/**
* @link /document-relation/:documentRelationId
*/
async function updateDocumentRelation({ documentRelationId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/document-relation/${documentRelationId}`,
		data,
		...options
	})).data;
}
/**
* @link /document/:documentId
*/
async function getDocument({ documentId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/document/${documentId}`,
		params,
		...options
	})).data;
}
/**
* @link /document/:documentId
*/
async function deleteFile({ documentId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/document/${documentId}`,
		...options
	})).data;
}
/**
* @link /documents/:documentId/annotations
*/
async function createDocumentAnnotation({ documentId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents/${documentId}/annotations`,
		data,
		...options
	})).data;
}
/**
* @link /documents/:documentId/annotations/:annotationId
*/
async function updateDocumentAnnotation({ documentId, annotationId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/documents/${documentId}/annotations/${annotationId}`,
		data,
		...options
	})).data;
}
/**
* @link /documents/:documentId/annotations/:annotationId
*/
async function deleteDocumentAnnotation({ documentId, annotationId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/documents/${documentId}/annotations/${annotationId}`,
		...options
	})).data;
}
/**
* @link /documents/sync
*/
async function generateDocumentSync(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents/sync`,
		data,
		...options
	})).data;
}
/**
* @link /document/generate
*/
async function generateDocumentFromPayload(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/document/generate`,
		data,
		...options
	})).data;
}
/**
* @link /document/generate-pdf-from-html
*/
async function generatePdfFromHtml(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/document/generate-pdf-from-html`,
		data,
		...options
	})).data;
}
/**
* @link /document/static-map
*/
async function getStaticMapImage(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/document/static-map`,
		params,
		...options
	})).data;
}
/**
* @link /estate/:estateId/document/:documentType
*/
async function getQuestionAnswerOfDocumentTemplateParams({ estateId, documentType }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/estate/${estateId}/document/${documentType}`,
		...options
	})).data;
}
/**
* @link /document-template/:documentType
*/
async function getDocumentTemplate({ documentType }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/document-template/${documentType}`,
		params,
		...options
	})).data;
}
/**
* @link /documents/email
*/
async function sendDocumentsByEmail(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents/email`,
		data,
		...options
	})).data;
}
/**
* @link /documents/gpt-parse-request
*/
async function createDocumentGptParseRequests(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents/gpt-parse-request`,
		data,
		...options
	})).data;
}
/**
* @link /documents-folder/:folderId
*/
async function deleteDocumentFolder({ folderId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/documents-folder/${folderId}`,
		...options
	})).data;
}
/**
* @link /documents-folder
*/
async function findDocumentsFolders(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/documents-folder`,
		params,
		...options
	})).data;
}
/**
* @link /documents-folder
*/
async function saveDocumentFolder(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents-folder`,
		data,
		...options
	})).data;
}
/**
* @link /documents-folder/move
*/
async function moveDocumentsOfFolders(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents-folder/move`,
		data,
		...options
	})).data;
}
/**
* @link /documents-folder/copy
*/
async function copyDocumentsOrFolders(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents-folder/copy`,
		data,
		...options
	})).data;
}
/**
* @link /documents
*/
async function updateMultipleDocuments(data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/documents`,
		data,
		...options
	})).data;
}
/**
* @link /documents/convert/images-pdf
*/
async function convertImagesToPdf(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents/convert/images-pdf`,
		data,
		...options
	})).data;
}
/**
* @link /data-room
*/
async function getDataRooms(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/data-room`,
		params,
		...options
	})).data;
}
/**
* @link /data-room
*/
async function saveDataRoom(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/data-room`,
		data,
		...options
	})).data;
}
/**
* @link /data-room/:dataRoomId
*/
async function getOneDataRoom({ dataRoomId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/data-room/${dataRoomId}`,
		params,
		...options
	})).data;
}
/**
* @link /data-room/:dataRoomId
*/
async function deleteDataRoom({ dataRoomId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/data-room/${dataRoomId}`,
		...options
	})).data;
}
/**
* @link /documents-folder/generate-folder-structure
*/
async function generateFolderStructure(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/documents-folder/generate-folder-structure`,
		data,
		...options
	})).data;
}
/**
* @link /link-documents
*/
async function createLinkDocument(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/link-documents`,
		data,
		...options
	})).data;
}
/**
* @link /google-sheet-metadata
*/
async function getGoogleSheetMetaData(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/google-sheet-metadata`,
		params,
		...options
	})).data;
}
/**
* @description List renovation strategy scenarios (current configs only)
* @link /renovation-scenarios
*/
async function findRenovationScenarios(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/renovation-scenarios`,
		params,
		...options
	})).data;
}
/**
* @description Create renovation scenario with config version 1
* @link /renovation-scenarios
*/
async function createRenovationScenario(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/renovation-scenarios`,
		data,
		...options
	})).data;
}
/**
* @description Get renovation scenario detail with current parameters
* @link /renovation-scenarios/:renovationScenarioId
*/
async function getRenovationScenario({ renovationScenarioId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/renovation-scenarios/${renovationScenarioId}`,
		...options
	})).data;
}
/**
* @description Update renovation scenario metadata (no config bump)
* @link /renovation-scenarios/:renovationScenarioId
*/
async function updateRenovationScenarioMetadata({ renovationScenarioId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/renovation-scenarios/${renovationScenarioId}`,
		data,
		...options
	})).data;
}
/**
* @description Save renovation scenario (metadata and/or parameters, new config or no-op)
* @link /renovation-scenarios/:renovationScenarioId/parameters
*/
async function saveRenovationScenarioParameters({ renovationScenarioId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/renovation-scenarios/${renovationScenarioId}/parameters`,
		data,
		...options
	})).data;
}
/**
* @description List config history for a renovation scenario
* @link /renovation-scenarios/:renovationScenarioId/configs
*/
async function findRenovationScenarioConfigs({ renovationScenarioId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/renovation-scenarios/${renovationScenarioId}/configs`,
		...options
	})).data;
}
/**
* @description Get a specific renovation scenario config
* @link /renovation-scenarios/:renovationScenarioId/configs/:version
*/
async function getRenovationScenarioConfig({ renovationScenarioId, version }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/renovation-scenarios/${renovationScenarioId}/configs/${version}`,
		...options
	})).data;
}
/**
* @description Save SEPA mandate
* @link /sepa-mandate
*/
async function saveSepaMandates(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/sepa-mandate`,
		data,
		...options
	})).data;
}
/**
* @description Returns list of SEPA Mandates
* @link /sepa-mandate
*/
async function getSepaMandates(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/sepa-mandate`,
		params,
		...options
	})).data;
}
/**
* @description Delete one sepa mandate
* @link /sepa-mandate/:sepaMandateId
*/
async function deleteSepaMandate({ sepaMandateId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/sepa-mandate/${sepaMandateId}`,
		...options
	})).data;
}
/**
* @link /mfh/csv
*/
async function bulkCreateMfhFromCsv(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/csv`,
		data,
		...options
	})).data;
}
/**
* @link /mfh
*/
async function getMfhList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh`,
		params,
		...options
	})).data;
}
/**
* @link /mfh
*/
async function createMfh(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/by-normalized-address
*/
async function findMfhsByNormalizedAddress(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/by-normalized-address`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/summary
*/
async function getOneMfhForSummary({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/summary`,
		params,
		...options
	})).data;
}
/**
* @link /mfh-sourcing-list
*/
async function getMfhSourcingList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh-sourcing-list`,
		params,
		...options
	})).data;
}
/**
* @link /eligible-assets
*/
async function getEligibleAssetsList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/eligible-assets`,
		params,
		...options
	})).data;
}
/**
* @link /assets-in-pipeline
*/
async function getAssetsInPipelineList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/assets-in-pipeline`,
		params,
		...options
	})).data;
}
/**
* @link /pipeline-mfh-portfolios
*/
async function getPipelineMfhPortfolios(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/pipeline-mfh-portfolios`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId
*/
async function getMfhWithExpand({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId
*/
async function updateMfh({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/${mfhId}`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/estates
*/
async function getMfhEstates({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/estates`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/contacts
*/
async function getMfhContacts({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/contacts`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/candidate-portfolio-relations
*/
async function getMfhCandidatePortfolioRelations({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/candidate-portfolio-relations`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/tasks
*/
async function getMfhTasks({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/tasks`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/task-milestone-report
*/
async function getMfhTaskMilestoneReport({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/task-milestone-report`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/task-hierarchy
*/
async function getMfhTaskHierarchy({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/task-hierarchy`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/stats
*/
async function getMfhStats({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/stats`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/project-plan-snapshots
*/
async function getMfhProjectPlanSnapshots({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/project-plan-snapshots`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/project-plan-snapshot
*/
async function createMfhProjectPlanSnapshot({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/project-plan-snapshot`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/project-plan-snapshot/:mfhProjectPlanId
*/
async function deleteMfhProjectPlanSnapshot({ mfhProjectPlanId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/mfh/project-plan-snapshot/${mfhProjectPlanId}`,
		...options
	})).data;
}
/**
* @link /mfh/automatic-asset
*/
async function createAutomaticPortfolioWithAsset(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/automatic-asset`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/infas-attributes
*/
async function fetchMfhAttributesFromInfas({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/infas-attributes`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/attribute-gpt-parse-request
*/
async function createMfhAttributeParseRequest({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/attribute-gpt-parse-request`,
		...options
	})).data;
}
/**
* @link /mfh/buildings/:mfhBuildingId/estates
*/
async function createMfhEstate({ mfhBuildingId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/buildings/${mfhBuildingId}/estates`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/estates/move/building/:mfhBuildingId
*/
async function moveEstatesToBuildingLocation({ mfhBuildingId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/estates/move/building/${mfhBuildingId}`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/mfh-hierarchy
*/
async function getMfhHierarchy({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/mfh-hierarchy`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/estarcore-estates
*/
async function getMfhEstarCoreEstates({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/estarcore-estates`,
		...options
	})).data;
}
/**
* @link /mfh/estarcore-mfh-ids
*/
async function getEstarCoreMfhIds(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/estarcore-mfh-ids`,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/restore-ledger
*/
async function restoreAssetLedger({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/restore-ledger`,
		...options
	})).data;
}
/**
* @link /assets-in-pipeline/config
*/
async function getAssetsInPipelineConfig(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/assets-in-pipeline/config`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/external-units
*/
async function getMfhExternalUnits({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/external-units`,
		...options
	})).data;
}
/**
* @link /mfh/elements/import-sheet-url
*/
async function getMfhElementImportSheetUrl(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/elements/import-sheet-url`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/elements/parse-from-sheet
*/
async function parseMfhElementsFromSheet(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/elements/parse-from-sheet`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/elements
*/
async function getMfhElements({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/elements`,
		params,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/elements
*/
async function saveMfhElements({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/elements`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/elements/:mfhElementId
*/
async function updateMfhElement({ mfhElementId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/elements/${mfhElementId}`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/elements
*/
async function deleteMfhElements(data, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/mfh/elements`,
		data,
		...options
	})).data;
}
/**
* @link /mfh/:mfhId/asset-rent-roll
*/
async function getAssetRentRoll({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/asset-rent-roll`,
		...options
	})).data;
}
/**
* @link /mfhs/:mfhId/grant-portal-view
*/
async function grantMfhPartnerImpersonation({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfhs/${mfhId}/grant-portal-view`,
		data,
		...options
	})).data;
}
/**
* @link /mfhs/:mfhId/placements
*/
async function getMfhPlacements({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfhs/${mfhId}/placements`,
		params,
		...options
	})).data;
}
/**
* @link /mfhs/:mfhId/placement/latest
*/
async function getMfhLatestPlacement({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfhs/${mfhId}/placement/latest`,
		params,
		...options
	})).data;
}
/**
* @link /mfhs/:mfhId/placement/buy-box
*/
async function getMfhPlacementBuyBox({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfhs/${mfhId}/placement/buy-box`,
		params,
		...options
	})).data;
}
/**
* @link /mfhs/placements/:mfhPlacementId
*/
async function updateMfhPlacement({ mfhPlacementId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfhs/placements/${mfhPlacementId}`,
		data,
		...options
	})).data;
}
/**
* @link /mfhs/placements/ics/:mfhPlacementICId/response
*/
async function updateMfhPlacementIcResponse({ mfhPlacementIcId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfhs/placements/ics/${mfhPlacementIcId}/response`,
		data,
		...options
	})).data;
}
/**
* @link /portal-handoff/consume
*/
async function consumePortalHandoff(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/portal-handoff/consume`,
		data,
		...options
	})).data;
}
/**
* @description Returns list of mfh investment-cases
* @link /mfh/:mfhId/finance/investment-cases
*/
async function findMfhInvestmentCasesByMfh({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases`,
		params,
		...options
	})).data;
}
/**
* @description Create an empty mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases
*/
async function createEmptyMfhInvestmentCase({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases`,
		data,
		...options
	})).data;
}
/**
* @description Delete MFH-Investment-Cases for a given mfh
* @link /mfh/:mfhId/finance/investment-cases
*/
async function deleteMfhInvestmentCases({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/mfh/${mfhId}/finance/investment-cases`,
		...options
	})).data;
}
/**
* @description Evaluates calculated investment cases against each case's asset-partner buy-box thresholds. Uncalculated cases are omitted.
* @link /mfh/:mfhId/finance/investment-cases/evaluate-partner-buy-box
*/
async function evaluateMfhInvestmentCasePartnerBuyBox({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/evaluate-partner-buy-box`,
		data,
		...options
	})).data;
}
/**
* @description Dry-run one asset-partner IC profile × renovation overlay: calcengine without persisting an investment case, then that profile buy-box. Calc failures return an error cell.
* @link /mfh/:mfhId/finance/investment-cases/screening-cell
*/
async function screenMfhInvestmentCasePartnerRenovationCell({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/screening-cell`,
		data,
		...options
	})).data;
}
/**
* @description Dry-run an explicit list of asset-partner IC profile × renovation overlay cells. Shared MFH/D2G/rent-index/Sprengnetter context is prepared once; calcengine runs per cell without persisting investment cases.
* @link /mfh/:mfhId/finance/investment-cases/screening-matrix
*/
async function screenMfhInvestmentCasePartnerRenovationMatrix({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/screening-matrix`,
		data,
		...options
	})).data;
}
/**
* @description Returns list of available D2G Versions
* @link /mfh/finance/d2g-versions
*/
async function getD2GVersions(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/d2g-versions`,
		...options
	})).data;
}
/**
* @description Returns asset-partner IC profiles; scoped to a company when companyId is given, otherwise all partners
* @link /mfh/finance/asset-partner-ic-profiles
*/
async function findAssetPartnerIcProfiles(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/asset-partner-ic-profiles`,
		params,
		...options
	})).data;
}
/**
* @description Creates a new asset-partner IC profile
* @link /mfh/finance/asset-partner-ic-profiles
*/
async function createAssetPartnerIcProfile(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/finance/asset-partner-ic-profiles`,
		data,
		...options
	})).data;
}
/**
* @description Returns version history for an asset-partner IC profile
* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId/versions
*/
async function findAssetPartnerIcProfileVersions({ assetPartnerIcProfileId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}/versions`,
		...options
	})).data;
}
/**
* @description Returns one immutable asset-partner IC profile version
* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId/versions/:assetPartnerIcProfileVersionId
*/
async function getAssetPartnerIcProfileVersion({ assetPartnerIcProfileId, assetPartnerIcProfileVersionId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}/versions/${assetPartnerIcProfileVersionId}`,
		...options
	})).data;
}
/**
* @description Updates an asset-partner IC profile
* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId
*/
async function updateAssetPartnerIcProfile({ assetPartnerIcProfileId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}`,
		data,
		...options
	})).data;
}
/**
* @description Deletes an asset-partner IC profile; blocked when it is still referenced by investment cases
* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId
*/
async function deleteAssetPartnerIcProfile({ assetPartnerIcProfileId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}`,
		...options
	})).data;
}
/**
* @description Returns default rent-index lookup values for a given MFH
* @link /mfh/:mfhId/finance/investment-cases/rent-index-lookup
*/
async function getMfhRentIndexLookup({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/rent-index-lookup`,
		...options
	})).data;
}
/**
* @description Returns rent-index source context and nearby GeoMap residential rental comparables with HERE driving distances for an MFH
* @link /mfh/:mfhId/finance/rent-market-data
*/
async function generateRentMarketData({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/rent-market-data`,
		params,
		...options
	})).data;
}
/**
* @description Returns a single investment-case by id
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId
*/
async function getMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}`,
		params,
		...options
	})).data;
}
/**
* @description Updates an existing mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId
*/
async function updateMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}`,
		data,
		...options
	})).data;
}
/**
* @description Deletes a mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId
*/
async function deleteMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}`,
		params,
		...options
	})).data;
}
/**
* @description Returns the approved investment-case for an MFH
* @link /mfh/:mfhId/finance/investment-cases/approved
*/
async function getApprovedMfhInvestmentCase({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/approved`,
		params,
		...options
	})).data;
}
/**
* @description Manually schedule a read-copy sync for an investment case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sync-read-copy
*/
async function triggerMfhInvestmentCaseReadCopySync({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sync-read-copy`,
		...options
	})).data;
}
/**
* @description Re-read the outputs of an investment-case. Use syncOutputs to save outputs
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/read-outputs
*/
async function readMfhInvestmentCaseOutputs({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/read-outputs`,
		params,
		...options
	})).data;
}
/**
* @description Download exportable investment-case as Excel file
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/download-mfh-investment-case-sheet
*/
async function downloadMfhInvestmentCaseSheet({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/download-mfh-investment-case-sheet`,
		...options
	})).data;
}
/**
* @description Upload reviewed investment case sheet from temporary GCS location
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/upload-reviewed-sheet
*/
async function uploadMfhInvestmentCaseReviewedSheet({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/upload-reviewed-sheet`,
		data,
		...options
	})).data;
}
/**
* @description Create a base investment-case draft for batch-creating cases across multiple asset-partner profiles
* @link /mfh/:mfhId/finance/base-investment-cases
*/
async function createBaseMfhInvestmentCase({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/base-investment-cases`,
		data,
		...options
	})).data;
}
/**
* @description Returns the base investment-case drafts for an MFH
* @link /mfh/:mfhId/finance/base-investment-cases
*/
async function fetchBaseMfhInvestmentCases({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/base-investment-cases`,
		...options
	})).data;
}
/**
* @description Persist the common inputs of a base investment-case draft (no sheet/calc)
* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/inputs
*/
async function saveBaseMfhInvestmentCaseInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/inputs`,
		data,
		...options
	})).data;
}
/**
* @description Materialises a base draft into one retained child investment-case per selected profile. Optionally calculates each child.
* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/fan-out
*/
async function fanOutBaseMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/fan-out`,
		data,
		...options
	})).data;
}
/**
* @description Validates and calculates one sampled base-case profile without persisting changes
* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/check
*/
async function checkBaseMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/check`,
		data,
		...options
	})).data;
}
/**
* @description Propagates shared base-case inputs to all live children without recalculating them
* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/propagate-inputs
*/
async function propagateBaseMfhInvestmentCaseInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/propagate-inputs`,
		data,
		...options
	})).data;
}
/**
* @description Calculates every live child of a base investment case and returns a per-child report
* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/calculate-children
*/
async function calculateBaseMfhInvestmentCaseChildren({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/calculate-children`,
		data,
		...options
	})).data;
}
/**
* @description Create a sheetless mfh investment-case
* @link /mfh/:mfhId/finance/sheetless-investment-cases
*/
async function createSheetlessMfhInvestmentCase({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/sheetless-investment-cases`,
		data,
		...options
	})).data;
}
/**
* @description Admin/debug: create a sheetless investment case from JSON (optionally including a rent roll; building IDs kept only if they belong to the target asset, or remapped to the first building when requested)
* @link /mfh/:mfhId/finance/investment-cases/import-from-json
*/
async function importMfhInvestmentCaseFromJson({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/import-from-json`,
		data,
		...options
	})).data;
}
/**
* @description Admin/debug: export a sheetless investment case as JSON transfer payload (optionally including rent roll)
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/export-as-json
*/
async function exportMfhInvestmentCaseAsJson({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/export-as-json`,
		...options
	})).data;
}
/**
* @description Prepares an empty investment-case (creating predictions, creating sheets)
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/prepare
*/
async function prepareMfhInvestmentCase({ mfhInvestmentCaseId, mfhId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/prepare`,
		...options
	})).data;
}
/**
* @description Changes the d2g-version/config-id of an mfh-investment-case (destructive action)
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/change-and-recreate
*/
async function changeAndRecreateMfhInvestmentCase({ mfhInvestmentCaseId, mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/change-and-recreate`,
		data,
		...options
	})).data;
}
/**
* @description Changes the d2g-version/config-id of a sheetless mfh-investment-case (destructive action)
* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/change-and-recreate
*/
async function changeAndRecreateSheetlessMfhInvestmentCase({ mfhInvestmentCaseId, mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/change-and-recreate`,
		data,
		...options
	})).data;
}
/**
* @description Copies an existing mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy
*/
async function copyMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/copy`,
		data,
		...options
	})).data;
}
/**
* @description Copies an existing sheetless mfh investment-case
* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/copy
*/
async function copySheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/copy`,
		data,
		...options
	})).data;
}
/**
* @description Creates a copy of an existing investment-case with a different asset-partner profile, using the latest root config
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy-and-change-asset-partner
*/
async function copyAndChangeAssetPartnerMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/copy-and-change-asset-partner`,
		data,
		...options
	})).data;
}
/**
* @description Creates a copy of an existing sheetless investment-case with a different asset-partner profile, using the latest root config
* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/copy-and-change-asset-partner
*/
async function copyAndChangeAssetPartnerSheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/copy-and-change-asset-partner`,
		data,
		...options
	})).data;
}
/**
* @description Copies an approved sourcing investment-case or existing asset-management case into a new asset-management investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy-to-asset-management
*/
async function copyMfhInvestmentCaseToAssetManagement({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/copy-to-asset-management`,
		data,
		...options
	})).data;
}
/**
* @description Returns version history sessions for a D2G investment case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions
*/
async function listMfhInvestmentCaseVersions({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions`,
		params,
		...options
	})).data;
}
/**
* @description Returns active persisted override groups including localized deltas for a D2G investment case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides
*/
async function listMfhInvestmentCaseOverrideGroups({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/overrides`,
		...options
	})).data;
}
/**
* @description Resolves a sheet cell or range to the calcengine placeholders it overlaps. Each match includes that placeholder’s original formula groups. Cells with no placeholder are omitted.
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/cell
*/
async function getMfhInvestmentCaseCell({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/cell`,
		params,
		...options
	})).data;
}
/**
* @description Returns every cell override still live after last-wins replay, with the revision that wrote the current value
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides/applied
*/
async function listAppliedMfhInvestmentCaseOverrides({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/overrides/applied`,
		...options
	})).data;
}
/**
* @description Commits spreadsheet cell, structural, and display-only design overrides for a D2G investment case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides/commit
*/
async function commitMfhInvestmentCaseOverrides({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/overrides/commit`,
		data,
		...options
	})).data;
}
/**
* @description Returns historical inputs and diffs without loading revision outputs
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/input-preview
*/
async function getMfhInvestmentCaseVersionInputPreview({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/input-preview`,
		...options
	})).data;
}
/**
* @description Lazily recalculates the historical result projection and compact diffs
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/result-preview
*/
async function getMfhInvestmentCaseVersionResultPreview({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/result-preview`,
		...options
	})).data;
}
/**
* @description Lazily recalculates CalcEngine-only historical sheet values and compact diffs
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/sheet-preview
*/
async function getMfhInvestmentCaseVersionSheetPreview({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/sheet-preview`,
		...options
	})).data;
}
/**
* @description Reverts an investment case to a previous immutable version snapshot
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/revert
*/
async function revertMfhInvestmentCaseVersion({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/revert`,
		...options
	})).data;
}
/**
* @description Restores a soft-deleted mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/restore
*/
async function restoreMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/restore`,
		...options
	})).data;
}
/**
* @description Sets an mfh investment-case as the primary case a mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/primary
*/
async function setMfhInvestmentCaseAsPrimary({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/primary`,
		data,
		...options
	})).data;
}
/**
* @description Pins an investment case to an asset-partner profile version and refreshes profile inputs
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/asset-partner-profile-version
*/
async function updateMfhInvestmentCaseAssetPartnerProfileVersion({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/asset-partner-profile-version`,
		data,
		...options
	})).data;
}
/**
* @description Previews investment-case inputs after applying an asset-partner profile version
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/asset-partner-profile-versions/:assetPartnerIcProfileVersionId/inputs-preview
*/
async function getAssetPartnerProfileVersionIcInputs({ mfhId, mfhInvestmentCaseId, assetPartnerIcProfileVersionId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/asset-partner-profile-versions/${assetPartnerIcProfileVersionId}/inputs-preview`,
		...options
	})).data;
}
/**
* @description Recalculates a mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/recalculate
*/
async function recalculateMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/recalculate`,
		data,
		...options
	})).data;
}
/**
* @description Recalculates a sheetless mfh investment-case
* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/recalculate
*/
async function recalculateSheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/recalculate`,
		data,
		...options
	})).data;
}
/**
* @description Get calcengine-inputs for local debugging
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/calc-engine-inputs
*/
async function getCalcengineInputs({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/calc-engine-inputs`,
		...options
	})).data;
}
/**
* @description Runs a bounded calcengine sensitivity sweep for an mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity
*/
async function runMfhInvestmentCaseSensitivity({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity`,
		data,
		...options
	})).data;
}
/**
* @description Starts a durable calcengine auto sensitivity run for an mfh investment-case
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto
*/
async function startMfhInvestmentCaseAutoSensitivity({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/auto`,
		data,
		...options
	})).data;
}
/**
* @description Cancels a durable calcengine auto sensitivity run
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto/cancel
*/
async function cancelMfhInvestmentCaseAutoSensitivity({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/auto/cancel`,
		data,
		...options
	})).data;
}
/**
* @description Streams durable calcengine auto sensitivity progress events
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto/runs/:runId/events
*/
async function subscribeMfhInvestmentCaseAutoSensitivityEvents({ mfhId, mfhInvestmentCaseId, runId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/auto/runs/${runId}/events`,
		params,
		...options
	})).data;
}
/**
* @description Maps a sensitivity winner output map onto the investment-case form inputs
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/takeover-inputs
*/
async function buildSensitivityTakeoverInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/takeover-inputs`,
		data,
		...options
	})).data;
}
/**
* @description Returns list of mfh investment-cases
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/synced-mfh-inputs
*/
async function getSyncedMfhInputs({ mfhInvestmentCaseId, mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/synced-mfh-inputs`,
		...options
	})).data;
}
/**
* @description Returns calculated (already converted to calcengine) values for investment case sheets
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/calculated-values
*/
async function getCalculatedInvestmentCaseValues({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/calculated-values`,
		...options
	})).data;
}
/**
* @description Syncs MFH investment-case inputs without recalculating
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sync
*/
async function syncMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sync`,
		data,
		...options
	})).data;
}
/**
* @description Syncs sheetless MFH investment-case inputs without recalculating
* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/sync
*/
async function syncSheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/sync`,
		data,
		...options
	})).data;
}
/**
* @description Get investment case aggregate for an MFH
* @link /mfh/:mfhId/finance/investment-case-aggregate
*/
async function getMfhInvestmentCaseAggregate({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-case-aggregate`,
		...options
	})).data;
}
/**
* @description Generate or regenerate investment case aggregate for an MFH
* @link /mfh/:mfhId/finance/investment-case-aggregate/generate
*/
async function generateMfhInvestmentCaseAggregate({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-case-aggregate/generate`,
		data,
		...options
	})).data;
}
/**
* @description Adds, edits, or clears the optional title of an investment-case version
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/title
*/
async function updateMfhInvestmentCaseVersionTitle({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/title`,
		data,
		...options
	})).data;
}
/**
* @description Returns the persisted IC teaser for an MFH investment case, or null when none exists
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
*/
async function getIcTeaser({ mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
		...options
	})).data;
}
/**
* @description Builds source data, generates narratives, and persists a new IC teaser
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
*/
async function createIcTeaser({ mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
		data,
		...options
	})).data;
}
/**
* @description Deletes the persisted IC teaser for an MFH investment case
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
*/
async function deleteIcTeaser({ mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
		...options
	})).data;
}
/**
* @description Updates IC teaser narrative fields, source data scalars, or slide configuration without AI generation
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
*/
async function updateIcTeaser({ mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
		data,
		...options
	})).data;
}
/**
* @description Builds fresh IC teaser source data from the live investment case (not persisted)
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/live-source
*/
async function getIcTeaserLiveSourceData({ mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser/live-source`,
		...options
	})).data;
}
/**
* @description Refreshes source data and regenerates all IC teaser narratives via durable job
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/regenerate
*/
async function regenerateIcTeaser({ mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser/regenerate`,
		data,
		...options
	})).data;
}
/**
* @description Synchronously regenerates selected IC teaser narrative fields and returns the updated teaser
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/regenerate-fields
*/
async function regenerateIcTeaserFields({ mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser/regenerate-fields`,
		data,
		...options
	})).data;
}
/**
* @description Evaluate selectable third-party market rent values before automatic investment-case creation
* @link /mfh/:mfhId/finance/investment-cases/automatic/market-rent-sources
*/
async function evaluateAutomaticMfhMarketRentSources({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/automatic/market-rent-sources`,
		...options
	})).data;
}
/**
* @description Create automatic mfh investment-cases from screening-selection cells in one request. Shared context is loaded once; the batch runs in a single transaction. Pass cells for the legacy flat create, or scenarioGroups to persist one retained Shared Base per scenario with linked children.
* @link /mfh/:mfhId/finance/investment-cases/automatic/batch
*/
async function createAutomaticMfhInvestmentCases({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/automatic/batch`,
		data,
		...options
	})).data;
}
/**
* @description Soft-delete several investment cases of one mfh in a single transaction: all are withdrawn or none is. Shared Bases cascade to their children, every refusal is reported at once, and already-deleted cases are skipped so the request can be resent. Supports x-dry-run as a preflight.
* @link /mfh/:mfhId/finance/investment-cases/automatic/withdraw
*/
async function withdrawAutomaticMfhInvestmentCases({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/automatic/withdraw`,
		data,
		...options
	})).data;
}
/**
* @description Create an automatic mfh investment-case in Basecamp without creating D2G Google Sheets
* @link /mfh/:mfhId/finance/investment-cases/automatic
*/
async function createAutomaticMfhInvestmentCase({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/automatic`,
		data,
		...options
	})).data;
}
/**
* @description Save inputs for an automatic mfh investment-case without requiring D2G Google Sheets
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic/inputs
*/
async function setAutomaticMfhInvestmentCaseInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/automatic/inputs`,
		data,
		...options
	})).data;
}
/**
* @description Calculate an automatic mfh investment-case through Calcengine without D2G Google Sheets
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic/calculate
*/
async function calculateAutomaticMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/automatic/calculate`,
		data,
		...options
	})).data;
}
/**
* @description Return an automatic mfh investment-case summary and, when the case was already calculated, the stored calcengine output projection
* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic
*/
async function getAutomaticMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/automatic`,
		...options
	})).data;
}
/**
* @description Returns calcengine-blocking missing inputs for an investment case
* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/missing-inputs
*/
async function getMfhInvestmentCaseMissingInputs({ mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/missing-inputs`,
		...options
	})).data;
}
/**
* @description Returns a single rent-roll version by id
* @link /rent-roll-versions/:rentRollVersionId
*/
async function getRentRollVersion({ rentRollVersionId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/rent-roll-versions/${rentRollVersionId}`,
		params,
		...options
	})).data;
}
/**
* @description Updates a rent-roll version
* @link /rent-roll-versions/:rentRollVersionId
*/
async function updateRentRollVersion({ rentRollVersionId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/rent-roll-versions/${rentRollVersionId}`,
		data,
		...options
	})).data;
}
/**
* @description Deletes a rent-roll version
* @link /rent-roll-versions/:rentRollVersionId
*/
async function deleteRentRollVersion({ rentRollVersionId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/rent-roll-versions/${rentRollVersionId}`,
		...options
	})).data;
}
/**
* @description Returns list of rent-roll versions
* @link /rent-roll-versions
*/
async function findRentRollVersions(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/rent-roll-versions`,
		params,
		...options
	})).data;
}
/**
* @description Creates a new rent-roll version; dryRun validates without writing
* @link /rent-roll-versions
*/
async function createRentRollVersion(data, params, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/rent-roll-versions`,
		params,
		data,
		...options
	})).data;
}
/**
* @description Creates rent-rolls for a rent-roll version
* @link /rent-roll-versions/:rentRollVersionId/rent-rolls
*/
async function createRentRolls({ rentRollVersionId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/rent-roll-versions/${rentRollVersionId}/rent-rolls`,
		data,
		...options
	})).data;
}
/**
* @description Imports Portfolio Analyzer rent-roll rows onto an existing MFH
* @link /mfh/:mfhId/automatic-rent-roll-import
*/
async function importAutomaticRentRoll({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/mfh/${mfhId}/automatic-rent-roll-import`,
		data,
		...options
	})).data;
}
/**
* @description Replaces all rent-roll data for a version; dryRun validates without writing
* @link /rent-roll-versions/:rentRollVersionId/replace-data
*/
async function replaceRentRollVersionData({ rentRollVersionId }, data, params, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/rent-roll-versions/${rentRollVersionId}/replace-data`,
		params,
		data,
		...options
	})).data;
}
/**
* @description Updates a rent-roll
* @link /rent-rolls/:rentRollId
*/
async function updateRentRoll({ rentRollId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/rent-rolls/${rentRollId}`,
		data,
		...options
	})).data;
}
/**
* @description Deletes multiple rent-rolls in bulk
* @link /rent-rolls/delete
*/
async function deleteRentRolls(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/rent-rolls/delete`,
		data,
		...options
	})).data;
}
/**
* @description Processes an event on a rent-roll version
* @link /rent-roll-versions/:rentRollVersionId/event
*/
async function processRentRollVersionEvent({ rentRollVersionId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/rent-roll-versions/${rentRollVersionId}/event`,
		data,
		...options
	})).data;
}
/**
* @link /user-tasks
*/
async function findUserTasks(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/user-tasks`,
		params,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId
*/
async function getUserTask({ userTaskId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/user-task/${userTaskId}`,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId
*/
async function deleteUserTask({ userTaskId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/user-task/${userTaskId}`,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId/reject
*/
async function rejectUserTask({ userTaskId }, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/user-task/${userTaskId}/reject`,
		...options
	})).data;
}
/**
* @link /user-task/classify-documents
*/
async function classifyDocuments(params, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-task/classify-documents`,
		params,
		...options
	})).data;
}
/**
* @link /user-task/classify-documents-email
*/
async function classifyDocumentsEmail(options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-task/classify-documents-email`,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId/classify-document/classification-result
*/
async function updateDocumentClassificationResult({ userTaskId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-task/${userTaskId}/classify-document/classification-result`,
		data,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId/portfolio-analyzer/complete
*/
async function completeAnalyzePortfolioUserTask({ userTaskId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-task/${userTaskId}/portfolio-analyzer/complete`,
		data,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId/portfolio-analyzer/result
*/
async function updatePortfolioAnalyzerResult({ userTaskId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-task/${userTaskId}/portfolio-analyzer/result`,
		data,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId/portfolio-analyzer/progress
*/
async function updatePortfolioAnalyzerProgress({ userTaskId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-task/${userTaskId}/portfolio-analyzer/progress`,
		data,
		...options
	})).data;
}
/**
* @link /user-task/:userTaskId/classify-document/user-confirmation
*/
async function confirmDocumentClassification({ userTaskId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/user-task/${userTaskId}/classify-document/user-confirmation`,
		data,
		...options
	})).data;
}
const operations = {
	findRoleBindingsByUser: {
		path: "/authz/users/:userId/role-bindings",
		method: "get"
	},
	bindRolesToUser: {
		path: "/authz/users/:userId/role-bindings",
		method: "post"
	},
	findRoleBindings: {
		path: "/authz/role-bindings",
		method: "get"
	},
	createSessionCookie: {
		path: "/authz/session-cookie",
		method: "post"
	},
	updateRole: {
		path: "/authz/roles/:roleId",
		method: "patch"
	},
	deleteRole: {
		path: "/authz/roles/:roleId",
		method: "delete"
	},
	bulkUpdateRoles: {
		path: "/authz/roles/bulk",
		method: "patch"
	},
	createRole: {
		path: "/authz/roles",
		method: "post"
	},
	findRoles: {
		path: "/authz/roles",
		method: "get"
	},
	findPermissions: {
		path: "/authz/permissions",
		method: "get"
	},
	updateDocument: {
		path: "/document",
		method: "patch"
	},
	findDocuments: {
		path: "/document",
		method: "get"
	},
	deleteDocumentByUuid: {
		path: "/document",
		method: "delete"
	},
	createDocumentRelation: {
		path: "/document-relation",
		method: "post"
	},
	updateDocumentRelation: {
		path: "/document-relation/:documentRelationId",
		method: "put"
	},
	getDocument: {
		path: "/document/:documentId",
		method: "get"
	},
	deleteFile: {
		path: "/document/:documentId",
		method: "delete"
	},
	createDocumentAnnotation: {
		path: "/documents/:documentId/annotations",
		method: "post"
	},
	updateDocumentAnnotation: {
		path: "/documents/:documentId/annotations/:annotationId",
		method: "patch"
	},
	deleteDocumentAnnotation: {
		path: "/documents/:documentId/annotations/:annotationId",
		method: "delete"
	},
	generateDocumentSync: {
		path: "/documents/sync",
		method: "post"
	},
	generateDocumentFromPayload: {
		path: "/document/generate",
		method: "post"
	},
	generatePdfFromHtml: {
		path: "/document/generate-pdf-from-html",
		method: "post"
	},
	getStaticMapImage: {
		path: "/document/static-map",
		method: "get"
	},
	getQuestionAnswerOfDocumentTemplateParams: {
		path: "/estate/:estateId/document/:documentType",
		method: "get"
	},
	getDocumentTemplate: {
		path: "/document-template/:documentType",
		method: "get"
	},
	sendDocumentsByEmail: {
		path: "/documents/email",
		method: "post"
	},
	createDocumentGptParseRequests: {
		path: "/documents/gpt-parse-request",
		method: "post"
	},
	deleteDocumentFolder: {
		path: "/documents-folder/:folderId",
		method: "delete"
	},
	findDocumentsFolders: {
		path: "/documents-folder",
		method: "get"
	},
	saveDocumentFolder: {
		path: "/documents-folder",
		method: "post"
	},
	moveDocumentsOfFolders: {
		path: "/documents-folder/move",
		method: "post"
	},
	copyDocumentsOrFolders: {
		path: "/documents-folder/copy",
		method: "post"
	},
	updateMultipleDocuments: {
		path: "/documents",
		method: "patch"
	},
	convertImagesToPdf: {
		path: "/documents/convert/images-pdf",
		method: "post"
	},
	getDataRooms: {
		path: "/data-room",
		method: "get"
	},
	saveDataRoom: {
		path: "/data-room",
		method: "post"
	},
	getOneDataRoom: {
		path: "/data-room/:dataRoomId",
		method: "get"
	},
	deleteDataRoom: {
		path: "/data-room/:dataRoomId",
		method: "delete"
	},
	generateFolderStructure: {
		path: "/documents-folder/generate-folder-structure",
		method: "post"
	},
	createLinkDocument: {
		path: "/link-documents",
		method: "post"
	},
	getGoogleSheetMetaData: {
		path: "/google-sheet-metadata",
		method: "get"
	},
	findRenovationScenarios: {
		path: "/renovation-scenarios",
		method: "get"
	},
	createRenovationScenario: {
		path: "/renovation-scenarios",
		method: "post"
	},
	getRenovationScenario: {
		path: "/renovation-scenarios/:renovationScenarioId",
		method: "get"
	},
	updateRenovationScenarioMetadata: {
		path: "/renovation-scenarios/:renovationScenarioId",
		method: "patch"
	},
	saveRenovationScenarioParameters: {
		path: "/renovation-scenarios/:renovationScenarioId/parameters",
		method: "put"
	},
	findRenovationScenarioConfigs: {
		path: "/renovation-scenarios/:renovationScenarioId/configs",
		method: "get"
	},
	getRenovationScenarioConfig: {
		path: "/renovation-scenarios/:renovationScenarioId/configs/:version",
		method: "get"
	},
	saveSepaMandates: {
		path: "/sepa-mandate",
		method: "post"
	},
	getSepaMandates: {
		path: "/sepa-mandate",
		method: "get"
	},
	deleteSepaMandate: {
		path: "/sepa-mandate/:sepaMandateId",
		method: "delete"
	},
	bulkCreateMFHFromCSV: {
		path: "/mfh/csv",
		method: "post"
	},
	getMFHList: {
		path: "/mfh",
		method: "get"
	},
	createMFH: {
		path: "/mfh",
		method: "post"
	},
	findMfhsByNormalizedAddress: {
		path: "/mfh/by-normalized-address",
		method: "get"
	},
	getOneMFHForSummary: {
		path: "/mfh/:mfhId/summary",
		method: "get"
	},
	getMFHSourcingList: {
		path: "/mfh-sourcing-list",
		method: "get"
	},
	getEligibleAssetsList: {
		path: "/eligible-assets",
		method: "get"
	},
	getAssetsInPipelineList: {
		path: "/assets-in-pipeline",
		method: "get"
	},
	getPipelineMfhPortfolios: {
		path: "/pipeline-mfh-portfolios",
		method: "get"
	},
	getMFHWithExpand: {
		path: "/mfh/:mfhId",
		method: "post"
	},
	updateMFH: {
		path: "/mfh/:mfhId",
		method: "patch"
	},
	getMFHEstates: {
		path: "/mfh/:mfhId/estates",
		method: "get"
	},
	getMfhContacts: {
		path: "/mfh/:mfhId/contacts",
		method: "get"
	},
	getMfhCandidatePortfolioRelations: {
		path: "/mfh/:mfhId/candidate-portfolio-relations",
		method: "get"
	},
	getMfhTasks: {
		path: "/mfh/:mfhId/tasks",
		method: "get"
	},
	getMfhTaskMilestoneReport: {
		path: "/mfh/:mfhId/task-milestone-report",
		method: "get"
	},
	getMfhTaskHierarchy: {
		path: "/mfh/:mfhId/task-hierarchy",
		method: "get"
	},
	getMfhStats: {
		path: "/mfh/:mfhId/stats",
		method: "get"
	},
	getMfhProjectPlanSnapshots: {
		path: "/mfh/:mfhId/project-plan-snapshots",
		method: "get"
	},
	createMfhProjectPlanSnapshot: {
		path: "/mfh/:mfhId/project-plan-snapshot",
		method: "post"
	},
	deleteMfhProjectPlanSnapshot: {
		path: "/mfh/project-plan-snapshot/:mfhProjectPlanId",
		method: "delete"
	},
	createAutomaticPortfolioWithAsset: {
		path: "/mfh/automatic-asset",
		method: "post"
	},
	fetchMfhAttributesFromInfas: {
		path: "/mfh/:mfhId/infas-attributes",
		method: "get"
	},
	createMfhAttributeParseRequest: {
		path: "/mfh/:mfhId/attribute-gpt-parse-request",
		method: "post"
	},
	createMfhEstate: {
		path: "/mfh/buildings/:mfhBuildingId/estates",
		method: "post"
	},
	moveEstatesToBuildingLocation: {
		path: "/mfh/estates/move/building/:mfhBuildingId",
		method: "patch"
	},
	getMfhHierarchy: {
		path: "/mfh/:mfhId/mfh-hierarchy",
		method: "get"
	},
	getMFHEstarCoreEstates: {
		path: "/mfh/:mfhId/estarcore-estates",
		method: "get"
	},
	getEstarCoreMFHIds: {
		path: "/mfh/estarcore-mfh-ids",
		method: "get"
	},
	restoreAssetLedger: {
		path: "/mfh/:mfhId/restore-ledger",
		method: "post"
	},
	getAssetsInPipelineConfig: {
		path: "/assets-in-pipeline/config",
		method: "get"
	},
	getMFHExternalUnits: {
		path: "/mfh/:mfhId/external-units",
		method: "get"
	},
	getMfhElementImportSheetUrl: {
		path: "/mfh/elements/import-sheet-url",
		method: "get"
	},
	parseMfhElementsFromSheet: {
		path: "/mfh/elements/parse-from-sheet",
		method: "post"
	},
	getMfhElements: {
		path: "/mfh/:mfhId/elements",
		method: "get"
	},
	saveMfhElements: {
		path: "/mfh/:mfhId/elements",
		method: "post"
	},
	updateMfhElement: {
		path: "/mfh/elements/:mfhElementId",
		method: "patch"
	},
	deleteMfhElements: {
		path: "/mfh/elements",
		method: "delete"
	},
	getAssetRentRoll: {
		path: "/mfh/:mfhId/asset-rent-roll",
		method: "get"
	},
	grantMfhPartnerImpersonation: {
		path: "/mfhs/:mfhId/grant-portal-view",
		method: "post"
	},
	getMfhPlacements: {
		path: "/mfhs/:mfhId/placements",
		method: "get"
	},
	getMfhLatestPlacement: {
		path: "/mfhs/:mfhId/placement/latest",
		method: "get"
	},
	getMfhPlacementBuyBox: {
		path: "/mfhs/:mfhId/placement/buy-box",
		method: "get"
	},
	updateMfhPlacement: {
		path: "/mfhs/placements/:mfhPlacementId",
		method: "patch"
	},
	updateMfhPlacementIcResponse: {
		path: "/mfhs/placements/ics/:mfhPlacementICId/response",
		method: "patch"
	},
	consumePortalHandoff: {
		path: "/portal-handoff/consume",
		method: "post"
	},
	findMFHInvestmentCasesByMFH: {
		path: "/mfh/:mfhId/finance/investment-cases",
		method: "get"
	},
	createEmptyMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases",
		method: "post"
	},
	deleteMFHInvestmentCases: {
		path: "/mfh/:mfhId/finance/investment-cases",
		method: "delete"
	},
	evaluateMfhInvestmentCasePartnerBuyBox: {
		path: "/mfh/:mfhId/finance/investment-cases/evaluate-partner-buy-box",
		method: "post"
	},
	screenMfhInvestmentCasePartnerRenovationCell: {
		path: "/mfh/:mfhId/finance/investment-cases/screening-cell",
		method: "post"
	},
	screenMfhInvestmentCasePartnerRenovationMatrix: {
		path: "/mfh/:mfhId/finance/investment-cases/screening-matrix",
		method: "post"
	},
	getD2GVersions: {
		path: "/mfh/finance/d2g-versions",
		method: "get"
	},
	findAssetPartnerIcProfiles: {
		path: "/mfh/finance/asset-partner-ic-profiles",
		method: "get"
	},
	createAssetPartnerIcProfile: {
		path: "/mfh/finance/asset-partner-ic-profiles",
		method: "post"
	},
	findAssetPartnerIcProfileVersions: {
		path: "/mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId/versions",
		method: "get"
	},
	getAssetPartnerIcProfileVersion: {
		path: "/mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId/versions/:assetPartnerIcProfileVersionId",
		method: "get"
	},
	updateAssetPartnerIcProfile: {
		path: "/mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId",
		method: "patch"
	},
	deleteAssetPartnerIcProfile: {
		path: "/mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId",
		method: "delete"
	},
	getMFHRentIndexLookup: {
		path: "/mfh/:mfhId/finance/investment-cases/rent-index-lookup",
		method: "get"
	},
	generateRentMarketData: {
		path: "/mfh/:mfhId/finance/rent-market-data",
		method: "get"
	},
	getMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId",
		method: "get"
	},
	updateMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId",
		method: "patch"
	},
	deleteMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId",
		method: "delete"
	},
	getApprovedMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/approved",
		method: "get"
	},
	triggerMFHInvestmentCaseReadCopySync: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sync-read-copy",
		method: "post"
	},
	readMFHInvestmentCaseOutputs: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/read-outputs",
		method: "get"
	},
	downloadMfhInvestmentCaseSheet: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/download-mfh-investment-case-sheet",
		method: "get"
	},
	uploadMfhInvestmentCaseReviewedSheet: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/upload-reviewed-sheet",
		method: "post"
	},
	createBaseMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/base-investment-cases",
		method: "post"
	},
	fetchBaseMFHInvestmentCases: {
		path: "/mfh/:mfhId/finance/base-investment-cases",
		method: "get"
	},
	saveBaseMFHInvestmentCaseInputs: {
		path: "/mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/inputs",
		method: "patch"
	},
	fanOutBaseMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/fan-out",
		method: "post"
	},
	checkBaseMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/check",
		method: "post"
	},
	propagateBaseMFHInvestmentCaseInputs: {
		path: "/mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/propagate-inputs",
		method: "post"
	},
	calculateBaseMFHInvestmentCaseChildren: {
		path: "/mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/calculate-children",
		method: "post"
	},
	createSheetlessMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/sheetless-investment-cases",
		method: "post"
	},
	importMFHInvestmentCaseFromJson: {
		path: "/mfh/:mfhId/finance/investment-cases/import-from-json",
		method: "post"
	},
	exportMFHInvestmentCaseAsJson: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/export-as-json",
		method: "get"
	},
	prepareMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/prepare",
		method: "post"
	},
	changeAndRecreateMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/change-and-recreate",
		method: "post"
	},
	changeAndRecreateSheetlessMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/change-and-recreate",
		method: "post"
	},
	copyMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy",
		method: "post"
	},
	copySheetlessMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/copy",
		method: "post"
	},
	copyAndChangeAssetPartnerMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy-and-change-asset-partner",
		method: "post"
	},
	copyAndChangeAssetPartnerSheetlessMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/copy-and-change-asset-partner",
		method: "post"
	},
	copyMFHInvestmentCaseToAssetManagement: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy-to-asset-management",
		method: "post"
	},
	listMFHInvestmentCaseVersions: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions",
		method: "get"
	},
	listMFHInvestmentCaseOverrideGroups: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides",
		method: "get"
	},
	getMFHInvestmentCaseCell: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/cell",
		method: "get"
	},
	listAppliedMFHInvestmentCaseOverrides: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides/applied",
		method: "get"
	},
	commitMFHInvestmentCaseOverrides: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides/commit",
		method: "post"
	},
	getMFHInvestmentCaseVersionInputPreview: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/input-preview",
		method: "get"
	},
	getMFHInvestmentCaseVersionResultPreview: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/result-preview",
		method: "get"
	},
	getMFHInvestmentCaseVersionSheetPreview: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/sheet-preview",
		method: "get"
	},
	revertMFHInvestmentCaseVersion: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/revert",
		method: "post"
	},
	restoreMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/restore",
		method: "put"
	},
	setMFHInvestmentCaseAsPrimary: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/primary",
		method: "post"
	},
	updateMFHInvestmentCaseAssetPartnerProfileVersion: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/asset-partner-profile-version",
		method: "post"
	},
	getAssetPartnerProfileVersionIcInputs: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/asset-partner-profile-versions/:assetPartnerIcProfileVersionId/inputs-preview",
		method: "get"
	},
	recalculateMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/recalculate",
		method: "post"
	},
	recalculateSheetlessMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/recalculate",
		method: "post"
	},
	getCalcengineInputs: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/calc-engine-inputs",
		method: "post"
	},
	runMFHInvestmentCaseSensitivity: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity",
		method: "post"
	},
	startMFHInvestmentCaseAutoSensitivity: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto",
		method: "post"
	},
	cancelMFHInvestmentCaseAutoSensitivity: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto/cancel",
		method: "post"
	},
	subscribeMFHInvestmentCaseAutoSensitivityEvents: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto/runs/:runId/events",
		method: "get"
	},
	buildSensitivityTakeoverInputs: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/takeover-inputs",
		method: "post"
	},
	getSyncedMFHInputs: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/synced-mfh-inputs",
		method: "get"
	},
	getCalculatedInvestmentCaseValues: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/calculated-values",
		method: "get"
	},
	syncMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sync",
		method: "post"
	},
	syncSheetlessMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/sync",
		method: "post"
	},
	getMFHInvestmentCaseAggregate: {
		path: "/mfh/:mfhId/finance/investment-case-aggregate",
		method: "get"
	},
	generateMFHInvestmentCaseAggregate: {
		path: "/mfh/:mfhId/finance/investment-case-aggregate/generate",
		method: "post"
	},
	updateMFHInvestmentCaseVersionTitle: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/title",
		method: "patch"
	},
	getICTeaser: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser",
		method: "get"
	},
	createICTeaser: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser",
		method: "post"
	},
	deleteICTeaser: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser",
		method: "delete"
	},
	updateICTeaser: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser",
		method: "patch"
	},
	getICTeaserLiveSourceData: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/live-source",
		method: "get"
	},
	regenerateICTeaser: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/regenerate",
		method: "post"
	},
	regenerateICTeaserFields: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/regenerate-fields",
		method: "post"
	},
	evaluateAutomaticMFHMarketRentSources: {
		path: "/mfh/:mfhId/finance/investment-cases/automatic/market-rent-sources",
		method: "get"
	},
	createAutomaticMFHInvestmentCases: {
		path: "/mfh/:mfhId/finance/investment-cases/automatic/batch",
		method: "post"
	},
	withdrawAutomaticMFHInvestmentCases: {
		path: "/mfh/:mfhId/finance/investment-cases/automatic/withdraw",
		method: "post"
	},
	createAutomaticMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/automatic",
		method: "post"
	},
	setAutomaticMFHInvestmentCaseInputs: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic/inputs",
		method: "post"
	},
	calculateAutomaticMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic/calculate",
		method: "post"
	},
	getAutomaticMFHInvestmentCase: {
		path: "/mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic",
		method: "get"
	},
	getMFHInvestmentCaseMissingInputs: {
		path: "/mfh/finance/investment-cases/:mfhInvestmentCaseId/missing-inputs",
		method: "get"
	},
	getRentRollVersion: {
		path: "/rent-roll-versions/:rentRollVersionId",
		method: "get"
	},
	updateRentRollVersion: {
		path: "/rent-roll-versions/:rentRollVersionId",
		method: "put"
	},
	deleteRentRollVersion: {
		path: "/rent-roll-versions/:rentRollVersionId",
		method: "delete"
	},
	findRentRollVersions: {
		path: "/rent-roll-versions",
		method: "get"
	},
	createRentRollVersion: {
		path: "/rent-roll-versions",
		method: "post"
	},
	createRentRolls: {
		path: "/rent-roll-versions/:rentRollVersionId/rent-rolls",
		method: "post"
	},
	importAutomaticRentRoll: {
		path: "/mfh/:mfhId/automatic-rent-roll-import",
		method: "post"
	},
	replaceRentRollVersionData: {
		path: "/rent-roll-versions/:rentRollVersionId/replace-data",
		method: "put"
	},
	updateRentRoll: {
		path: "/rent-rolls/:rentRollId",
		method: "put"
	},
	deleteRentRolls: {
		path: "/rent-rolls/delete",
		method: "post"
	},
	processRentRollVersionEvent: {
		path: "/rent-roll-versions/:rentRollVersionId/event",
		method: "post"
	},
	findUserTasks: {
		path: "/user-tasks",
		method: "get"
	},
	getUserTask: {
		path: "/user-task/:userTaskId",
		method: "get"
	},
	deleteUserTask: {
		path: "/user-task/:userTaskId",
		method: "delete"
	},
	rejectUserTask: {
		path: "/user-task/:userTaskId/reject",
		method: "put"
	},
	classifyDocuments: {
		path: "/user-task/classify-documents",
		method: "post"
	},
	classifyDocumentsEmail: {
		path: "/user-task/classify-documents-email",
		method: "post"
	},
	updateDocumentClassificationResult: {
		path: "/user-task/:userTaskId/classify-document/classification-result",
		method: "post"
	},
	completeAnalyzePortfolioUserTask: {
		path: "/user-task/:userTaskId/portfolio-analyzer/complete",
		method: "post"
	},
	updatePortfolioAnalyzerResult: {
		path: "/user-task/:userTaskId/portfolio-analyzer/result",
		method: "post"
	},
	updatePortfolioAnalyzerProgress: {
		path: "/user-task/:userTaskId/portfolio-analyzer/progress",
		method: "post"
	},
	confirmDocumentClassification: {
		path: "/user-task/:userTaskId/classify-document/user-confirmation",
		method: "put"
	}
};
//#endregion
//#region src/basecamp/gen/clients/axios-class-client.ts
var BasecampSdk = class {
	client;
	constructor(client) {
		this.client = client;
	}
	async axiosClient(config) {
		return this.client.request({ ...config }).catch((e) => {
			throw e;
		});
	}
	/**
	* @description Returns role bindings for a user
	* @link /authz/users/:userId/role-bindings
	*/
	async findRoleBindingsByUser({ userId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/authz/users/${userId}/role-bindings`,
			...options
		})).data;
	}
	/**
	* @description Binds roles to a user
	* @link /authz/users/:userId/role-bindings
	*/
	async bindRolesToUser({ userId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/authz/users/${userId}/role-bindings`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns role bindings
	* @link /authz/role-bindings
	*/
	async findRoleBindings(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/authz/role-bindings`,
			...options
		})).data;
	}
	/**
	* @description Creates a session cookie for username and password login
	* @link /authz/session-cookie
	*/
	async createSessionCookie(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/authz/session-cookie`,
			data,
			...options
		})).data;
	}
	/**
	* @description Updates a role
	* @link /authz/roles/:roleId
	*/
	async updateRole({ roleId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/authz/roles/${roleId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes a role
	* @link /authz/roles/:roleId
	*/
	async deleteRole({ roleId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/authz/roles/${roleId}`,
			...options
		})).data;
	}
	/**
	* @description Updates roles in bulk
	* @link /authz/roles/bulk
	*/
	async bulkUpdateRoles(data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/authz/roles/bulk`,
			data,
			...options
		})).data;
	}
	/**
	* @description Creates a role
	* @link /authz/roles
	*/
	async createRole(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/authz/roles`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns roles matching the query
	* @link /authz/roles
	*/
	async findRoles(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/authz/roles`,
			params,
			...options
		})).data;
	}
	/**
	* @description Returns available permissions
	* @link /authz/permissions
	*/
	async findPermissions(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/authz/permissions`,
			...options
		})).data;
	}
	/** @link /document */
	async updateDocument(data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/document`,
			data,
			...options
		})).data;
	}
	/** @link /document */
	async findDocuments(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/document`,
			params,
			...options
		})).data;
	}
	/** @link /document */
	async deleteDocumentByUuid(params, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/document`,
			params,
			...options
		})).data;
	}
	/** @link /document-relation */
	async createDocumentRelation(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/document-relation`,
			data,
			...options
		})).data;
	}
	/** @link /document-relation/:documentRelationId */
	async updateDocumentRelation({ documentRelationId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/document-relation/${documentRelationId}`,
			data,
			...options
		})).data;
	}
	/** @link /document/:documentId */
	async getDocument({ documentId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/document/${documentId}`,
			params,
			...options
		})).data;
	}
	/** @link /document/:documentId */
	async deleteFile({ documentId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/document/${documentId}`,
			...options
		})).data;
	}
	/** @link /documents/:documentId/annotations */
	async createDocumentAnnotation({ documentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents/${documentId}/annotations`,
			data,
			...options
		})).data;
	}
	/** @link /documents/:documentId/annotations/:annotationId */
	async updateDocumentAnnotation({ documentId, annotationId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/documents/${documentId}/annotations/${annotationId}`,
			data,
			...options
		})).data;
	}
	/** @link /documents/:documentId/annotations/:annotationId */
	async deleteDocumentAnnotation({ documentId, annotationId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/documents/${documentId}/annotations/${annotationId}`,
			...options
		})).data;
	}
	/** @link /documents/sync */
	async generateDocumentSync(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents/sync`,
			data,
			...options
		})).data;
	}
	/** @link /document/generate */
	async generateDocumentFromPayload(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/document/generate`,
			data,
			...options
		})).data;
	}
	/** @link /document/generate-pdf-from-html */
	async generatePdfFromHtml(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/document/generate-pdf-from-html`,
			data,
			...options
		})).data;
	}
	/** @link /document/static-map */
	async getStaticMapImage(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/document/static-map`,
			params,
			...options
		})).data;
	}
	/** @link /estate/:estateId/document/:documentType */
	async getQuestionAnswerOfDocumentTemplateParams({ estateId, documentType }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/estate/${estateId}/document/${documentType}`,
			...options
		})).data;
	}
	/** @link /document-template/:documentType */
	async getDocumentTemplate({ documentType }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/document-template/${documentType}`,
			params,
			...options
		})).data;
	}
	/** @link /documents/email */
	async sendDocumentsByEmail(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents/email`,
			data,
			...options
		})).data;
	}
	/** @link /documents/gpt-parse-request */
	async createDocumentGptParseRequests(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents/gpt-parse-request`,
			data,
			...options
		})).data;
	}
	/** @link /documents-folder/:folderId */
	async deleteDocumentFolder({ folderId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/documents-folder/${folderId}`,
			...options
		})).data;
	}
	/** @link /documents-folder */
	async findDocumentsFolders(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/documents-folder`,
			params,
			...options
		})).data;
	}
	/** @link /documents-folder */
	async saveDocumentFolder(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents-folder`,
			data,
			...options
		})).data;
	}
	/** @link /documents-folder/move */
	async moveDocumentsOfFolders(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents-folder/move`,
			data,
			...options
		})).data;
	}
	/** @link /documents-folder/copy */
	async copyDocumentsOrFolders(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents-folder/copy`,
			data,
			...options
		})).data;
	}
	/** @link /documents */
	async updateMultipleDocuments(data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/documents`,
			data,
			...options
		})).data;
	}
	/** @link /documents/convert/images-pdf */
	async convertImagesToPdf(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents/convert/images-pdf`,
			data,
			...options
		})).data;
	}
	/** @link /data-room */
	async getDataRooms(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/data-room`,
			params,
			...options
		})).data;
	}
	/** @link /data-room */
	async saveDataRoom(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/data-room`,
			data,
			...options
		})).data;
	}
	/** @link /data-room/:dataRoomId */
	async getOneDataRoom({ dataRoomId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/data-room/${dataRoomId}`,
			params,
			...options
		})).data;
	}
	/** @link /data-room/:dataRoomId */
	async deleteDataRoom({ dataRoomId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/data-room/${dataRoomId}`,
			...options
		})).data;
	}
	/** @link /documents-folder/generate-folder-structure */
	async generateFolderStructure(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/documents-folder/generate-folder-structure`,
			data,
			...options
		})).data;
	}
	/** @link /link-documents */
	async createLinkDocument(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/link-documents`,
			data,
			...options
		})).data;
	}
	/** @link /google-sheet-metadata */
	async getGoogleSheetMetaData(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/google-sheet-metadata`,
			params,
			...options
		})).data;
	}
	/**
	* @description List renovation strategy scenarios (current configs only)
	* @link /renovation-scenarios
	*/
	async findRenovationScenarios(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/renovation-scenarios`,
			params,
			...options
		})).data;
	}
	/**
	* @description Create renovation scenario with config version 1
	* @link /renovation-scenarios
	*/
	async createRenovationScenario(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/renovation-scenarios`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get renovation scenario detail with current parameters
	* @link /renovation-scenarios/:renovationScenarioId
	*/
	async getRenovationScenario({ renovationScenarioId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/renovation-scenarios/${renovationScenarioId}`,
			...options
		})).data;
	}
	/**
	* @description Update renovation scenario metadata (no config bump)
	* @link /renovation-scenarios/:renovationScenarioId
	*/
	async updateRenovationScenarioMetadata({ renovationScenarioId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/renovation-scenarios/${renovationScenarioId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Save renovation scenario (metadata and/or parameters, new config or no-op)
	* @link /renovation-scenarios/:renovationScenarioId/parameters
	*/
	async saveRenovationScenarioParameters({ renovationScenarioId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/renovation-scenarios/${renovationScenarioId}/parameters`,
			data,
			...options
		})).data;
	}
	/**
	* @description List config history for a renovation scenario
	* @link /renovation-scenarios/:renovationScenarioId/configs
	*/
	async findRenovationScenarioConfigs({ renovationScenarioId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/renovation-scenarios/${renovationScenarioId}/configs`,
			...options
		})).data;
	}
	/**
	* @description Get a specific renovation scenario config
	* @link /renovation-scenarios/:renovationScenarioId/configs/:version
	*/
	async getRenovationScenarioConfig({ renovationScenarioId, version }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/renovation-scenarios/${renovationScenarioId}/configs/${version}`,
			...options
		})).data;
	}
	/**
	* @description Save SEPA mandate
	* @link /sepa-mandate
	*/
	async saveSepaMandates(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/sepa-mandate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns list of SEPA Mandates
	* @link /sepa-mandate
	*/
	async getSepaMandates(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/sepa-mandate`,
			params,
			...options
		})).data;
	}
	/**
	* @description Delete one sepa mandate
	* @link /sepa-mandate/:sepaMandateId
	*/
	async deleteSepaMandate({ sepaMandateId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/sepa-mandate/${sepaMandateId}`,
			...options
		})).data;
	}
	/** @link /mfh/csv */
	async bulkCreateMfhFromCsv(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/csv`,
			data,
			...options
		})).data;
	}
	/** @link /mfh */
	async getMfhList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh`,
			params,
			...options
		})).data;
	}
	/** @link /mfh */
	async createMfh(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/by-normalized-address */
	async findMfhsByNormalizedAddress(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/by-normalized-address`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/summary */
	async getOneMfhForSummary({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/summary`,
			params,
			...options
		})).data;
	}
	/** @link /mfh-sourcing-list */
	async getMfhSourcingList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh-sourcing-list`,
			params,
			...options
		})).data;
	}
	/** @link /eligible-assets */
	async getEligibleAssetsList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/eligible-assets`,
			params,
			...options
		})).data;
	}
	/** @link /assets-in-pipeline */
	async getAssetsInPipelineList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/assets-in-pipeline`,
			params,
			...options
		})).data;
	}
	/** @link /pipeline-mfh-portfolios */
	async getPipelineMfhPortfolios(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/pipeline-mfh-portfolios`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId */
	async getMfhWithExpand({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId */
	async updateMfh({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/${mfhId}`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/estates */
	async getMfhEstates({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/estates`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/contacts */
	async getMfhContacts({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/contacts`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/candidate-portfolio-relations */
	async getMfhCandidatePortfolioRelations({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/candidate-portfolio-relations`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/tasks */
	async getMfhTasks({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/tasks`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/task-milestone-report */
	async getMfhTaskMilestoneReport({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/task-milestone-report`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/task-hierarchy */
	async getMfhTaskHierarchy({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/task-hierarchy`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/stats */
	async getMfhStats({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/stats`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/project-plan-snapshots */
	async getMfhProjectPlanSnapshots({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/project-plan-snapshots`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/project-plan-snapshot */
	async createMfhProjectPlanSnapshot({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/project-plan-snapshot`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/project-plan-snapshot/:mfhProjectPlanId */
	async deleteMfhProjectPlanSnapshot({ mfhProjectPlanId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/mfh/project-plan-snapshot/${mfhProjectPlanId}`,
			...options
		})).data;
	}
	/** @link /mfh/automatic-asset */
	async createAutomaticPortfolioWithAsset(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/automatic-asset`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/infas-attributes */
	async fetchMfhAttributesFromInfas({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/infas-attributes`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/attribute-gpt-parse-request */
	async createMfhAttributeParseRequest({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/attribute-gpt-parse-request`,
			...options
		})).data;
	}
	/** @link /mfh/buildings/:mfhBuildingId/estates */
	async createMfhEstate({ mfhBuildingId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/buildings/${mfhBuildingId}/estates`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/estates/move/building/:mfhBuildingId */
	async moveEstatesToBuildingLocation({ mfhBuildingId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/estates/move/building/${mfhBuildingId}`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/mfh-hierarchy */
	async getMfhHierarchy({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/mfh-hierarchy`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/estarcore-estates */
	async getMfhEstarCoreEstates({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/estarcore-estates`,
			...options
		})).data;
	}
	/** @link /mfh/estarcore-mfh-ids */
	async getEstarCoreMfhIds(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/estarcore-mfh-ids`,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/restore-ledger */
	async restoreAssetLedger({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/restore-ledger`,
			...options
		})).data;
	}
	/** @link /assets-in-pipeline/config */
	async getAssetsInPipelineConfig(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/assets-in-pipeline/config`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/external-units */
	async getMfhExternalUnits({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/external-units`,
			...options
		})).data;
	}
	/** @link /mfh/elements/import-sheet-url */
	async getMfhElementImportSheetUrl(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/elements/import-sheet-url`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/elements/parse-from-sheet */
	async parseMfhElementsFromSheet(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/elements/parse-from-sheet`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/elements */
	async getMfhElements({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/elements`,
			params,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/elements */
	async saveMfhElements({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/elements`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/elements/:mfhElementId */
	async updateMfhElement({ mfhElementId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/elements/${mfhElementId}`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/elements */
	async deleteMfhElements(data, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/mfh/elements`,
			data,
			...options
		})).data;
	}
	/** @link /mfh/:mfhId/asset-rent-roll */
	async getAssetRentRoll({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/asset-rent-roll`,
			...options
		})).data;
	}
	/** @link /mfhs/:mfhId/grant-portal-view */
	async grantMfhPartnerImpersonation({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfhs/${mfhId}/grant-portal-view`,
			data,
			...options
		})).data;
	}
	/** @link /mfhs/:mfhId/placements */
	async getMfhPlacements({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfhs/${mfhId}/placements`,
			params,
			...options
		})).data;
	}
	/** @link /mfhs/:mfhId/placement/latest */
	async getMfhLatestPlacement({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfhs/${mfhId}/placement/latest`,
			params,
			...options
		})).data;
	}
	/** @link /mfhs/:mfhId/placement/buy-box */
	async getMfhPlacementBuyBox({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfhs/${mfhId}/placement/buy-box`,
			params,
			...options
		})).data;
	}
	/** @link /mfhs/placements/:mfhPlacementId */
	async updateMfhPlacement({ mfhPlacementId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfhs/placements/${mfhPlacementId}`,
			data,
			...options
		})).data;
	}
	/** @link /mfhs/placements/ics/:mfhPlacementICId/response */
	async updateMfhPlacementIcResponse({ mfhPlacementIcId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfhs/placements/ics/${mfhPlacementIcId}/response`,
			data,
			...options
		})).data;
	}
	/** @link /portal-handoff/consume */
	async consumePortalHandoff(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/portal-handoff/consume`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns list of mfh investment-cases
	* @link /mfh/:mfhId/finance/investment-cases
	*/
	async findMfhInvestmentCasesByMfh({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases`,
			params,
			...options
		})).data;
	}
	/**
	* @description Create an empty mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases
	*/
	async createEmptyMfhInvestmentCase({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete MFH-Investment-Cases for a given mfh
	* @link /mfh/:mfhId/finance/investment-cases
	*/
	async deleteMfhInvestmentCases({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/mfh/${mfhId}/finance/investment-cases`,
			...options
		})).data;
	}
	/**
	* @description Evaluates calculated investment cases against each case's asset-partner buy-box thresholds. Uncalculated cases are omitted.
	* @link /mfh/:mfhId/finance/investment-cases/evaluate-partner-buy-box
	*/
	async evaluateMfhInvestmentCasePartnerBuyBox({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/evaluate-partner-buy-box`,
			data,
			...options
		})).data;
	}
	/**
	* @description Dry-run one asset-partner IC profile × renovation overlay: calcengine without persisting an investment case, then that profile buy-box. Calc failures return an error cell.
	* @link /mfh/:mfhId/finance/investment-cases/screening-cell
	*/
	async screenMfhInvestmentCasePartnerRenovationCell({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/screening-cell`,
			data,
			...options
		})).data;
	}
	/**
	* @description Dry-run an explicit list of asset-partner IC profile × renovation overlay cells. Shared MFH/D2G/rent-index/Sprengnetter context is prepared once; calcengine runs per cell without persisting investment cases.
	* @link /mfh/:mfhId/finance/investment-cases/screening-matrix
	*/
	async screenMfhInvestmentCasePartnerRenovationMatrix({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/screening-matrix`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns list of available D2G Versions
	* @link /mfh/finance/d2g-versions
	*/
	async getD2GVersions(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/d2g-versions`,
			...options
		})).data;
	}
	/**
	* @description Returns asset-partner IC profiles; scoped to a company when companyId is given, otherwise all partners
	* @link /mfh/finance/asset-partner-ic-profiles
	*/
	async findAssetPartnerIcProfiles(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/asset-partner-ic-profiles`,
			params,
			...options
		})).data;
	}
	/**
	* @description Creates a new asset-partner IC profile
	* @link /mfh/finance/asset-partner-ic-profiles
	*/
	async createAssetPartnerIcProfile(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/finance/asset-partner-ic-profiles`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns version history for an asset-partner IC profile
	* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId/versions
	*/
	async findAssetPartnerIcProfileVersions({ assetPartnerIcProfileId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}/versions`,
			...options
		})).data;
	}
	/**
	* @description Returns one immutable asset-partner IC profile version
	* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId/versions/:assetPartnerIcProfileVersionId
	*/
	async getAssetPartnerIcProfileVersion({ assetPartnerIcProfileId, assetPartnerIcProfileVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}/versions/${assetPartnerIcProfileVersionId}`,
			...options
		})).data;
	}
	/**
	* @description Updates an asset-partner IC profile
	* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId
	*/
	async updateAssetPartnerIcProfile({ assetPartnerIcProfileId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes an asset-partner IC profile; blocked when it is still referenced by investment cases
	* @link /mfh/finance/asset-partner-ic-profiles/:assetPartnerIcProfileId
	*/
	async deleteAssetPartnerIcProfile({ assetPartnerIcProfileId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/mfh/finance/asset-partner-ic-profiles/${assetPartnerIcProfileId}`,
			...options
		})).data;
	}
	/**
	* @description Returns default rent-index lookup values for a given MFH
	* @link /mfh/:mfhId/finance/investment-cases/rent-index-lookup
	*/
	async getMfhRentIndexLookup({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/rent-index-lookup`,
			...options
		})).data;
	}
	/**
	* @description Returns rent-index source context and nearby GeoMap residential rental comparables with HERE driving distances for an MFH
	* @link /mfh/:mfhId/finance/rent-market-data
	*/
	async generateRentMarketData({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/rent-market-data`,
			params,
			...options
		})).data;
	}
	/**
	* @description Returns a single investment-case by id
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId
	*/
	async getMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Updates an existing mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId
	*/
	async updateMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes a mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId
	*/
	async deleteMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Returns the approved investment-case for an MFH
	* @link /mfh/:mfhId/finance/investment-cases/approved
	*/
	async getApprovedMfhInvestmentCase({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/approved`,
			params,
			...options
		})).data;
	}
	/**
	* @description Manually schedule a read-copy sync for an investment case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sync-read-copy
	*/
	async triggerMfhInvestmentCaseReadCopySync({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sync-read-copy`,
			...options
		})).data;
	}
	/**
	* @description Re-read the outputs of an investment-case. Use syncOutputs to save outputs
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/read-outputs
	*/
	async readMfhInvestmentCaseOutputs({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/read-outputs`,
			params,
			...options
		})).data;
	}
	/**
	* @description Download exportable investment-case as Excel file
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/download-mfh-investment-case-sheet
	*/
	async downloadMfhInvestmentCaseSheet({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/download-mfh-investment-case-sheet`,
			...options
		})).data;
	}
	/**
	* @description Upload reviewed investment case sheet from temporary GCS location
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/upload-reviewed-sheet
	*/
	async uploadMfhInvestmentCaseReviewedSheet({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/upload-reviewed-sheet`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create a base investment-case draft for batch-creating cases across multiple asset-partner profiles
	* @link /mfh/:mfhId/finance/base-investment-cases
	*/
	async createBaseMfhInvestmentCase({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/base-investment-cases`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns the base investment-case drafts for an MFH
	* @link /mfh/:mfhId/finance/base-investment-cases
	*/
	async fetchBaseMfhInvestmentCases({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/base-investment-cases`,
			...options
		})).data;
	}
	/**
	* @description Persist the common inputs of a base investment-case draft (no sheet/calc)
	* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/inputs
	*/
	async saveBaseMfhInvestmentCaseInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/inputs`,
			data,
			...options
		})).data;
	}
	/**
	* @description Materialises a base draft into one retained child investment-case per selected profile. Optionally calculates each child.
	* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/fan-out
	*/
	async fanOutBaseMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/fan-out`,
			data,
			...options
		})).data;
	}
	/**
	* @description Validates and calculates one sampled base-case profile without persisting changes
	* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/check
	*/
	async checkBaseMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/check`,
			data,
			...options
		})).data;
	}
	/**
	* @description Propagates shared base-case inputs to all live children without recalculating them
	* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/propagate-inputs
	*/
	async propagateBaseMfhInvestmentCaseInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/propagate-inputs`,
			data,
			...options
		})).data;
	}
	/**
	* @description Calculates every live child of a base investment case and returns a per-child report
	* @link /mfh/:mfhId/finance/base-investment-cases/:mfhInvestmentCaseId/calculate-children
	*/
	async calculateBaseMfhInvestmentCaseChildren({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/base-investment-cases/${mfhInvestmentCaseId}/calculate-children`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create a sheetless mfh investment-case
	* @link /mfh/:mfhId/finance/sheetless-investment-cases
	*/
	async createSheetlessMfhInvestmentCase({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/sheetless-investment-cases`,
			data,
			...options
		})).data;
	}
	/**
	* @description Admin/debug: create a sheetless investment case from JSON (optionally including a rent roll; building IDs kept only if they belong to the target asset, or remapped to the first building when requested)
	* @link /mfh/:mfhId/finance/investment-cases/import-from-json
	*/
	async importMfhInvestmentCaseFromJson({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/import-from-json`,
			data,
			...options
		})).data;
	}
	/**
	* @description Admin/debug: export a sheetless investment case as JSON transfer payload (optionally including rent roll)
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/export-as-json
	*/
	async exportMfhInvestmentCaseAsJson({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/export-as-json`,
			...options
		})).data;
	}
	/**
	* @description Prepares an empty investment-case (creating predictions, creating sheets)
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/prepare
	*/
	async prepareMfhInvestmentCase({ mfhInvestmentCaseId, mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/prepare`,
			...options
		})).data;
	}
	/**
	* @description Changes the d2g-version/config-id of an mfh-investment-case (destructive action)
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/change-and-recreate
	*/
	async changeAndRecreateMfhInvestmentCase({ mfhInvestmentCaseId, mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/change-and-recreate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Changes the d2g-version/config-id of a sheetless mfh-investment-case (destructive action)
	* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/change-and-recreate
	*/
	async changeAndRecreateSheetlessMfhInvestmentCase({ mfhInvestmentCaseId, mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/change-and-recreate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Copies an existing mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy
	*/
	async copyMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/copy`,
			data,
			...options
		})).data;
	}
	/**
	* @description Copies an existing sheetless mfh investment-case
	* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/copy
	*/
	async copySheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/copy`,
			data,
			...options
		})).data;
	}
	/**
	* @description Creates a copy of an existing investment-case with a different asset-partner profile, using the latest root config
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy-and-change-asset-partner
	*/
	async copyAndChangeAssetPartnerMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/copy-and-change-asset-partner`,
			data,
			...options
		})).data;
	}
	/**
	* @description Creates a copy of an existing sheetless investment-case with a different asset-partner profile, using the latest root config
	* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/copy-and-change-asset-partner
	*/
	async copyAndChangeAssetPartnerSheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/copy-and-change-asset-partner`,
			data,
			...options
		})).data;
	}
	/**
	* @description Copies an approved sourcing investment-case or existing asset-management case into a new asset-management investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/copy-to-asset-management
	*/
	async copyMfhInvestmentCaseToAssetManagement({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/copy-to-asset-management`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns version history sessions for a D2G investment case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions
	*/
	async listMfhInvestmentCaseVersions({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions`,
			params,
			...options
		})).data;
	}
	/**
	* @description Returns active persisted override groups including localized deltas for a D2G investment case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides
	*/
	async listMfhInvestmentCaseOverrideGroups({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/overrides`,
			...options
		})).data;
	}
	/**
	* @description Resolves a sheet cell or range to the calcengine placeholders it overlaps. Each match includes that placeholder’s original formula groups. Cells with no placeholder are omitted.
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/cell
	*/
	async getMfhInvestmentCaseCell({ mfhId, mfhInvestmentCaseId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/cell`,
			params,
			...options
		})).data;
	}
	/**
	* @description Returns every cell override still live after last-wins replay, with the revision that wrote the current value
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides/applied
	*/
	async listAppliedMfhInvestmentCaseOverrides({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/overrides/applied`,
			...options
		})).data;
	}
	/**
	* @description Commits spreadsheet cell, structural, and display-only design overrides for a D2G investment case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/overrides/commit
	*/
	async commitMfhInvestmentCaseOverrides({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/overrides/commit`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns historical inputs and diffs without loading revision outputs
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/input-preview
	*/
	async getMfhInvestmentCaseVersionInputPreview({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/input-preview`,
			...options
		})).data;
	}
	/**
	* @description Lazily recalculates the historical result projection and compact diffs
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/result-preview
	*/
	async getMfhInvestmentCaseVersionResultPreview({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/result-preview`,
			...options
		})).data;
	}
	/**
	* @description Lazily recalculates CalcEngine-only historical sheet values and compact diffs
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/sheet-preview
	*/
	async getMfhInvestmentCaseVersionSheetPreview({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/sheet-preview`,
			...options
		})).data;
	}
	/**
	* @description Reverts an investment case to a previous immutable version snapshot
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/revert
	*/
	async revertMfhInvestmentCaseVersion({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/revert`,
			...options
		})).data;
	}
	/**
	* @description Restores a soft-deleted mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/restore
	*/
	async restoreMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/restore`,
			...options
		})).data;
	}
	/**
	* @description Sets an mfh investment-case as the primary case a mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/primary
	*/
	async setMfhInvestmentCaseAsPrimary({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/primary`,
			data,
			...options
		})).data;
	}
	/**
	* @description Pins an investment case to an asset-partner profile version and refreshes profile inputs
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/asset-partner-profile-version
	*/
	async updateMfhInvestmentCaseAssetPartnerProfileVersion({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/asset-partner-profile-version`,
			data,
			...options
		})).data;
	}
	/**
	* @description Previews investment-case inputs after applying an asset-partner profile version
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/asset-partner-profile-versions/:assetPartnerIcProfileVersionId/inputs-preview
	*/
	async getAssetPartnerProfileVersionIcInputs({ mfhId, mfhInvestmentCaseId, assetPartnerIcProfileVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/asset-partner-profile-versions/${assetPartnerIcProfileVersionId}/inputs-preview`,
			...options
		})).data;
	}
	/**
	* @description Recalculates a mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/recalculate
	*/
	async recalculateMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/recalculate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Recalculates a sheetless mfh investment-case
	* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/recalculate
	*/
	async recalculateSheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/recalculate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get calcengine-inputs for local debugging
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/calc-engine-inputs
	*/
	async getCalcengineInputs({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/calc-engine-inputs`,
			...options
		})).data;
	}
	/**
	* @description Runs a bounded calcengine sensitivity sweep for an mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity
	*/
	async runMfhInvestmentCaseSensitivity({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity`,
			data,
			...options
		})).data;
	}
	/**
	* @description Starts a durable calcengine auto sensitivity run for an mfh investment-case
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto
	*/
	async startMfhInvestmentCaseAutoSensitivity({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/auto`,
			data,
			...options
		})).data;
	}
	/**
	* @description Cancels a durable calcengine auto sensitivity run
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto/cancel
	*/
	async cancelMfhInvestmentCaseAutoSensitivity({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/auto/cancel`,
			data,
			...options
		})).data;
	}
	/**
	* @description Streams durable calcengine auto sensitivity progress events
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/auto/runs/:runId/events
	*/
	async subscribeMfhInvestmentCaseAutoSensitivityEvents({ mfhId, mfhInvestmentCaseId, runId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/auto/runs/${runId}/events`,
			params,
			...options
		})).data;
	}
	/**
	* @description Maps a sensitivity winner output map onto the investment-case form inputs
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sensitivity/takeover-inputs
	*/
	async buildSensitivityTakeoverInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sensitivity/takeover-inputs`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns list of mfh investment-cases
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/synced-mfh-inputs
	*/
	async getSyncedMfhInputs({ mfhInvestmentCaseId, mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/synced-mfh-inputs`,
			...options
		})).data;
	}
	/**
	* @description Returns calculated (already converted to calcengine) values for investment case sheets
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/calculated-values
	*/
	async getCalculatedInvestmentCaseValues({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/calculated-values`,
			...options
		})).data;
	}
	/**
	* @description Syncs MFH investment-case inputs without recalculating
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/sync
	*/
	async syncMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/sync`,
			data,
			...options
		})).data;
	}
	/**
	* @description Syncs sheetless MFH investment-case inputs without recalculating
	* @link /mfh/:mfhId/finance/sheetless-investment-cases/:mfhInvestmentCaseId/sync
	*/
	async syncSheetlessMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/sheetless-investment-cases/${mfhInvestmentCaseId}/sync`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get investment case aggregate for an MFH
	* @link /mfh/:mfhId/finance/investment-case-aggregate
	*/
	async getMfhInvestmentCaseAggregate({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-case-aggregate`,
			...options
		})).data;
	}
	/**
	* @description Generate or regenerate investment case aggregate for an MFH
	* @link /mfh/:mfhId/finance/investment-case-aggregate/generate
	*/
	async generateMfhInvestmentCaseAggregate({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-case-aggregate/generate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Adds, edits, or clears the optional title of an investment-case version
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/versions/:mfhInvestmentCaseVersionId/title
	*/
	async updateMfhInvestmentCaseVersionTitle({ mfhId, mfhInvestmentCaseId, mfhInvestmentCaseVersionId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/versions/${mfhInvestmentCaseVersionId}/title`,
			data,
			...options
		})).data;
	}
	/**
	* @description Returns the persisted IC teaser for an MFH investment case, or null when none exists
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
	*/
	async getIcTeaser({ mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
			...options
		})).data;
	}
	/**
	* @description Builds source data, generates narratives, and persists a new IC teaser
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
	*/
	async createIcTeaser({ mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes the persisted IC teaser for an MFH investment case
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
	*/
	async deleteIcTeaser({ mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
			...options
		})).data;
	}
	/**
	* @description Updates IC teaser narrative fields, source data scalars, or slide configuration without AI generation
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser
	*/
	async updateIcTeaser({ mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser`,
			data,
			...options
		})).data;
	}
	/**
	* @description Builds fresh IC teaser source data from the live investment case (not persisted)
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/live-source
	*/
	async getIcTeaserLiveSourceData({ mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser/live-source`,
			...options
		})).data;
	}
	/**
	* @description Refreshes source data and regenerates all IC teaser narratives via durable job
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/regenerate
	*/
	async regenerateIcTeaser({ mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser/regenerate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Synchronously regenerates selected IC teaser narrative fields and returns the updated teaser
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/teaser/regenerate-fields
	*/
	async regenerateIcTeaserFields({ mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/teaser/regenerate-fields`,
			data,
			...options
		})).data;
	}
	/**
	* @description Evaluate selectable third-party market rent values before automatic investment-case creation
	* @link /mfh/:mfhId/finance/investment-cases/automatic/market-rent-sources
	*/
	async evaluateAutomaticMfhMarketRentSources({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/automatic/market-rent-sources`,
			...options
		})).data;
	}
	/**
	* @description Create automatic mfh investment-cases from screening-selection cells in one request. Shared context is loaded once; the batch runs in a single transaction. Pass cells for the legacy flat create, or scenarioGroups to persist one retained Shared Base per scenario with linked children.
	* @link /mfh/:mfhId/finance/investment-cases/automatic/batch
	*/
	async createAutomaticMfhInvestmentCases({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/automatic/batch`,
			data,
			...options
		})).data;
	}
	/**
	* @description Soft-delete several investment cases of one mfh in a single transaction: all are withdrawn or none is. Shared Bases cascade to their children, every refusal is reported at once, and already-deleted cases are skipped so the request can be resent. Supports x-dry-run as a preflight.
	* @link /mfh/:mfhId/finance/investment-cases/automatic/withdraw
	*/
	async withdrawAutomaticMfhInvestmentCases({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/automatic/withdraw`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create an automatic mfh investment-case in Basecamp without creating D2G Google Sheets
	* @link /mfh/:mfhId/finance/investment-cases/automatic
	*/
	async createAutomaticMfhInvestmentCase({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/automatic`,
			data,
			...options
		})).data;
	}
	/**
	* @description Save inputs for an automatic mfh investment-case without requiring D2G Google Sheets
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic/inputs
	*/
	async setAutomaticMfhInvestmentCaseInputs({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/automatic/inputs`,
			data,
			...options
		})).data;
	}
	/**
	* @description Calculate an automatic mfh investment-case through Calcengine without D2G Google Sheets
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic/calculate
	*/
	async calculateAutomaticMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/automatic/calculate`,
			data,
			...options
		})).data;
	}
	/**
	* @description Return an automatic mfh investment-case summary and, when the case was already calculated, the stored calcengine output projection
	* @link /mfh/:mfhId/finance/investment-cases/:mfhInvestmentCaseId/automatic
	*/
	async getAutomaticMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/${mfhId}/finance/investment-cases/${mfhInvestmentCaseId}/automatic`,
			...options
		})).data;
	}
	/**
	* @description Returns calcengine-blocking missing inputs for an investment case
	* @link /mfh/finance/investment-cases/:mfhInvestmentCaseId/missing-inputs
	*/
	async getMfhInvestmentCaseMissingInputs({ mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/mfh/finance/investment-cases/${mfhInvestmentCaseId}/missing-inputs`,
			...options
		})).data;
	}
	/**
	* @description Returns a single rent-roll version by id
	* @link /rent-roll-versions/:rentRollVersionId
	*/
	async getRentRollVersion({ rentRollVersionId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/rent-roll-versions/${rentRollVersionId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Updates a rent-roll version
	* @link /rent-roll-versions/:rentRollVersionId
	*/
	async updateRentRollVersion({ rentRollVersionId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/rent-roll-versions/${rentRollVersionId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes a rent-roll version
	* @link /rent-roll-versions/:rentRollVersionId
	*/
	async deleteRentRollVersion({ rentRollVersionId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/rent-roll-versions/${rentRollVersionId}`,
			...options
		})).data;
	}
	/**
	* @description Returns list of rent-roll versions
	* @link /rent-roll-versions
	*/
	async findRentRollVersions(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/rent-roll-versions`,
			params,
			...options
		})).data;
	}
	/**
	* @description Creates a new rent-roll version; dryRun validates without writing
	* @link /rent-roll-versions
	*/
	async createRentRollVersion(data, params, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/rent-roll-versions`,
			params,
			data,
			...options
		})).data;
	}
	/**
	* @description Creates rent-rolls for a rent-roll version
	* @link /rent-roll-versions/:rentRollVersionId/rent-rolls
	*/
	async createRentRolls({ rentRollVersionId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/rent-roll-versions/${rentRollVersionId}/rent-rolls`,
			data,
			...options
		})).data;
	}
	/**
	* @description Imports Portfolio Analyzer rent-roll rows onto an existing MFH
	* @link /mfh/:mfhId/automatic-rent-roll-import
	*/
	async importAutomaticRentRoll({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/mfh/${mfhId}/automatic-rent-roll-import`,
			data,
			...options
		})).data;
	}
	/**
	* @description Replaces all rent-roll data for a version; dryRun validates without writing
	* @link /rent-roll-versions/:rentRollVersionId/replace-data
	*/
	async replaceRentRollVersionData({ rentRollVersionId }, data, params, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/rent-roll-versions/${rentRollVersionId}/replace-data`,
			params,
			data,
			...options
		})).data;
	}
	/**
	* @description Updates a rent-roll
	* @link /rent-rolls/:rentRollId
	*/
	async updateRentRoll({ rentRollId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/rent-rolls/${rentRollId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Deletes multiple rent-rolls in bulk
	* @link /rent-rolls/delete
	*/
	async deleteRentRolls(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/rent-rolls/delete`,
			data,
			...options
		})).data;
	}
	/**
	* @description Processes an event on a rent-roll version
	* @link /rent-roll-versions/:rentRollVersionId/event
	*/
	async processRentRollVersionEvent({ rentRollVersionId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/rent-roll-versions/${rentRollVersionId}/event`,
			data,
			...options
		})).data;
	}
	/** @link /user-tasks */
	async findUserTasks(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/user-tasks`,
			params,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId */
	async getUserTask({ userTaskId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/user-task/${userTaskId}`,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId */
	async deleteUserTask({ userTaskId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/user-task/${userTaskId}`,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId/reject */
	async rejectUserTask({ userTaskId }, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/user-task/${userTaskId}/reject`,
			...options
		})).data;
	}
	/** @link /user-task/classify-documents */
	async classifyDocuments(params, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-task/classify-documents`,
			params,
			...options
		})).data;
	}
	/** @link /user-task/classify-documents-email */
	async classifyDocumentsEmail(options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-task/classify-documents-email`,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId/classify-document/classification-result */
	async updateDocumentClassificationResult({ userTaskId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-task/${userTaskId}/classify-document/classification-result`,
			data,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId/portfolio-analyzer/complete */
	async completeAnalyzePortfolioUserTask({ userTaskId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-task/${userTaskId}/portfolio-analyzer/complete`,
			data,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId/portfolio-analyzer/result */
	async updatePortfolioAnalyzerResult({ userTaskId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-task/${userTaskId}/portfolio-analyzer/result`,
			data,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId/portfolio-analyzer/progress */
	async updatePortfolioAnalyzerProgress({ userTaskId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-task/${userTaskId}/portfolio-analyzer/progress`,
			data,
			...options
		})).data;
	}
	/** @link /user-task/:userTaskId/classify-document/user-confirmation */
	async confirmDocumentClassification({ userTaskId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/user-task/${userTaskId}/classify-document/user-confirmation`,
			data,
			...options
		})).data;
	}
};
//#endregion
export { AddressNation, AddressNation10, AddressNation2, AddressNation3, AddressNation4, AddressNation5, AddressNation6, AddressNation7, AddressNation8, AddressNation9, AttributesAdjoiningBuilding, AttributesAdjoiningBuilding2, AttributesApartmentType, AttributesBuildingEnergyRating, AttributesBuildingEnergyRating2, AttributesBuildingEnergyRating3, AttributesBuildingLocationType, AttributesCellarHeating, AttributesCellarHeating2, AttributesExitType, AttributesExitType2, AttributesMandateType, AttributesMandateType2, AttributesMandateType3, AttributesPrimaryHeatingType, AttributesRestrictions, AttributesRestrictions2, AttributesRiwisLocation, AttributesRiwisLocation2, AttributesRoofOrientation, AttributesRoofOrientation2, AttributesRoofShape, AttributesRoofShape2, AttributesRoofUse, AttributesRoofUse2, AttributesSplitStatus, AttributesSplitStatus2, AttributesWaterHeating, AttributesWaterHeating2, AttributesWindowGlazing, AttributesWindowGlazing2, AutomaticRentRollImportStatus, AutomaticRentRollImportStatus2, AutomaticRentRollImportStatus3, AutomaticRentRollImportStatus4, BaseInvestmentCaseInvestmentCaseType, BaseInvestmentCaseInvestmentCaseType2, BaseInvestmentCaseStatus, BaseInvestmentCaseStatus2, BasecampSdk, BottomCenterTopRightStyle, BottomCenterTopRightStyle10, BottomCenterTopRightStyle11, BottomCenterTopRightStyle12, BottomCenterTopRightStyle13, BottomCenterTopRightStyle14, BottomCenterTopRightStyle15, BottomCenterTopRightStyle16, BottomCenterTopRightStyle17, BottomCenterTopRightStyle18, BottomCenterTopRightStyle19, BottomCenterTopRightStyle2, BottomCenterTopRightStyle20, BottomCenterTopRightStyle21, BottomCenterTopRightStyle22, BottomCenterTopRightStyle23, BottomCenterTopRightStyle24, BottomCenterTopRightStyle25, BottomCenterTopRightStyle26, BottomCenterTopRightStyle27, BottomCenterTopRightStyle28, BottomCenterTopRightStyle29, BottomCenterTopRightStyle3, BottomCenterTopRightStyle30, BottomCenterTopRightStyle31, BottomCenterTopRightStyle32, BottomCenterTopRightStyle33, BottomCenterTopRightStyle34, BottomCenterTopRightStyle35, BottomCenterTopRightStyle36, BottomCenterTopRightStyle37, BottomCenterTopRightStyle38, BottomCenterTopRightStyle39, BottomCenterTopRightStyle4, BottomCenterTopRightStyle40, BottomCenterTopRightStyle41, BottomCenterTopRightStyle42, BottomCenterTopRightStyle43, BottomCenterTopRightStyle44, BottomCenterTopRightStyle45, BottomCenterTopRightStyle46, BottomCenterTopRightStyle47, BottomCenterTopRightStyle48, BottomCenterTopRightStyle49, BottomCenterTopRightStyle5, BottomCenterTopRightStyle50, BottomCenterTopRightStyle51, BottomCenterTopRightStyle52, BottomCenterTopRightStyle53, BottomCenterTopRightStyle54, BottomCenterTopRightStyle55, BottomCenterTopRightStyle56, BottomCenterTopRightStyle57, BottomCenterTopRightStyle58, BottomCenterTopRightStyle59, BottomCenterTopRightStyle6, BottomCenterTopRightStyle60, BottomCenterTopRightStyle61, BottomCenterTopRightStyle62, BottomCenterTopRightStyle63, BottomCenterTopRightStyle64, BottomCenterTopRightStyle65, BottomCenterTopRightStyle66, BottomCenterTopRightStyle67, BottomCenterTopRightStyle68, BottomCenterTopRightStyle69, BottomCenterTopRightStyle7, BottomCenterTopRightStyle70, BottomCenterTopRightStyle71, BottomCenterTopRightStyle72, BottomCenterTopRightStyle73, BottomCenterTopRightStyle74, BottomCenterTopRightStyle75, BottomCenterTopRightStyle76, BottomCenterTopRightStyle77, BottomCenterTopRightStyle78, BottomCenterTopRightStyle79, BottomCenterTopRightStyle8, BottomCenterTopRightStyle80, BottomCenterTopRightStyle81, BottomCenterTopRightStyle82, BottomCenterTopRightStyle83, BottomCenterTopRightStyle84, BottomCenterTopRightStyle85, BottomCenterTopRightStyle86, BottomCenterTopRightStyle87, BottomCenterTopRightStyle88, BottomCenterTopRightStyle89, BottomCenterTopRightStyle9, BottomCenterTopRightStyle90, BottomCenterTopRightStyle91, BottomCenterTopRightStyle92, BottomCenterTopRightStyle93, BottomCenterTopRightStyle94, BottomCenterTopRightStyle95, BottomCenterTopRightStyle96, BottomCenterTopRightStyle97, BottomCenterTopRightStyle98, BottomLeftTopRightStyle, BottomLeftTopRightStyle10, BottomLeftTopRightStyle11, BottomLeftTopRightStyle12, BottomLeftTopRightStyle13, BottomLeftTopRightStyle14, BottomLeftTopRightStyle15, BottomLeftTopRightStyle16, BottomLeftTopRightStyle17, BottomLeftTopRightStyle18, BottomLeftTopRightStyle19, BottomLeftTopRightStyle2, BottomLeftTopRightStyle20, BottomLeftTopRightStyle21, BottomLeftTopRightStyle22, BottomLeftTopRightStyle23, BottomLeftTopRightStyle24, BottomLeftTopRightStyle25, BottomLeftTopRightStyle26, BottomLeftTopRightStyle27, BottomLeftTopRightStyle28, BottomLeftTopRightStyle29, BottomLeftTopRightStyle3, BottomLeftTopRightStyle30, BottomLeftTopRightStyle31, BottomLeftTopRightStyle32, BottomLeftTopRightStyle33, BottomLeftTopRightStyle34, BottomLeftTopRightStyle35, BottomLeftTopRightStyle36, BottomLeftTopRightStyle37, BottomLeftTopRightStyle38, BottomLeftTopRightStyle39, BottomLeftTopRightStyle4, BottomLeftTopRightStyle40, BottomLeftTopRightStyle41, BottomLeftTopRightStyle42, BottomLeftTopRightStyle43, BottomLeftTopRightStyle44, BottomLeftTopRightStyle45, BottomLeftTopRightStyle46, BottomLeftTopRightStyle47, BottomLeftTopRightStyle48, BottomLeftTopRightStyle49, BottomLeftTopRightStyle5, BottomLeftTopRightStyle50, BottomLeftTopRightStyle51, BottomLeftTopRightStyle52, BottomLeftTopRightStyle53, BottomLeftTopRightStyle54, BottomLeftTopRightStyle55, BottomLeftTopRightStyle56, BottomLeftTopRightStyle57, BottomLeftTopRightStyle58, BottomLeftTopRightStyle59, BottomLeftTopRightStyle6, BottomLeftTopRightStyle60, BottomLeftTopRightStyle61, BottomLeftTopRightStyle62, BottomLeftTopRightStyle63, BottomLeftTopRightStyle64, BottomLeftTopRightStyle65, BottomLeftTopRightStyle66, BottomLeftTopRightStyle67, BottomLeftTopRightStyle68, BottomLeftTopRightStyle69, BottomLeftTopRightStyle7, BottomLeftTopRightStyle70, BottomLeftTopRightStyle71, BottomLeftTopRightStyle72, BottomLeftTopRightStyle73, BottomLeftTopRightStyle74, BottomLeftTopRightStyle75, BottomLeftTopRightStyle76, BottomLeftTopRightStyle77, BottomLeftTopRightStyle78, BottomLeftTopRightStyle79, BottomLeftTopRightStyle8, BottomLeftTopRightStyle80, BottomLeftTopRightStyle81, BottomLeftTopRightStyle82, BottomLeftTopRightStyle83, BottomLeftTopRightStyle84, BottomLeftTopRightStyle85, BottomLeftTopRightStyle86, BottomLeftTopRightStyle87, BottomLeftTopRightStyle88, BottomLeftTopRightStyle89, BottomLeftTopRightStyle9, BottomLeftTopRightStyle90, BottomLeftTopRightStyle91, BottomLeftTopRightStyle92, BottomLeftTopRightStyle93, BottomLeftTopRightStyle94, BottomLeftTopRightStyle95, BottomLeftTopRightStyle96, BottomLeftTopRightStyle97, BottomLeftTopRightStyle98, BottomStyle, BottomStyle10, BottomStyle11, BottomStyle12, BottomStyle13, BottomStyle14, BottomStyle15, BottomStyle16, BottomStyle17, BottomStyle18, BottomStyle19, BottomStyle2, BottomStyle20, BottomStyle21, BottomStyle22, BottomStyle23, BottomStyle24, BottomStyle25, BottomStyle26, BottomStyle27, BottomStyle28, BottomStyle29, BottomStyle3, BottomStyle30, BottomStyle31, BottomStyle32, BottomStyle33, BottomStyle34, BottomStyle35, BottomStyle36, BottomStyle37, BottomStyle38, BottomStyle39, BottomStyle4, BottomStyle40, BottomStyle41, BottomStyle42, BottomStyle43, BottomStyle44, BottomStyle45, BottomStyle46, BottomStyle47, BottomStyle48, BottomStyle49, BottomStyle5, BottomStyle50, BottomStyle51, BottomStyle52, BottomStyle53, BottomStyle54, BottomStyle55, BottomStyle56, BottomStyle57, BottomStyle58, BottomStyle59, BottomStyle6, BottomStyle60, BottomStyle61, BottomStyle62, BottomStyle63, BottomStyle64, BottomStyle65, BottomStyle66, BottomStyle67, BottomStyle68, BottomStyle69, BottomStyle7, BottomStyle70, BottomStyle71, BottomStyle72, BottomStyle73, BottomStyle74, BottomStyle75, BottomStyle76, BottomStyle77, BottomStyle78, BottomStyle79, BottomStyle8, BottomStyle80, BottomStyle81, BottomStyle82, BottomStyle83, BottomStyle84, BottomStyle85, BottomStyle86, BottomStyle87, BottomStyle88, BottomStyle89, BottomStyle9, BottomStyle90, BottomStyle91, BottomStyle92, BottomStyle93, BottomStyle94, BottomStyle95, BottomStyle96, BottomStyle97, BottomStyle98, ByConditionCondition, ByConditionCondition2, ByConditionCondition3, ByConditionCondition4, CalculateAutomaticMfhInvestmentCase200Status, CalculateAutomaticMfhInvestmentCase200Status2, CalculateAutomaticMfhInvestmentCaseMutationResponseStatus, CalculateAutomaticMfhInvestmentCaseMutationResponseStatus2, CellEntriesKind, CellEntriesKind2, CellEntriesKind3, CellEntriesSourceLanguage, CellEntriesSourceLanguage2, CellsBuyBoxStatus, CellsBuyBoxStatus2, CellsKind, CellsKind10, CellsKind11, CellsKind12, CellsKind13, CellsKind14, CellsKind15, CellsKind16, CellsKind17, CellsKind18, CellsKind2, CellsKind3, CellsKind4, CellsKind5, CellsKind6, CellsKind7, CellsKind8, CellsKind9, ChartsChartType, ChartsChartType10, ChartsChartType11, ChartsChartType12, ChartsChartType13, ChartsChartType14, ChartsChartType15, ChartsChartType16, ChartsChartType2, ChartsChartType3, ChartsChartType4, ChartsChartType5, ChartsChartType6, ChartsChartType7, ChartsChartType8, ChartsChartType9, CocPercentageStatus, CocPercentageStatus2, CommercialShareStatus, CommercialShareStatus2, CommitMfhInvestmentCaseOverrides200ReadCopySyncStatus, CommitMfhInvestmentCaseOverridesMutationResponseReadCopySyncStatus, ConvertOptionsPageOrientation, ConvertOptionsPageOrientation2, CopyAndChangeAssetPartnerMfhInvestmentCase200Status, CopyAndChangeAssetPartnerMfhInvestmentCaseMutationResponseStatus, CopyMfhInvestmentCase200Status, CopyMfhInvestmentCaseMutationRequestExitApproach, CopyMfhInvestmentCaseMutationResponseStatus, CopyMfhInvestmentCaseToAssetManagement200Status, CopyMfhInvestmentCaseToAssetManagementMutationResponseStatus, CreateAutomaticMfhInvestmentCaseMutationRequestMarketRentSource, CreateAutomaticMfhInvestmentCaseMutationRequestMarketRentSource2, CreateAutomaticMfhInvestmentCaseMutationRequestMarketRentSource3, CreateAutomaticMfhInvestmentCasesMutationRequestMarketRentSource, CreateAutomaticMfhInvestmentCasesMutationRequestMarketRentSource2, CreateAutomaticMfhInvestmentCasesMutationRequestMarketRentSource3, CreateBaseMfhInvestmentCaseMutationRequestExitApproach, CreateEmptyMfhInvestmentCaseMutationRequestExitApproach, CreateIcTeaser200Status, CreateIcTeaserMutationResponseStatus, CreateLinkDocumentMutationRequestCategory, CreateLinkDocumentMutationRequestCategory10, CreateLinkDocumentMutationRequestCategory2, CreateLinkDocumentMutationRequestCategory3, CreateLinkDocumentMutationRequestCategory4, CreateLinkDocumentMutationRequestCategory5, CreateLinkDocumentMutationRequestCategory6, CreateLinkDocumentMutationRequestCategory7, CreateLinkDocumentMutationRequestCategory8, CreateLinkDocumentMutationRequestCategory9, CreateLinkDocumentMutationRequestConstructionCraft, CreateLinkDocumentMutationRequestConstructionCraft10, CreateLinkDocumentMutationRequestConstructionCraft11, CreateLinkDocumentMutationRequestConstructionCraft12, CreateLinkDocumentMutationRequestConstructionCraft2, CreateLinkDocumentMutationRequestConstructionCraft3, CreateLinkDocumentMutationRequestConstructionCraft4, CreateLinkDocumentMutationRequestConstructionCraft5, CreateLinkDocumentMutationRequestConstructionCraft6, CreateLinkDocumentMutationRequestConstructionCraft7, CreateLinkDocumentMutationRequestConstructionCraft8, CreateLinkDocumentMutationRequestConstructionCraft9, CreateLinkDocumentMutationRequestFileCategory, CreateLinkDocumentMutationRequestFileCategory2, CreateMfhEstateMutationRequestRentableUnitState, CreateRenovationScenarioMutationRequestEnergeticMeasureType, CreateRenovationScenarioMutationRequestEnergeticMeasureType2, CreateRenovationScenarioMutationRequestEnergeticMeasureType3, CreateRenovationScenarioMutationRequestExpansionType, CreateRenovationScenarioMutationRequestExpansionType2, CreateRenovationScenarioMutationRequestExpansionType3, CreateRenovationScenarioMutationRequestSubsidyScheme, CreateRenovationScenarioMutationRequestSubsidyScheme2, CreateRentRollVersion200Outcome, CreateRentRollVersion200Outcome2, CreateRentRollVersionMutationResponseOutcome, CreateRentRollVersionMutationResponseOutcome2, DataApartmentCondition, DataApartmentCondition2, DataApartmentCondition3, DataApartmentType, DataApartmentType10, DataApartmentType11, DataApartmentType12, DataApartmentType13, DataApartmentType14, DataApartmentType15, DataApartmentType16, DataApartmentType17, DataApartmentType18, DataApartmentType19, DataApartmentType2, DataApartmentType20, DataApartmentType21, DataApartmentType22, DataApartmentType23, DataApartmentType24, DataApartmentType25, DataApartmentType26, DataApartmentType27, DataApartmentType3, DataApartmentType4, DataApartmentType5, DataApartmentType6, DataApartmentType7, DataApartmentType8, DataApartmentType9, DataCondoSalesCondition, DataCondoSalesCondition2, DataCondoSalesCondition3, DataRentIncreaseType, DataRentIncreaseType2, DataRentIncreaseType3, DataRentIncreaseType4, DataRentingState, DataRentingState2, DataRentingState3, DataRentingState4, DecisionAction, DecisionAction10, DecisionAction11, DecisionAction12, DecisionAction13, DecisionAction14, DecisionAction15, DecisionAction16, DecisionAction17, DecisionAction18, DecisionAction19, DecisionAction2, DecisionAction20, DecisionAction21, DecisionAction22, DecisionAction23, DecisionAction24, DecisionAction25, DecisionAction26, DecisionAction27, DecisionAction28, DecisionAction29, DecisionAction3, DecisionAction30, DecisionAction31, DecisionAction32, DecisionAction33, DecisionAction34, DecisionAction35, DecisionAction36, DecisionAction37, DecisionAction38, DecisionAction39, DecisionAction4, DecisionAction40, DecisionAction41, DecisionAction42, DecisionAction43, DecisionAction44, DecisionAction45, DecisionAction46, DecisionAction47, DecisionAction48, DecisionAction49, DecisionAction5, DecisionAction50, DecisionAction51, DecisionAction52, DecisionAction53, DecisionAction54, DecisionAction55, DecisionAction56, DecisionAction57, DecisionAction58, DecisionAction59, DecisionAction6, DecisionAction60, DecisionAction61, DecisionAction62, DecisionAction63, DecisionAction64, DecisionAction7, DecisionAction8, DecisionAction9, DeleteMfhInvestmentCases200Status, DeleteMfhInvestmentCasesMutationResponseStatus, DownloadMfhInvestmentCaseSheet200Status, DownloadMfhInvestmentCaseSheetQueryResponseStatus, DuplicateCheckConfigMode, DuplicateCheckConfigMode2, DuplicateCheckConfigMode3, DuplicateCheckConfigScope, DuplicateCheckConfigScope2, EnergyTargetEnergyClass, EnergyTargetEnergyClass10, EnergyTargetEnergyClass11, EnergyTargetEnergyClass12, EnergyTargetEnergyClass13, EnergyTargetEnergyClass14, EnergyTargetEnergyClass15, EnergyTargetEnergyClass16, EnergyTargetEnergyClass17, EnergyTargetEnergyClass18, EnergyTargetEnergyClass19, EnergyTargetEnergyClass2, EnergyTargetEnergyClass20, EnergyTargetEnergyClass21, EnergyTargetEnergyClass22, EnergyTargetEnergyClass23, EnergyTargetEnergyClass24, EnergyTargetEnergyClass25, EnergyTargetEnergyClass26, EnergyTargetEnergyClass27, EnergyTargetEnergyClass3, EnergyTargetEnergyClass4, EnergyTargetEnergyClass5, EnergyTargetEnergyClass6, EnergyTargetEnergyClass7, EnergyTargetEnergyClass8, EnergyTargetEnergyClass9, EvaluationsBuyBoxStatus, EvaluationsBuyBoxStatus2, FailingCriteriaDirection, FailingCriteriaDirection10, FailingCriteriaDirection11, FailingCriteriaDirection12, FailingCriteriaDirection13, FailingCriteriaDirection14, FailingCriteriaDirection15, FailingCriteriaDirection16, FailingCriteriaDirection17, FailingCriteriaDirection18, FailingCriteriaDirection2, FailingCriteriaDirection3, FailingCriteriaDirection4, FailingCriteriaDirection5, FailingCriteriaDirection6, FailingCriteriaDirection7, FailingCriteriaDirection8, FailingCriteriaDirection9, FieldTupleErrorsSourceKind, FieldTupleErrorsSourceKind10, FieldTupleErrorsSourceKind11, FieldTupleErrorsSourceKind12, FieldTupleErrorsSourceKind2, FieldTupleErrorsSourceKind3, FieldTupleErrorsSourceKind4, FieldTupleErrorsSourceKind5, FieldTupleErrorsSourceKind6, FieldTupleErrorsSourceKind7, FieldTupleErrorsSourceKind8, FieldTupleErrorsSourceKind9, FieldTupleErrorsTupleKind, FieldTupleErrorsTupleKind10, FieldTupleErrorsTupleKind11, FieldTupleErrorsTupleKind12, FieldTupleErrorsTupleKind13, FieldTupleErrorsTupleKind14, FieldTupleErrorsTupleKind15, FieldTupleErrorsTupleKind16, FieldTupleErrorsTupleKind2, FieldTupleErrorsTupleKind3, FieldTupleErrorsTupleKind4, FieldTupleErrorsTupleKind5, FieldTupleErrorsTupleKind6, FieldTupleErrorsTupleKind7, FieldTupleErrorsTupleKind8, FieldTupleErrorsTupleKind9, FiltersListedSince, FiltersListedSince10, FiltersListedSince11, FiltersListedSince12, FiltersListedSince13, FiltersListedSince14, FiltersListedSince15, FiltersListedSince16, FiltersListedSince17, FiltersListedSince18, FiltersListedSince19, FiltersListedSince2, FiltersListedSince20, FiltersListedSince21, FiltersListedSince22, FiltersListedSince23, FiltersListedSince24, FiltersListedSince3, FiltersListedSince4, FiltersListedSince5, FiltersListedSince6, FiltersListedSince7, FiltersListedSince8, FiltersListedSince9, FiltersMfhConditions, FiltersMfhConditions2, FiltersMfhConditions3, FiltersMfhConditions4, FindMfhInvestmentCasesByMfhQueryParamsInvestmentCaseType, FindMfhInvestmentCasesByMfhQueryParamsStatus, FindRenovationScenariosQueryParamsGroup, FindRentRollVersionsQueryParamsOrder, FindRentRollVersionsQueryParamsOrder2, FindRentRollVersionsQueryParamsStatus, FindRentRollVersionsQueryParamsStatus2, FindRentRollVersionsQueryParamsStatus3, FindRolesQueryParamsPermissions, FindUserTasksQueryParamsOrder, FindUserTasksQueryParamsOrder2, FindUserTasksQueryParamsSource, FindUserTasksQueryParamsSource2, FindUserTasksQueryParamsSource3, FindUserTasksQueryParamsStatus, FindUserTasksQueryParamsStatus2, FindUserTasksQueryParamsStatus3, FindUserTasksQueryParamsType, FindUserTasksQueryParamsType2, GenerateRentMarketData200MfhConditions, GenerateRentMarketData200RoutingStatus, GenerateRentMarketDataQueryParamsListedSince, GenerateRentMarketDataQueryParamsMfhConditions, GenerateRentMarketDataQueryResponseMfhConditions, GenerateRentMarketDataQueryResponseRoutingStatus, GetAssetsInPipelineConfigQueryParamsSourcingState, GetAssetsInPipelineListQueryParamsInvestmentRiskProfile, GetAssetsInPipelineListQueryParamsInvestmentStrategy, GetAssetsInPipelineListQueryParamsOrder, GetAssetsInPipelineListQueryParamsOrder2, GetEligibleAssetsListQueryParamsEstateType, GetEligibleAssetsListQueryParamsInvestmentRiskProfile, GetEligibleAssetsListQueryParamsInvestmentStrategy, GetEligibleAssetsListQueryParamsMandateType, GetEligibleAssetsListQueryParamsMandateType2, GetEligibleAssetsListQueryParamsOrder, GetEligibleAssetsListQueryParamsOrder2, GetMfhElementImportSheetUrlQueryParamsType, GetMfhElementsQueryParamsType, GetMfhListQueryParamsEstateType, GetMfhListQueryParamsInvestmentRiskProfile, GetMfhListQueryParamsInvestmentStrategy, GetMfhListQueryParamsMandateType, GetMfhListQueryParamsMandateType2, GetMfhListQueryParamsOrder, GetMfhListQueryParamsOrder2, GetMfhRentIndexLookup200PriceModel, GetMfhRentIndexLookup200Status, GetMfhRentIndexLookupQueryResponsePriceModel, GetMfhRentIndexLookupQueryResponseStatus, GetMfhSourcingListQueryParamsEstateType, GetMfhSourcingListQueryParamsInvestmentRiskProfile, GetMfhSourcingListQueryParamsInvestmentStrategy, GetMfhSourcingListQueryParamsMandateType, GetMfhSourcingListQueryParamsMandateType2, GetMfhSourcingListQueryParamsOrder, GetMfhSourcingListQueryParamsOrder2, GetStaticMapImageQueryParamsScale, GetStaticMapImageQueryParamsScale2, InvestmentCaseInvestmentCaseType, InvestmentCaseInvestmentCaseType10, InvestmentCaseInvestmentCaseType11, InvestmentCaseInvestmentCaseType12, InvestmentCaseInvestmentCaseType13, InvestmentCaseInvestmentCaseType14, InvestmentCaseInvestmentCaseType15, InvestmentCaseInvestmentCaseType16, InvestmentCaseInvestmentCaseType17, InvestmentCaseInvestmentCaseType18, InvestmentCaseInvestmentCaseType19, InvestmentCaseInvestmentCaseType2, InvestmentCaseInvestmentCaseType20, InvestmentCaseInvestmentCaseType21, InvestmentCaseInvestmentCaseType22, InvestmentCaseInvestmentCaseType23, InvestmentCaseInvestmentCaseType24, InvestmentCaseInvestmentCaseType25, InvestmentCaseInvestmentCaseType26, InvestmentCaseInvestmentCaseType27, InvestmentCaseInvestmentCaseType28, InvestmentCaseInvestmentCaseType29, InvestmentCaseInvestmentCaseType3, InvestmentCaseInvestmentCaseType30, InvestmentCaseInvestmentCaseType31, InvestmentCaseInvestmentCaseType32, InvestmentCaseInvestmentCaseType33, InvestmentCaseInvestmentCaseType34, InvestmentCaseInvestmentCaseType35, InvestmentCaseInvestmentCaseType36, InvestmentCaseInvestmentCaseType4, InvestmentCaseInvestmentCaseType5, InvestmentCaseInvestmentCaseType6, InvestmentCaseInvestmentCaseType7, InvestmentCaseInvestmentCaseType8, InvestmentCaseInvestmentCaseType9, InvestmentCaseStatus, InvestmentCaseStatus10, InvestmentCaseStatus11, InvestmentCaseStatus12, InvestmentCaseStatus13, InvestmentCaseStatus14, InvestmentCaseStatus15, InvestmentCaseStatus16, InvestmentCaseStatus17, InvestmentCaseStatus18, InvestmentCaseStatus19, InvestmentCaseStatus2, InvestmentCaseStatus20, InvestmentCaseStatus21, InvestmentCaseStatus22, InvestmentCaseStatus23, InvestmentCaseStatus24, InvestmentCaseStatus25, InvestmentCaseStatus26, InvestmentCaseStatus27, InvestmentCaseStatus28, InvestmentCaseStatus29, InvestmentCaseStatus3, InvestmentCaseStatus30, InvestmentCaseStatus31, InvestmentCaseStatus32, InvestmentCaseStatus33, InvestmentCaseStatus34, InvestmentCaseStatus35, InvestmentCaseStatus36, InvestmentCaseStatus4, InvestmentCaseStatus5, InvestmentCaseStatus6, InvestmentCaseStatus7, InvestmentCaseStatus8, InvestmentCaseStatus9, InvestmentCasesInvestmentCaseType, InvestmentCasesInvestmentCaseType2, InvestmentCasesInvestmentCaseType3, InvestmentCasesInvestmentCaseType4, InvestmentCasesStatus, InvestmentCasesStatus2, InvestmentCasesStatus3, InvestmentCasesStatus4, InvestmentVolumeStatus, InvestmentVolumeStatus2, IrrPercentageStatus, IrrPercentageStatus2, LeftStyle, LeftStyle10, LeftStyle11, LeftStyle12, LeftStyle13, LeftStyle14, LeftStyle15, LeftStyle16, LeftStyle17, LeftStyle18, LeftStyle19, LeftStyle2, LeftStyle20, LeftStyle21, LeftStyle22, LeftStyle23, LeftStyle24, LeftStyle25, LeftStyle26, LeftStyle27, LeftStyle28, LeftStyle29, LeftStyle3, LeftStyle30, LeftStyle31, LeftStyle32, LeftStyle33, LeftStyle34, LeftStyle35, LeftStyle36, LeftStyle37, LeftStyle38, LeftStyle39, LeftStyle4, LeftStyle40, LeftStyle41, LeftStyle42, LeftStyle43, LeftStyle44, LeftStyle45, LeftStyle46, LeftStyle47, LeftStyle48, LeftStyle49, LeftStyle5, LeftStyle50, LeftStyle51, LeftStyle52, LeftStyle53, LeftStyle54, LeftStyle55, LeftStyle56, LeftStyle57, LeftStyle58, LeftStyle59, LeftStyle6, LeftStyle60, LeftStyle61, LeftStyle62, LeftStyle63, LeftStyle64, LeftStyle65, LeftStyle66, LeftStyle67, LeftStyle68, LeftStyle69, LeftStyle7, LeftStyle70, LeftStyle71, LeftStyle72, LeftStyle73, LeftStyle74, LeftStyle75, LeftStyle76, LeftStyle77, LeftStyle78, LeftStyle79, LeftStyle8, LeftStyle80, LeftStyle81, LeftStyle82, LeftStyle83, LeftStyle84, LeftStyle85, LeftStyle86, LeftStyle87, LeftStyle88, LeftStyle89, LeftStyle9, LeftStyle90, LeftStyle91, LeftStyle92, LeftStyle93, LeftStyle94, LeftStyle95, LeftStyle96, LeftStyle97, LeftStyle98, LinkableCompaniesRelationName, LinkableContactsRelationName, ListingsCondition, ListingsCondition2, ListingsCondition3, ListingsCondition4, LocationMethod, LocationMethod2, LocationMethod3, LocationMethod4, LocationMethod5, LocationMethod6, LtvStatus, LtvStatus2, MarketRentFallbackProvider, MarketRentFallbackProvider2, MarketRentFallbackProvider3, MarketRentFallbackProvider4, MarketRentFallbackProvider5, MarketRentFallbackProvider6, MarketRentFallbackProvider7, MarketRentFallbackProvider8, MarketRentFallbackStatus, MarketRentFallbackStatus10, MarketRentFallbackStatus11, MarketRentFallbackStatus12, MarketRentFallbackStatus2, MarketRentFallbackStatus3, MarketRentFallbackStatus4, MarketRentFallbackStatus5, MarketRentFallbackStatus6, MarketRentFallbackStatus7, MarketRentFallbackStatus8, MarketRentFallbackStatus9, MarketRentFallbacksProvider, MarketRentFallbacksProvider10, MarketRentFallbacksProvider11, MarketRentFallbacksProvider12, MarketRentFallbacksProvider2, MarketRentFallbacksProvider3, MarketRentFallbacksProvider4, MarketRentFallbacksProvider5, MarketRentFallbacksProvider6, MarketRentFallbacksProvider7, MarketRentFallbacksProvider8, MarketRentFallbacksProvider9, MarketRentFallbacksStatus, MarketRentFallbacksStatus10, MarketRentFallbacksStatus11, MarketRentFallbacksStatus12, MarketRentFallbacksStatus13, MarketRentFallbacksStatus14, MarketRentFallbacksStatus15, MarketRentFallbacksStatus16, MarketRentFallbacksStatus17, MarketRentFallbacksStatus18, MarketRentFallbacksStatus2, MarketRentFallbacksStatus3, MarketRentFallbacksStatus4, MarketRentFallbacksStatus5, MarketRentFallbacksStatus6, MarketRentFallbacksStatus7, MarketRentFallbacksStatus8, MarketRentFallbacksStatus9, MarketRentOptionsProvider, MarketRentOptionsProvider2, MarketRentOptionsProvider3, MarketRentOptionsProvider4, MarketRentOptionsSource, MarketRentOptionsSource2, MarketRentOptionsSource3, MarketRentOptionsSource4, MarketRentOptionsSource5, MarketRentOptionsSource6, MarketRentSelectionProvider, MarketRentSelectionProvider2, MarketRentSelectionProvider3, MarketRentSelectionProvider4, MarketRentSelectionProvider5, MarketRentSelectionProvider6, MarketRentSelectionProvider7, MarketRentSelectionProvider8, MarketRentSelectionSource, MarketRentSelectionSource10, MarketRentSelectionSource11, MarketRentSelectionSource12, MarketRentSelectionSource2, MarketRentSelectionSource3, MarketRentSelectionSource4, MarketRentSelectionSource5, MarketRentSelectionSource6, MarketRentSelectionSource7, MarketRentSelectionSource8, MarketRentSelectionSource9, MfhChannelName, MiddleLeftTopRightStyle, MiddleLeftTopRightStyle10, MiddleLeftTopRightStyle11, MiddleLeftTopRightStyle12, MiddleLeftTopRightStyle13, MiddleLeftTopRightStyle14, MiddleLeftTopRightStyle15, MiddleLeftTopRightStyle16, MiddleLeftTopRightStyle17, MiddleLeftTopRightStyle18, MiddleLeftTopRightStyle19, MiddleLeftTopRightStyle2, MiddleLeftTopRightStyle20, MiddleLeftTopRightStyle21, MiddleLeftTopRightStyle22, MiddleLeftTopRightStyle23, MiddleLeftTopRightStyle24, MiddleLeftTopRightStyle25, MiddleLeftTopRightStyle26, MiddleLeftTopRightStyle27, MiddleLeftTopRightStyle28, MiddleLeftTopRightStyle29, MiddleLeftTopRightStyle3, MiddleLeftTopRightStyle30, MiddleLeftTopRightStyle31, MiddleLeftTopRightStyle32, MiddleLeftTopRightStyle33, MiddleLeftTopRightStyle34, MiddleLeftTopRightStyle35, MiddleLeftTopRightStyle36, MiddleLeftTopRightStyle37, MiddleLeftTopRightStyle38, MiddleLeftTopRightStyle39, MiddleLeftTopRightStyle4, MiddleLeftTopRightStyle40, MiddleLeftTopRightStyle41, MiddleLeftTopRightStyle42, MiddleLeftTopRightStyle43, MiddleLeftTopRightStyle44, MiddleLeftTopRightStyle45, MiddleLeftTopRightStyle46, MiddleLeftTopRightStyle47, MiddleLeftTopRightStyle48, MiddleLeftTopRightStyle49, MiddleLeftTopRightStyle5, MiddleLeftTopRightStyle50, MiddleLeftTopRightStyle51, MiddleLeftTopRightStyle52, MiddleLeftTopRightStyle53, MiddleLeftTopRightStyle54, MiddleLeftTopRightStyle55, MiddleLeftTopRightStyle56, MiddleLeftTopRightStyle57, MiddleLeftTopRightStyle58, MiddleLeftTopRightStyle59, MiddleLeftTopRightStyle6, MiddleLeftTopRightStyle60, MiddleLeftTopRightStyle61, MiddleLeftTopRightStyle62, MiddleLeftTopRightStyle63, MiddleLeftTopRightStyle64, MiddleLeftTopRightStyle65, MiddleLeftTopRightStyle66, MiddleLeftTopRightStyle67, MiddleLeftTopRightStyle68, MiddleLeftTopRightStyle69, MiddleLeftTopRightStyle7, MiddleLeftTopRightStyle70, MiddleLeftTopRightStyle71, MiddleLeftTopRightStyle72, MiddleLeftTopRightStyle73, MiddleLeftTopRightStyle74, MiddleLeftTopRightStyle75, MiddleLeftTopRightStyle76, MiddleLeftTopRightStyle77, MiddleLeftTopRightStyle78, MiddleLeftTopRightStyle79, MiddleLeftTopRightStyle8, MiddleLeftTopRightStyle80, MiddleLeftTopRightStyle81, MiddleLeftTopRightStyle82, MiddleLeftTopRightStyle83, MiddleLeftTopRightStyle84, MiddleLeftTopRightStyle85, MiddleLeftTopRightStyle86, MiddleLeftTopRightStyle87, MiddleLeftTopRightStyle88, MiddleLeftTopRightStyle89, MiddleLeftTopRightStyle9, MiddleLeftTopRightStyle90, MiddleLeftTopRightStyle91, MiddleLeftTopRightStyle92, MiddleLeftTopRightStyle93, MiddleLeftTopRightStyle94, MiddleLeftTopRightStyle95, MiddleLeftTopRightStyle96, MiddleLeftTopRightStyle97, MiddleLeftTopRightStyle98, MissingInputsCode, MissingInputsCode2, MissingInputsSource, MissingInputsSource10, MissingInputsSource11, MissingInputsSource12, MissingInputsSource2, MissingInputsSource3, MissingInputsSource4, MissingInputsSource5, MissingInputsSource6, MissingInputsSource7, MissingInputsSource8, MissingInputsSource9, MocMultiplierStatus, MocMultiplierStatus2, OutputsFormat, OutputsFormat10, OutputsFormat11, OutputsFormat12, OutputsFormat13, OutputsFormat14, OutputsFormat15, OutputsFormat16, OutputsFormat2, OutputsFormat3, OutputsFormat4, OutputsFormat5, OutputsFormat6, OutputsFormat7, OutputsFormat8, OutputsFormat9, OutputsGroup, OutputsGroup10, OutputsGroup11, OutputsGroup12, OutputsGroup13, OutputsGroup14, OutputsGroup15, OutputsGroup16, OutputsGroup17, OutputsGroup18, OutputsGroup19, OutputsGroup2, OutputsGroup20, OutputsGroup21, OutputsGroup22, OutputsGroup23, OutputsGroup24, OutputsGroup25, OutputsGroup26, OutputsGroup27, OutputsGroup28, OutputsGroup3, OutputsGroup4, OutputsGroup5, OutputsGroup6, OutputsGroup7, OutputsGroup8, OutputsGroup9, OverridesKind, OverridesKind2, OverridesKind3, OverridesKind4, ParametersListedSince, ParametersListedSince10, ParametersListedSince11, ParametersListedSince12, ParametersListedSince2, ParametersListedSince3, ParametersListedSince4, ParametersListedSince5, ParametersListedSince6, ParametersListedSince7, ParametersListedSince8, ParametersListedSince9, ParametersMfhConditions, ParametersMfhConditions2, ParseMfhElementsFromSheetMutationRequestType, PreferredLocationsStatus, PreferredLocationsStatus2, PreferredLocationsThreshold, PreferredLocationsThreshold2, PreferredLocationsValue, PreferredLocationsValue2, PreoptimizationLogKind, PreoptimizationLogKind2, PreoptimizationLogKind3, PreoptimizationLogKind4, PreoptimizationLogKind5, PreoptimizationLogKind6, PreoptimizationLogKind7, PreoptimizationLogKind8, PreoptimizationLogOutcome, PreoptimizationLogOutcome10, PreoptimizationLogOutcome11, PreoptimizationLogOutcome12, PreoptimizationLogOutcome2, PreoptimizationLogOutcome3, PreoptimizationLogOutcome4, PreoptimizationLogOutcome5, PreoptimizationLogOutcome6, PreoptimizationLogOutcome7, PreoptimizationLogOutcome8, PreoptimizationLogOutcome9, PrepareMfhInvestmentCase200Status, PrepareMfhInvestmentCaseMutationResponseStatus, ProblemsSource, ProblemsSource2, ProblemsSource3, ProblemsSource4, ProcessRentRollVersionEventMutationRequestEvent, ProcessRentRollVersionEventMutationRequestEvent2, ProcessRentRollVersionEventMutationRequestEvent3, PurchasePriceDiscountStatus, PurchasePriceDiscountStatus2, PurchasePriceStatus, PurchasePriceStatus2, QueryDocumentCategories, QueryDocumentCategories10, QueryDocumentCategories11, QueryDocumentCategories12, QueryDocumentCategories13, QueryDocumentCategories14, QueryDocumentCategories15, QueryDocumentCategories16, QueryDocumentCategories17, QueryDocumentCategories18, QueryDocumentCategories19, QueryDocumentCategories2, QueryDocumentCategories20, QueryDocumentCategories21, QueryDocumentCategories22, QueryDocumentCategories23, QueryDocumentCategories24, QueryDocumentCategories25, QueryDocumentCategories26, QueryDocumentCategories27, QueryDocumentCategories28, QueryDocumentCategories3, QueryDocumentCategories4, QueryDocumentCategories5, QueryDocumentCategories6, QueryDocumentCategories7, QueryDocumentCategories8, QueryDocumentCategories9, QueryDocumentTypes, QueryDocumentTypes10, QueryDocumentTypes100, QueryDocumentTypes101, QueryDocumentTypes102, QueryDocumentTypes103, QueryDocumentTypes104, QueryDocumentTypes105, QueryDocumentTypes106, QueryDocumentTypes107, QueryDocumentTypes108, QueryDocumentTypes109, QueryDocumentTypes11, QueryDocumentTypes110, QueryDocumentTypes111, QueryDocumentTypes112, QueryDocumentTypes113, QueryDocumentTypes114, QueryDocumentTypes115, QueryDocumentTypes116, QueryDocumentTypes117, QueryDocumentTypes118, QueryDocumentTypes119, QueryDocumentTypes12, QueryDocumentTypes120, QueryDocumentTypes121, QueryDocumentTypes122, QueryDocumentTypes123, QueryDocumentTypes124, QueryDocumentTypes125, QueryDocumentTypes126, QueryDocumentTypes127, QueryDocumentTypes128, QueryDocumentTypes129, QueryDocumentTypes13, QueryDocumentTypes130, QueryDocumentTypes131, QueryDocumentTypes132, QueryDocumentTypes133, QueryDocumentTypes134, QueryDocumentTypes135, QueryDocumentTypes136, QueryDocumentTypes137, QueryDocumentTypes138, QueryDocumentTypes139, QueryDocumentTypes14, QueryDocumentTypes140, QueryDocumentTypes141, QueryDocumentTypes142, QueryDocumentTypes143, QueryDocumentTypes144, QueryDocumentTypes145, QueryDocumentTypes146, QueryDocumentTypes147, QueryDocumentTypes148, QueryDocumentTypes149, QueryDocumentTypes15, QueryDocumentTypes150, QueryDocumentTypes151, QueryDocumentTypes152, QueryDocumentTypes153, QueryDocumentTypes154, QueryDocumentTypes155, QueryDocumentTypes156, QueryDocumentTypes157, QueryDocumentTypes158, QueryDocumentTypes159, QueryDocumentTypes16, QueryDocumentTypes160, QueryDocumentTypes161, QueryDocumentTypes162, QueryDocumentTypes163, QueryDocumentTypes164, QueryDocumentTypes165, QueryDocumentTypes166, QueryDocumentTypes167, QueryDocumentTypes168, QueryDocumentTypes169, QueryDocumentTypes17, QueryDocumentTypes170, QueryDocumentTypes171, QueryDocumentTypes172, QueryDocumentTypes173, QueryDocumentTypes174, QueryDocumentTypes175, QueryDocumentTypes176, QueryDocumentTypes177, QueryDocumentTypes178, QueryDocumentTypes179, QueryDocumentTypes18, QueryDocumentTypes180, QueryDocumentTypes181, QueryDocumentTypes182, QueryDocumentTypes183, QueryDocumentTypes184, QueryDocumentTypes185, QueryDocumentTypes186, QueryDocumentTypes187, QueryDocumentTypes188, QueryDocumentTypes189, QueryDocumentTypes19, QueryDocumentTypes190, QueryDocumentTypes191, QueryDocumentTypes192, QueryDocumentTypes193, QueryDocumentTypes194, QueryDocumentTypes195, QueryDocumentTypes196, QueryDocumentTypes197, QueryDocumentTypes198, QueryDocumentTypes199, QueryDocumentTypes2, QueryDocumentTypes20, QueryDocumentTypes200, QueryDocumentTypes201, QueryDocumentTypes202, QueryDocumentTypes203, QueryDocumentTypes204, QueryDocumentTypes205, QueryDocumentTypes206, QueryDocumentTypes207, QueryDocumentTypes208, QueryDocumentTypes209, QueryDocumentTypes21, QueryDocumentTypes210, QueryDocumentTypes211, QueryDocumentTypes212, QueryDocumentTypes213, QueryDocumentTypes214, QueryDocumentTypes215, QueryDocumentTypes216, QueryDocumentTypes217, QueryDocumentTypes218, QueryDocumentTypes219, QueryDocumentTypes22, QueryDocumentTypes220, QueryDocumentTypes221, QueryDocumentTypes222, QueryDocumentTypes223, QueryDocumentTypes224, QueryDocumentTypes225, QueryDocumentTypes226, QueryDocumentTypes227, QueryDocumentTypes228, QueryDocumentTypes229, QueryDocumentTypes23, QueryDocumentTypes230, QueryDocumentTypes231, QueryDocumentTypes232, QueryDocumentTypes233, QueryDocumentTypes234, QueryDocumentTypes235, QueryDocumentTypes236, QueryDocumentTypes237, QueryDocumentTypes238, QueryDocumentTypes239, QueryDocumentTypes24, QueryDocumentTypes240, QueryDocumentTypes241, QueryDocumentTypes242, QueryDocumentTypes243, QueryDocumentTypes244, QueryDocumentTypes245, QueryDocumentTypes246, QueryDocumentTypes247, QueryDocumentTypes248, QueryDocumentTypes249, QueryDocumentTypes25, QueryDocumentTypes250, QueryDocumentTypes251, QueryDocumentTypes252, QueryDocumentTypes253, QueryDocumentTypes254, QueryDocumentTypes255, QueryDocumentTypes256, QueryDocumentTypes257, QueryDocumentTypes258, QueryDocumentTypes259, QueryDocumentTypes26, QueryDocumentTypes260, QueryDocumentTypes261, QueryDocumentTypes262, QueryDocumentTypes263, QueryDocumentTypes264, QueryDocumentTypes265, QueryDocumentTypes266, QueryDocumentTypes267, QueryDocumentTypes268, QueryDocumentTypes269, QueryDocumentTypes27, QueryDocumentTypes270, QueryDocumentTypes271, QueryDocumentTypes272, QueryDocumentTypes273, QueryDocumentTypes274, QueryDocumentTypes275, QueryDocumentTypes276, QueryDocumentTypes277, QueryDocumentTypes278, QueryDocumentTypes279, QueryDocumentTypes28, QueryDocumentTypes280, QueryDocumentTypes281, QueryDocumentTypes282, QueryDocumentTypes283, QueryDocumentTypes284, QueryDocumentTypes285, QueryDocumentTypes286, QueryDocumentTypes287, QueryDocumentTypes288, QueryDocumentTypes289, QueryDocumentTypes29, QueryDocumentTypes290, QueryDocumentTypes291, QueryDocumentTypes292, QueryDocumentTypes293, QueryDocumentTypes294, QueryDocumentTypes295, QueryDocumentTypes296, QueryDocumentTypes297, QueryDocumentTypes298, QueryDocumentTypes299, QueryDocumentTypes3, QueryDocumentTypes30, QueryDocumentTypes300, QueryDocumentTypes301, QueryDocumentTypes302, QueryDocumentTypes303, QueryDocumentTypes304, QueryDocumentTypes305, QueryDocumentTypes306, QueryDocumentTypes307, QueryDocumentTypes308, QueryDocumentTypes309, QueryDocumentTypes31, QueryDocumentTypes310, QueryDocumentTypes311, QueryDocumentTypes312, QueryDocumentTypes313, QueryDocumentTypes314, QueryDocumentTypes315, QueryDocumentTypes316, QueryDocumentTypes317, QueryDocumentTypes318, QueryDocumentTypes319, QueryDocumentTypes32, QueryDocumentTypes320, QueryDocumentTypes321, QueryDocumentTypes322, QueryDocumentTypes323, QueryDocumentTypes324, QueryDocumentTypes325, QueryDocumentTypes326, QueryDocumentTypes327, QueryDocumentTypes328, QueryDocumentTypes329, QueryDocumentTypes33, QueryDocumentTypes330, QueryDocumentTypes331, QueryDocumentTypes332, QueryDocumentTypes333, QueryDocumentTypes334, QueryDocumentTypes335, QueryDocumentTypes336, QueryDocumentTypes337, QueryDocumentTypes338, QueryDocumentTypes339, QueryDocumentTypes34, QueryDocumentTypes340, QueryDocumentTypes341, QueryDocumentTypes342, QueryDocumentTypes343, QueryDocumentTypes344, QueryDocumentTypes345, QueryDocumentTypes346, QueryDocumentTypes347, QueryDocumentTypes348, QueryDocumentTypes349, QueryDocumentTypes35, QueryDocumentTypes350, QueryDocumentTypes351, QueryDocumentTypes352, QueryDocumentTypes353, QueryDocumentTypes354, QueryDocumentTypes355, QueryDocumentTypes356, QueryDocumentTypes357, QueryDocumentTypes358, QueryDocumentTypes359, QueryDocumentTypes36, QueryDocumentTypes360, QueryDocumentTypes361, QueryDocumentTypes362, QueryDocumentTypes37, QueryDocumentTypes38, QueryDocumentTypes39, QueryDocumentTypes4, QueryDocumentTypes40, QueryDocumentTypes41, QueryDocumentTypes42, QueryDocumentTypes43, QueryDocumentTypes44, QueryDocumentTypes45, QueryDocumentTypes46, QueryDocumentTypes47, QueryDocumentTypes48, QueryDocumentTypes49, QueryDocumentTypes5, QueryDocumentTypes50, QueryDocumentTypes51, QueryDocumentTypes52, QueryDocumentTypes53, QueryDocumentTypes54, QueryDocumentTypes55, QueryDocumentTypes56, QueryDocumentTypes57, QueryDocumentTypes58, QueryDocumentTypes59, QueryDocumentTypes6, QueryDocumentTypes60, QueryDocumentTypes61, QueryDocumentTypes62, QueryDocumentTypes63, QueryDocumentTypes64, QueryDocumentTypes65, QueryDocumentTypes66, QueryDocumentTypes67, QueryDocumentTypes68, QueryDocumentTypes69, QueryDocumentTypes7, QueryDocumentTypes70, QueryDocumentTypes71, QueryDocumentTypes72, QueryDocumentTypes73, QueryDocumentTypes74, QueryDocumentTypes75, QueryDocumentTypes76, QueryDocumentTypes77, QueryDocumentTypes78, QueryDocumentTypes79, QueryDocumentTypes8, QueryDocumentTypes80, QueryDocumentTypes81, QueryDocumentTypes82, QueryDocumentTypes83, QueryDocumentTypes84, QueryDocumentTypes85, QueryDocumentTypes86, QueryDocumentTypes87, QueryDocumentTypes88, QueryDocumentTypes89, QueryDocumentTypes9, QueryDocumentTypes90, QueryDocumentTypes91, QueryDocumentTypes92, QueryDocumentTypes93, QueryDocumentTypes94, QueryDocumentTypes95, QueryDocumentTypes96, QueryDocumentTypes97, QueryDocumentTypes98, QueryDocumentTypes99, QueryServiceChargeStatementIds, QuerySource, QueryStatus, RecalculateMfhInvestmentCaseMutationRequestVersionTriggerType, RecalculateSheetlessMfhInvestmentCaseMutationRequestInputOrigin, RecalculateSheetlessMfhInvestmentCaseMutationRequestVersionTriggerType, RegenerateIcTeaser200Status, RegenerateIcTeaserFieldsMutationRequestKeys, RegenerateIcTeaserMutationResponseStatus, RenovationEnergeticMeasureType, RenovationScenarioExpansionType, RenovationScenarioGroupCode, RenovationScenarioSubsidyScheme, RentRollsApartmentCondition, RentRollsApartmentCondition2, RentRollsApartmentCondition3, RentRollsApartmentCondition4, RentRollsApartmentCondition5, RentRollsApartmentCondition6, RentRollsApartmentCondition7, RentRollsApartmentCondition8, RentRollsApartmentCondition9, RentRollsApartmentType, RentRollsApartmentType10, RentRollsApartmentType11, RentRollsApartmentType12, RentRollsApartmentType13, RentRollsApartmentType14, RentRollsApartmentType15, RentRollsApartmentType16, RentRollsApartmentType17, RentRollsApartmentType18, RentRollsApartmentType19, RentRollsApartmentType2, RentRollsApartmentType20, RentRollsApartmentType21, RentRollsApartmentType22, RentRollsApartmentType23, RentRollsApartmentType24, RentRollsApartmentType25, RentRollsApartmentType26, RentRollsApartmentType27, RentRollsApartmentType28, RentRollsApartmentType29, RentRollsApartmentType3, RentRollsApartmentType30, RentRollsApartmentType31, RentRollsApartmentType32, RentRollsApartmentType33, RentRollsApartmentType34, RentRollsApartmentType35, RentRollsApartmentType36, RentRollsApartmentType37, RentRollsApartmentType38, RentRollsApartmentType39, RentRollsApartmentType4, RentRollsApartmentType40, RentRollsApartmentType41, RentRollsApartmentType42, RentRollsApartmentType43, RentRollsApartmentType44, RentRollsApartmentType45, RentRollsApartmentType46, RentRollsApartmentType47, RentRollsApartmentType48, RentRollsApartmentType49, RentRollsApartmentType5, RentRollsApartmentType50, RentRollsApartmentType51, RentRollsApartmentType52, RentRollsApartmentType53, RentRollsApartmentType54, RentRollsApartmentType55, RentRollsApartmentType56, RentRollsApartmentType57, RentRollsApartmentType58, RentRollsApartmentType59, RentRollsApartmentType6, RentRollsApartmentType60, RentRollsApartmentType61, RentRollsApartmentType62, RentRollsApartmentType63, RentRollsApartmentType64, RentRollsApartmentType65, RentRollsApartmentType66, RentRollsApartmentType67, RentRollsApartmentType68, RentRollsApartmentType69, RentRollsApartmentType7, RentRollsApartmentType70, RentRollsApartmentType71, RentRollsApartmentType72, RentRollsApartmentType73, RentRollsApartmentType74, RentRollsApartmentType75, RentRollsApartmentType76, RentRollsApartmentType77, RentRollsApartmentType78, RentRollsApartmentType79, RentRollsApartmentType8, RentRollsApartmentType80, RentRollsApartmentType81, RentRollsApartmentType9, RentRollsCondoSalesCondition, RentRollsCondoSalesCondition2, RentRollsCondoSalesCondition3, RentRollsCondoSalesCondition4, RentRollsCondoSalesCondition5, RentRollsCondoSalesCondition6, RentRollsCondoSalesCondition7, RentRollsCondoSalesCondition8, RentRollsCondoSalesCondition9, RentRollsRentIncreaseType, RentRollsRentIncreaseType10, RentRollsRentIncreaseType11, RentRollsRentIncreaseType12, RentRollsRentIncreaseType2, RentRollsRentIncreaseType3, RentRollsRentIncreaseType4, RentRollsRentIncreaseType5, RentRollsRentIncreaseType6, RentRollsRentIncreaseType7, RentRollsRentIncreaseType8, RentRollsRentIncreaseType9, RentRollsRentingState, RentRollsRentingState10, RentRollsRentingState11, RentRollsRentingState12, RentRollsRentingState2, RentRollsRentingState3, RentRollsRentingState4, RentRollsRentingState5, RentRollsRentingState6, RentRollsRentingState7, RentRollsRentingState8, RentRollsRentingState9, ReplaceRentRollVersionData200Outcome, ReplaceRentRollVersionData200Outcome2, ReplaceRentRollVersionDataMutationResponseOutcome, ReplaceRentRollVersionDataMutationResponseOutcome2, ResultMfhConditions, ResultMfhConditions2, ResultRoutingStatus, ResultRoutingStatus2, RightStyle, RightStyle10, RightStyle11, RightStyle12, RightStyle13, RightStyle14, RightStyle15, RightStyle16, RightStyle17, RightStyle18, RightStyle19, RightStyle2, RightStyle20, RightStyle21, RightStyle22, RightStyle23, RightStyle24, RightStyle25, RightStyle26, RightStyle27, RightStyle28, RightStyle29, RightStyle3, RightStyle30, RightStyle31, RightStyle32, RightStyle33, RightStyle34, RightStyle35, RightStyle36, RightStyle37, RightStyle38, RightStyle39, RightStyle4, RightStyle40, RightStyle41, RightStyle42, RightStyle43, RightStyle44, RightStyle45, RightStyle46, RightStyle47, RightStyle48, RightStyle49, RightStyle5, RightStyle50, RightStyle51, RightStyle52, RightStyle53, RightStyle54, RightStyle55, RightStyle56, RightStyle57, RightStyle58, RightStyle59, RightStyle6, RightStyle60, RightStyle61, RightStyle62, RightStyle63, RightStyle64, RightStyle65, RightStyle66, RightStyle67, RightStyle68, RightStyle69, RightStyle7, RightStyle70, RightStyle71, RightStyle72, RightStyle73, RightStyle74, RightStyle75, RightStyle76, RightStyle77, RightStyle78, RightStyle79, RightStyle8, RightStyle80, RightStyle81, RightStyle82, RightStyle83, RightStyle84, RightStyle85, RightStyle86, RightStyle87, RightStyle88, RightStyle89, RightStyle9, RightStyle90, RightStyle91, RightStyle92, RightStyle93, RightStyle94, RightStyle95, RightStyle96, RightStyle97, RightStyle98, RolePermissions, RolePermissions2, RolesPermissions, RowsApartmentType, RowsApartmentType2, RowsRentIncreaseType, RowsRentIncreaseType2, RowsRentingState, RowsRentingState2, RunMfhInvestmentCaseSensitivity200Version, RunMfhInvestmentCaseSensitivity200Version10, RunMfhInvestmentCaseSensitivity200Version11, RunMfhInvestmentCaseSensitivity200Version2, RunMfhInvestmentCaseSensitivity200Version3, RunMfhInvestmentCaseSensitivity200Version4, RunMfhInvestmentCaseSensitivity200Version5, RunMfhInvestmentCaseSensitivity200Version6, RunMfhInvestmentCaseSensitivity200Version7, RunMfhInvestmentCaseSensitivity200Version8, RunMfhInvestmentCaseSensitivity200Version9, RunMfhInvestmentCaseSensitivityMutationResponseVersion, RunMfhInvestmentCaseSensitivityMutationResponseVersion10, RunMfhInvestmentCaseSensitivityMutationResponseVersion11, RunMfhInvestmentCaseSensitivityMutationResponseVersion2, RunMfhInvestmentCaseSensitivityMutationResponseVersion3, RunMfhInvestmentCaseSensitivityMutationResponseVersion4, RunMfhInvestmentCaseSensitivityMutationResponseVersion5, RunMfhInvestmentCaseSensitivityMutationResponseVersion6, RunMfhInvestmentCaseSensitivityMutationResponseVersion7, RunMfhInvestmentCaseSensitivityMutationResponseVersion8, RunMfhInvestmentCaseSensitivityMutationResponseVersion9, ScreenMfhInvestmentCasePartnerRenovationCell200BuyBoxStatus, ScreenMfhInvestmentCasePartnerRenovationCellMutationResponseBuyBoxStatus, ScreenMfhInvestmentCasePartnerRenovationMatrixMutationRequestMarketRentSource, ScreenMfhInvestmentCasePartnerRenovationMatrixMutationRequestMarketRentSource2, ScreenMfhInvestmentCasePartnerRenovationMatrixMutationRequestMarketRentSource3, SepaDirectDebitSource, SepaDirectDebitSource2, SepaDirectDebitStatus, SepaDirectDebitType, SepaMandateDtoMandateType, SepaMandateDtoSource, SepaMandateDtoSource2, SepaMandateDtoStatus, SepaMandateFullDtoMandateType, SepaMandateFullDtoSource, SepaMandateFullDtoSource2, SepaMandateFullDtoStatus, SeriesFormat, SeriesFormat10, SeriesFormat11, SeriesFormat12, SeriesFormat13, SeriesFormat14, SeriesFormat15, SeriesFormat16, SeriesFormat2, SeriesFormat3, SeriesFormat4, SeriesFormat5, SeriesFormat6, SeriesFormat7, SeriesFormat8, SeriesFormat9, SlicesFormat, SlicesFormat10, SlicesFormat11, SlicesFormat12, SlicesFormat13, SlicesFormat14, SlicesFormat15, SlicesFormat16, SlicesFormat2, SlicesFormat3, SlicesFormat4, SlicesFormat5, SlicesFormat6, SlicesFormat7, SlicesFormat8, SlicesFormat9, SlicesRole, SlicesRole10, SlicesRole11, SlicesRole12, SlicesRole2, SlicesRole3, SlicesRole4, SlicesRole5, SlicesRole6, SlicesRole7, SlicesRole8, SlicesRole9, SlidesBodyKind, SlidesBodyKind10, SlidesBodyKind11, SlidesBodyKind12, SlidesBodyKind13, SlidesBodyKind14, SlidesBodyKind2, SlidesBodyKind3, SlidesBodyKind4, SlidesBodyKind5, SlidesBodyKind6, SlidesBodyKind7, SlidesBodyKind8, SlidesBodyKind9, SourceType, SourceType2, SourceType3, SourceType4, SourceType5, SourceType6, SourceType7, SourceType8, StyleHorizontalAlign, StyleHorizontalAlign10, StyleHorizontalAlign11, StyleHorizontalAlign12, StyleHorizontalAlign13, StyleHorizontalAlign14, StyleHorizontalAlign15, StyleHorizontalAlign16, StyleHorizontalAlign17, StyleHorizontalAlign18, StyleHorizontalAlign19, StyleHorizontalAlign2, StyleHorizontalAlign20, StyleHorizontalAlign21, StyleHorizontalAlign22, StyleHorizontalAlign23, StyleHorizontalAlign24, StyleHorizontalAlign25, StyleHorizontalAlign26, StyleHorizontalAlign27, StyleHorizontalAlign28, StyleHorizontalAlign29, StyleHorizontalAlign3, StyleHorizontalAlign30, StyleHorizontalAlign31, StyleHorizontalAlign32, StyleHorizontalAlign33, StyleHorizontalAlign34, StyleHorizontalAlign35, StyleHorizontalAlign36, StyleHorizontalAlign37, StyleHorizontalAlign38, StyleHorizontalAlign39, StyleHorizontalAlign4, StyleHorizontalAlign40, StyleHorizontalAlign41, StyleHorizontalAlign42, StyleHorizontalAlign43, StyleHorizontalAlign44, StyleHorizontalAlign45, StyleHorizontalAlign46, StyleHorizontalAlign47, StyleHorizontalAlign48, StyleHorizontalAlign49, StyleHorizontalAlign5, StyleHorizontalAlign6, StyleHorizontalAlign7, StyleHorizontalAlign8, StyleHorizontalAlign9, StyleVerticalAlign, StyleVerticalAlign10, StyleVerticalAlign11, StyleVerticalAlign12, StyleVerticalAlign13, StyleVerticalAlign14, StyleVerticalAlign15, StyleVerticalAlign16, StyleVerticalAlign17, StyleVerticalAlign18, StyleVerticalAlign19, StyleVerticalAlign2, StyleVerticalAlign20, StyleVerticalAlign21, StyleVerticalAlign22, StyleVerticalAlign23, StyleVerticalAlign24, StyleVerticalAlign25, StyleVerticalAlign26, StyleVerticalAlign27, StyleVerticalAlign28, StyleVerticalAlign3, StyleVerticalAlign4, StyleVerticalAlign5, StyleVerticalAlign6, StyleVerticalAlign7, StyleVerticalAlign8, StyleVerticalAlign9, StyleWrapStrategy, StyleWrapStrategy10, StyleWrapStrategy11, StyleWrapStrategy12, StyleWrapStrategy13, StyleWrapStrategy14, StyleWrapStrategy15, StyleWrapStrategy16, StyleWrapStrategy17, StyleWrapStrategy18, StyleWrapStrategy19, StyleWrapStrategy2, StyleWrapStrategy20, StyleWrapStrategy21, StyleWrapStrategy22, StyleWrapStrategy23, StyleWrapStrategy24, StyleWrapStrategy25, StyleWrapStrategy26, StyleWrapStrategy27, StyleWrapStrategy28, StyleWrapStrategy3, StyleWrapStrategy4, StyleWrapStrategy5, StyleWrapStrategy6, StyleWrapStrategy7, StyleWrapStrategy8, StyleWrapStrategy9, SubsidiesBegEmOption, SubsidiesBegEmOption10, SubsidiesBegEmOption11, SubsidiesBegEmOption12, SubsidiesBegEmOption13, SubsidiesBegEmOption14, SubsidiesBegEmOption15, SubsidiesBegEmOption2, SubsidiesBegEmOption3, SubsidiesBegEmOption4, SubsidiesBegEmOption5, SubsidiesBegEmOption6, SubsidiesBegEmOption7, SubsidiesBegEmOption8, SubsidiesBegEmOption9, SubsidiesIfbStandard, SubsidiesIfbStandard10, SubsidiesIfbStandard11, SubsidiesIfbStandard12, SubsidiesIfbStandard13, SubsidiesIfbStandard14, SubsidiesIfbStandard15, SubsidiesIfbStandard16, SubsidiesIfbStandard17, SubsidiesIfbStandard18, SubsidiesIfbStandard2, SubsidiesIfbStandard3, SubsidiesIfbStandard4, SubsidiesIfbStandard5, SubsidiesIfbStandard6, SubsidiesIfbStandard7, SubsidiesIfbStandard8, SubsidiesIfbStandard9, SubsidiesKfwStandard, SubsidiesKfwStandard10, SubsidiesKfwStandard11, SubsidiesKfwStandard12, SubsidiesKfwStandard2, SubsidiesKfwStandard3, SubsidiesKfwStandard4, SubsidiesKfwStandard5, SubsidiesKfwStandard6, SubsidiesKfwStandard7, SubsidiesKfwStandard8, SubsidiesKfwStandard9, TargetOutputInvestmentCaseType, TargetOutputInvestmentCaseType2, TargetOutputStatus, TargetOutputStatus2, TopLeftBottomCenterStyle, TopLeftBottomCenterStyle10, TopLeftBottomCenterStyle11, TopLeftBottomCenterStyle12, TopLeftBottomCenterStyle13, TopLeftBottomCenterStyle14, TopLeftBottomCenterStyle15, TopLeftBottomCenterStyle16, TopLeftBottomCenterStyle17, TopLeftBottomCenterStyle18, TopLeftBottomCenterStyle19, TopLeftBottomCenterStyle2, TopLeftBottomCenterStyle20, TopLeftBottomCenterStyle21, TopLeftBottomCenterStyle22, TopLeftBottomCenterStyle23, TopLeftBottomCenterStyle24, TopLeftBottomCenterStyle25, TopLeftBottomCenterStyle26, TopLeftBottomCenterStyle27, TopLeftBottomCenterStyle28, TopLeftBottomCenterStyle29, TopLeftBottomCenterStyle3, TopLeftBottomCenterStyle30, TopLeftBottomCenterStyle31, TopLeftBottomCenterStyle32, TopLeftBottomCenterStyle33, TopLeftBottomCenterStyle34, TopLeftBottomCenterStyle35, TopLeftBottomCenterStyle36, TopLeftBottomCenterStyle37, TopLeftBottomCenterStyle38, TopLeftBottomCenterStyle39, TopLeftBottomCenterStyle4, TopLeftBottomCenterStyle40, TopLeftBottomCenterStyle41, TopLeftBottomCenterStyle42, TopLeftBottomCenterStyle43, TopLeftBottomCenterStyle44, TopLeftBottomCenterStyle45, TopLeftBottomCenterStyle46, TopLeftBottomCenterStyle47, TopLeftBottomCenterStyle48, TopLeftBottomCenterStyle49, TopLeftBottomCenterStyle5, TopLeftBottomCenterStyle50, TopLeftBottomCenterStyle51, TopLeftBottomCenterStyle52, TopLeftBottomCenterStyle53, TopLeftBottomCenterStyle54, TopLeftBottomCenterStyle55, TopLeftBottomCenterStyle56, TopLeftBottomCenterStyle57, TopLeftBottomCenterStyle58, TopLeftBottomCenterStyle59, TopLeftBottomCenterStyle6, TopLeftBottomCenterStyle60, TopLeftBottomCenterStyle61, TopLeftBottomCenterStyle62, TopLeftBottomCenterStyle63, TopLeftBottomCenterStyle64, TopLeftBottomCenterStyle65, TopLeftBottomCenterStyle66, TopLeftBottomCenterStyle67, TopLeftBottomCenterStyle68, TopLeftBottomCenterStyle69, TopLeftBottomCenterStyle7, TopLeftBottomCenterStyle70, TopLeftBottomCenterStyle71, TopLeftBottomCenterStyle72, TopLeftBottomCenterStyle73, TopLeftBottomCenterStyle74, TopLeftBottomCenterStyle75, TopLeftBottomCenterStyle76, TopLeftBottomCenterStyle77, TopLeftBottomCenterStyle78, TopLeftBottomCenterStyle79, TopLeftBottomCenterStyle8, TopLeftBottomCenterStyle80, TopLeftBottomCenterStyle81, TopLeftBottomCenterStyle82, TopLeftBottomCenterStyle83, TopLeftBottomCenterStyle84, TopLeftBottomCenterStyle85, TopLeftBottomCenterStyle86, TopLeftBottomCenterStyle87, TopLeftBottomCenterStyle88, TopLeftBottomCenterStyle89, TopLeftBottomCenterStyle9, TopLeftBottomCenterStyle90, TopLeftBottomCenterStyle91, TopLeftBottomCenterStyle92, TopLeftBottomCenterStyle93, TopLeftBottomCenterStyle94, TopLeftBottomCenterStyle95, TopLeftBottomCenterStyle96, TopLeftBottomCenterStyle97, TopLeftBottomCenterStyle98, TopLeftBottomRightStyle, TopLeftBottomRightStyle10, TopLeftBottomRightStyle11, TopLeftBottomRightStyle12, TopLeftBottomRightStyle13, TopLeftBottomRightStyle14, TopLeftBottomRightStyle15, TopLeftBottomRightStyle16, TopLeftBottomRightStyle17, TopLeftBottomRightStyle18, TopLeftBottomRightStyle19, TopLeftBottomRightStyle2, TopLeftBottomRightStyle20, TopLeftBottomRightStyle21, TopLeftBottomRightStyle22, TopLeftBottomRightStyle23, TopLeftBottomRightStyle24, TopLeftBottomRightStyle25, TopLeftBottomRightStyle26, TopLeftBottomRightStyle27, TopLeftBottomRightStyle28, TopLeftBottomRightStyle29, TopLeftBottomRightStyle3, TopLeftBottomRightStyle30, TopLeftBottomRightStyle31, TopLeftBottomRightStyle32, TopLeftBottomRightStyle33, TopLeftBottomRightStyle34, TopLeftBottomRightStyle35, TopLeftBottomRightStyle36, TopLeftBottomRightStyle37, TopLeftBottomRightStyle38, TopLeftBottomRightStyle39, TopLeftBottomRightStyle4, TopLeftBottomRightStyle40, TopLeftBottomRightStyle41, TopLeftBottomRightStyle42, TopLeftBottomRightStyle43, TopLeftBottomRightStyle44, TopLeftBottomRightStyle45, TopLeftBottomRightStyle46, TopLeftBottomRightStyle47, TopLeftBottomRightStyle48, TopLeftBottomRightStyle49, TopLeftBottomRightStyle5, TopLeftBottomRightStyle50, TopLeftBottomRightStyle51, TopLeftBottomRightStyle52, TopLeftBottomRightStyle53, TopLeftBottomRightStyle54, TopLeftBottomRightStyle55, TopLeftBottomRightStyle56, TopLeftBottomRightStyle57, TopLeftBottomRightStyle58, TopLeftBottomRightStyle59, TopLeftBottomRightStyle6, TopLeftBottomRightStyle60, TopLeftBottomRightStyle61, TopLeftBottomRightStyle62, TopLeftBottomRightStyle63, TopLeftBottomRightStyle64, TopLeftBottomRightStyle65, TopLeftBottomRightStyle66, TopLeftBottomRightStyle67, TopLeftBottomRightStyle68, TopLeftBottomRightStyle69, TopLeftBottomRightStyle7, TopLeftBottomRightStyle70, TopLeftBottomRightStyle71, TopLeftBottomRightStyle72, TopLeftBottomRightStyle73, TopLeftBottomRightStyle74, TopLeftBottomRightStyle75, TopLeftBottomRightStyle76, TopLeftBottomRightStyle77, TopLeftBottomRightStyle78, TopLeftBottomRightStyle79, TopLeftBottomRightStyle8, TopLeftBottomRightStyle80, TopLeftBottomRightStyle81, TopLeftBottomRightStyle82, TopLeftBottomRightStyle83, TopLeftBottomRightStyle84, TopLeftBottomRightStyle85, TopLeftBottomRightStyle86, TopLeftBottomRightStyle87, TopLeftBottomRightStyle88, TopLeftBottomRightStyle89, TopLeftBottomRightStyle9, TopLeftBottomRightStyle90, TopLeftBottomRightStyle91, TopLeftBottomRightStyle92, TopLeftBottomRightStyle93, TopLeftBottomRightStyle94, TopLeftBottomRightStyle95, TopLeftBottomRightStyle96, TopLeftBottomRightStyle97, TopLeftBottomRightStyle98, TopLeftMiddleRightStyle, TopLeftMiddleRightStyle10, TopLeftMiddleRightStyle11, TopLeftMiddleRightStyle12, TopLeftMiddleRightStyle13, TopLeftMiddleRightStyle14, TopLeftMiddleRightStyle15, TopLeftMiddleRightStyle16, TopLeftMiddleRightStyle17, TopLeftMiddleRightStyle18, TopLeftMiddleRightStyle19, TopLeftMiddleRightStyle2, TopLeftMiddleRightStyle20, TopLeftMiddleRightStyle21, TopLeftMiddleRightStyle22, TopLeftMiddleRightStyle23, TopLeftMiddleRightStyle24, TopLeftMiddleRightStyle25, TopLeftMiddleRightStyle26, TopLeftMiddleRightStyle27, TopLeftMiddleRightStyle28, TopLeftMiddleRightStyle29, TopLeftMiddleRightStyle3, TopLeftMiddleRightStyle30, TopLeftMiddleRightStyle31, TopLeftMiddleRightStyle32, TopLeftMiddleRightStyle33, TopLeftMiddleRightStyle34, TopLeftMiddleRightStyle35, TopLeftMiddleRightStyle36, TopLeftMiddleRightStyle37, TopLeftMiddleRightStyle38, TopLeftMiddleRightStyle39, TopLeftMiddleRightStyle4, TopLeftMiddleRightStyle40, TopLeftMiddleRightStyle41, TopLeftMiddleRightStyle42, TopLeftMiddleRightStyle43, TopLeftMiddleRightStyle44, TopLeftMiddleRightStyle45, TopLeftMiddleRightStyle46, TopLeftMiddleRightStyle47, TopLeftMiddleRightStyle48, TopLeftMiddleRightStyle49, TopLeftMiddleRightStyle5, TopLeftMiddleRightStyle50, TopLeftMiddleRightStyle51, TopLeftMiddleRightStyle52, TopLeftMiddleRightStyle53, TopLeftMiddleRightStyle54, TopLeftMiddleRightStyle55, TopLeftMiddleRightStyle56, TopLeftMiddleRightStyle57, TopLeftMiddleRightStyle58, TopLeftMiddleRightStyle59, TopLeftMiddleRightStyle6, TopLeftMiddleRightStyle60, TopLeftMiddleRightStyle61, TopLeftMiddleRightStyle62, TopLeftMiddleRightStyle63, TopLeftMiddleRightStyle64, TopLeftMiddleRightStyle65, TopLeftMiddleRightStyle66, TopLeftMiddleRightStyle67, TopLeftMiddleRightStyle68, TopLeftMiddleRightStyle69, TopLeftMiddleRightStyle7, TopLeftMiddleRightStyle70, TopLeftMiddleRightStyle71, TopLeftMiddleRightStyle72, TopLeftMiddleRightStyle73, TopLeftMiddleRightStyle74, TopLeftMiddleRightStyle75, TopLeftMiddleRightStyle76, TopLeftMiddleRightStyle77, TopLeftMiddleRightStyle78, TopLeftMiddleRightStyle79, TopLeftMiddleRightStyle8, TopLeftMiddleRightStyle80, TopLeftMiddleRightStyle81, TopLeftMiddleRightStyle82, TopLeftMiddleRightStyle83, TopLeftMiddleRightStyle84, TopLeftMiddleRightStyle85, TopLeftMiddleRightStyle86, TopLeftMiddleRightStyle87, TopLeftMiddleRightStyle88, TopLeftMiddleRightStyle89, TopLeftMiddleRightStyle9, TopLeftMiddleRightStyle90, TopLeftMiddleRightStyle91, TopLeftMiddleRightStyle92, TopLeftMiddleRightStyle93, TopLeftMiddleRightStyle94, TopLeftMiddleRightStyle95, TopLeftMiddleRightStyle96, TopLeftMiddleRightStyle97, TopLeftMiddleRightStyle98, TopStyle, TopStyle10, TopStyle11, TopStyle12, TopStyle13, TopStyle14, TopStyle15, TopStyle16, TopStyle17, TopStyle18, TopStyle19, TopStyle2, TopStyle20, TopStyle21, TopStyle22, TopStyle23, TopStyle24, TopStyle25, TopStyle26, TopStyle27, TopStyle28, TopStyle29, TopStyle3, TopStyle30, TopStyle31, TopStyle32, TopStyle33, TopStyle34, TopStyle35, TopStyle36, TopStyle37, TopStyle38, TopStyle39, TopStyle4, TopStyle40, TopStyle41, TopStyle42, TopStyle43, TopStyle44, TopStyle45, TopStyle46, TopStyle47, TopStyle48, TopStyle49, TopStyle5, TopStyle50, TopStyle51, TopStyle52, TopStyle53, TopStyle54, TopStyle55, TopStyle56, TopStyle57, TopStyle58, TopStyle59, TopStyle6, TopStyle60, TopStyle61, TopStyle62, TopStyle63, TopStyle64, TopStyle65, TopStyle66, TopStyle67, TopStyle68, TopStyle69, TopStyle7, TopStyle70, TopStyle71, TopStyle72, TopStyle73, TopStyle74, TopStyle75, TopStyle76, TopStyle77, TopStyle78, TopStyle79, TopStyle8, TopStyle80, TopStyle81, TopStyle82, TopStyle83, TopStyle84, TopStyle85, TopStyle86, TopStyle87, TopStyle88, TopStyle89, TopStyle9, TopStyle90, TopStyle91, TopStyle92, TopStyle93, TopStyle94, TopStyle95, TopStyle96, TopStyle97, TopStyle98, TriggerMfhInvestmentCaseReadCopySync200ReadCopySyncStatus, TriggerMfhInvestmentCaseReadCopySyncMutationResponseReadCopySyncStatus, UpdateDocumentMutationRequestDocumentCategory, UpdateDocumentMutationRequestDocumentCategory10, UpdateDocumentMutationRequestDocumentCategory11, UpdateDocumentMutationRequestDocumentCategory12, UpdateDocumentMutationRequestDocumentCategory13, UpdateDocumentMutationRequestDocumentCategory14, UpdateDocumentMutationRequestDocumentCategory15, UpdateDocumentMutationRequestDocumentCategory16, UpdateDocumentMutationRequestDocumentCategory17, UpdateDocumentMutationRequestDocumentCategory18, UpdateDocumentMutationRequestDocumentCategory19, UpdateDocumentMutationRequestDocumentCategory2, UpdateDocumentMutationRequestDocumentCategory20, UpdateDocumentMutationRequestDocumentCategory21, UpdateDocumentMutationRequestDocumentCategory22, UpdateDocumentMutationRequestDocumentCategory23, UpdateDocumentMutationRequestDocumentCategory24, UpdateDocumentMutationRequestDocumentCategory25, UpdateDocumentMutationRequestDocumentCategory26, UpdateDocumentMutationRequestDocumentCategory27, UpdateDocumentMutationRequestDocumentCategory28, UpdateDocumentMutationRequestDocumentCategory3, UpdateDocumentMutationRequestDocumentCategory4, UpdateDocumentMutationRequestDocumentCategory5, UpdateDocumentMutationRequestDocumentCategory6, UpdateDocumentMutationRequestDocumentCategory7, UpdateDocumentMutationRequestDocumentCategory8, UpdateDocumentMutationRequestDocumentCategory9, UpdateDocumentMutationRequestDocumentType, UpdateDocumentMutationRequestDocumentType10, UpdateDocumentMutationRequestDocumentType100, UpdateDocumentMutationRequestDocumentType101, UpdateDocumentMutationRequestDocumentType102, UpdateDocumentMutationRequestDocumentType103, UpdateDocumentMutationRequestDocumentType104, UpdateDocumentMutationRequestDocumentType105, UpdateDocumentMutationRequestDocumentType106, UpdateDocumentMutationRequestDocumentType107, UpdateDocumentMutationRequestDocumentType108, UpdateDocumentMutationRequestDocumentType109, UpdateDocumentMutationRequestDocumentType11, UpdateDocumentMutationRequestDocumentType110, UpdateDocumentMutationRequestDocumentType111, UpdateDocumentMutationRequestDocumentType112, UpdateDocumentMutationRequestDocumentType113, UpdateDocumentMutationRequestDocumentType114, UpdateDocumentMutationRequestDocumentType115, UpdateDocumentMutationRequestDocumentType116, UpdateDocumentMutationRequestDocumentType117, UpdateDocumentMutationRequestDocumentType118, UpdateDocumentMutationRequestDocumentType119, UpdateDocumentMutationRequestDocumentType12, UpdateDocumentMutationRequestDocumentType120, UpdateDocumentMutationRequestDocumentType121, UpdateDocumentMutationRequestDocumentType122, UpdateDocumentMutationRequestDocumentType123, UpdateDocumentMutationRequestDocumentType124, UpdateDocumentMutationRequestDocumentType125, UpdateDocumentMutationRequestDocumentType126, UpdateDocumentMutationRequestDocumentType127, UpdateDocumentMutationRequestDocumentType128, UpdateDocumentMutationRequestDocumentType129, UpdateDocumentMutationRequestDocumentType13, UpdateDocumentMutationRequestDocumentType130, UpdateDocumentMutationRequestDocumentType131, UpdateDocumentMutationRequestDocumentType132, UpdateDocumentMutationRequestDocumentType133, UpdateDocumentMutationRequestDocumentType134, UpdateDocumentMutationRequestDocumentType135, UpdateDocumentMutationRequestDocumentType136, UpdateDocumentMutationRequestDocumentType137, UpdateDocumentMutationRequestDocumentType138, UpdateDocumentMutationRequestDocumentType139, UpdateDocumentMutationRequestDocumentType14, UpdateDocumentMutationRequestDocumentType140, UpdateDocumentMutationRequestDocumentType141, UpdateDocumentMutationRequestDocumentType142, UpdateDocumentMutationRequestDocumentType143, UpdateDocumentMutationRequestDocumentType144, UpdateDocumentMutationRequestDocumentType145, UpdateDocumentMutationRequestDocumentType146, UpdateDocumentMutationRequestDocumentType147, UpdateDocumentMutationRequestDocumentType148, UpdateDocumentMutationRequestDocumentType149, UpdateDocumentMutationRequestDocumentType15, UpdateDocumentMutationRequestDocumentType150, UpdateDocumentMutationRequestDocumentType151, UpdateDocumentMutationRequestDocumentType152, UpdateDocumentMutationRequestDocumentType153, UpdateDocumentMutationRequestDocumentType154, UpdateDocumentMutationRequestDocumentType155, UpdateDocumentMutationRequestDocumentType156, UpdateDocumentMutationRequestDocumentType157, UpdateDocumentMutationRequestDocumentType158, UpdateDocumentMutationRequestDocumentType159, UpdateDocumentMutationRequestDocumentType16, UpdateDocumentMutationRequestDocumentType160, UpdateDocumentMutationRequestDocumentType161, UpdateDocumentMutationRequestDocumentType162, UpdateDocumentMutationRequestDocumentType163, UpdateDocumentMutationRequestDocumentType164, UpdateDocumentMutationRequestDocumentType165, UpdateDocumentMutationRequestDocumentType166, UpdateDocumentMutationRequestDocumentType167, UpdateDocumentMutationRequestDocumentType168, UpdateDocumentMutationRequestDocumentType169, UpdateDocumentMutationRequestDocumentType17, UpdateDocumentMutationRequestDocumentType170, UpdateDocumentMutationRequestDocumentType171, UpdateDocumentMutationRequestDocumentType172, UpdateDocumentMutationRequestDocumentType173, UpdateDocumentMutationRequestDocumentType174, UpdateDocumentMutationRequestDocumentType175, UpdateDocumentMutationRequestDocumentType176, UpdateDocumentMutationRequestDocumentType177, UpdateDocumentMutationRequestDocumentType178, UpdateDocumentMutationRequestDocumentType179, UpdateDocumentMutationRequestDocumentType18, UpdateDocumentMutationRequestDocumentType180, UpdateDocumentMutationRequestDocumentType181, UpdateDocumentMutationRequestDocumentType182, UpdateDocumentMutationRequestDocumentType183, UpdateDocumentMutationRequestDocumentType184, UpdateDocumentMutationRequestDocumentType185, UpdateDocumentMutationRequestDocumentType186, UpdateDocumentMutationRequestDocumentType187, UpdateDocumentMutationRequestDocumentType188, UpdateDocumentMutationRequestDocumentType189, UpdateDocumentMutationRequestDocumentType19, UpdateDocumentMutationRequestDocumentType190, UpdateDocumentMutationRequestDocumentType191, UpdateDocumentMutationRequestDocumentType192, UpdateDocumentMutationRequestDocumentType193, UpdateDocumentMutationRequestDocumentType194, UpdateDocumentMutationRequestDocumentType195, UpdateDocumentMutationRequestDocumentType196, UpdateDocumentMutationRequestDocumentType197, UpdateDocumentMutationRequestDocumentType198, UpdateDocumentMutationRequestDocumentType199, UpdateDocumentMutationRequestDocumentType2, UpdateDocumentMutationRequestDocumentType20, UpdateDocumentMutationRequestDocumentType200, UpdateDocumentMutationRequestDocumentType201, UpdateDocumentMutationRequestDocumentType202, UpdateDocumentMutationRequestDocumentType203, UpdateDocumentMutationRequestDocumentType204, UpdateDocumentMutationRequestDocumentType205, UpdateDocumentMutationRequestDocumentType206, UpdateDocumentMutationRequestDocumentType207, UpdateDocumentMutationRequestDocumentType208, UpdateDocumentMutationRequestDocumentType209, UpdateDocumentMutationRequestDocumentType21, UpdateDocumentMutationRequestDocumentType210, UpdateDocumentMutationRequestDocumentType211, UpdateDocumentMutationRequestDocumentType212, UpdateDocumentMutationRequestDocumentType213, UpdateDocumentMutationRequestDocumentType214, UpdateDocumentMutationRequestDocumentType215, UpdateDocumentMutationRequestDocumentType216, UpdateDocumentMutationRequestDocumentType217, UpdateDocumentMutationRequestDocumentType218, UpdateDocumentMutationRequestDocumentType219, UpdateDocumentMutationRequestDocumentType22, UpdateDocumentMutationRequestDocumentType220, UpdateDocumentMutationRequestDocumentType221, UpdateDocumentMutationRequestDocumentType222, UpdateDocumentMutationRequestDocumentType223, UpdateDocumentMutationRequestDocumentType224, UpdateDocumentMutationRequestDocumentType225, UpdateDocumentMutationRequestDocumentType226, UpdateDocumentMutationRequestDocumentType227, UpdateDocumentMutationRequestDocumentType228, UpdateDocumentMutationRequestDocumentType229, UpdateDocumentMutationRequestDocumentType23, UpdateDocumentMutationRequestDocumentType230, UpdateDocumentMutationRequestDocumentType231, UpdateDocumentMutationRequestDocumentType232, UpdateDocumentMutationRequestDocumentType233, UpdateDocumentMutationRequestDocumentType234, UpdateDocumentMutationRequestDocumentType235, UpdateDocumentMutationRequestDocumentType236, UpdateDocumentMutationRequestDocumentType237, UpdateDocumentMutationRequestDocumentType238, UpdateDocumentMutationRequestDocumentType239, UpdateDocumentMutationRequestDocumentType24, UpdateDocumentMutationRequestDocumentType240, UpdateDocumentMutationRequestDocumentType241, UpdateDocumentMutationRequestDocumentType242, UpdateDocumentMutationRequestDocumentType243, UpdateDocumentMutationRequestDocumentType244, UpdateDocumentMutationRequestDocumentType245, UpdateDocumentMutationRequestDocumentType246, UpdateDocumentMutationRequestDocumentType247, UpdateDocumentMutationRequestDocumentType248, UpdateDocumentMutationRequestDocumentType249, UpdateDocumentMutationRequestDocumentType25, UpdateDocumentMutationRequestDocumentType250, UpdateDocumentMutationRequestDocumentType251, UpdateDocumentMutationRequestDocumentType252, UpdateDocumentMutationRequestDocumentType253, UpdateDocumentMutationRequestDocumentType254, UpdateDocumentMutationRequestDocumentType255, UpdateDocumentMutationRequestDocumentType256, UpdateDocumentMutationRequestDocumentType257, UpdateDocumentMutationRequestDocumentType258, UpdateDocumentMutationRequestDocumentType259, UpdateDocumentMutationRequestDocumentType26, UpdateDocumentMutationRequestDocumentType260, UpdateDocumentMutationRequestDocumentType261, UpdateDocumentMutationRequestDocumentType262, UpdateDocumentMutationRequestDocumentType263, UpdateDocumentMutationRequestDocumentType264, UpdateDocumentMutationRequestDocumentType265, UpdateDocumentMutationRequestDocumentType266, UpdateDocumentMutationRequestDocumentType267, UpdateDocumentMutationRequestDocumentType268, UpdateDocumentMutationRequestDocumentType269, UpdateDocumentMutationRequestDocumentType27, UpdateDocumentMutationRequestDocumentType270, UpdateDocumentMutationRequestDocumentType271, UpdateDocumentMutationRequestDocumentType272, UpdateDocumentMutationRequestDocumentType273, UpdateDocumentMutationRequestDocumentType274, UpdateDocumentMutationRequestDocumentType275, UpdateDocumentMutationRequestDocumentType276, UpdateDocumentMutationRequestDocumentType277, UpdateDocumentMutationRequestDocumentType278, UpdateDocumentMutationRequestDocumentType279, UpdateDocumentMutationRequestDocumentType28, UpdateDocumentMutationRequestDocumentType280, UpdateDocumentMutationRequestDocumentType281, UpdateDocumentMutationRequestDocumentType282, UpdateDocumentMutationRequestDocumentType283, UpdateDocumentMutationRequestDocumentType284, UpdateDocumentMutationRequestDocumentType285, UpdateDocumentMutationRequestDocumentType286, UpdateDocumentMutationRequestDocumentType287, UpdateDocumentMutationRequestDocumentType288, UpdateDocumentMutationRequestDocumentType289, UpdateDocumentMutationRequestDocumentType29, UpdateDocumentMutationRequestDocumentType290, UpdateDocumentMutationRequestDocumentType291, UpdateDocumentMutationRequestDocumentType292, UpdateDocumentMutationRequestDocumentType293, UpdateDocumentMutationRequestDocumentType294, UpdateDocumentMutationRequestDocumentType295, UpdateDocumentMutationRequestDocumentType296, UpdateDocumentMutationRequestDocumentType297, UpdateDocumentMutationRequestDocumentType298, UpdateDocumentMutationRequestDocumentType299, UpdateDocumentMutationRequestDocumentType3, UpdateDocumentMutationRequestDocumentType30, UpdateDocumentMutationRequestDocumentType300, UpdateDocumentMutationRequestDocumentType301, UpdateDocumentMutationRequestDocumentType302, UpdateDocumentMutationRequestDocumentType303, UpdateDocumentMutationRequestDocumentType304, UpdateDocumentMutationRequestDocumentType305, UpdateDocumentMutationRequestDocumentType306, UpdateDocumentMutationRequestDocumentType307, UpdateDocumentMutationRequestDocumentType308, UpdateDocumentMutationRequestDocumentType309, UpdateDocumentMutationRequestDocumentType31, UpdateDocumentMutationRequestDocumentType310, UpdateDocumentMutationRequestDocumentType311, UpdateDocumentMutationRequestDocumentType312, UpdateDocumentMutationRequestDocumentType313, UpdateDocumentMutationRequestDocumentType314, UpdateDocumentMutationRequestDocumentType315, UpdateDocumentMutationRequestDocumentType316, UpdateDocumentMutationRequestDocumentType317, UpdateDocumentMutationRequestDocumentType318, UpdateDocumentMutationRequestDocumentType319, UpdateDocumentMutationRequestDocumentType32, UpdateDocumentMutationRequestDocumentType320, UpdateDocumentMutationRequestDocumentType321, UpdateDocumentMutationRequestDocumentType322, UpdateDocumentMutationRequestDocumentType323, UpdateDocumentMutationRequestDocumentType324, UpdateDocumentMutationRequestDocumentType325, UpdateDocumentMutationRequestDocumentType326, UpdateDocumentMutationRequestDocumentType327, UpdateDocumentMutationRequestDocumentType328, UpdateDocumentMutationRequestDocumentType329, UpdateDocumentMutationRequestDocumentType33, UpdateDocumentMutationRequestDocumentType330, UpdateDocumentMutationRequestDocumentType331, UpdateDocumentMutationRequestDocumentType332, UpdateDocumentMutationRequestDocumentType333, UpdateDocumentMutationRequestDocumentType334, UpdateDocumentMutationRequestDocumentType335, UpdateDocumentMutationRequestDocumentType336, UpdateDocumentMutationRequestDocumentType337, UpdateDocumentMutationRequestDocumentType338, UpdateDocumentMutationRequestDocumentType339, UpdateDocumentMutationRequestDocumentType34, UpdateDocumentMutationRequestDocumentType340, UpdateDocumentMutationRequestDocumentType341, UpdateDocumentMutationRequestDocumentType342, UpdateDocumentMutationRequestDocumentType343, UpdateDocumentMutationRequestDocumentType344, UpdateDocumentMutationRequestDocumentType345, UpdateDocumentMutationRequestDocumentType346, UpdateDocumentMutationRequestDocumentType347, UpdateDocumentMutationRequestDocumentType348, UpdateDocumentMutationRequestDocumentType349, UpdateDocumentMutationRequestDocumentType35, UpdateDocumentMutationRequestDocumentType350, UpdateDocumentMutationRequestDocumentType351, UpdateDocumentMutationRequestDocumentType352, UpdateDocumentMutationRequestDocumentType353, UpdateDocumentMutationRequestDocumentType354, UpdateDocumentMutationRequestDocumentType355, UpdateDocumentMutationRequestDocumentType356, UpdateDocumentMutationRequestDocumentType357, UpdateDocumentMutationRequestDocumentType358, UpdateDocumentMutationRequestDocumentType359, UpdateDocumentMutationRequestDocumentType36, UpdateDocumentMutationRequestDocumentType360, UpdateDocumentMutationRequestDocumentType361, UpdateDocumentMutationRequestDocumentType362, UpdateDocumentMutationRequestDocumentType37, UpdateDocumentMutationRequestDocumentType38, UpdateDocumentMutationRequestDocumentType39, UpdateDocumentMutationRequestDocumentType4, UpdateDocumentMutationRequestDocumentType40, UpdateDocumentMutationRequestDocumentType41, UpdateDocumentMutationRequestDocumentType42, UpdateDocumentMutationRequestDocumentType43, UpdateDocumentMutationRequestDocumentType44, UpdateDocumentMutationRequestDocumentType45, UpdateDocumentMutationRequestDocumentType46, UpdateDocumentMutationRequestDocumentType47, UpdateDocumentMutationRequestDocumentType48, UpdateDocumentMutationRequestDocumentType49, UpdateDocumentMutationRequestDocumentType5, UpdateDocumentMutationRequestDocumentType50, UpdateDocumentMutationRequestDocumentType51, UpdateDocumentMutationRequestDocumentType52, UpdateDocumentMutationRequestDocumentType53, UpdateDocumentMutationRequestDocumentType54, UpdateDocumentMutationRequestDocumentType55, UpdateDocumentMutationRequestDocumentType56, UpdateDocumentMutationRequestDocumentType57, UpdateDocumentMutationRequestDocumentType58, UpdateDocumentMutationRequestDocumentType59, UpdateDocumentMutationRequestDocumentType6, UpdateDocumentMutationRequestDocumentType60, UpdateDocumentMutationRequestDocumentType61, UpdateDocumentMutationRequestDocumentType62, UpdateDocumentMutationRequestDocumentType63, UpdateDocumentMutationRequestDocumentType64, UpdateDocumentMutationRequestDocumentType65, UpdateDocumentMutationRequestDocumentType66, UpdateDocumentMutationRequestDocumentType67, UpdateDocumentMutationRequestDocumentType68, UpdateDocumentMutationRequestDocumentType69, UpdateDocumentMutationRequestDocumentType7, UpdateDocumentMutationRequestDocumentType70, UpdateDocumentMutationRequestDocumentType71, UpdateDocumentMutationRequestDocumentType72, UpdateDocumentMutationRequestDocumentType73, UpdateDocumentMutationRequestDocumentType74, UpdateDocumentMutationRequestDocumentType75, UpdateDocumentMutationRequestDocumentType76, UpdateDocumentMutationRequestDocumentType77, UpdateDocumentMutationRequestDocumentType78, UpdateDocumentMutationRequestDocumentType79, UpdateDocumentMutationRequestDocumentType8, UpdateDocumentMutationRequestDocumentType80, UpdateDocumentMutationRequestDocumentType81, UpdateDocumentMutationRequestDocumentType82, UpdateDocumentMutationRequestDocumentType83, UpdateDocumentMutationRequestDocumentType84, UpdateDocumentMutationRequestDocumentType85, UpdateDocumentMutationRequestDocumentType86, UpdateDocumentMutationRequestDocumentType87, UpdateDocumentMutationRequestDocumentType88, UpdateDocumentMutationRequestDocumentType89, UpdateDocumentMutationRequestDocumentType9, UpdateDocumentMutationRequestDocumentType90, UpdateDocumentMutationRequestDocumentType91, UpdateDocumentMutationRequestDocumentType92, UpdateDocumentMutationRequestDocumentType93, UpdateDocumentMutationRequestDocumentType94, UpdateDocumentMutationRequestDocumentType95, UpdateDocumentMutationRequestDocumentType96, UpdateDocumentMutationRequestDocumentType97, UpdateDocumentMutationRequestDocumentType98, UpdateDocumentMutationRequestDocumentType99, UpdateMfhMutationRequestChannelName, UpdateMfhPlacementIcResponseMutationRequestAssetPartnerPlacementResponseStatus, UpdatePortfolioAnalyzerResultMutationRequestStatus, VersionTriggerType, VersionTriggerType2, VersionTriggerType3, VersionTriggerType4, VersionVersionStatus, VersionVersionStatus2, VersionVersionStatus3, VersionVersionStatus4, VersionsTriggerType, VersionsTriggerType2, VersionsVersionStatus, VersionsVersionStatus2, axios_exports as basecampApi, initHTTPClient as initBasecampHTTPClient };
